/**
 * Yle Design System
 * v2.x.x
 */

const BORDER_SM = '1px';
const BORDER_MD = '2px';
const BORDER_LG = '3px';

var border = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BORDER_LG: BORDER_LG,
  BORDER_MD: BORDER_MD,
  BORDER_SM: BORDER_SM
});

/**
 * Yle Design System
 * v2.x.x
 */

const NONE = 0;
const XSMALL = '1px';
const SMALL = '2px';
const MEDIUM = '4px';
const LARGE = '8px';
const XLARGE = '16px';
const XXLARGE = '24px';
const FULL = '9999px';

var borderRadius = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FULL: FULL,
  LARGE: LARGE,
  MEDIUM: MEDIUM,
  NONE: NONE,
  SMALL: SMALL,
  XLARGE: XLARGE,
  XSMALL: XSMALL,
  XXLARGE: XXLARGE
});

/**
 * Yle Design System
 * v2.x.x
 */

const GRAY_5 = '#f8f9fa';
const GRAY_10 = '#f1f2f4';
const GRAY_20 = '#e8e9eb';
const GRAY_30 = '#d8d9db';
const GRAY_40 = '#b4b6b7';
const GRAY_50 = '#878a8b';
const GRAY_60 = '#4a4f54';
const GRAY_70 = '#323639';
const GRAY_80 = '#292b2d';
const GRAY_90 = '#1f2123';
const GRAY_95 = '#131415';
const BLACK_OPACITY_5 = 'rgba(0, 0, 0, 0.02)';
const BLACK_OPACITY_10 = 'rgba(0, 0, 0, 0.05)';
const BLACK_OPACITY_20 = 'rgba(0, 0, 0, 0.09)';
const BLACK_OPACITY_30 = 'rgba(0, 0, 0, 0.15)';
const BLACK_OPACITY_40 = 'rgba(0, 0, 0, 0.29)';
const BLACK_OPACITY_50 = 'rgba(0, 0, 0, 0.47)';
const BLACK_OPACITY_60 = 'rgba(0, 0, 0, 0.7)';
const BLACK_OPACITY_70 = 'rgba(0, 0, 0, 0.79)';
const BLACK_OPACITY_80 = 'rgba(0, 0, 0, 0.83)';
const BLACK_OPACITY_90 = 'rgba(0, 0, 0, 0.87)';
const BLACK_OPACITY_95 = 'rgba(0, 0, 0, 0.92)';
const WHITE_OPACITY_5 = 'rgba(255, 255, 255, 0.08)';
const WHITE_OPACITY_10 = 'rgba(255, 255, 255, 0.13)';
const WHITE_OPACITY_20 = 'rgba(255, 255, 255, 0.17)';
const WHITE_OPACITY_30 = 'rgba(255, 255, 255, 0.21)';
const WHITE_OPACITY_40 = 'rgba(255, 255, 255, 0.3)';
const WHITE_OPACITY_50 = 'rgba(255, 255, 255, 0.53)';
const WHITE_OPACITY_60 = 'rgba(255, 255, 255, 0.71)';
const WHITE_OPACITY_70 = 'rgba(255, 255, 255, 0.85)';
const WHITE_OPACITY_80 = 'rgba(255, 255, 255, 0.91)';
const WHITE_OPACITY_90 = 'rgba(255, 255, 255, 0.95)';
const WHITE_OPACITY_95 = 'rgba(255, 255, 255, 0.98)';
const WHITE = '#ffffff';
const BLACK = '#000000';
const TURQUOISE_5 = '#e5fdff';
const TURQUOISE_10 = '#c7f4fa';
const TURQUOISE_20 = '#9cebf4';
const TURQUOISE_30 = '#5ddbe9';
const TURQUOISE_40 = '#29ccde';
const TURQUOISE_50 = '#00b4c8';
const TURQUOISE_60 = '#009cb5';
const TURQUOISE_70 = '#00809c';
const TURQUOISE_80 = '#00637d';
const TURQUOISE_90 = '#00475e';
const TURQUOISE_95 = '#0b3f4b';
const NEWS_VIOLET_5 = '#e6e5ff';
const NEWS_VIOLET_10 = '#d3cbfb';
const NEWS_VIOLET_20 = '#b7a8fa';
const NEWS_VIOLET_30 = '#9479fb';
const NEWS_VIOLET_40 = '#7c59fa';
const NEWS_VIOLET_50 = '#694bd7';
const NEWS_VIOLET_60 = '#553db4';
const NEWS_VIOLET_70 = '#413091';
const NEWS_VIOLET_80 = '#2f2372';
const NEWS_VIOLET_90 = '#1e1753';
const NEWS_VIOLET_95 = '#120e3e';
const NEWS_ORANGE_5 = '#fff2f2';
const NEWS_ORANGE_10 = '#fdd6d3';
const NEWS_ORANGE_20 = '#fab8b3';
const NEWS_ORANGE_30 = '#f79c94';
const NEWS_ORANGE_40 = '#f57f74';
const NEWS_ORANGE_50 = '#f26659';
const NEWS_ORANGE_60 = '#d24f45';
const NEWS_ORANGE_70 = '#b83c35';
const NEWS_ORANGE_80 = '#9b2823';
const NEWS_ORANGE_90 = '#7f1412';
const NEWS_ORANGE_95 = '#650101';
const SPORTS_VIOLET_5 = '#eeeeff';
const SPORTS_VIOLET_10 = '#ddd9fc';
const SPORTS_VIOLET_20 = '#b3abf7';
const SPORTS_VIOLET_30 = '#8578f2';
const SPORTS_VIOLET_40 = '#6553ef';
const SPORTS_VIOLET_50 = '#5541ed';
const SPORTS_VIOLET_60 = '#372bb1';
const SPORTS_VIOLET_70 = '#292094';
const SPORTS_VIOLET_80 = '#1a1476';
const SPORTS_VIOLET_90 = '#0d0a5c';
const SPORTS_VIOLET_95 = '#030349';
const SPORTS_LIME_5 = '#fdfde7';
const SPORTS_LIME_10 = '#f9ffc6';
const SPORTS_LIME_20 = '#ebfe8d';
const SPORTS_LIME_30 = '#d4ff42';
const SPORTS_LIME_40 = '#caf53e';
const SPORTS_LIME_50 = '#b0d934';
const SPORTS_LIME_60 = '#91ae42';
const SPORTS_LIME_70 = '#7a9a2c';
const SPORTS_LIME_80 = '#618515';
const SPORTS_LIME_90 = '#46690b';
const SPORTS_LIME_95 = '#2c4d01';
const SPORTS_PINK_5 = '#fff5f9';
const SPORTS_PINK_10 = '#fcd9e8';
const SPORTS_PINK_20 = '#f7abcb';
const SPORTS_PINK_30 = '#f273a8';
const SPORTS_PINK_40 = '#ea3e85';
const SPORTS_PINK_50 = '#e60060';
const SPORTS_PINK_60 = '#c50152';
const SPORTS_PINK_70 = '#a70146';
const SPORTS_PINK_80 = '#880139';
const SPORTS_PINK_90 = '#6b012c';
const SPORTS_PINK_95 = '#4d0120';
const INFO_ORANGE_5 = '#fff3e2';
const INFO_ORANGE_10 = '#ffe3bf';
const INFO_ORANGE_20 = '#ffd199';
const INFO_ORANGE_30 = '#fec075';
const INFO_ORANGE_40 = '#feb054';
const INFO_ORANGE_50 = '#ff8f33';
const INFO_ORANGE_60 = '#f56a1b';
const INFO_ORANGE_70 = '#e65a27';
const INFO_ORANGE_80 = '#e04312';
const INFO_ORANGE_90 = '#c93c11';
const INFO_ORANGE_95 = '#9b2e0d';
const INFO_YELLOW_5 = '#fff8e0';
const INFO_YELLOW_10 = '#ffeeb2';
const INFO_YELLOW_20 = '#ffe387';
const INFO_YELLOW_30 = '#ffd959';
const INFO_YELLOW_40 = '#ffcf2d';
const INFO_YELLOW_50 = '#ffc400';
const INFO_YELLOW_60 = '#f1b601';
const INFO_YELLOW_70 = '#cc9601';
const INFO_YELLOW_80 = '#ae7b01';
const INFO_YELLOW_90 = '#926201';
const INFO_YELLOW_95 = '#764901';
const INFO_GREEN_5 = '#e0fff4';
const INFO_GREEN_10 = '#b4f5de';
const INFO_GREEN_20 = '#88eac7';
const INFO_GREEN_30 = '#5fe0b2';
const INFO_GREEN_40 = '#33d59b';
const INFO_GREEN_50 = '#07ca84';
const INFO_GREEN_60 = '#07b577';
const INFO_GREEN_70 = '#06a26a';
const INFO_GREEN_80 = '#068e5d';
const INFO_GREEN_90 = '#05794f';
const INFO_GREEN_95 = '#046542';
const INFO_BLUE_5 = '#e0f2ff';
const INFO_BLUE_10 = '#bbdcff';
const INFO_BLUE_20 = '#95c6ff';
const INFO_BLUE_30 = '#71b0ff';
const INFO_BLUE_40 = '#4b9aff';
const INFO_BLUE_50 = '#2684ff';
const INFO_BLUE_60 = '#2078ed';
const INFO_BLUE_70 = '#196dda';
const INFO_BLUE_80 = '#1260c7';
const INFO_BLUE_90 = '#0b54b4';
const INFO_BLUE_95 = '#0448a1';
const INFO_DEEP_BLUE_5 = '#e3eaf3';
const INFO_DEEP_BLUE_10 = '#c9d5e6';
const INFO_DEEP_BLUE_20 = '#b0c1da';
const INFO_DEEP_BLUE_30 = '#99aece';
const INFO_DEEP_BLUE_40 = '#738ab5';
const INFO_DEEP_BLUE_50 = '#546d9c';
const INFO_DEEP_BLUE_60 = '#3d5483';
const INFO_DEEP_BLUE_70 = '#1e2e52';
const INFO_DEEP_BLUE_80 = '#131e39';
const INFO_DEEP_BLUE_90 = '#131625';
const INFO_DEEP_BLUE_95 = '#020408';
const INFO_PURPLE_5 = '#fcf5ff';
const INFO_PURPLE_10 = '#e8d0f1';
const INFO_PURPLE_20 = '#d9b0e8';
const INFO_PURPLE_30 = '#ca91de';
const INFO_PURPLE_40 = '#ba72d5';
const INFO_PURPLE_50 = '#9436b5';
const INFO_PURPLE_60 = '#80259f';
const INFO_PURPLE_70 = '#620579';
const INFO_PURPLE_80 = '#4b075b';
const INFO_PURPLE_90 = '#30063a';
const INFO_PURPLE_95 = '#1c0222';
const RED_5 = '#fff5f8';
const RED_10 = '#fcc5d3';
const RED_20 = '#f99fb5';
const RED_30 = '#f77898';
const RED_40 = '#f5517a';
const RED_50 = '#e90e43';
const RED_60 = '#d10b3d';
const RED_70 = '#9a092d';
const RED_80 = '#740722';
const RED_90 = '#4d0417';
const GREEN_5 = '#e5fff9';
const GREEN_10 = '#a1f9dd';
const GREEN_20 = '#62f9c2';
const GREEN_30 = '#1ff0a4';
const GREEN_40 = '#03e592';
const GREEN_50 = '#07ca84';
const GREEN_60 = '#06b173';
const GREEN_70 = '#058657';
const GREEN_80 = '#046240';
const GREEN_90 = '#023b26';
const ORANGE_5 = '#fff3e2';
const ORANGE_10 = '#ffe1b8';
const ORANGE_20 = '#ffce8b';
const ORANGE_30 = '#ffb95f';
const ORANGE_40 = '#ff9c31';
const ORANGE_50 = '#ff8f33';
const ORANGE_60 = '#f1722a';
const ORANGE_70 = '#e65a27';
const ORANGE_80 = '#e04312';
const ORANGE_90 = '#c93c11';
const BLUE_5 = '#e0f2ff';
const BLUE_10 = '#ccdef5';
const BLUE_20 = '#9fc8ee';
const BLUE_30 = '#88b3e7';
const BLUE_40 = '#669de1';
const BLUE_50 = '#2975d0';
const BLUE_60 = '#1163b0';
const BLUE_70 = '#234c93';
const BLUE_80 = '#0a3276';
const BLUE_90 = '#00284e';

var colors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BLACK: BLACK,
  BLACK_OPACITY_10: BLACK_OPACITY_10,
  BLACK_OPACITY_20: BLACK_OPACITY_20,
  BLACK_OPACITY_30: BLACK_OPACITY_30,
  BLACK_OPACITY_40: BLACK_OPACITY_40,
  BLACK_OPACITY_5: BLACK_OPACITY_5,
  BLACK_OPACITY_50: BLACK_OPACITY_50,
  BLACK_OPACITY_60: BLACK_OPACITY_60,
  BLACK_OPACITY_70: BLACK_OPACITY_70,
  BLACK_OPACITY_80: BLACK_OPACITY_80,
  BLACK_OPACITY_90: BLACK_OPACITY_90,
  BLACK_OPACITY_95: BLACK_OPACITY_95,
  BLUE_10: BLUE_10,
  BLUE_20: BLUE_20,
  BLUE_30: BLUE_30,
  BLUE_40: BLUE_40,
  BLUE_5: BLUE_5,
  BLUE_50: BLUE_50,
  BLUE_60: BLUE_60,
  BLUE_70: BLUE_70,
  BLUE_80: BLUE_80,
  BLUE_90: BLUE_90,
  GRAY_10: GRAY_10,
  GRAY_20: GRAY_20,
  GRAY_30: GRAY_30,
  GRAY_40: GRAY_40,
  GRAY_5: GRAY_5,
  GRAY_50: GRAY_50,
  GRAY_60: GRAY_60,
  GRAY_70: GRAY_70,
  GRAY_80: GRAY_80,
  GRAY_90: GRAY_90,
  GRAY_95: GRAY_95,
  GREEN_10: GREEN_10,
  GREEN_20: GREEN_20,
  GREEN_30: GREEN_30,
  GREEN_40: GREEN_40,
  GREEN_5: GREEN_5,
  GREEN_50: GREEN_50,
  GREEN_60: GREEN_60,
  GREEN_70: GREEN_70,
  GREEN_80: GREEN_80,
  GREEN_90: GREEN_90,
  INFO_BLUE_10: INFO_BLUE_10,
  INFO_BLUE_20: INFO_BLUE_20,
  INFO_BLUE_30: INFO_BLUE_30,
  INFO_BLUE_40: INFO_BLUE_40,
  INFO_BLUE_5: INFO_BLUE_5,
  INFO_BLUE_50: INFO_BLUE_50,
  INFO_BLUE_60: INFO_BLUE_60,
  INFO_BLUE_70: INFO_BLUE_70,
  INFO_BLUE_80: INFO_BLUE_80,
  INFO_BLUE_90: INFO_BLUE_90,
  INFO_BLUE_95: INFO_BLUE_95,
  INFO_DEEP_BLUE_10: INFO_DEEP_BLUE_10,
  INFO_DEEP_BLUE_20: INFO_DEEP_BLUE_20,
  INFO_DEEP_BLUE_30: INFO_DEEP_BLUE_30,
  INFO_DEEP_BLUE_40: INFO_DEEP_BLUE_40,
  INFO_DEEP_BLUE_5: INFO_DEEP_BLUE_5,
  INFO_DEEP_BLUE_50: INFO_DEEP_BLUE_50,
  INFO_DEEP_BLUE_60: INFO_DEEP_BLUE_60,
  INFO_DEEP_BLUE_70: INFO_DEEP_BLUE_70,
  INFO_DEEP_BLUE_80: INFO_DEEP_BLUE_80,
  INFO_DEEP_BLUE_90: INFO_DEEP_BLUE_90,
  INFO_DEEP_BLUE_95: INFO_DEEP_BLUE_95,
  INFO_GREEN_10: INFO_GREEN_10,
  INFO_GREEN_20: INFO_GREEN_20,
  INFO_GREEN_30: INFO_GREEN_30,
  INFO_GREEN_40: INFO_GREEN_40,
  INFO_GREEN_5: INFO_GREEN_5,
  INFO_GREEN_50: INFO_GREEN_50,
  INFO_GREEN_60: INFO_GREEN_60,
  INFO_GREEN_70: INFO_GREEN_70,
  INFO_GREEN_80: INFO_GREEN_80,
  INFO_GREEN_90: INFO_GREEN_90,
  INFO_GREEN_95: INFO_GREEN_95,
  INFO_ORANGE_10: INFO_ORANGE_10,
  INFO_ORANGE_20: INFO_ORANGE_20,
  INFO_ORANGE_30: INFO_ORANGE_30,
  INFO_ORANGE_40: INFO_ORANGE_40,
  INFO_ORANGE_5: INFO_ORANGE_5,
  INFO_ORANGE_50: INFO_ORANGE_50,
  INFO_ORANGE_60: INFO_ORANGE_60,
  INFO_ORANGE_70: INFO_ORANGE_70,
  INFO_ORANGE_80: INFO_ORANGE_80,
  INFO_ORANGE_90: INFO_ORANGE_90,
  INFO_ORANGE_95: INFO_ORANGE_95,
  INFO_PURPLE_10: INFO_PURPLE_10,
  INFO_PURPLE_20: INFO_PURPLE_20,
  INFO_PURPLE_30: INFO_PURPLE_30,
  INFO_PURPLE_40: INFO_PURPLE_40,
  INFO_PURPLE_5: INFO_PURPLE_5,
  INFO_PURPLE_50: INFO_PURPLE_50,
  INFO_PURPLE_60: INFO_PURPLE_60,
  INFO_PURPLE_70: INFO_PURPLE_70,
  INFO_PURPLE_80: INFO_PURPLE_80,
  INFO_PURPLE_90: INFO_PURPLE_90,
  INFO_PURPLE_95: INFO_PURPLE_95,
  INFO_YELLOW_10: INFO_YELLOW_10,
  INFO_YELLOW_20: INFO_YELLOW_20,
  INFO_YELLOW_30: INFO_YELLOW_30,
  INFO_YELLOW_40: INFO_YELLOW_40,
  INFO_YELLOW_5: INFO_YELLOW_5,
  INFO_YELLOW_50: INFO_YELLOW_50,
  INFO_YELLOW_60: INFO_YELLOW_60,
  INFO_YELLOW_70: INFO_YELLOW_70,
  INFO_YELLOW_80: INFO_YELLOW_80,
  INFO_YELLOW_90: INFO_YELLOW_90,
  INFO_YELLOW_95: INFO_YELLOW_95,
  NEWS_ORANGE_10: NEWS_ORANGE_10,
  NEWS_ORANGE_20: NEWS_ORANGE_20,
  NEWS_ORANGE_30: NEWS_ORANGE_30,
  NEWS_ORANGE_40: NEWS_ORANGE_40,
  NEWS_ORANGE_5: NEWS_ORANGE_5,
  NEWS_ORANGE_50: NEWS_ORANGE_50,
  NEWS_ORANGE_60: NEWS_ORANGE_60,
  NEWS_ORANGE_70: NEWS_ORANGE_70,
  NEWS_ORANGE_80: NEWS_ORANGE_80,
  NEWS_ORANGE_90: NEWS_ORANGE_90,
  NEWS_ORANGE_95: NEWS_ORANGE_95,
  NEWS_VIOLET_10: NEWS_VIOLET_10,
  NEWS_VIOLET_20: NEWS_VIOLET_20,
  NEWS_VIOLET_30: NEWS_VIOLET_30,
  NEWS_VIOLET_40: NEWS_VIOLET_40,
  NEWS_VIOLET_5: NEWS_VIOLET_5,
  NEWS_VIOLET_50: NEWS_VIOLET_50,
  NEWS_VIOLET_60: NEWS_VIOLET_60,
  NEWS_VIOLET_70: NEWS_VIOLET_70,
  NEWS_VIOLET_80: NEWS_VIOLET_80,
  NEWS_VIOLET_90: NEWS_VIOLET_90,
  NEWS_VIOLET_95: NEWS_VIOLET_95,
  ORANGE_10: ORANGE_10,
  ORANGE_20: ORANGE_20,
  ORANGE_30: ORANGE_30,
  ORANGE_40: ORANGE_40,
  ORANGE_5: ORANGE_5,
  ORANGE_50: ORANGE_50,
  ORANGE_60: ORANGE_60,
  ORANGE_70: ORANGE_70,
  ORANGE_80: ORANGE_80,
  ORANGE_90: ORANGE_90,
  RED_10: RED_10,
  RED_20: RED_20,
  RED_30: RED_30,
  RED_40: RED_40,
  RED_5: RED_5,
  RED_50: RED_50,
  RED_60: RED_60,
  RED_70: RED_70,
  RED_80: RED_80,
  RED_90: RED_90,
  SPORTS_LIME_10: SPORTS_LIME_10,
  SPORTS_LIME_20: SPORTS_LIME_20,
  SPORTS_LIME_30: SPORTS_LIME_30,
  SPORTS_LIME_40: SPORTS_LIME_40,
  SPORTS_LIME_5: SPORTS_LIME_5,
  SPORTS_LIME_50: SPORTS_LIME_50,
  SPORTS_LIME_60: SPORTS_LIME_60,
  SPORTS_LIME_70: SPORTS_LIME_70,
  SPORTS_LIME_80: SPORTS_LIME_80,
  SPORTS_LIME_90: SPORTS_LIME_90,
  SPORTS_LIME_95: SPORTS_LIME_95,
  SPORTS_PINK_10: SPORTS_PINK_10,
  SPORTS_PINK_20: SPORTS_PINK_20,
  SPORTS_PINK_30: SPORTS_PINK_30,
  SPORTS_PINK_40: SPORTS_PINK_40,
  SPORTS_PINK_5: SPORTS_PINK_5,
  SPORTS_PINK_50: SPORTS_PINK_50,
  SPORTS_PINK_60: SPORTS_PINK_60,
  SPORTS_PINK_70: SPORTS_PINK_70,
  SPORTS_PINK_80: SPORTS_PINK_80,
  SPORTS_PINK_90: SPORTS_PINK_90,
  SPORTS_PINK_95: SPORTS_PINK_95,
  SPORTS_VIOLET_10: SPORTS_VIOLET_10,
  SPORTS_VIOLET_20: SPORTS_VIOLET_20,
  SPORTS_VIOLET_30: SPORTS_VIOLET_30,
  SPORTS_VIOLET_40: SPORTS_VIOLET_40,
  SPORTS_VIOLET_5: SPORTS_VIOLET_5,
  SPORTS_VIOLET_50: SPORTS_VIOLET_50,
  SPORTS_VIOLET_60: SPORTS_VIOLET_60,
  SPORTS_VIOLET_70: SPORTS_VIOLET_70,
  SPORTS_VIOLET_80: SPORTS_VIOLET_80,
  SPORTS_VIOLET_90: SPORTS_VIOLET_90,
  SPORTS_VIOLET_95: SPORTS_VIOLET_95,
  TURQUOISE_10: TURQUOISE_10,
  TURQUOISE_20: TURQUOISE_20,
  TURQUOISE_30: TURQUOISE_30,
  TURQUOISE_40: TURQUOISE_40,
  TURQUOISE_5: TURQUOISE_5,
  TURQUOISE_50: TURQUOISE_50,
  TURQUOISE_60: TURQUOISE_60,
  TURQUOISE_70: TURQUOISE_70,
  TURQUOISE_80: TURQUOISE_80,
  TURQUOISE_90: TURQUOISE_90,
  TURQUOISE_95: TURQUOISE_95,
  WHITE: WHITE,
  WHITE_OPACITY_10: WHITE_OPACITY_10,
  WHITE_OPACITY_20: WHITE_OPACITY_20,
  WHITE_OPACITY_30: WHITE_OPACITY_30,
  WHITE_OPACITY_40: WHITE_OPACITY_40,
  WHITE_OPACITY_5: WHITE_OPACITY_5,
  WHITE_OPACITY_50: WHITE_OPACITY_50,
  WHITE_OPACITY_60: WHITE_OPACITY_60,
  WHITE_OPACITY_70: WHITE_OPACITY_70,
  WHITE_OPACITY_80: WHITE_OPACITY_80,
  WHITE_OPACITY_90: WHITE_OPACITY_90,
  WHITE_OPACITY_95: WHITE_OPACITY_95
});

/**
 * Yle Design System
 * v2.x.x
 */

const SHADOW_SM$2 = '0 0 8px 0 rgba(0, 0, 0, 0.70)';
const SHADOW_MD$2 = '0 0 16px 0 rgba(0, 0, 0, 0.70)';
const SHADOW_LG$2 = '0 0 24px 0 rgba(0, 0, 0, 0.87)';

var shadowDark = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SHADOW_LG: SHADOW_LG$2,
  SHADOW_MD: SHADOW_MD$2,
  SHADOW_SM: SHADOW_SM$2
});

/**
 * Yle Design System
 * v2.x.x
 */

const SHADOW_SM$1 = '0 0 8px 0 rgba(0, 0, 0, 0.15)';
const SHADOW_MD$1 = '0 0 16px 0 rgba(0, 0, 0, 0.15)';
const SHADOW_LG$1 = '0 0 24px 0 rgba(0, 0, 0, 0.41)';

var shadowDefault = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SHADOW_LG: SHADOW_LG$1,
  SHADOW_MD: SHADOW_MD$1,
  SHADOW_SM: SHADOW_SM$1
});

/**
 * Yle Design System
 * v2.x.x
 */

const SHADOW_SM = '0 0 8px 0 rgba(0, 0, 0, 0.15)';
const SHADOW_MD = '0 0 16px 0 rgba(0, 0, 0, 0.15)';
const SHADOW_LG = '0 0 24px 0 rgba(0, 0, 0, 0.41)';

var shadowLight = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SHADOW_LG: SHADOW_LG,
  SHADOW_MD: SHADOW_MD,
  SHADOW_SM: SHADOW_SM
});

/**
 * Yle Design System
 * v2.x.x
 */

const SPACING_2 = '2px';
const SPACING_4 = '4px';
const SPACING_8 = '8px';
const SPACING_12 = '12px';
const SPACING_16 = '16px';
const SPACING_24 = '24px';
const SPACING_32 = '32px';
const SPACING_40 = '40px';
const SPACING_48 = '48px';
const SPACING_56 = '56px';
const SPACING_64 = '64px';
const SPACING_72 = '72px';

var spacing = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SPACING_12: SPACING_12,
  SPACING_16: SPACING_16,
  SPACING_2: SPACING_2,
  SPACING_24: SPACING_24,
  SPACING_32: SPACING_32,
  SPACING_4: SPACING_4,
  SPACING_40: SPACING_40,
  SPACING_48: SPACING_48,
  SPACING_56: SPACING_56,
  SPACING_64: SPACING_64,
  SPACING_72: SPACING_72,
  SPACING_8: SPACING_8
});

/**
 * Yle Design System
 * v2.x.x
 */

const BACKGROUND$8 = '#131415'; // gray-95
const BACKGROUND_VARIANT$5 = '#1f2123'; // gray-90
const BACKGROUND_NEGATIVE$5 = '#ffffff'; // white
const BACKGROUND_NAVIGATION$2 = '#000000'; // black
const BACKGROUND_CONTROL$2 = 'rgba(255, 255, 255, 0.53)'; // white-opacity-50
const BACKGROUND_CONTROL_DISABLED$2 = 'rgba(255, 255, 255, 0.21)'; // white-opacity-30
const BACKGROUND_INPUT$5 = '#131415'; // gray-95
const BACKGROUND_HIGHLIGHT$2 = '#0b3f4b'; // turquoise-95
const BACKGROUND_INTERACTIVE$5 = '#292b2d'; // gray-80
const BACKGROUND_DIALOG$5 = '#1f2123'; // gray-90
const BACKGROUND_DIALOG_OVERLAY$5 = 'rgba(0, 0, 0, 0.7)'; // black-opacity-60
const BACKGROUND_INFO_PRIMARY$5 = '#d8d9db'; // gray-30
const BACKGROUND_INFO_SECONDARY$5 = '#292b2d'; // gray-80
const BACKGROUND_SUCCESS$5 = '#33d59b'; // info-green-40
const BACKGROUND_WARNING$5 = '#feb054'; // info-orange-40
const BACKGROUND_ERROR$5 = '#f5517a'; // red-40
const BACKGROUND_OPINION_ARTICLE$2 = '#3d5483'; // info-deep-blue-60
const BACKGROUND_LIST$2 = '#131415'; // gray-95
const BACKGROUND_DROPDOWN$2 = '#292b2d'; // gray-80
const TEXT_DEFAULT$8 = '#f8f9fa'; // gray-5
const TEXT_NEGATIVE$8 = '#131415'; // gray-95
const TEXT_INPUT_PLACEHOLDER$2 = '#878a8b'; // gray-50
const TEXT_HIGH_EMPHASIS$2 = 'rgba(255, 255, 255, 0.85)'; // white-opacity-70
const TEXT_MEDIUM_EMPHASIS$2 = 'rgba(255, 255, 255, 0.71)'; // white-opacity-60
const TEXT_DISABLED$5 = 'rgba(255, 255, 255, 0.3)'; // white-opacity-40
const TEXT_LIGHT$5 = '#f8f9fa'; // gray-5
const TEXT_DARK$8 = '#131415'; // gray-95
const TEXT_LIGHT_HIGH_CONTRAST$2 = '#ffffff'; // white
const TEXT_FEEDBACK_LIVE$5 = '#ffffff'; // light-high-contrast-text
const ACTION_PRIMARY$5 = '#f8f9fa'; // gray-5
const ACTION_PRIMARY_VARIANT$5 = 'rgba(255, 255, 255, 0.71)'; // white-opacity-60
const ACTION_SECONDARY$5 = 'rgba(255, 255, 255, 0.08)'; // white-opacity-5
const ACTION_SECONDARY_VARIANT$5 = 'rgba(255, 255, 255, 0.17)'; // white-opacity-20
const ACTION_DISABLED$5 = 'rgba(255, 255, 255, 0.21)'; // white-opacity-30
const ACTION_DANGER_PRIMARY$2 = '#f77898'; // red-30
const ACTION_DANGER_PRIMARY_VARIANT$2 = '#f5517a'; // red-40
const ACTION_SELECTED$5 = '#f8f9fa'; // gray-5
const ACTION_UNSELECTED$5 = '#323639'; // gray-70
const BORDER$5 = '#f8f9fa'; // gray-5
const BORDER_DISABLED$5 = 'rgba(255, 255, 255, 0.3)'; // white-opacity-40
const BORDER_PRIMARY_FOCUS$5 = '#29ccde'; // turquoise-40
const BORDER_SECONDARY_FOCUS$2 = '#f8f9fa'; // gray-5
const BORDER_SEPARATOR$5 = 'rgba(255, 255, 255, 0.13)'; // white-opacity-10
const BORDER_NEGATIVE$5 = '#131415'; // background
const ILLUSTRATIVE_ICONS_ICON_PRIMARY$2 = '#f8f9fa'; // gray-5
const ILLUSTRATIVE_ICONS_ICON_SECONDARY$2 = '#009cb5'; // turquoise-60
const PLAYER_PROGRESS_BAR$2 = 'rgba(255, 255, 255, 0.3)'; // white-opacity-40
const PLAYER_PROGRESS_INDICATOR$2 = '#29ccde'; // turquoise-40
const SPINNER_DEFAULT$5 = '#ffffff'; // white
const SPINNER_NEGATIVE$5 = '#131415'; // gray-95
const SPINNER_HIGHLIGHT_DEFAULT$2 = '#29ccde'; // turquoise-40
const SPINNER_HIGHLIGHT_NEGATIVE$2 = '#009cb5'; // turquoise-60
const SPINNER_BACKGROUND_DEFAULT$5 = '#323639'; // gray-70
const SPINNER_BACKGROUND_NEGATIVE$5 = '#d8d9db'; // gray-30
const SPINNER_ERROR$2 = '#f5517a'; // error
const SPINNER_SUCCESS$2 = '#03e592'; // success
const SPINNER_BACKGROUND_ERROR$2 = '#740722'; // red-80
const FEEDBACK_HIGHLIGHT$5 = '#29ccde'; // turquoise-40
const FEEDBACK_ERROR$5 = '#f5517a'; // red-40
const FEEDBACK_WARNING$5 = '#ff9c31'; // orange-40
const FEEDBACK_SUCCESS$5 = '#03e592'; // green-40
const FEEDBACK_LIVE$5 = '#e90e43'; // red-50
const LOGO_YLE_BACKGROUND_BRAND$2 = '#f8f9fa'; // gray-5
const LOGO_TV1$2 = '#3311aa'; // yle-tv-1
const LOGO_TV_2$2 = '#cb0fd0'; // yle-tv-2
const LOGO_YLE_TEEMA$2 = '#fe8300'; // yle-teema
const LOGO_YLE_FEM$2 = '#a3bd2f'; // yle-fem
const LOGO_LASTENAREENA$2 = '#feb500'; // lastenareena
const LOGO_YLE_RADIO_1$2 = '#dc006a'; // yle-radio-1
const LOGO_YLE_RADIO_SUOMI$2 = '#00b9eb'; // yle-radio-suomi-2
const LOGO_YLE_X$2 = '#fd2b77'; // yle-x
const LOGO_YLE_X3M$2 = '#ff4c20'; // yle-x3m
const LOGO_YLE_VEGA$2 = '#169bd4'; // yle-vega
const LOGO_YLE_KLASSINEN$2 = '#0f7b87'; // yle-klassinen
const LOGO_YLE_SAMI_RADIO$2 = '#0049bf'; // yle-sami-radio
const LOGO_AREENA$2 = '#29ccde'; // turquoise-40
const LOGO_YLE_BACKGROUND_DEFAULT$2 = '#f8f9fa'; // default-text
const LOGO_YLE_TEXT$2 = '#131415'; // negative-text
const LOGO_BACKGROUND$2 = '#ffffff'; // white
const LOGO_NEGA$2 = '#ffffff'; // white
const LOGO_TEXT$2 = '#000000'; // black
const BRAND_YLE$2 = '#00b4c8'; // turquoise-50
const TAG_LIVE$5 = '#e90e43'; // red-50
const TAG_DEFAULT$2 = '#ffffff'; // white
const TAG_OPINION$2 = '#3d5483'; // info-deep-blue-60
const TAG_YLE_CORPORATE$2 = '#00809c'; // turquoise-70
const TAG_PRIMARY_ACTION$2 = '#f8f9fa'; // gray-5
const TAG_PRIMARY_ACTION_VARIANT$2 = 'rgba(255, 255, 255, 0.71)'; // white-opacity-60
const TAG_SECONDARY_ACTION$2 = 'rgba(255, 255, 255, 0.13)'; // white-opacity-10
const TAG_SECONDARY_ACTION_VARIANT$2 = 'rgba(255, 255, 255, 0.08)'; // white-opacity-5
const TAG_NEUTRAL$2 = '#323639'; // gray-70
const SHADOW_S$5 = 'rgba(0, 0, 0, 0.7)';
const SHADOW_M$5 = 'rgba(0, 0, 0, 0.7)';
const SHADOW_L$5 = 'rgba(0, 0, 0, 0.87)';
const TIETAJA_BACKGROUND_PLAYER_CARD$5 = 'rgba(0, 0, 0, 0.29)'; // black-opacity-40
const TIETAJA_TEXT_SCORE$5 = '#29ccde'; // highlight
const TIETAJA_BORDER_HIGHLIGHT$5 = '#29ccde'; // highlight

var darkThemeImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACTION_DANGER_PRIMARY: ACTION_DANGER_PRIMARY$2,
  ACTION_DANGER_PRIMARY_VARIANT: ACTION_DANGER_PRIMARY_VARIANT$2,
  ACTION_DISABLED: ACTION_DISABLED$5,
  ACTION_PRIMARY: ACTION_PRIMARY$5,
  ACTION_PRIMARY_VARIANT: ACTION_PRIMARY_VARIANT$5,
  ACTION_SECONDARY: ACTION_SECONDARY$5,
  ACTION_SECONDARY_VARIANT: ACTION_SECONDARY_VARIANT$5,
  ACTION_SELECTED: ACTION_SELECTED$5,
  ACTION_UNSELECTED: ACTION_UNSELECTED$5,
  BACKGROUND: BACKGROUND$8,
  BACKGROUND_CONTROL: BACKGROUND_CONTROL$2,
  BACKGROUND_CONTROL_DISABLED: BACKGROUND_CONTROL_DISABLED$2,
  BACKGROUND_DIALOG: BACKGROUND_DIALOG$5,
  BACKGROUND_DIALOG_OVERLAY: BACKGROUND_DIALOG_OVERLAY$5,
  BACKGROUND_DROPDOWN: BACKGROUND_DROPDOWN$2,
  BACKGROUND_ERROR: BACKGROUND_ERROR$5,
  BACKGROUND_HIGHLIGHT: BACKGROUND_HIGHLIGHT$2,
  BACKGROUND_INFO_PRIMARY: BACKGROUND_INFO_PRIMARY$5,
  BACKGROUND_INFO_SECONDARY: BACKGROUND_INFO_SECONDARY$5,
  BACKGROUND_INPUT: BACKGROUND_INPUT$5,
  BACKGROUND_INTERACTIVE: BACKGROUND_INTERACTIVE$5,
  BACKGROUND_LIST: BACKGROUND_LIST$2,
  BACKGROUND_NAVIGATION: BACKGROUND_NAVIGATION$2,
  BACKGROUND_NEGATIVE: BACKGROUND_NEGATIVE$5,
  BACKGROUND_OPINION_ARTICLE: BACKGROUND_OPINION_ARTICLE$2,
  BACKGROUND_SUCCESS: BACKGROUND_SUCCESS$5,
  BACKGROUND_VARIANT: BACKGROUND_VARIANT$5,
  BACKGROUND_WARNING: BACKGROUND_WARNING$5,
  BORDER: BORDER$5,
  BORDER_DISABLED: BORDER_DISABLED$5,
  BORDER_NEGATIVE: BORDER_NEGATIVE$5,
  BORDER_PRIMARY_FOCUS: BORDER_PRIMARY_FOCUS$5,
  BORDER_SECONDARY_FOCUS: BORDER_SECONDARY_FOCUS$2,
  BORDER_SEPARATOR: BORDER_SEPARATOR$5,
  BRAND_YLE: BRAND_YLE$2,
  FEEDBACK_ERROR: FEEDBACK_ERROR$5,
  FEEDBACK_HIGHLIGHT: FEEDBACK_HIGHLIGHT$5,
  FEEDBACK_LIVE: FEEDBACK_LIVE$5,
  FEEDBACK_SUCCESS: FEEDBACK_SUCCESS$5,
  FEEDBACK_WARNING: FEEDBACK_WARNING$5,
  ILLUSTRATIVE_ICONS_ICON_PRIMARY: ILLUSTRATIVE_ICONS_ICON_PRIMARY$2,
  ILLUSTRATIVE_ICONS_ICON_SECONDARY: ILLUSTRATIVE_ICONS_ICON_SECONDARY$2,
  LOGO_AREENA: LOGO_AREENA$2,
  LOGO_BACKGROUND: LOGO_BACKGROUND$2,
  LOGO_LASTENAREENA: LOGO_LASTENAREENA$2,
  LOGO_NEGA: LOGO_NEGA$2,
  LOGO_TEXT: LOGO_TEXT$2,
  LOGO_TV1: LOGO_TV1$2,
  LOGO_TV_2: LOGO_TV_2$2,
  LOGO_YLE_BACKGROUND_BRAND: LOGO_YLE_BACKGROUND_BRAND$2,
  LOGO_YLE_BACKGROUND_DEFAULT: LOGO_YLE_BACKGROUND_DEFAULT$2,
  LOGO_YLE_FEM: LOGO_YLE_FEM$2,
  LOGO_YLE_KLASSINEN: LOGO_YLE_KLASSINEN$2,
  LOGO_YLE_RADIO_1: LOGO_YLE_RADIO_1$2,
  LOGO_YLE_RADIO_SUOMI: LOGO_YLE_RADIO_SUOMI$2,
  LOGO_YLE_SAMI_RADIO: LOGO_YLE_SAMI_RADIO$2,
  LOGO_YLE_TEEMA: LOGO_YLE_TEEMA$2,
  LOGO_YLE_TEXT: LOGO_YLE_TEXT$2,
  LOGO_YLE_VEGA: LOGO_YLE_VEGA$2,
  LOGO_YLE_X: LOGO_YLE_X$2,
  LOGO_YLE_X3M: LOGO_YLE_X3M$2,
  PLAYER_PROGRESS_BAR: PLAYER_PROGRESS_BAR$2,
  PLAYER_PROGRESS_INDICATOR: PLAYER_PROGRESS_INDICATOR$2,
  SHADOW_L: SHADOW_L$5,
  SHADOW_M: SHADOW_M$5,
  SHADOW_S: SHADOW_S$5,
  SPINNER_BACKGROUND_DEFAULT: SPINNER_BACKGROUND_DEFAULT$5,
  SPINNER_BACKGROUND_ERROR: SPINNER_BACKGROUND_ERROR$2,
  SPINNER_BACKGROUND_NEGATIVE: SPINNER_BACKGROUND_NEGATIVE$5,
  SPINNER_DEFAULT: SPINNER_DEFAULT$5,
  SPINNER_ERROR: SPINNER_ERROR$2,
  SPINNER_HIGHLIGHT_DEFAULT: SPINNER_HIGHLIGHT_DEFAULT$2,
  SPINNER_HIGHLIGHT_NEGATIVE: SPINNER_HIGHLIGHT_NEGATIVE$2,
  SPINNER_NEGATIVE: SPINNER_NEGATIVE$5,
  SPINNER_SUCCESS: SPINNER_SUCCESS$2,
  TAG_DEFAULT: TAG_DEFAULT$2,
  TAG_LIVE: TAG_LIVE$5,
  TAG_NEUTRAL: TAG_NEUTRAL$2,
  TAG_OPINION: TAG_OPINION$2,
  TAG_PRIMARY_ACTION: TAG_PRIMARY_ACTION$2,
  TAG_PRIMARY_ACTION_VARIANT: TAG_PRIMARY_ACTION_VARIANT$2,
  TAG_SECONDARY_ACTION: TAG_SECONDARY_ACTION$2,
  TAG_SECONDARY_ACTION_VARIANT: TAG_SECONDARY_ACTION_VARIANT$2,
  TAG_YLE_CORPORATE: TAG_YLE_CORPORATE$2,
  TEXT_DARK: TEXT_DARK$8,
  TEXT_DEFAULT: TEXT_DEFAULT$8,
  TEXT_DISABLED: TEXT_DISABLED$5,
  TEXT_FEEDBACK_LIVE: TEXT_FEEDBACK_LIVE$5,
  TEXT_HIGH_EMPHASIS: TEXT_HIGH_EMPHASIS$2,
  TEXT_INPUT_PLACEHOLDER: TEXT_INPUT_PLACEHOLDER$2,
  TEXT_LIGHT: TEXT_LIGHT$5,
  TEXT_LIGHT_HIGH_CONTRAST: TEXT_LIGHT_HIGH_CONTRAST$2,
  TEXT_MEDIUM_EMPHASIS: TEXT_MEDIUM_EMPHASIS$2,
  TEXT_NEGATIVE: TEXT_NEGATIVE$8,
  TIETAJA_BACKGROUND_PLAYER_CARD: TIETAJA_BACKGROUND_PLAYER_CARD$5,
  TIETAJA_BORDER_HIGHLIGHT: TIETAJA_BORDER_HIGHLIGHT$5,
  TIETAJA_TEXT_SCORE: TIETAJA_TEXT_SCORE$5
});

/**
 * Yle Design System
 * v2.x.x
 */

const BACKGROUND$7 = 'var(--yds-color-background, #ffffff)'; // white
const BACKGROUND_VARIANT$4 = 'var(--yds-color-background-variant, #f8f9fa)'; // gray-5
const BACKGROUND_NEGATIVE$4 = 'var(--yds-color-background-negative, #131415)'; // gray-95
const BACKGROUND_NAVIGATION$1 = 'var(--yds-color-background-navigation, #ffffff)'; // white
const BACKGROUND_CONTROL$1 = 'var(--yds-color-background-control, rgba(0, 0, 0, 0.47))'; // black-opacity-50
const BACKGROUND_CONTROL_DISABLED$1 =
  'var(--yds-color-background-control-disabled, rgba(0, 0, 0, 0.15))'; // black-opacity-30
const BACKGROUND_INPUT$4 = 'var(--yds-color-background-input, #ffffff)'; // white
const BACKGROUND_HIGHLIGHT$1 = 'var(--yds-color-background-highlight, #e8e9eb)'; // gray-20
const BACKGROUND_INTERACTIVE$4 = 'var(--yds-color-background-interactive, #f1f2f4)'; // gray-10
const BACKGROUND_DIALOG$4 = 'var(--yds-color-background-dialog, #ffffff)'; // white
const BACKGROUND_DIALOG_OVERLAY$4 =
  'var(--yds-color-background-dialog-overlay, rgba(0, 0, 0, 0.47))'; // black-opacity-50
const BACKGROUND_INFO_PRIMARY$4 = 'var(--yds-color-background-info-primary, #9fc8ee)'; // blue-20
const BACKGROUND_INFO_SECONDARY$4 = 'var(--yds-color-background-info-secondary, #f1f2f4)'; // gray-10
const BACKGROUND_SUCCESS$4 = 'var(--yds-color-background-success, #62f9c2)'; // green-20
const BACKGROUND_WARNING$4 = 'var(--yds-color-background-warning, #ffd199)'; // info-orange-20
const BACKGROUND_ERROR$4 = 'var(--yds-color-background-error, #f99fb5)'; // red-20
const BACKGROUND_OPINION_ARTICLE$1 = 'var(--yds-color-background-opinion-article, #3d5483)'; // info-deep-blue-60
const BACKGROUND_LIST$1 = 'var(--yds-color-background-list, #f8f9fa)'; // gray-5
const BACKGROUND_DROPDOWN$1 = 'var(--yds-color-background-dropdown, #f8f9fa)'; // gray-5
const TEXT_DEFAULT$7 = 'var(--yds-color-text-default, #131415)'; // gray-95
const TEXT_NEGATIVE$7 = 'var(--yds-color-text-negative, #f8f9fa)'; // gray-5
const TEXT_INPUT_PLACEHOLDER$1 = 'var(--yds-color-text-input-placeholder, #4a4f54)'; // gray-60
const TEXT_HIGH_EMPHASIS$1 = 'var(--yds-color-text-high-emphasis, rgba(0, 0, 0, 0.79))'; // black-opacity-70
const TEXT_MEDIUM_EMPHASIS$1 = 'var(--yds-color-text-medium-emphasis, rgba(0, 0, 0, 0.7))'; // black-opacity-60
const TEXT_DISABLED$4 = 'var(--yds-color-text-disabled, rgba(0, 0, 0, 0.29))'; // black-opacity-40
const TEXT_LIGHT$4 = 'var(--yds-color-text-light, #f8f9fa)'; // gray-5
const TEXT_DARK$7 = 'var(--yds-color-text-dark, #131415)'; // gray-95
const TEXT_LIGHT_HIGH_CONTRAST$1 = 'var(--yds-color-text-light-high-contrast, #ffffff)'; // white
const TEXT_FEEDBACK_LIVE$4 = 'var(--yds-color-text-feedback-live, #ffffff)'; // light-high-contrast-text
const ACTION_PRIMARY$4 = 'var(--yds-color-action-primary, #131415)'; // gray-95
const ACTION_PRIMARY_VARIANT$4 = 'var(--yds-color-action-primary-variant, rgba(0, 0, 0, 0.7))'; // black-opacity-60
const ACTION_SECONDARY$4 = 'var(--yds-color-action-secondary, rgba(0, 0, 0, 0.05))'; // black-opacity-10
const ACTION_SECONDARY_VARIANT$4 =
  'var(--yds-color-action-secondary-variant, rgba(0, 0, 0, 0.09))'; // black-opacity-20
const ACTION_DISABLED$4 = 'var(--yds-color-action-disabled, rgba(0, 0, 0, 0.15))'; // black-opacity-30
const ACTION_DANGER_PRIMARY$1 = 'var(--yds-color-action-danger-primary, #d10b3d)'; // red-60
const ACTION_DANGER_PRIMARY_VARIANT$1 =
  'var(--yds-color-action-danger-primary-variant, #e90e43)'; // red-50
const ACTION_SELECTED$4 = 'var(--yds-color-action-selected, #131415)'; // gray-95
const ACTION_UNSELECTED$4 = 'var(--yds-color-action-unselected, #e8e9eb)'; // gray-20
const BORDER$4 = 'var(--yds-color-border, #131415)'; // gray-95
const BORDER_DISABLED$4 = 'var(--yds-color-border-disabled, rgba(0, 0, 0, 0.29))'; // black-opacity-40
const BORDER_PRIMARY_FOCUS$4 = 'var(--yds-color-border-primary-focus, #009cb5)'; // turquoise-60
const BORDER_SECONDARY_FOCUS$1 = 'var(--yds-color-border-secondary-focus, #131415)'; // gray-95
const BORDER_SEPARATOR$4 = 'var(--yds-color-border-separator, rgba(0, 0, 0, 0.09))'; // black-opacity-20
const BORDER_NEGATIVE$4 = 'var(--yds-color-border-negative, #ffffff)'; // background
const ILLUSTRATIVE_ICONS_ICON_PRIMARY$1 =
  'var(--yds-color-illustrative-icons-icon-primary, #131415)'; // gray-95
const ILLUSTRATIVE_ICONS_ICON_SECONDARY$1 =
  'var(--yds-color-illustrative-icons-icon-secondary, #5ddbe9)'; // turquoise-30
const PLAYER_PROGRESS_BAR$1 = 'var(--yds-color-player-progress-bar, rgba(255, 255, 255, 0.3))'; // white-opacity-40
const PLAYER_PROGRESS_INDICATOR$1 = 'var(--yds-color-player-progress-indicator, #29ccde)'; // turquoise-40
const SPINNER_DEFAULT$4 = 'var(--yds-color-spinner-default, #131415)'; // gray-95
const SPINNER_NEGATIVE$4 = 'var(--yds-color-spinner-negative, #ffffff)'; // white
const SPINNER_HIGHLIGHT_DEFAULT$1 = 'var(--yds-color-spinner-highlight-default, #009cb5)'; // turquoise-60
const SPINNER_HIGHLIGHT_NEGATIVE$1 = 'var(--yds-color-spinner-highlight-negative, #29ccde)'; // turquoise-40
const SPINNER_BACKGROUND_DEFAULT$4 = 'var(--yds-color-spinner-background-default, #d8d9db)'; // gray-30
const SPINNER_BACKGROUND_NEGATIVE$4 = 'var(--yds-color-spinner-background-negative, #323639)'; // gray-70
const SPINNER_ERROR$1 = 'var(--yds-color-spinner-error, #d10b3d)'; // error
const SPINNER_SUCCESS$1 = 'var(--yds-color-spinner-success, #058657)'; // success
const SPINNER_BACKGROUND_ERROR$1 = 'var(--yds-color-spinner-background-error, #fcc5d3)'; // red-10
const FEEDBACK_HIGHLIGHT$4 = 'var(--yds-color-feedback-highlight, #009cb5)'; // turquoise-60
const FEEDBACK_ERROR$4 = 'var(--yds-color-feedback-error, #d10b3d)'; // red-60
const FEEDBACK_WARNING$4 = 'var(--yds-color-feedback-warning, #f1722a)'; // orange-60
const FEEDBACK_SUCCESS$4 = 'var(--yds-color-feedback-success, #058657)'; // green-70
const FEEDBACK_LIVE$4 = 'var(--yds-color-feedback-live, #e90e43)'; // red-50
const LOGO_YLE_BACKGROUND_BRAND$1 = 'var(--yds-color-logo-yle-background-brand, #00b4c8)'; // turquoise-50
const LOGO_TV1$1 = 'var(--yds-color-logo-tv1, #3311aa)'; // yle-tv-1
const LOGO_TV_2$1 = 'var(--yds-color-logo-tv-2, #cb0fd0)'; // yle-tv-2
const LOGO_YLE_TEEMA$1 = 'var(--yds-color-logo-yle-teema, #fe8300)'; // yle-teema
const LOGO_YLE_FEM$1 = 'var(--yds-color-logo-yle-fem, #a3bd2f)'; // yle-fem
const LOGO_LASTENAREENA$1 = 'var(--yds-color-logo-lastenareena, #feb500)'; // lastenareena
const LOGO_YLE_RADIO_1$1 = 'var(--yds-color-logo-yle-radio-1, #dc006a)'; // yle-radio-1
const LOGO_YLE_RADIO_SUOMI$1 = 'var(--yds-color-logo-yle-radio-suomi, #0000e6)'; // yle-radio-suomi
const LOGO_YLE_X$1 = 'var(--yds-color-logo-yle-x, #fd2b77)'; // yle-x
const LOGO_YLE_X3M$1 = 'var(--yds-color-logo-yle-x3-m, #ff4c20)'; // yle-x3m
const LOGO_YLE_VEGA$1 = 'var(--yds-color-logo-yle-vega, #169bd4)'; // yle-vega
const LOGO_YLE_KLASSINEN$1 = 'var(--yds-color-logo-yle-klassinen, #0f7b87)'; // yle-klassinen
const LOGO_YLE_SAMI_RADIO$1 = 'var(--yds-color-logo-yle-sami-radio, #0049bf)'; // yle-sami-radio
const LOGO_AREENA$1 = 'var(--yds-color-logo-areena, #29ccde)'; // turquoise-40
const LOGO_YLE_BACKGROUND_DEFAULT$1 = 'var(--yds-color-logo-yle-background-default, #131415)'; // default-text
const LOGO_YLE_TEXT$1 = 'var(--yds-color-logo-yle-text, #f8f9fa)'; // negative-text
const LOGO_BACKGROUND$1 = 'var(--yds-color-logo-background, #000000)'; // black
const LOGO_NEGA$1 = 'var(--yds-color-logo-nega, #ffffff)'; // white
const LOGO_TEXT$1 = 'var(--yds-color-logo-text, #ffffff)'; // white
const BRAND_YLE$1 = 'var(--yds-color-brand-yle, #00b4c8)'; // turquoise-50
const TAG_LIVE$4 = 'var(--yds-color-tag-live, #e90e43)'; // red-50
const TAG_DEFAULT$1 = 'var(--yds-color-tag-default, #131415)'; // gray-95
const TAG_OPINION$1 = 'var(--yds-color-tag-opinion, #3d5483)'; // info-deep-blue-60
const TAG_YLE_CORPORATE$1 = 'var(--yds-color-tag-yle-corporate, #00809c)'; // turquoise-70
const TAG_PRIMARY_ACTION$1 = 'var(--yds-color-tag-primary-action, #131415)'; // gray-95
const TAG_PRIMARY_ACTION_VARIANT$1 =
  'var(--yds-color-tag-primary-action-variant, rgba(0, 0, 0, 0.7))'; // black-opacity-60
const TAG_SECONDARY_ACTION$1 = 'var(--yds-color-tag-secondary-action, rgba(0, 0, 0, 0.05))'; // black-opacity-10
const TAG_SECONDARY_ACTION_VARIANT$1 =
  'var(--yds-color-tag-secondary-action-variant, rgba(0, 0, 0, 0.02))'; // black-opacity-5
const TAG_NEUTRAL$1 = 'var(--yds-color-tag-neutral, #e8e9eb)'; // gray-20
const SHADOW_S$4 = 'var(--yds-color-shadow-s, rgba(0, 0, 0, 0.15))';
const SHADOW_M$4 = 'var(--yds-color-shadow-m, rgba(0, 0, 0, 0.15))';
const SHADOW_L$4 = 'var(--yds-color-shadow-l, rgba(0, 0, 0, 0.41))';
const TIETAJA_BACKGROUND_PLAYER_CARD$4 =
  'var(--yds-color-tietaja-background-player-card, rgba(0, 0, 0, 0.15))'; // black-opacity-30
const TIETAJA_TEXT_SCORE$4 = 'var(--yds-color-tietaja-text-score, #009cb5)'; // highlight
const TIETAJA_BORDER_HIGHLIGHT$4 = 'var(--yds-color-tietaja-border-highlight, #009cb5)'; // highlight

var themeDefault = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACTION_DANGER_PRIMARY: ACTION_DANGER_PRIMARY$1,
  ACTION_DANGER_PRIMARY_VARIANT: ACTION_DANGER_PRIMARY_VARIANT$1,
  ACTION_DISABLED: ACTION_DISABLED$4,
  ACTION_PRIMARY: ACTION_PRIMARY$4,
  ACTION_PRIMARY_VARIANT: ACTION_PRIMARY_VARIANT$4,
  ACTION_SECONDARY: ACTION_SECONDARY$4,
  ACTION_SECONDARY_VARIANT: ACTION_SECONDARY_VARIANT$4,
  ACTION_SELECTED: ACTION_SELECTED$4,
  ACTION_UNSELECTED: ACTION_UNSELECTED$4,
  BACKGROUND: BACKGROUND$7,
  BACKGROUND_CONTROL: BACKGROUND_CONTROL$1,
  BACKGROUND_CONTROL_DISABLED: BACKGROUND_CONTROL_DISABLED$1,
  BACKGROUND_DIALOG: BACKGROUND_DIALOG$4,
  BACKGROUND_DIALOG_OVERLAY: BACKGROUND_DIALOG_OVERLAY$4,
  BACKGROUND_DROPDOWN: BACKGROUND_DROPDOWN$1,
  BACKGROUND_ERROR: BACKGROUND_ERROR$4,
  BACKGROUND_HIGHLIGHT: BACKGROUND_HIGHLIGHT$1,
  BACKGROUND_INFO_PRIMARY: BACKGROUND_INFO_PRIMARY$4,
  BACKGROUND_INFO_SECONDARY: BACKGROUND_INFO_SECONDARY$4,
  BACKGROUND_INPUT: BACKGROUND_INPUT$4,
  BACKGROUND_INTERACTIVE: BACKGROUND_INTERACTIVE$4,
  BACKGROUND_LIST: BACKGROUND_LIST$1,
  BACKGROUND_NAVIGATION: BACKGROUND_NAVIGATION$1,
  BACKGROUND_NEGATIVE: BACKGROUND_NEGATIVE$4,
  BACKGROUND_OPINION_ARTICLE: BACKGROUND_OPINION_ARTICLE$1,
  BACKGROUND_SUCCESS: BACKGROUND_SUCCESS$4,
  BACKGROUND_VARIANT: BACKGROUND_VARIANT$4,
  BACKGROUND_WARNING: BACKGROUND_WARNING$4,
  BORDER: BORDER$4,
  BORDER_DISABLED: BORDER_DISABLED$4,
  BORDER_NEGATIVE: BORDER_NEGATIVE$4,
  BORDER_PRIMARY_FOCUS: BORDER_PRIMARY_FOCUS$4,
  BORDER_SECONDARY_FOCUS: BORDER_SECONDARY_FOCUS$1,
  BORDER_SEPARATOR: BORDER_SEPARATOR$4,
  BRAND_YLE: BRAND_YLE$1,
  FEEDBACK_ERROR: FEEDBACK_ERROR$4,
  FEEDBACK_HIGHLIGHT: FEEDBACK_HIGHLIGHT$4,
  FEEDBACK_LIVE: FEEDBACK_LIVE$4,
  FEEDBACK_SUCCESS: FEEDBACK_SUCCESS$4,
  FEEDBACK_WARNING: FEEDBACK_WARNING$4,
  ILLUSTRATIVE_ICONS_ICON_PRIMARY: ILLUSTRATIVE_ICONS_ICON_PRIMARY$1,
  ILLUSTRATIVE_ICONS_ICON_SECONDARY: ILLUSTRATIVE_ICONS_ICON_SECONDARY$1,
  LOGO_AREENA: LOGO_AREENA$1,
  LOGO_BACKGROUND: LOGO_BACKGROUND$1,
  LOGO_LASTENAREENA: LOGO_LASTENAREENA$1,
  LOGO_NEGA: LOGO_NEGA$1,
  LOGO_TEXT: LOGO_TEXT$1,
  LOGO_TV1: LOGO_TV1$1,
  LOGO_TV_2: LOGO_TV_2$1,
  LOGO_YLE_BACKGROUND_BRAND: LOGO_YLE_BACKGROUND_BRAND$1,
  LOGO_YLE_BACKGROUND_DEFAULT: LOGO_YLE_BACKGROUND_DEFAULT$1,
  LOGO_YLE_FEM: LOGO_YLE_FEM$1,
  LOGO_YLE_KLASSINEN: LOGO_YLE_KLASSINEN$1,
  LOGO_YLE_RADIO_1: LOGO_YLE_RADIO_1$1,
  LOGO_YLE_RADIO_SUOMI: LOGO_YLE_RADIO_SUOMI$1,
  LOGO_YLE_SAMI_RADIO: LOGO_YLE_SAMI_RADIO$1,
  LOGO_YLE_TEEMA: LOGO_YLE_TEEMA$1,
  LOGO_YLE_TEXT: LOGO_YLE_TEXT$1,
  LOGO_YLE_VEGA: LOGO_YLE_VEGA$1,
  LOGO_YLE_X: LOGO_YLE_X$1,
  LOGO_YLE_X3M: LOGO_YLE_X3M$1,
  PLAYER_PROGRESS_BAR: PLAYER_PROGRESS_BAR$1,
  PLAYER_PROGRESS_INDICATOR: PLAYER_PROGRESS_INDICATOR$1,
  SHADOW_L: SHADOW_L$4,
  SHADOW_M: SHADOW_M$4,
  SHADOW_S: SHADOW_S$4,
  SPINNER_BACKGROUND_DEFAULT: SPINNER_BACKGROUND_DEFAULT$4,
  SPINNER_BACKGROUND_ERROR: SPINNER_BACKGROUND_ERROR$1,
  SPINNER_BACKGROUND_NEGATIVE: SPINNER_BACKGROUND_NEGATIVE$4,
  SPINNER_DEFAULT: SPINNER_DEFAULT$4,
  SPINNER_ERROR: SPINNER_ERROR$1,
  SPINNER_HIGHLIGHT_DEFAULT: SPINNER_HIGHLIGHT_DEFAULT$1,
  SPINNER_HIGHLIGHT_NEGATIVE: SPINNER_HIGHLIGHT_NEGATIVE$1,
  SPINNER_NEGATIVE: SPINNER_NEGATIVE$4,
  SPINNER_SUCCESS: SPINNER_SUCCESS$1,
  TAG_DEFAULT: TAG_DEFAULT$1,
  TAG_LIVE: TAG_LIVE$4,
  TAG_NEUTRAL: TAG_NEUTRAL$1,
  TAG_OPINION: TAG_OPINION$1,
  TAG_PRIMARY_ACTION: TAG_PRIMARY_ACTION$1,
  TAG_PRIMARY_ACTION_VARIANT: TAG_PRIMARY_ACTION_VARIANT$1,
  TAG_SECONDARY_ACTION: TAG_SECONDARY_ACTION$1,
  TAG_SECONDARY_ACTION_VARIANT: TAG_SECONDARY_ACTION_VARIANT$1,
  TAG_YLE_CORPORATE: TAG_YLE_CORPORATE$1,
  TEXT_DARK: TEXT_DARK$7,
  TEXT_DEFAULT: TEXT_DEFAULT$7,
  TEXT_DISABLED: TEXT_DISABLED$4,
  TEXT_FEEDBACK_LIVE: TEXT_FEEDBACK_LIVE$4,
  TEXT_HIGH_EMPHASIS: TEXT_HIGH_EMPHASIS$1,
  TEXT_INPUT_PLACEHOLDER: TEXT_INPUT_PLACEHOLDER$1,
  TEXT_LIGHT: TEXT_LIGHT$4,
  TEXT_LIGHT_HIGH_CONTRAST: TEXT_LIGHT_HIGH_CONTRAST$1,
  TEXT_MEDIUM_EMPHASIS: TEXT_MEDIUM_EMPHASIS$1,
  TEXT_NEGATIVE: TEXT_NEGATIVE$7,
  TIETAJA_BACKGROUND_PLAYER_CARD: TIETAJA_BACKGROUND_PLAYER_CARD$4,
  TIETAJA_BORDER_HIGHLIGHT: TIETAJA_BORDER_HIGHLIGHT$4,
  TIETAJA_TEXT_SCORE: TIETAJA_TEXT_SCORE$4
});

/**
 * Yle Design System
 * v2.x.x
 */

const BACKGROUND$6 = '#ffffff'; // white
const BACKGROUND_VARIANT$3 = '#f8f9fa'; // gray-5
const BACKGROUND_NEGATIVE$3 = '#131415'; // gray-95
const BACKGROUND_NAVIGATION = '#ffffff'; // white
const BACKGROUND_CONTROL = 'rgba(0, 0, 0, 0.47)'; // black-opacity-50
const BACKGROUND_CONTROL_DISABLED = 'rgba(0, 0, 0, 0.15)'; // black-opacity-30
const BACKGROUND_INPUT$3 = '#ffffff'; // white
const BACKGROUND_HIGHLIGHT = '#e8e9eb'; // gray-20
const BACKGROUND_INTERACTIVE$3 = '#f1f2f4'; // gray-10
const BACKGROUND_DIALOG$3 = '#ffffff'; // white
const BACKGROUND_DIALOG_OVERLAY$3 = 'rgba(0, 0, 0, 0.47)'; // black-opacity-50
const BACKGROUND_INFO_PRIMARY$3 = '#9fc8ee'; // blue-20
const BACKGROUND_INFO_SECONDARY$3 = '#f1f2f4'; // gray-10
const BACKGROUND_SUCCESS$3 = '#62f9c2'; // green-20
const BACKGROUND_WARNING$3 = '#ffd199'; // info-orange-20
const BACKGROUND_ERROR$3 = '#f99fb5'; // red-20
const BACKGROUND_OPINION_ARTICLE = '#3d5483'; // info-deep-blue-60
const BACKGROUND_LIST = '#f8f9fa'; // gray-5
const BACKGROUND_DROPDOWN = '#f8f9fa'; // gray-5
const TEXT_DEFAULT$6 = '#131415'; // gray-95
const TEXT_NEGATIVE$6 = '#f8f9fa'; // gray-5
const TEXT_INPUT_PLACEHOLDER = '#4a4f54'; // gray-60
const TEXT_HIGH_EMPHASIS = 'rgba(0, 0, 0, 0.79)'; // black-opacity-70
const TEXT_MEDIUM_EMPHASIS = 'rgba(0, 0, 0, 0.7)'; // black-opacity-60
const TEXT_DISABLED$3 = 'rgba(0, 0, 0, 0.29)'; // black-opacity-40
const TEXT_LIGHT$3 = '#f8f9fa'; // gray-5
const TEXT_DARK$6 = '#131415'; // gray-95
const TEXT_LIGHT_HIGH_CONTRAST = '#ffffff'; // white
const TEXT_FEEDBACK_LIVE$3 = '#ffffff'; // light-high-contrast-text
const ACTION_PRIMARY$3 = '#131415'; // gray-95
const ACTION_PRIMARY_VARIANT$3 = 'rgba(0, 0, 0, 0.7)'; // black-opacity-60
const ACTION_SECONDARY$3 = 'rgba(0, 0, 0, 0.05)'; // black-opacity-10
const ACTION_SECONDARY_VARIANT$3 = 'rgba(0, 0, 0, 0.09)'; // black-opacity-20
const ACTION_DISABLED$3 = 'rgba(0, 0, 0, 0.15)'; // black-opacity-30
const ACTION_DANGER_PRIMARY = '#d10b3d'; // red-60
const ACTION_DANGER_PRIMARY_VARIANT = '#e90e43'; // red-50
const ACTION_SELECTED$3 = '#131415'; // gray-95
const ACTION_UNSELECTED$3 = '#e8e9eb'; // gray-20
const BORDER$3 = '#131415'; // gray-95
const BORDER_DISABLED$3 = 'rgba(0, 0, 0, 0.29)'; // black-opacity-40
const BORDER_PRIMARY_FOCUS$3 = '#009cb5'; // turquoise-60
const BORDER_SECONDARY_FOCUS = '#131415'; // gray-95
const BORDER_SEPARATOR$3 = 'rgba(0, 0, 0, 0.09)'; // black-opacity-20
const BORDER_NEGATIVE$3 = '#ffffff'; // background
const ILLUSTRATIVE_ICONS_ICON_PRIMARY = '#131415'; // gray-95
const ILLUSTRATIVE_ICONS_ICON_SECONDARY = '#5ddbe9'; // turquoise-30
const PLAYER_PROGRESS_BAR = 'rgba(255, 255, 255, 0.3)'; // white-opacity-40
const PLAYER_PROGRESS_INDICATOR = '#29ccde'; // turquoise-40
const SPINNER_DEFAULT$3 = '#131415'; // gray-95
const SPINNER_NEGATIVE$3 = '#ffffff'; // white
const SPINNER_HIGHLIGHT_DEFAULT = '#009cb5'; // turquoise-60
const SPINNER_HIGHLIGHT_NEGATIVE = '#29ccde'; // turquoise-40
const SPINNER_BACKGROUND_DEFAULT$3 = '#d8d9db'; // gray-30
const SPINNER_BACKGROUND_NEGATIVE$3 = '#323639'; // gray-70
const SPINNER_ERROR = '#d10b3d'; // error
const SPINNER_SUCCESS = '#058657'; // success
const SPINNER_BACKGROUND_ERROR = '#fcc5d3'; // red-10
const FEEDBACK_HIGHLIGHT$3 = '#009cb5'; // turquoise-60
const FEEDBACK_ERROR$3 = '#d10b3d'; // red-60
const FEEDBACK_WARNING$3 = '#f1722a'; // orange-60
const FEEDBACK_SUCCESS$3 = '#058657'; // green-70
const FEEDBACK_LIVE$3 = '#e90e43'; // red-50
const LOGO_YLE_BACKGROUND_BRAND = '#00b4c8'; // turquoise-50
const LOGO_TV1 = '#3311aa'; // yle-tv-1
const LOGO_TV_2 = '#cb0fd0'; // yle-tv-2
const LOGO_YLE_TEEMA = '#fe8300'; // yle-teema
const LOGO_YLE_FEM = '#a3bd2f'; // yle-fem
const LOGO_LASTENAREENA = '#feb500'; // lastenareena
const LOGO_YLE_RADIO_1 = '#dc006a'; // yle-radio-1
const LOGO_YLE_RADIO_SUOMI = '#0000e6'; // yle-radio-suomi
const LOGO_YLE_X = '#fd2b77'; // yle-x
const LOGO_YLE_X3M = '#ff4c20'; // yle-x3m
const LOGO_YLE_VEGA = '#169bd4'; // yle-vega
const LOGO_YLE_KLASSINEN = '#0f7b87'; // yle-klassinen
const LOGO_YLE_SAMI_RADIO = '#0049bf'; // yle-sami-radio
const LOGO_AREENA = '#29ccde'; // turquoise-40
const LOGO_YLE_BACKGROUND_DEFAULT = '#131415'; // default-text
const LOGO_YLE_TEXT = '#f8f9fa'; // negative-text
const LOGO_BACKGROUND = '#000000'; // black
const LOGO_NEGA = '#ffffff'; // white
const LOGO_TEXT = '#ffffff'; // white
const BRAND_YLE = '#00b4c8'; // turquoise-50
const TAG_LIVE$3 = '#e90e43'; // red-50
const TAG_DEFAULT = '#131415'; // gray-95
const TAG_OPINION = '#3d5483'; // info-deep-blue-60
const TAG_YLE_CORPORATE = '#00809c'; // turquoise-70
const TAG_PRIMARY_ACTION = '#131415'; // gray-95
const TAG_PRIMARY_ACTION_VARIANT = 'rgba(0, 0, 0, 0.7)'; // black-opacity-60
const TAG_SECONDARY_ACTION = 'rgba(0, 0, 0, 0.05)'; // black-opacity-10
const TAG_SECONDARY_ACTION_VARIANT = 'rgba(0, 0, 0, 0.02)'; // black-opacity-5
const TAG_NEUTRAL = '#e8e9eb'; // gray-20
const SHADOW_S$3 = 'rgba(0, 0, 0, 0.15)';
const SHADOW_M$3 = 'rgba(0, 0, 0, 0.15)';
const SHADOW_L$3 = 'rgba(0, 0, 0, 0.41)';
const TIETAJA_BACKGROUND_PLAYER_CARD$3 = 'rgba(0, 0, 0, 0.15)'; // black-opacity-30
const TIETAJA_TEXT_SCORE$3 = '#009cb5'; // highlight
const TIETAJA_BORDER_HIGHLIGHT$3 = '#009cb5'; // highlight

var themeLight = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACTION_DANGER_PRIMARY: ACTION_DANGER_PRIMARY,
  ACTION_DANGER_PRIMARY_VARIANT: ACTION_DANGER_PRIMARY_VARIANT,
  ACTION_DISABLED: ACTION_DISABLED$3,
  ACTION_PRIMARY: ACTION_PRIMARY$3,
  ACTION_PRIMARY_VARIANT: ACTION_PRIMARY_VARIANT$3,
  ACTION_SECONDARY: ACTION_SECONDARY$3,
  ACTION_SECONDARY_VARIANT: ACTION_SECONDARY_VARIANT$3,
  ACTION_SELECTED: ACTION_SELECTED$3,
  ACTION_UNSELECTED: ACTION_UNSELECTED$3,
  BACKGROUND: BACKGROUND$6,
  BACKGROUND_CONTROL: BACKGROUND_CONTROL,
  BACKGROUND_CONTROL_DISABLED: BACKGROUND_CONTROL_DISABLED,
  BACKGROUND_DIALOG: BACKGROUND_DIALOG$3,
  BACKGROUND_DIALOG_OVERLAY: BACKGROUND_DIALOG_OVERLAY$3,
  BACKGROUND_DROPDOWN: BACKGROUND_DROPDOWN,
  BACKGROUND_ERROR: BACKGROUND_ERROR$3,
  BACKGROUND_HIGHLIGHT: BACKGROUND_HIGHLIGHT,
  BACKGROUND_INFO_PRIMARY: BACKGROUND_INFO_PRIMARY$3,
  BACKGROUND_INFO_SECONDARY: BACKGROUND_INFO_SECONDARY$3,
  BACKGROUND_INPUT: BACKGROUND_INPUT$3,
  BACKGROUND_INTERACTIVE: BACKGROUND_INTERACTIVE$3,
  BACKGROUND_LIST: BACKGROUND_LIST,
  BACKGROUND_NAVIGATION: BACKGROUND_NAVIGATION,
  BACKGROUND_NEGATIVE: BACKGROUND_NEGATIVE$3,
  BACKGROUND_OPINION_ARTICLE: BACKGROUND_OPINION_ARTICLE,
  BACKGROUND_SUCCESS: BACKGROUND_SUCCESS$3,
  BACKGROUND_VARIANT: BACKGROUND_VARIANT$3,
  BACKGROUND_WARNING: BACKGROUND_WARNING$3,
  BORDER: BORDER$3,
  BORDER_DISABLED: BORDER_DISABLED$3,
  BORDER_NEGATIVE: BORDER_NEGATIVE$3,
  BORDER_PRIMARY_FOCUS: BORDER_PRIMARY_FOCUS$3,
  BORDER_SECONDARY_FOCUS: BORDER_SECONDARY_FOCUS,
  BORDER_SEPARATOR: BORDER_SEPARATOR$3,
  BRAND_YLE: BRAND_YLE,
  FEEDBACK_ERROR: FEEDBACK_ERROR$3,
  FEEDBACK_HIGHLIGHT: FEEDBACK_HIGHLIGHT$3,
  FEEDBACK_LIVE: FEEDBACK_LIVE$3,
  FEEDBACK_SUCCESS: FEEDBACK_SUCCESS$3,
  FEEDBACK_WARNING: FEEDBACK_WARNING$3,
  ILLUSTRATIVE_ICONS_ICON_PRIMARY: ILLUSTRATIVE_ICONS_ICON_PRIMARY,
  ILLUSTRATIVE_ICONS_ICON_SECONDARY: ILLUSTRATIVE_ICONS_ICON_SECONDARY,
  LOGO_AREENA: LOGO_AREENA,
  LOGO_BACKGROUND: LOGO_BACKGROUND,
  LOGO_LASTENAREENA: LOGO_LASTENAREENA,
  LOGO_NEGA: LOGO_NEGA,
  LOGO_TEXT: LOGO_TEXT,
  LOGO_TV1: LOGO_TV1,
  LOGO_TV_2: LOGO_TV_2,
  LOGO_YLE_BACKGROUND_BRAND: LOGO_YLE_BACKGROUND_BRAND,
  LOGO_YLE_BACKGROUND_DEFAULT: LOGO_YLE_BACKGROUND_DEFAULT,
  LOGO_YLE_FEM: LOGO_YLE_FEM,
  LOGO_YLE_KLASSINEN: LOGO_YLE_KLASSINEN,
  LOGO_YLE_RADIO_1: LOGO_YLE_RADIO_1,
  LOGO_YLE_RADIO_SUOMI: LOGO_YLE_RADIO_SUOMI,
  LOGO_YLE_SAMI_RADIO: LOGO_YLE_SAMI_RADIO,
  LOGO_YLE_TEEMA: LOGO_YLE_TEEMA,
  LOGO_YLE_TEXT: LOGO_YLE_TEXT,
  LOGO_YLE_VEGA: LOGO_YLE_VEGA,
  LOGO_YLE_X: LOGO_YLE_X,
  LOGO_YLE_X3M: LOGO_YLE_X3M,
  PLAYER_PROGRESS_BAR: PLAYER_PROGRESS_BAR,
  PLAYER_PROGRESS_INDICATOR: PLAYER_PROGRESS_INDICATOR,
  SHADOW_L: SHADOW_L$3,
  SHADOW_M: SHADOW_M$3,
  SHADOW_S: SHADOW_S$3,
  SPINNER_BACKGROUND_DEFAULT: SPINNER_BACKGROUND_DEFAULT$3,
  SPINNER_BACKGROUND_ERROR: SPINNER_BACKGROUND_ERROR,
  SPINNER_BACKGROUND_NEGATIVE: SPINNER_BACKGROUND_NEGATIVE$3,
  SPINNER_DEFAULT: SPINNER_DEFAULT$3,
  SPINNER_ERROR: SPINNER_ERROR,
  SPINNER_HIGHLIGHT_DEFAULT: SPINNER_HIGHLIGHT_DEFAULT,
  SPINNER_HIGHLIGHT_NEGATIVE: SPINNER_HIGHLIGHT_NEGATIVE,
  SPINNER_NEGATIVE: SPINNER_NEGATIVE$3,
  SPINNER_SUCCESS: SPINNER_SUCCESS,
  TAG_DEFAULT: TAG_DEFAULT,
  TAG_LIVE: TAG_LIVE$3,
  TAG_NEUTRAL: TAG_NEUTRAL,
  TAG_OPINION: TAG_OPINION,
  TAG_PRIMARY_ACTION: TAG_PRIMARY_ACTION,
  TAG_PRIMARY_ACTION_VARIANT: TAG_PRIMARY_ACTION_VARIANT,
  TAG_SECONDARY_ACTION: TAG_SECONDARY_ACTION,
  TAG_SECONDARY_ACTION_VARIANT: TAG_SECONDARY_ACTION_VARIANT,
  TAG_YLE_CORPORATE: TAG_YLE_CORPORATE,
  TEXT_DARK: TEXT_DARK$6,
  TEXT_DEFAULT: TEXT_DEFAULT$6,
  TEXT_DISABLED: TEXT_DISABLED$3,
  TEXT_FEEDBACK_LIVE: TEXT_FEEDBACK_LIVE$3,
  TEXT_HIGH_EMPHASIS: TEXT_HIGH_EMPHASIS,
  TEXT_INPUT_PLACEHOLDER: TEXT_INPUT_PLACEHOLDER,
  TEXT_LIGHT: TEXT_LIGHT$3,
  TEXT_LIGHT_HIGH_CONTRAST: TEXT_LIGHT_HIGH_CONTRAST,
  TEXT_MEDIUM_EMPHASIS: TEXT_MEDIUM_EMPHASIS,
  TEXT_NEGATIVE: TEXT_NEGATIVE$6,
  TIETAJA_BACKGROUND_PLAYER_CARD: TIETAJA_BACKGROUND_PLAYER_CARD$3,
  TIETAJA_BORDER_HIGHLIGHT: TIETAJA_BORDER_HIGHLIGHT$3,
  TIETAJA_TEXT_SCORE: TIETAJA_TEXT_SCORE$3
});

/**
 * Yle Design System
 * v2.x.x
 */

const DURATION_INSTANT = '0ms';
const DURATION_XXS = '70ms';
const DURATION_XS = '150ms';
const DURATION_S = '250ms';
const DURATION_M = '450ms';
const DURATION_L = '750ms';
const DURATION_XL = '1000ms';
const DURATION_XXL = '2000ms';
const DELAY_XXS = '70ms';
const DELAY_XS = '150ms';
const DELAY_S = '250ms';
const DELAY_M = '450ms';
const DELAY_L = '750ms';
const DELAY_XL = '1000ms';
const DELAY_XXL = '2000ms';
const DELAY_INSTANT = '0ms';
const EASING_DEC = 'cubic-bezier(0.17, 0.84, 0.44, 1.0)';
const EASING_ACC = 'cubic-bezier(0.84, 0.17, 1, 0.44)';
const EASING_DEFAULT = 'cubic-bezier(0.65, 0.05, 0.35, 1.0)';
const EASING_EXP = 'cubic-bezier(0.75, 0, 0.17, 1.0)';
const EASING_BOUNCE_SM = 'cubic-bezier(0.6, 0.0, 0.1, 1.3)';
const EASING_BOUNCE_LG = 'cubic-bezier(0.6, 0.0, 0.1, 3)';
const EASING_LINEAR = 'cubic-bezier(0, 0, 1, 1)';

var transition = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DELAY_INSTANT: DELAY_INSTANT,
  DELAY_L: DELAY_L,
  DELAY_M: DELAY_M,
  DELAY_S: DELAY_S,
  DELAY_XL: DELAY_XL,
  DELAY_XS: DELAY_XS,
  DELAY_XXL: DELAY_XXL,
  DELAY_XXS: DELAY_XXS,
  DURATION_INSTANT: DURATION_INSTANT,
  DURATION_L: DURATION_L,
  DURATION_M: DURATION_M,
  DURATION_S: DURATION_S,
  DURATION_XL: DURATION_XL,
  DURATION_XS: DURATION_XS,
  DURATION_XXL: DURATION_XXL,
  DURATION_XXS: DURATION_XXS,
  EASING_ACC: EASING_ACC,
  EASING_BOUNCE_LG: EASING_BOUNCE_LG,
  EASING_BOUNCE_SM: EASING_BOUNCE_SM,
  EASING_DEC: EASING_DEC,
  EASING_DEFAULT: EASING_DEFAULT,
  EASING_EXP: EASING_EXP,
  EASING_LINEAR: EASING_LINEAR
});

/**
 * Yle Design System
 * v2.x.x
 */

const DEFAULT_7XL_BOLD_FONT_SIZE$2 = '3.5rem';
const DEFAULT_7XL_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_7XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_7XL_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_7XL_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_7XL_BOLD_FONT_STRETCH$2 = 'normal';
const DEFAULT_7XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_7XL_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_7XL_BOLD_LINE_HEIGHT$2 = '1.25';
const DEFAULT_7XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_7XL_BOLD_PARAGRAPH_SPACING$2 = '3.5rem';
const DEFAULT_7XL_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_7XL_HEAVY_FONT_SIZE$2 = '3.5rem';
const DEFAULT_7XL_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_7XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_7XL_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_7XL_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_7XL_HEAVY_FONT_STRETCH$2 = 'normal';
const DEFAULT_7XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_7XL_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_7XL_HEAVY_LINE_HEIGHT$2 = '1.25';
const DEFAULT_7XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_7XL_HEAVY_PARAGRAPH_SPACING$2 = '3.5rem';
const DEFAULT_7XL_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_SIZE$2 = '3.5rem';
const DEFAULT_7XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_7XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_7XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.25';
const DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_7XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_6XL_BOLD_FONT_SIZE$2 = '3rem';
const DEFAULT_6XL_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_6XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_6XL_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_6XL_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_6XL_BOLD_FONT_STRETCH$2 = 'normal';
const DEFAULT_6XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_6XL_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_6XL_BOLD_LINE_HEIGHT$2 = '1.25';
const DEFAULT_6XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_6XL_BOLD_PARAGRAPH_SPACING$2 = '3rem';
const DEFAULT_6XL_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_6XL_HEAVY_FONT_SIZE$2 = '3rem';
const DEFAULT_6XL_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_6XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_6XL_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_6XL_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_6XL_HEAVY_FONT_STRETCH$2 = 'normal';
const DEFAULT_6XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_6XL_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_6XL_HEAVY_LINE_HEIGHT$2 = '1.25';
const DEFAULT_6XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_6XL_HEAVY_PARAGRAPH_SPACING$2 = '3rem';
const DEFAULT_6XL_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_SIZE$2 = '3rem';
const DEFAULT_6XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_6XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_6XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.25';
const DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_6XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_5XL_BOLD_FONT_SIZE$2 = '2.5rem';
const DEFAULT_5XL_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_5XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_5XL_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_5XL_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_5XL_BOLD_FONT_STRETCH$2 = 'normal';
const DEFAULT_5XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_5XL_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_5XL_BOLD_LINE_HEIGHT$2 = '1.25';
const DEFAULT_5XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_5XL_BOLD_PARAGRAPH_SPACING$2 = '2.5rem';
const DEFAULT_5XL_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_5XL_HEAVY_FONT_SIZE$2 = '2.5rem';
const DEFAULT_5XL_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_5XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_5XL_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_5XL_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_5XL_HEAVY_FONT_STRETCH$2 = 'normal';
const DEFAULT_5XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_5XL_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_5XL_HEAVY_LINE_HEIGHT$2 = '1.25';
const DEFAULT_5XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_5XL_HEAVY_PARAGRAPH_SPACING$2 = '2.5rem';
const DEFAULT_5XL_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_SIZE$2 = '2.5rem';
const DEFAULT_5XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_5XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_5XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.25';
const DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_5XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_4XL_BOLD_FONT_SIZE$2 = '2rem';
const DEFAULT_4XL_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_4XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_4XL_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_4XL_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_4XL_BOLD_FONT_STRETCH$2 = 'normal';
const DEFAULT_4XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_4XL_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_4XL_BOLD_LINE_HEIGHT$2 = '1.35';
const DEFAULT_4XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_4XL_BOLD_PARAGRAPH_SPACING$2 = '2rem';
const DEFAULT_4XL_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_4XL_HEAVY_FONT_SIZE$2 = '2rem';
const DEFAULT_4XL_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_4XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_4XL_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_4XL_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_4XL_HEAVY_FONT_STRETCH$2 = 'normal';
const DEFAULT_4XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_4XL_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_4XL_HEAVY_LINE_HEIGHT$2 = '1.35';
const DEFAULT_4XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_4XL_HEAVY_PARAGRAPH_SPACING$2 = '2rem';
const DEFAULT_4XL_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_SIZE$2 = '2rem';
const DEFAULT_4XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_4XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_4XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.35';
const DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_4XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_3XL_BOLD_FONT_SIZE$2 = '1.75rem';
const DEFAULT_3XL_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_3XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_3XL_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_3XL_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_3XL_BOLD_FONT_STRETCH$2 = 'normal';
const DEFAULT_3XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_3XL_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_3XL_BOLD_LINE_HEIGHT$2 = '1.35';
const DEFAULT_3XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_3XL_BOLD_PARAGRAPH_SPACING$2 = '1.75rem';
const DEFAULT_3XL_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_3XL_HEAVY_FONT_SIZE$2 = '1.75rem';
const DEFAULT_3XL_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_3XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_3XL_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_3XL_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_3XL_HEAVY_FONT_STRETCH$2 = 'normal';
const DEFAULT_3XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_3XL_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_3XL_HEAVY_LINE_HEIGHT$2 = '1.35';
const DEFAULT_3XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_3XL_HEAVY_PARAGRAPH_SPACING$2 = '1.75rem';
const DEFAULT_3XL_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_SIZE$2 = '1.75rem';
const DEFAULT_3XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_3XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_3XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.35';
const DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_3XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_2XL_FONT_SIZE$2 = '1.5rem';
const DEFAULT_2XL_TEXT_DECORATION$2 = 'none';
const DEFAULT_2XL_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_2XL_FONT_WEIGHT$2 = 400;
const DEFAULT_2XL_FONT_STYLE$2 = 'normal';
const DEFAULT_2XL_FONT_STRETCH$2 = 'normal';
const DEFAULT_2XL_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_2XL_LETTER_SPACING$2 = 0;
const DEFAULT_2XL_LINE_HEIGHT$2 = '1.35';
const DEFAULT_2XL_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_2XL_PARAGRAPH_SPACING$2 = '1.5rem';
const DEFAULT_2XL_TEXT_CASE$2 = 'none';
const DEFAULT_2XL_BOLD_FONT_SIZE$2 = '1.5rem';
const DEFAULT_2XL_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_2XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_2XL_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_2XL_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_2XL_BOLD_FONT_STRETCH$2 = 'normal';
const DEFAULT_2XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_2XL_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_2XL_BOLD_LINE_HEIGHT$2 = '1.35';
const DEFAULT_2XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_2XL_BOLD_PARAGRAPH_SPACING$2 = '1.5rem';
const DEFAULT_2XL_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_2XL_HEAVY_FONT_SIZE$2 = '1.5rem';
const DEFAULT_2XL_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_2XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_2XL_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_2XL_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_2XL_HEAVY_FONT_STRETCH$2 = 'normal';
const DEFAULT_2XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_2XL_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_2XL_HEAVY_LINE_HEIGHT$2 = '1.35';
const DEFAULT_2XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_2XL_HEAVY_PARAGRAPH_SPACING$2 = '1.5rem';
const DEFAULT_2XL_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_SIZE$2 = '1.5rem';
const DEFAULT_2XL_CONDENSED_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_STRETCH$2 = 'condensed';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_2XL_CONDENSED_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_2XL_CONDENSED_BOLD_LINE_HEIGHT$2 = '1.35';
const DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_2XL_CONDENSED_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_SIZE$2 = '1.5rem';
const DEFAULT_2XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_2XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_2XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.35';
const DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_2XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_XL_FONT_SIZE$2 = '1.25rem';
const DEFAULT_XL_TEXT_DECORATION$2 = 'none';
const DEFAULT_XL_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XL_FONT_WEIGHT$2 = 400;
const DEFAULT_XL_FONT_STYLE$2 = 'normal';
const DEFAULT_XL_FONT_STRETCH$2 = 'normal';
const DEFAULT_XL_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_XL_LETTER_SPACING$2 = 0;
const DEFAULT_XL_LINE_HEIGHT$2 = '1.45';
const DEFAULT_XL_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XL_PARAGRAPH_SPACING$2 = '1.25rem';
const DEFAULT_XL_TEXT_CASE$2 = 'none';
const DEFAULT_XL_ITALIC_FONT_SIZE$2 = '1.25rem';
const DEFAULT_XL_ITALIC_TEXT_DECORATION$2 = 'none';
const DEFAULT_XL_ITALIC_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XL_ITALIC_FONT_WEIGHT$2 = 400;
const DEFAULT_XL_ITALIC_FONT_STYLE$2 = 'italic';
const DEFAULT_XL_ITALIC_FONT_STRETCH$2 = 'normal';
const DEFAULT_XL_ITALIC_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_XL_ITALIC_LETTER_SPACING$2 = 0;
const DEFAULT_XL_ITALIC_LINE_HEIGHT$2 = '1.45';
const DEFAULT_XL_ITALIC_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XL_ITALIC_PARAGRAPH_SPACING$2 = '1.25rem';
const DEFAULT_XL_ITALIC_TEXT_CASE$2 = 'none';
const DEFAULT_XL_BOLD_FONT_SIZE$2 = '1.25rem';
const DEFAULT_XL_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XL_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_XL_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_XL_BOLD_FONT_STRETCH$2 = 'normal';
const DEFAULT_XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_XL_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_XL_BOLD_LINE_HEIGHT$2 = '1.45';
const DEFAULT_XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XL_BOLD_PARAGRAPH_SPACING$2 = '1.25rem';
const DEFAULT_XL_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_XL_HEAVY_FONT_SIZE$2 = '1.25rem';
const DEFAULT_XL_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XL_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_XL_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_XL_HEAVY_FONT_STRETCH$2 = 'normal';
const DEFAULT_XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_XL_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_XL_HEAVY_LINE_HEIGHT$2 = '1.45';
const DEFAULT_XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XL_HEAVY_PARAGRAPH_SPACING$2 = '1.25rem';
const DEFAULT_XL_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_XL_CONDENSED_FONT_SIZE$2 = '1.25rem';
const DEFAULT_XL_CONDENSED_TEXT_DECORATION$2 = 'none';
const DEFAULT_XL_CONDENSED_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XL_CONDENSED_FONT_WEIGHT$2 = 400;
const DEFAULT_XL_CONDENSED_FONT_STYLE$2 = 'normal';
const DEFAULT_XL_CONDENSED_FONT_STRETCH$2 = 'condensed';
const DEFAULT_XL_CONDENSED_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_XL_CONDENSED_LETTER_SPACING$2 = 0;
const DEFAULT_XL_CONDENSED_LINE_HEIGHT$2 = '1.45';
const DEFAULT_XL_CONDENSED_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XL_CONDENSED_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_XL_CONDENSED_TEXT_CASE$2 = 'none';
const DEFAULT_XL_CONDENSED_BOLD_FONT_SIZE$2 = '1.25rem';
const DEFAULT_XL_CONDENSED_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_XL_CONDENSED_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XL_CONDENSED_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_XL_CONDENSED_BOLD_FONT_STRETCH$2 = 'condensed';
const DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_XL_CONDENSED_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_XL_CONDENSED_BOLD_LINE_HEIGHT$2 = '1.45';
const DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_XL_CONDENSED_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_SIZE$2 = '1.25rem';
const DEFAULT_XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.45';
const DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_L_FONT_SIZE$2 = '1.125rem';
const DEFAULT_L_TEXT_DECORATION$2 = 'none';
const DEFAULT_L_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_L_FONT_WEIGHT$2 = 400;
const DEFAULT_L_FONT_STYLE$2 = 'normal';
const DEFAULT_L_FONT_STRETCH$2 = 'normal';
const DEFAULT_L_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_L_LETTER_SPACING$2 = 0;
const DEFAULT_L_LINE_HEIGHT$2 = '1.45';
const DEFAULT_L_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_L_PARAGRAPH_SPACING$2 = '1.125rem';
const DEFAULT_L_TEXT_CASE$2 = 'none';
const DEFAULT_L_ITALIC_FONT_SIZE$2 = '1.125rem';
const DEFAULT_L_ITALIC_TEXT_DECORATION$2 = 'none';
const DEFAULT_L_ITALIC_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_L_ITALIC_FONT_WEIGHT$2 = 400;
const DEFAULT_L_ITALIC_FONT_STYLE$2 = 'italic';
const DEFAULT_L_ITALIC_FONT_STRETCH$2 = 'normal';
const DEFAULT_L_ITALIC_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_L_ITALIC_LETTER_SPACING$2 = 0;
const DEFAULT_L_ITALIC_LINE_HEIGHT$2 = '1.45';
const DEFAULT_L_ITALIC_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_L_ITALIC_PARAGRAPH_SPACING$2 = '1.125rem';
const DEFAULT_L_ITALIC_TEXT_CASE$2 = 'none';
const DEFAULT_L_BOLD_FONT_SIZE$2 = '1.125rem';
const DEFAULT_L_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_L_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_L_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_L_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_L_BOLD_FONT_STRETCH$2 = 'normal';
const DEFAULT_L_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_L_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_L_BOLD_LINE_HEIGHT$2 = '1.45';
const DEFAULT_L_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_L_BOLD_PARAGRAPH_SPACING$2 = '1.125rem';
const DEFAULT_L_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_L_HEAVY_FONT_SIZE$2 = '1.125rem';
const DEFAULT_L_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_L_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_L_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_L_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_L_HEAVY_FONT_STRETCH$2 = 'normal';
const DEFAULT_L_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_L_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_L_HEAVY_LINE_HEIGHT$2 = '1.45';
const DEFAULT_L_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_L_HEAVY_PARAGRAPH_SPACING$2 = '1.125rem';
const DEFAULT_L_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_L_CONDENSED_FONT_SIZE$2 = '1.125rem';
const DEFAULT_L_CONDENSED_TEXT_DECORATION$2 = 'none';
const DEFAULT_L_CONDENSED_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_L_CONDENSED_FONT_WEIGHT$2 = 400;
const DEFAULT_L_CONDENSED_FONT_STYLE$2 = 'normal';
const DEFAULT_L_CONDENSED_FONT_STRETCH$2 = 'condensed';
const DEFAULT_L_CONDENSED_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_L_CONDENSED_LETTER_SPACING$2 = 0;
const DEFAULT_L_CONDENSED_LINE_HEIGHT$2 = '1.45';
const DEFAULT_L_CONDENSED_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_L_CONDENSED_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_L_CONDENSED_TEXT_CASE$2 = 'none';
const DEFAULT_L_CONDENSED_BOLD_FONT_SIZE$2 = '1.125rem';
const DEFAULT_L_CONDENSED_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_L_CONDENSED_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_L_CONDENSED_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_L_CONDENSED_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_L_CONDENSED_BOLD_FONT_STRETCH$2 = 'condensed';
const DEFAULT_L_CONDENSED_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_L_CONDENSED_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_L_CONDENSED_BOLD_LINE_HEIGHT$2 = '1.45';
const DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_L_CONDENSED_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_L_CONDENSED_HEAVY_FONT_SIZE$2 = '1.125rem';
const DEFAULT_L_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const DEFAULT_L_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_L_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const DEFAULT_L_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const DEFAULT_L_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const DEFAULT_L_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.45';
const DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_L_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const DEFAULT_M_FONT_SIZE$2 = '1rem';
const DEFAULT_M_TEXT_DECORATION$2 = 'none';
const DEFAULT_M_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_M_FONT_WEIGHT$2 = 400;
const DEFAULT_M_FONT_STYLE$2 = 'normal';
const DEFAULT_M_FONT_STRETCH$2 = 'normal';
const DEFAULT_M_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_M_LETTER_SPACING$2 = 0;
const DEFAULT_M_LINE_HEIGHT$2 = '1.50';
const DEFAULT_M_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_M_PARAGRAPH_SPACING$2 = '1rem';
const DEFAULT_M_TEXT_CASE$2 = 'none';
const DEFAULT_M_AC_FONT_SIZE$2 = '1rem';
const DEFAULT_M_AC_TEXT_DECORATION$2 = 'none';
const DEFAULT_M_AC_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_M_AC_FONT_WEIGHT$2 = 400;
const DEFAULT_M_AC_FONT_STYLE$2 = 'normal';
const DEFAULT_M_AC_FONT_STRETCH$2 = 'normal';
const DEFAULT_M_AC_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_M_AC_LETTER_SPACING$2 = '0.01em';
const DEFAULT_M_AC_LINE_HEIGHT$2 = '1.50';
const DEFAULT_M_AC_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_M_AC_PARAGRAPH_SPACING$2 = '1rem';
const DEFAULT_M_AC_TEXT_CASE$2 = 'uppercase';
const DEFAULT_M_ITALIC_FONT_SIZE$2 = '1rem';
const DEFAULT_M_ITALIC_TEXT_DECORATION$2 = 'none';
const DEFAULT_M_ITALIC_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_M_ITALIC_FONT_WEIGHT$2 = 400;
const DEFAULT_M_ITALIC_FONT_STYLE$2 = 'italic';
const DEFAULT_M_ITALIC_FONT_STRETCH$2 = 'normal';
const DEFAULT_M_ITALIC_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_M_ITALIC_LETTER_SPACING$2 = 0;
const DEFAULT_M_ITALIC_LINE_HEIGHT$2 = '1.50';
const DEFAULT_M_ITALIC_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_M_ITALIC_PARAGRAPH_SPACING$2 = '1rem';
const DEFAULT_M_ITALIC_TEXT_CASE$2 = 'none';
const DEFAULT_M_MEDIUM_FONT_SIZE$2 = '1rem';
const DEFAULT_M_MEDIUM_TEXT_DECORATION$2 = 'none';
const DEFAULT_M_MEDIUM_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_M_MEDIUM_FONT_WEIGHT$2 = 500;
const DEFAULT_M_MEDIUM_FONT_STYLE$2 = 'normal';
const DEFAULT_M_MEDIUM_FONT_STRETCH$2 = 'normal';
const DEFAULT_M_MEDIUM_FONT_STYLE_OLD$2 = 'Medium';
const DEFAULT_M_MEDIUM_LETTER_SPACING$2 = 0;
const DEFAULT_M_MEDIUM_LINE_HEIGHT$2 = '1.50';
const DEFAULT_M_MEDIUM_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_M_MEDIUM_PARAGRAPH_SPACING$2 = '1rem';
const DEFAULT_M_MEDIUM_TEXT_CASE$2 = 'none';
const DEFAULT_M_BOLD_FONT_SIZE$2 = '1rem';
const DEFAULT_M_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_M_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_M_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_M_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_M_BOLD_FONT_STRETCH$2 = 'normal';
const DEFAULT_M_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_M_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_M_BOLD_LINE_HEIGHT$2 = '1.50';
const DEFAULT_M_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_M_BOLD_PARAGRAPH_SPACING$2 = '1rem';
const DEFAULT_M_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_M_BOLD_AC_FONT_SIZE$2 = '1rem';
const DEFAULT_M_BOLD_AC_TEXT_DECORATION$2 = 'none';
const DEFAULT_M_BOLD_AC_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_M_BOLD_AC_FONT_WEIGHT$2 = 700;
const DEFAULT_M_BOLD_AC_FONT_STYLE$2 = 'normal';
const DEFAULT_M_BOLD_AC_FONT_STRETCH$2 = 'normal';
const DEFAULT_M_BOLD_AC_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_M_BOLD_AC_LETTER_SPACING$2 = '0.01em';
const DEFAULT_M_BOLD_AC_LINE_HEIGHT$2 = '1.50';
const DEFAULT_M_BOLD_AC_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_M_BOLD_AC_PARAGRAPH_SPACING$2 = '1rem';
const DEFAULT_M_BOLD_AC_TEXT_CASE$2 = 'uppercase';
const DEFAULT_M_CONDENSED_FONT_SIZE$2 = '1rem';
const DEFAULT_M_CONDENSED_TEXT_DECORATION$2 = 'none';
const DEFAULT_M_CONDENSED_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_M_CONDENSED_FONT_WEIGHT$2 = 400;
const DEFAULT_M_CONDENSED_FONT_STYLE$2 = 'normal';
const DEFAULT_M_CONDENSED_FONT_STRETCH$2 = 'condensed';
const DEFAULT_M_CONDENSED_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_M_CONDENSED_LETTER_SPACING$2 = 0;
const DEFAULT_M_CONDENSED_LINE_HEIGHT$2 = '1.50';
const DEFAULT_M_CONDENSED_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_M_CONDENSED_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_M_CONDENSED_TEXT_CASE$2 = 'none';
const DEFAULT_M_CONDENSED_BOLD_FONT_SIZE$2 = '1rem';
const DEFAULT_M_CONDENSED_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_M_CONDENSED_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_M_CONDENSED_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_M_CONDENSED_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_M_CONDENSED_BOLD_FONT_STRETCH$2 = 'condensed';
const DEFAULT_M_CONDENSED_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_M_CONDENSED_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_M_CONDENSED_BOLD_LINE_HEIGHT$2 = '1.50';
const DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_M_CONDENSED_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_S_FONT_SIZE$2 = '0.875rem';
const DEFAULT_S_TEXT_DECORATION$2 = 'none';
const DEFAULT_S_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_S_FONT_WEIGHT$2 = 400;
const DEFAULT_S_FONT_STYLE$2 = 'normal';
const DEFAULT_S_FONT_STRETCH$2 = 'normal';
const DEFAULT_S_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_S_LETTER_SPACING$2 = 0;
const DEFAULT_S_LINE_HEIGHT$2 = '1.50';
const DEFAULT_S_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_S_PARAGRAPH_SPACING$2 = '0.875rem';
const DEFAULT_S_TEXT_CASE$2 = 'none';
const DEFAULT_S_ITALIC_FONT_SIZE$2 = '0.875rem';
const DEFAULT_S_ITALIC_TEXT_DECORATION$2 = 'none';
const DEFAULT_S_ITALIC_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_S_ITALIC_FONT_WEIGHT$2 = 400;
const DEFAULT_S_ITALIC_FONT_STYLE$2 = 'italic';
const DEFAULT_S_ITALIC_FONT_STRETCH$2 = 'normal';
const DEFAULT_S_ITALIC_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_S_ITALIC_LETTER_SPACING$2 = 0;
const DEFAULT_S_ITALIC_LINE_HEIGHT$2 = '1.50';
const DEFAULT_S_ITALIC_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_S_ITALIC_PARAGRAPH_SPACING$2 = '0.875rem';
const DEFAULT_S_ITALIC_TEXT_CASE$2 = 'none';
const DEFAULT_S_AC_FONT_SIZE$2 = '0.875rem';
const DEFAULT_S_AC_TEXT_DECORATION$2 = 'none';
const DEFAULT_S_AC_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_S_AC_FONT_WEIGHT$2 = 400;
const DEFAULT_S_AC_FONT_STYLE$2 = 'normal';
const DEFAULT_S_AC_FONT_STRETCH$2 = 'normal';
const DEFAULT_S_AC_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_S_AC_LETTER_SPACING$2 = '0.01em';
const DEFAULT_S_AC_LINE_HEIGHT$2 = '1.50';
const DEFAULT_S_AC_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_S_AC_PARAGRAPH_SPACING$2 = '0.875rem';
const DEFAULT_S_AC_TEXT_CASE$2 = 'uppercase';
const DEFAULT_S_MEDIUM_FONT_SIZE$2 = '0.875rem';
const DEFAULT_S_MEDIUM_TEXT_DECORATION$2 = 'none';
const DEFAULT_S_MEDIUM_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_S_MEDIUM_FONT_WEIGHT$2 = 500;
const DEFAULT_S_MEDIUM_FONT_STYLE$2 = 'normal';
const DEFAULT_S_MEDIUM_FONT_STRETCH$2 = 'normal';
const DEFAULT_S_MEDIUM_FONT_STYLE_OLD$2 = 'Medium';
const DEFAULT_S_MEDIUM_LETTER_SPACING$2 = 0;
const DEFAULT_S_MEDIUM_LINE_HEIGHT$2 = '1.50';
const DEFAULT_S_MEDIUM_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_S_MEDIUM_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_S_MEDIUM_TEXT_CASE$2 = 'none';
const DEFAULT_S_BOLD_FONT_SIZE$2 = '0.875rem';
const DEFAULT_S_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_S_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_S_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_S_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_S_BOLD_FONT_STRETCH$2 = 'normal';
const DEFAULT_S_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_S_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_S_BOLD_LINE_HEIGHT$2 = '1.50';
const DEFAULT_S_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_S_BOLD_PARAGRAPH_SPACING$2 = '0.875rem';
const DEFAULT_S_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_S_BOLD_AC_FONT_SIZE$2 = '0.875rem';
const DEFAULT_S_BOLD_AC_TEXT_DECORATION$2 = 'none';
const DEFAULT_S_BOLD_AC_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_S_BOLD_AC_FONT_WEIGHT$2 = 700;
const DEFAULT_S_BOLD_AC_FONT_STYLE$2 = 'normal';
const DEFAULT_S_BOLD_AC_FONT_STRETCH$2 = 'normal';
const DEFAULT_S_BOLD_AC_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_S_BOLD_AC_LETTER_SPACING$2 = '0.01em';
const DEFAULT_S_BOLD_AC_LINE_HEIGHT$2 = '1.50';
const DEFAULT_S_BOLD_AC_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_S_BOLD_AC_PARAGRAPH_SPACING$2 = '0.875rem';
const DEFAULT_S_BOLD_AC_TEXT_CASE$2 = 'uppercase';
const DEFAULT_S_CONDENSED_FONT_SIZE$2 = '0.875rem';
const DEFAULT_S_CONDENSED_TEXT_DECORATION$2 = 'none';
const DEFAULT_S_CONDENSED_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_S_CONDENSED_FONT_WEIGHT$2 = 400;
const DEFAULT_S_CONDENSED_FONT_STYLE$2 = 'normal';
const DEFAULT_S_CONDENSED_FONT_STRETCH$2 = 'condensed';
const DEFAULT_S_CONDENSED_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_S_CONDENSED_LETTER_SPACING$2 = 0;
const DEFAULT_S_CONDENSED_LINE_HEIGHT$2 = '1.50';
const DEFAULT_S_CONDENSED_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_S_CONDENSED_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_S_CONDENSED_TEXT_CASE$2 = 'none';
const DEFAULT_S_CONDENSED_BOLD_FONT_SIZE$2 = '0.875rem';
const DEFAULT_S_CONDENSED_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_S_CONDENSED_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_S_CONDENSED_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_S_CONDENSED_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_S_CONDENSED_BOLD_FONT_STRETCH$2 = 'condensed';
const DEFAULT_S_CONDENSED_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_S_CONDENSED_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_S_CONDENSED_BOLD_LINE_HEIGHT$2 = '1.50';
const DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_S_CONDENSED_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_XS_FONT_SIZE$2 = '0.75rem';
const DEFAULT_XS_TEXT_DECORATION$2 = 'none';
const DEFAULT_XS_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XS_FONT_WEIGHT$2 = 400;
const DEFAULT_XS_FONT_STYLE$2 = 'normal';
const DEFAULT_XS_FONT_STRETCH$2 = 'normal';
const DEFAULT_XS_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_XS_LETTER_SPACING$2 = 0;
const DEFAULT_XS_LINE_HEIGHT$2 = '1.50';
const DEFAULT_XS_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XS_PARAGRAPH_SPACING$2 = '0.75rem';
const DEFAULT_XS_TEXT_CASE$2 = 'none';
const DEFAULT_XS_ITALIC_FONT_SIZE$2 = '0.75rem';
const DEFAULT_XS_ITALIC_TEXT_DECORATION$2 = 'none';
const DEFAULT_XS_ITALIC_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XS_ITALIC_FONT_WEIGHT$2 = 400;
const DEFAULT_XS_ITALIC_FONT_STYLE$2 = 'italic';
const DEFAULT_XS_ITALIC_FONT_STRETCH$2 = 'normal';
const DEFAULT_XS_ITALIC_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_XS_ITALIC_LETTER_SPACING$2 = 0;
const DEFAULT_XS_ITALIC_LINE_HEIGHT$2 = '1.50';
const DEFAULT_XS_ITALIC_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XS_ITALIC_PARAGRAPH_SPACING$2 = '0.75rem';
const DEFAULT_XS_ITALIC_TEXT_CASE$2 = 'none';
const DEFAULT_XS_AC_FONT_SIZE$2 = '0.75rem';
const DEFAULT_XS_AC_TEXT_DECORATION$2 = 'none';
const DEFAULT_XS_AC_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XS_AC_FONT_WEIGHT$2 = 400;
const DEFAULT_XS_AC_FONT_STYLE$2 = 'normal';
const DEFAULT_XS_AC_FONT_STRETCH$2 = 'normal';
const DEFAULT_XS_AC_FONT_STYLE_OLD$2 = 'Regular';
const DEFAULT_XS_AC_LETTER_SPACING$2 = '0.01em';
const DEFAULT_XS_AC_LINE_HEIGHT$2 = '1.50';
const DEFAULT_XS_AC_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XS_AC_PARAGRAPH_SPACING$2 = '0.75rem';
const DEFAULT_XS_AC_TEXT_CASE$2 = 'uppercase';
const DEFAULT_XS_BOLD_FONT_SIZE$2 = '0.75rem';
const DEFAULT_XS_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_XS_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XS_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_XS_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_XS_BOLD_FONT_STRETCH$2 = 'normal';
const DEFAULT_XS_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_XS_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_XS_BOLD_LINE_HEIGHT$2 = '1.50';
const DEFAULT_XS_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XS_BOLD_PARAGRAPH_SPACING$2 = '0.75rem';
const DEFAULT_XS_BOLD_TEXT_CASE$2 = 'none';
const DEFAULT_XS_BOLD_AC_FONT_SIZE$2 = '0.75rem';
const DEFAULT_XS_BOLD_AC_TEXT_DECORATION$2 = 'none';
const DEFAULT_XS_BOLD_AC_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XS_BOLD_AC_FONT_WEIGHT$2 = 700;
const DEFAULT_XS_BOLD_AC_FONT_STYLE$2 = 'normal';
const DEFAULT_XS_BOLD_AC_FONT_STRETCH$2 = 'normal';
const DEFAULT_XS_BOLD_AC_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_XS_BOLD_AC_LETTER_SPACING$2 = '0.01em';
const DEFAULT_XS_BOLD_AC_LINE_HEIGHT$2 = '1.50';
const DEFAULT_XS_BOLD_AC_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XS_BOLD_AC_PARAGRAPH_SPACING$2 = '0.75rem';
const DEFAULT_XS_BOLD_AC_TEXT_CASE$2 = 'uppercase';
const DEFAULT_XS_CONDENSED_BOLD_FONT_SIZE$2 = '0.75rem';
const DEFAULT_XS_CONDENSED_BOLD_TEXT_DECORATION$2 = 'none';
const DEFAULT_XS_CONDENSED_BOLD_FONT_FAMILY$2 = 'Yle Next';
const DEFAULT_XS_CONDENSED_BOLD_FONT_WEIGHT$2 = 700;
const DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE$2 = 'normal';
const DEFAULT_XS_CONDENSED_BOLD_FONT_STRETCH$2 = 'condensed';
const DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const DEFAULT_XS_CONDENSED_BOLD_LETTER_SPACING$2 = 0;
const DEFAULT_XS_CONDENSED_BOLD_LINE_HEIGHT$2 = '1.50';
const DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT$2 = 0;
const DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING$2 = 0;
const DEFAULT_XS_CONDENSED_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_7XL_BOLD_FONT_SIZE$2 = '3.5rem';
const YLE_NEXT_7XL_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_7XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_7XL_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_7XL_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_7XL_BOLD_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_7XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_7XL_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_7XL_BOLD_LINE_HEIGHT$2 = '1.25';
const YLE_NEXT_7XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_7XL_BOLD_PARAGRAPH_SPACING$2 = '3.5rem';
const YLE_NEXT_7XL_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_7XL_HEAVY_FONT_SIZE$2 = '3.5rem';
const YLE_NEXT_7XL_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_7XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_7XL_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_7XL_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_7XL_HEAVY_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_7XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_7XL_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_7XL_HEAVY_LINE_HEIGHT$2 = '1.25';
const YLE_NEXT_7XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_7XL_HEAVY_PARAGRAPH_SPACING$2 = '3.5rem';
const YLE_NEXT_7XL_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_SIZE$2 = '3.5rem';
const YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_7XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_7XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.25';
const YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_6XL_BOLD_FONT_SIZE$2 = '3rem';
const YLE_NEXT_6XL_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_6XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_6XL_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_6XL_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_6XL_BOLD_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_6XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_6XL_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_6XL_BOLD_LINE_HEIGHT$2 = '1.25';
const YLE_NEXT_6XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_6XL_BOLD_PARAGRAPH_SPACING$2 = '3rem';
const YLE_NEXT_6XL_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_6XL_HEAVY_FONT_SIZE$2 = '3rem';
const YLE_NEXT_6XL_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_6XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_6XL_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_6XL_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_6XL_HEAVY_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_6XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_6XL_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_6XL_HEAVY_LINE_HEIGHT$2 = '1.25';
const YLE_NEXT_6XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_6XL_HEAVY_PARAGRAPH_SPACING$2 = '3rem';
const YLE_NEXT_6XL_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_SIZE$2 = '3rem';
const YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_6XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_6XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.25';
const YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_5XL_BOLD_FONT_SIZE$2 = '2.5rem';
const YLE_NEXT_5XL_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_5XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_5XL_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_5XL_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_5XL_BOLD_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_5XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_5XL_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_5XL_BOLD_LINE_HEIGHT$2 = '1.25';
const YLE_NEXT_5XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_5XL_BOLD_PARAGRAPH_SPACING$2 = '2.5rem';
const YLE_NEXT_5XL_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_5XL_HEAVY_FONT_SIZE$2 = '2.5rem';
const YLE_NEXT_5XL_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_5XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_5XL_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_5XL_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_5XL_HEAVY_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_5XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_5XL_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_5XL_HEAVY_LINE_HEIGHT$2 = '1.25';
const YLE_NEXT_5XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_5XL_HEAVY_PARAGRAPH_SPACING$2 = '2.5rem';
const YLE_NEXT_5XL_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_SIZE$2 = '2.5rem';
const YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_5XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_5XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.25';
const YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_4XL_BOLD_FONT_SIZE$2 = '2rem';
const YLE_NEXT_4XL_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_4XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_4XL_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_4XL_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_4XL_BOLD_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_4XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_4XL_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_4XL_BOLD_LINE_HEIGHT$2 = '1.35';
const YLE_NEXT_4XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_4XL_BOLD_PARAGRAPH_SPACING$2 = '2rem';
const YLE_NEXT_4XL_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_4XL_HEAVY_FONT_SIZE$2 = '2rem';
const YLE_NEXT_4XL_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_4XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_4XL_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_4XL_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_4XL_HEAVY_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_4XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_4XL_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_4XL_HEAVY_LINE_HEIGHT$2 = '1.35';
const YLE_NEXT_4XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_4XL_HEAVY_PARAGRAPH_SPACING$2 = '2rem';
const YLE_NEXT_4XL_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_SIZE$2 = '2rem';
const YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_4XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_4XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.35';
const YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_3XL_BOLD_FONT_SIZE$2 = '1.75rem';
const YLE_NEXT_3XL_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_3XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_3XL_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_3XL_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_3XL_BOLD_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_3XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_3XL_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_3XL_BOLD_LINE_HEIGHT$2 = '1.35';
const YLE_NEXT_3XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_3XL_BOLD_PARAGRAPH_SPACING$2 = '1.75rem';
const YLE_NEXT_3XL_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_3XL_HEAVY_FONT_SIZE$2 = '1.75rem';
const YLE_NEXT_3XL_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_3XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_3XL_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_3XL_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_3XL_HEAVY_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_3XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_3XL_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_3XL_HEAVY_LINE_HEIGHT$2 = '1.35';
const YLE_NEXT_3XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_3XL_HEAVY_PARAGRAPH_SPACING$2 = '1.75rem';
const YLE_NEXT_3XL_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_SIZE$2 = '1.75rem';
const YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_3XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_3XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.35';
const YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_2XL_FONT_SIZE$2 = '1.5rem';
const YLE_NEXT_2XL_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_2XL_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_2XL_FONT_WEIGHT$2 = 400;
const YLE_NEXT_2XL_FONT_STYLE$2 = 'normal';
const YLE_NEXT_2XL_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_2XL_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_2XL_LETTER_SPACING$2 = 0;
const YLE_NEXT_2XL_LINE_HEIGHT$2 = '1.35';
const YLE_NEXT_2XL_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_2XL_PARAGRAPH_SPACING$2 = '1.5rem';
const YLE_NEXT_2XL_TEXT_CASE$2 = 'none';
const YLE_NEXT_2XL_BOLD_FONT_SIZE$2 = '1.5rem';
const YLE_NEXT_2XL_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_2XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_2XL_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_2XL_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_2XL_BOLD_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_2XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_2XL_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_2XL_BOLD_LINE_HEIGHT$2 = '1.35';
const YLE_NEXT_2XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_2XL_BOLD_PARAGRAPH_SPACING$2 = '1.5rem';
const YLE_NEXT_2XL_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_2XL_HEAVY_FONT_SIZE$2 = '1.5rem';
const YLE_NEXT_2XL_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_2XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_2XL_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_2XL_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_2XL_HEAVY_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_2XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_2XL_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_2XL_HEAVY_LINE_HEIGHT$2 = '1.35';
const YLE_NEXT_2XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_2XL_HEAVY_PARAGRAPH_SPACING$2 = '1.5rem';
const YLE_NEXT_2XL_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_SIZE$2 = '1.5rem';
const YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_2XL_CONDENSED_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_2XL_CONDENSED_BOLD_LINE_HEIGHT$2 = '1.35';
const YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_SIZE$2 = '1.5rem';
const YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_2XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_2XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.35';
const YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_XL_FONT_SIZE$2 = '1.25rem';
const YLE_NEXT_XL_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XL_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XL_FONT_WEIGHT$2 = 400;
const YLE_NEXT_XL_FONT_STYLE$2 = 'normal';
const YLE_NEXT_XL_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_XL_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_XL_LETTER_SPACING$2 = 0;
const YLE_NEXT_XL_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_XL_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XL_PARAGRAPH_SPACING$2 = '1.25rem';
const YLE_NEXT_XL_TEXT_CASE$2 = 'none';
const YLE_NEXT_XL_ITALIC_FONT_SIZE$2 = '1.25rem';
const YLE_NEXT_XL_ITALIC_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XL_ITALIC_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XL_ITALIC_FONT_WEIGHT$2 = 400;
const YLE_NEXT_XL_ITALIC_FONT_STYLE$2 = 'italic';
const YLE_NEXT_XL_ITALIC_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_XL_ITALIC_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_XL_ITALIC_LETTER_SPACING$2 = 0;
const YLE_NEXT_XL_ITALIC_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_XL_ITALIC_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XL_ITALIC_PARAGRAPH_SPACING$2 = '1.25rem';
const YLE_NEXT_XL_ITALIC_TEXT_CASE$2 = 'none';
const YLE_NEXT_XL_BOLD_FONT_SIZE$2 = '1.25rem';
const YLE_NEXT_XL_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XL_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XL_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_XL_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_XL_BOLD_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_XL_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_XL_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_XL_BOLD_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_XL_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XL_BOLD_PARAGRAPH_SPACING$2 = '1.25rem';
const YLE_NEXT_XL_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_XL_HEAVY_FONT_SIZE$2 = '1.25rem';
const YLE_NEXT_XL_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XL_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XL_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_XL_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_XL_HEAVY_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_XL_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_XL_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_XL_HEAVY_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_XL_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XL_HEAVY_PARAGRAPH_SPACING$2 = '1.25rem';
const YLE_NEXT_XL_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_XL_CONDENSED_FONT_SIZE$2 = '1.25rem';
const YLE_NEXT_XL_CONDENSED_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XL_CONDENSED_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XL_CONDENSED_FONT_WEIGHT$2 = 400;
const YLE_NEXT_XL_CONDENSED_FONT_STYLE$2 = 'normal';
const YLE_NEXT_XL_CONDENSED_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_XL_CONDENSED_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_XL_CONDENSED_LETTER_SPACING$2 = 0;
const YLE_NEXT_XL_CONDENSED_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_XL_CONDENSED_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XL_CONDENSED_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_XL_CONDENSED_TEXT_CASE$2 = 'none';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_SIZE$2 = '1.25rem';
const YLE_NEXT_XL_CONDENSED_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_XL_CONDENSED_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_XL_CONDENSED_BOLD_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_XL_CONDENSED_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_SIZE$2 = '1.25rem';
const YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_XL_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_XL_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_L_FONT_SIZE$2 = '1.125rem';
const YLE_NEXT_L_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_L_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_L_FONT_WEIGHT$2 = 400;
const YLE_NEXT_L_FONT_STYLE$2 = 'normal';
const YLE_NEXT_L_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_L_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_L_LETTER_SPACING$2 = 0;
const YLE_NEXT_L_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_L_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_L_PARAGRAPH_SPACING$2 = '1.125rem';
const YLE_NEXT_L_TEXT_CASE$2 = 'none';
const YLE_NEXT_L_ITALIC_FONT_SIZE$2 = '1.125rem';
const YLE_NEXT_L_ITALIC_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_L_ITALIC_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_L_ITALIC_FONT_WEIGHT$2 = 400;
const YLE_NEXT_L_ITALIC_FONT_STYLE$2 = 'italic';
const YLE_NEXT_L_ITALIC_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_L_ITALIC_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_L_ITALIC_LETTER_SPACING$2 = 0;
const YLE_NEXT_L_ITALIC_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_L_ITALIC_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_L_ITALIC_PARAGRAPH_SPACING$2 = '1.125rem';
const YLE_NEXT_L_ITALIC_TEXT_CASE$2 = 'none';
const YLE_NEXT_L_BOLD_FONT_SIZE$2 = '1.125rem';
const YLE_NEXT_L_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_L_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_L_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_L_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_L_BOLD_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_L_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_L_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_L_BOLD_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_L_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_L_BOLD_PARAGRAPH_SPACING$2 = '1.125rem';
const YLE_NEXT_L_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_L_HEAVY_FONT_SIZE$2 = '1.125rem';
const YLE_NEXT_L_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_L_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_L_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_L_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_L_HEAVY_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_L_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_L_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_L_HEAVY_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_L_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_L_HEAVY_PARAGRAPH_SPACING$2 = '1.125rem';
const YLE_NEXT_L_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_L_CONDENSED_FONT_SIZE$2 = '1.125rem';
const YLE_NEXT_L_CONDENSED_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_L_CONDENSED_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_L_CONDENSED_FONT_WEIGHT$2 = 400;
const YLE_NEXT_L_CONDENSED_FONT_STYLE$2 = 'normal';
const YLE_NEXT_L_CONDENSED_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_L_CONDENSED_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_L_CONDENSED_LETTER_SPACING$2 = 0;
const YLE_NEXT_L_CONDENSED_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_L_CONDENSED_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_L_CONDENSED_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_L_CONDENSED_TEXT_CASE$2 = 'none';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_SIZE$2 = '1.125rem';
const YLE_NEXT_L_CONDENSED_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_L_CONDENSED_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_L_CONDENSED_BOLD_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_L_CONDENSED_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_SIZE$2 = '1.125rem';
const YLE_NEXT_L_CONDENSED_HEAVY_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_WEIGHT$2 = 900;
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE$2 = 'normal';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE_OLD$2 = 'Black';
const YLE_NEXT_L_CONDENSED_HEAVY_LETTER_SPACING$2 = 0;
const YLE_NEXT_L_CONDENSED_HEAVY_LINE_HEIGHT$2 = '1.45';
const YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_L_CONDENSED_HEAVY_TEXT_CASE$2 = 'none';
const YLE_NEXT_M_FONT_SIZE$2 = '1rem';
const YLE_NEXT_M_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_M_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_M_FONT_WEIGHT$2 = 400;
const YLE_NEXT_M_FONT_STYLE$2 = 'normal';
const YLE_NEXT_M_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_M_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_M_LETTER_SPACING$2 = 0;
const YLE_NEXT_M_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_M_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_M_PARAGRAPH_SPACING$2 = '1rem';
const YLE_NEXT_M_TEXT_CASE$2 = 'none';
const YLE_NEXT_M_AC_FONT_SIZE$2 = '1rem';
const YLE_NEXT_M_AC_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_M_AC_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_M_AC_FONT_WEIGHT$2 = 400;
const YLE_NEXT_M_AC_FONT_STYLE$2 = 'normal';
const YLE_NEXT_M_AC_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_M_AC_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_M_AC_LETTER_SPACING$2 = '0.01em';
const YLE_NEXT_M_AC_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_M_AC_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_M_AC_PARAGRAPH_SPACING$2 = '1rem';
const YLE_NEXT_M_AC_TEXT_CASE$2 = 'uppercase';
const YLE_NEXT_M_ITALIC_FONT_SIZE$2 = '1rem';
const YLE_NEXT_M_ITALIC_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_M_ITALIC_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_M_ITALIC_FONT_WEIGHT$2 = 400;
const YLE_NEXT_M_ITALIC_FONT_STYLE$2 = 'italic';
const YLE_NEXT_M_ITALIC_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_M_ITALIC_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_M_ITALIC_LETTER_SPACING$2 = 0;
const YLE_NEXT_M_ITALIC_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_M_ITALIC_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_M_ITALIC_PARAGRAPH_SPACING$2 = '1rem';
const YLE_NEXT_M_ITALIC_TEXT_CASE$2 = 'none';
const YLE_NEXT_M_MEDIUM_FONT_SIZE$2 = '1rem';
const YLE_NEXT_M_MEDIUM_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_M_MEDIUM_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_M_MEDIUM_FONT_WEIGHT$2 = 500;
const YLE_NEXT_M_MEDIUM_FONT_STYLE$2 = 'normal';
const YLE_NEXT_M_MEDIUM_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_M_MEDIUM_FONT_STYLE_OLD$2 = 'Medium';
const YLE_NEXT_M_MEDIUM_LETTER_SPACING$2 = 0;
const YLE_NEXT_M_MEDIUM_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_M_MEDIUM_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_M_MEDIUM_PARAGRAPH_SPACING$2 = '1rem';
const YLE_NEXT_M_MEDIUM_TEXT_CASE$2 = 'none';
const YLE_NEXT_M_BOLD_FONT_SIZE$2 = '1rem';
const YLE_NEXT_M_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_M_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_M_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_M_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_M_BOLD_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_M_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_M_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_M_BOLD_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_M_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_M_BOLD_PARAGRAPH_SPACING$2 = '1rem';
const YLE_NEXT_M_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_M_BOLD_AC_FONT_SIZE$2 = '1rem';
const YLE_NEXT_M_BOLD_AC_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_M_BOLD_AC_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_M_BOLD_AC_FONT_WEIGHT$2 = 700;
const YLE_NEXT_M_BOLD_AC_FONT_STYLE$2 = 'normal';
const YLE_NEXT_M_BOLD_AC_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_M_BOLD_AC_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_M_BOLD_AC_LETTER_SPACING$2 = '0.01em';
const YLE_NEXT_M_BOLD_AC_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_M_BOLD_AC_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_M_BOLD_AC_PARAGRAPH_SPACING$2 = '1rem';
const YLE_NEXT_M_BOLD_AC_TEXT_CASE$2 = 'uppercase';
const YLE_NEXT_M_CONDENSED_FONT_SIZE$2 = '1rem';
const YLE_NEXT_M_CONDENSED_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_M_CONDENSED_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_M_CONDENSED_FONT_WEIGHT$2 = 400;
const YLE_NEXT_M_CONDENSED_FONT_STYLE$2 = 'normal';
const YLE_NEXT_M_CONDENSED_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_M_CONDENSED_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_M_CONDENSED_LETTER_SPACING$2 = 0;
const YLE_NEXT_M_CONDENSED_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_M_CONDENSED_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_M_CONDENSED_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_M_CONDENSED_TEXT_CASE$2 = 'none';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_SIZE$2 = '1rem';
const YLE_NEXT_M_CONDENSED_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_M_CONDENSED_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_M_CONDENSED_BOLD_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_M_CONDENSED_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_S_FONT_SIZE$2 = '0.875rem';
const YLE_NEXT_S_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_S_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_S_FONT_WEIGHT$2 = 400;
const YLE_NEXT_S_FONT_STYLE$2 = 'normal';
const YLE_NEXT_S_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_S_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_S_LETTER_SPACING$2 = 0;
const YLE_NEXT_S_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_S_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_S_PARAGRAPH_SPACING$2 = '0.875rem';
const YLE_NEXT_S_TEXT_CASE$2 = 'none';
const YLE_NEXT_S_ITALIC_FONT_SIZE$2 = '0.875rem';
const YLE_NEXT_S_ITALIC_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_S_ITALIC_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_S_ITALIC_FONT_WEIGHT$2 = 400;
const YLE_NEXT_S_ITALIC_FONT_STYLE$2 = 'italic';
const YLE_NEXT_S_ITALIC_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_S_ITALIC_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_S_ITALIC_LETTER_SPACING$2 = 0;
const YLE_NEXT_S_ITALIC_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_S_ITALIC_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_S_ITALIC_PARAGRAPH_SPACING$2 = '0.875rem';
const YLE_NEXT_S_ITALIC_TEXT_CASE$2 = 'none';
const YLE_NEXT_S_AC_FONT_SIZE$2 = '0.875rem';
const YLE_NEXT_S_AC_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_S_AC_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_S_AC_FONT_WEIGHT$2 = 400;
const YLE_NEXT_S_AC_FONT_STYLE$2 = 'normal';
const YLE_NEXT_S_AC_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_S_AC_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_S_AC_LETTER_SPACING$2 = '0.01em';
const YLE_NEXT_S_AC_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_S_AC_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_S_AC_PARAGRAPH_SPACING$2 = '0.875rem';
const YLE_NEXT_S_AC_TEXT_CASE$2 = 'uppercase';
const YLE_NEXT_S_MEDIUM_FONT_SIZE$2 = '0.875rem';
const YLE_NEXT_S_MEDIUM_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_S_MEDIUM_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_S_MEDIUM_FONT_WEIGHT$2 = 500;
const YLE_NEXT_S_MEDIUM_FONT_STYLE$2 = 'normal';
const YLE_NEXT_S_MEDIUM_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_S_MEDIUM_FONT_STYLE_OLD$2 = 'Medium';
const YLE_NEXT_S_MEDIUM_LETTER_SPACING$2 = 0;
const YLE_NEXT_S_MEDIUM_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_S_MEDIUM_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_S_MEDIUM_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_S_MEDIUM_TEXT_CASE$2 = 'none';
const YLE_NEXT_S_BOLD_FONT_SIZE$2 = '0.875rem';
const YLE_NEXT_S_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_S_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_S_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_S_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_S_BOLD_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_S_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_S_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_S_BOLD_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_S_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_S_BOLD_PARAGRAPH_SPACING$2 = '0.875rem';
const YLE_NEXT_S_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_S_BOLD_AC_FONT_SIZE$2 = '0.875rem';
const YLE_NEXT_S_BOLD_AC_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_S_BOLD_AC_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_S_BOLD_AC_FONT_WEIGHT$2 = 700;
const YLE_NEXT_S_BOLD_AC_FONT_STYLE$2 = 'normal';
const YLE_NEXT_S_BOLD_AC_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_S_BOLD_AC_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_S_BOLD_AC_LETTER_SPACING$2 = '0.01em';
const YLE_NEXT_S_BOLD_AC_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_S_BOLD_AC_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_S_BOLD_AC_PARAGRAPH_SPACING$2 = '0.875rem';
const YLE_NEXT_S_BOLD_AC_TEXT_CASE$2 = 'uppercase';
const YLE_NEXT_S_CONDENSED_FONT_SIZE$2 = '0.875rem';
const YLE_NEXT_S_CONDENSED_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_S_CONDENSED_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_S_CONDENSED_FONT_WEIGHT$2 = 400;
const YLE_NEXT_S_CONDENSED_FONT_STYLE$2 = 'normal';
const YLE_NEXT_S_CONDENSED_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_S_CONDENSED_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_S_CONDENSED_LETTER_SPACING$2 = 0;
const YLE_NEXT_S_CONDENSED_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_S_CONDENSED_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_S_CONDENSED_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_S_CONDENSED_TEXT_CASE$2 = 'none';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_SIZE$2 = '0.875rem';
const YLE_NEXT_S_CONDENSED_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_S_CONDENSED_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_S_CONDENSED_BOLD_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_S_CONDENSED_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_XS_FONT_SIZE$2 = '0.75rem';
const YLE_NEXT_XS_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XS_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XS_FONT_WEIGHT$2 = 400;
const YLE_NEXT_XS_FONT_STYLE$2 = 'normal';
const YLE_NEXT_XS_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_XS_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_XS_LETTER_SPACING$2 = 0;
const YLE_NEXT_XS_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_XS_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XS_PARAGRAPH_SPACING$2 = '0.75rem';
const YLE_NEXT_XS_TEXT_CASE$2 = 'none';
const YLE_NEXT_XS_ITALIC_FONT_SIZE$2 = '0.75rem';
const YLE_NEXT_XS_ITALIC_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XS_ITALIC_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XS_ITALIC_FONT_WEIGHT$2 = 400;
const YLE_NEXT_XS_ITALIC_FONT_STYLE$2 = 'italic';
const YLE_NEXT_XS_ITALIC_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_XS_ITALIC_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_XS_ITALIC_LETTER_SPACING$2 = 0;
const YLE_NEXT_XS_ITALIC_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_XS_ITALIC_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XS_ITALIC_PARAGRAPH_SPACING$2 = '0.75rem';
const YLE_NEXT_XS_ITALIC_TEXT_CASE$2 = 'none';
const YLE_NEXT_XS_AC_FONT_SIZE$2 = '0.75rem';
const YLE_NEXT_XS_AC_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XS_AC_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XS_AC_FONT_WEIGHT$2 = 400;
const YLE_NEXT_XS_AC_FONT_STYLE$2 = 'normal';
const YLE_NEXT_XS_AC_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_XS_AC_FONT_STYLE_OLD$2 = 'Regular';
const YLE_NEXT_XS_AC_LETTER_SPACING$2 = '0.01em';
const YLE_NEXT_XS_AC_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_XS_AC_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XS_AC_PARAGRAPH_SPACING$2 = '0.75rem';
const YLE_NEXT_XS_AC_TEXT_CASE$2 = 'uppercase';
const YLE_NEXT_XS_BOLD_FONT_SIZE$2 = '0.75rem';
const YLE_NEXT_XS_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XS_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XS_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_XS_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_XS_BOLD_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_XS_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_XS_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_XS_BOLD_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_XS_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XS_BOLD_PARAGRAPH_SPACING$2 = '0.75rem';
const YLE_NEXT_XS_BOLD_TEXT_CASE$2 = 'none';
const YLE_NEXT_XS_BOLD_AC_FONT_SIZE$2 = '0.75rem';
const YLE_NEXT_XS_BOLD_AC_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XS_BOLD_AC_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XS_BOLD_AC_FONT_WEIGHT$2 = 700;
const YLE_NEXT_XS_BOLD_AC_FONT_STYLE$2 = 'normal';
const YLE_NEXT_XS_BOLD_AC_FONT_STRETCH$2 = 'normal';
const YLE_NEXT_XS_BOLD_AC_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_XS_BOLD_AC_LETTER_SPACING$2 = '0.01em';
const YLE_NEXT_XS_BOLD_AC_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_XS_BOLD_AC_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XS_BOLD_AC_PARAGRAPH_SPACING$2 = '0.75rem';
const YLE_NEXT_XS_BOLD_AC_TEXT_CASE$2 = 'uppercase';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_SIZE$2 = '0.75rem';
const YLE_NEXT_XS_CONDENSED_BOLD_TEXT_DECORATION$2 = 'none';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_FAMILY$2 = 'Yle Next';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_WEIGHT$2 = 700;
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE$2 = 'normal';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_STRETCH$2 = 'condensed';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE_OLD$2 = 'Bold';
const YLE_NEXT_XS_CONDENSED_BOLD_LETTER_SPACING$2 = 0;
const YLE_NEXT_XS_CONDENSED_BOLD_LINE_HEIGHT$2 = '1.50';
const YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT$2 = 0;
const YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING$2 = 0;
const YLE_NEXT_XS_CONDENSED_BOLD_TEXT_CASE$2 = 'none';

var typography = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DEFAULT_2XL_BOLD_FONT_FAMILY: DEFAULT_2XL_BOLD_FONT_FAMILY$2,
  DEFAULT_2XL_BOLD_FONT_SIZE: DEFAULT_2XL_BOLD_FONT_SIZE$2,
  DEFAULT_2XL_BOLD_FONT_STRETCH: DEFAULT_2XL_BOLD_FONT_STRETCH$2,
  DEFAULT_2XL_BOLD_FONT_STYLE: DEFAULT_2XL_BOLD_FONT_STYLE$2,
  DEFAULT_2XL_BOLD_FONT_STYLE_OLD: DEFAULT_2XL_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_2XL_BOLD_FONT_WEIGHT: DEFAULT_2XL_BOLD_FONT_WEIGHT$2,
  DEFAULT_2XL_BOLD_LETTER_SPACING: DEFAULT_2XL_BOLD_LETTER_SPACING$2,
  DEFAULT_2XL_BOLD_LINE_HEIGHT: DEFAULT_2XL_BOLD_LINE_HEIGHT$2,
  DEFAULT_2XL_BOLD_PARAGRAPH_INDENT: DEFAULT_2XL_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_2XL_BOLD_PARAGRAPH_SPACING: DEFAULT_2XL_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_2XL_BOLD_TEXT_CASE: DEFAULT_2XL_BOLD_TEXT_CASE$2,
  DEFAULT_2XL_BOLD_TEXT_DECORATION: DEFAULT_2XL_BOLD_TEXT_DECORATION$2,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_2XL_CONDENSED_BOLD_FONT_FAMILY$2,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_SIZE: DEFAULT_2XL_CONDENSED_BOLD_FONT_SIZE$2,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_2XL_CONDENSED_BOLD_FONT_STRETCH$2,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE: DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE$2,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_2XL_CONDENSED_BOLD_FONT_WEIGHT$2,
  DEFAULT_2XL_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_2XL_CONDENSED_BOLD_LETTER_SPACING$2,
  DEFAULT_2XL_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_2XL_CONDENSED_BOLD_LINE_HEIGHT$2,
  DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_2XL_CONDENSED_BOLD_TEXT_CASE: DEFAULT_2XL_CONDENSED_BOLD_TEXT_CASE$2,
  DEFAULT_2XL_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_2XL_CONDENSED_BOLD_TEXT_DECORATION$2,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_2XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_2XL_CONDENSED_HEAVY_FONT_SIZE$2,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_2XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE$2,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_2XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  DEFAULT_2XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_2XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  DEFAULT_2XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_2XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_2XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_2XL_CONDENSED_HEAVY_TEXT_CASE$2,
  DEFAULT_2XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_2XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  DEFAULT_2XL_FONT_FAMILY: DEFAULT_2XL_FONT_FAMILY$2,
  DEFAULT_2XL_FONT_SIZE: DEFAULT_2XL_FONT_SIZE$2,
  DEFAULT_2XL_FONT_STRETCH: DEFAULT_2XL_FONT_STRETCH$2,
  DEFAULT_2XL_FONT_STYLE: DEFAULT_2XL_FONT_STYLE$2,
  DEFAULT_2XL_FONT_STYLE_OLD: DEFAULT_2XL_FONT_STYLE_OLD$2,
  DEFAULT_2XL_FONT_WEIGHT: DEFAULT_2XL_FONT_WEIGHT$2,
  DEFAULT_2XL_HEAVY_FONT_FAMILY: DEFAULT_2XL_HEAVY_FONT_FAMILY$2,
  DEFAULT_2XL_HEAVY_FONT_SIZE: DEFAULT_2XL_HEAVY_FONT_SIZE$2,
  DEFAULT_2XL_HEAVY_FONT_STRETCH: DEFAULT_2XL_HEAVY_FONT_STRETCH$2,
  DEFAULT_2XL_HEAVY_FONT_STYLE: DEFAULT_2XL_HEAVY_FONT_STYLE$2,
  DEFAULT_2XL_HEAVY_FONT_STYLE_OLD: DEFAULT_2XL_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_2XL_HEAVY_FONT_WEIGHT: DEFAULT_2XL_HEAVY_FONT_WEIGHT$2,
  DEFAULT_2XL_HEAVY_LETTER_SPACING: DEFAULT_2XL_HEAVY_LETTER_SPACING$2,
  DEFAULT_2XL_HEAVY_LINE_HEIGHT: DEFAULT_2XL_HEAVY_LINE_HEIGHT$2,
  DEFAULT_2XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_2XL_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_2XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_2XL_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_2XL_HEAVY_TEXT_CASE: DEFAULT_2XL_HEAVY_TEXT_CASE$2,
  DEFAULT_2XL_HEAVY_TEXT_DECORATION: DEFAULT_2XL_HEAVY_TEXT_DECORATION$2,
  DEFAULT_2XL_LETTER_SPACING: DEFAULT_2XL_LETTER_SPACING$2,
  DEFAULT_2XL_LINE_HEIGHT: DEFAULT_2XL_LINE_HEIGHT$2,
  DEFAULT_2XL_PARAGRAPH_INDENT: DEFAULT_2XL_PARAGRAPH_INDENT$2,
  DEFAULT_2XL_PARAGRAPH_SPACING: DEFAULT_2XL_PARAGRAPH_SPACING$2,
  DEFAULT_2XL_TEXT_CASE: DEFAULT_2XL_TEXT_CASE$2,
  DEFAULT_2XL_TEXT_DECORATION: DEFAULT_2XL_TEXT_DECORATION$2,
  DEFAULT_3XL_BOLD_FONT_FAMILY: DEFAULT_3XL_BOLD_FONT_FAMILY$2,
  DEFAULT_3XL_BOLD_FONT_SIZE: DEFAULT_3XL_BOLD_FONT_SIZE$2,
  DEFAULT_3XL_BOLD_FONT_STRETCH: DEFAULT_3XL_BOLD_FONT_STRETCH$2,
  DEFAULT_3XL_BOLD_FONT_STYLE: DEFAULT_3XL_BOLD_FONT_STYLE$2,
  DEFAULT_3XL_BOLD_FONT_STYLE_OLD: DEFAULT_3XL_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_3XL_BOLD_FONT_WEIGHT: DEFAULT_3XL_BOLD_FONT_WEIGHT$2,
  DEFAULT_3XL_BOLD_LETTER_SPACING: DEFAULT_3XL_BOLD_LETTER_SPACING$2,
  DEFAULT_3XL_BOLD_LINE_HEIGHT: DEFAULT_3XL_BOLD_LINE_HEIGHT$2,
  DEFAULT_3XL_BOLD_PARAGRAPH_INDENT: DEFAULT_3XL_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_3XL_BOLD_PARAGRAPH_SPACING: DEFAULT_3XL_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_3XL_BOLD_TEXT_CASE: DEFAULT_3XL_BOLD_TEXT_CASE$2,
  DEFAULT_3XL_BOLD_TEXT_DECORATION: DEFAULT_3XL_BOLD_TEXT_DECORATION$2,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_3XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_3XL_CONDENSED_HEAVY_FONT_SIZE$2,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_3XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE$2,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_3XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  DEFAULT_3XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_3XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  DEFAULT_3XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_3XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_3XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_3XL_CONDENSED_HEAVY_TEXT_CASE$2,
  DEFAULT_3XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_3XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  DEFAULT_3XL_HEAVY_FONT_FAMILY: DEFAULT_3XL_HEAVY_FONT_FAMILY$2,
  DEFAULT_3XL_HEAVY_FONT_SIZE: DEFAULT_3XL_HEAVY_FONT_SIZE$2,
  DEFAULT_3XL_HEAVY_FONT_STRETCH: DEFAULT_3XL_HEAVY_FONT_STRETCH$2,
  DEFAULT_3XL_HEAVY_FONT_STYLE: DEFAULT_3XL_HEAVY_FONT_STYLE$2,
  DEFAULT_3XL_HEAVY_FONT_STYLE_OLD: DEFAULT_3XL_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_3XL_HEAVY_FONT_WEIGHT: DEFAULT_3XL_HEAVY_FONT_WEIGHT$2,
  DEFAULT_3XL_HEAVY_LETTER_SPACING: DEFAULT_3XL_HEAVY_LETTER_SPACING$2,
  DEFAULT_3XL_HEAVY_LINE_HEIGHT: DEFAULT_3XL_HEAVY_LINE_HEIGHT$2,
  DEFAULT_3XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_3XL_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_3XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_3XL_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_3XL_HEAVY_TEXT_CASE: DEFAULT_3XL_HEAVY_TEXT_CASE$2,
  DEFAULT_3XL_HEAVY_TEXT_DECORATION: DEFAULT_3XL_HEAVY_TEXT_DECORATION$2,
  DEFAULT_4XL_BOLD_FONT_FAMILY: DEFAULT_4XL_BOLD_FONT_FAMILY$2,
  DEFAULT_4XL_BOLD_FONT_SIZE: DEFAULT_4XL_BOLD_FONT_SIZE$2,
  DEFAULT_4XL_BOLD_FONT_STRETCH: DEFAULT_4XL_BOLD_FONT_STRETCH$2,
  DEFAULT_4XL_BOLD_FONT_STYLE: DEFAULT_4XL_BOLD_FONT_STYLE$2,
  DEFAULT_4XL_BOLD_FONT_STYLE_OLD: DEFAULT_4XL_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_4XL_BOLD_FONT_WEIGHT: DEFAULT_4XL_BOLD_FONT_WEIGHT$2,
  DEFAULT_4XL_BOLD_LETTER_SPACING: DEFAULT_4XL_BOLD_LETTER_SPACING$2,
  DEFAULT_4XL_BOLD_LINE_HEIGHT: DEFAULT_4XL_BOLD_LINE_HEIGHT$2,
  DEFAULT_4XL_BOLD_PARAGRAPH_INDENT: DEFAULT_4XL_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_4XL_BOLD_PARAGRAPH_SPACING: DEFAULT_4XL_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_4XL_BOLD_TEXT_CASE: DEFAULT_4XL_BOLD_TEXT_CASE$2,
  DEFAULT_4XL_BOLD_TEXT_DECORATION: DEFAULT_4XL_BOLD_TEXT_DECORATION$2,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_4XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_4XL_CONDENSED_HEAVY_FONT_SIZE$2,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_4XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE$2,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_4XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  DEFAULT_4XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_4XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  DEFAULT_4XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_4XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_4XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_4XL_CONDENSED_HEAVY_TEXT_CASE$2,
  DEFAULT_4XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_4XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  DEFAULT_4XL_HEAVY_FONT_FAMILY: DEFAULT_4XL_HEAVY_FONT_FAMILY$2,
  DEFAULT_4XL_HEAVY_FONT_SIZE: DEFAULT_4XL_HEAVY_FONT_SIZE$2,
  DEFAULT_4XL_HEAVY_FONT_STRETCH: DEFAULT_4XL_HEAVY_FONT_STRETCH$2,
  DEFAULT_4XL_HEAVY_FONT_STYLE: DEFAULT_4XL_HEAVY_FONT_STYLE$2,
  DEFAULT_4XL_HEAVY_FONT_STYLE_OLD: DEFAULT_4XL_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_4XL_HEAVY_FONT_WEIGHT: DEFAULT_4XL_HEAVY_FONT_WEIGHT$2,
  DEFAULT_4XL_HEAVY_LETTER_SPACING: DEFAULT_4XL_HEAVY_LETTER_SPACING$2,
  DEFAULT_4XL_HEAVY_LINE_HEIGHT: DEFAULT_4XL_HEAVY_LINE_HEIGHT$2,
  DEFAULT_4XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_4XL_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_4XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_4XL_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_4XL_HEAVY_TEXT_CASE: DEFAULT_4XL_HEAVY_TEXT_CASE$2,
  DEFAULT_4XL_HEAVY_TEXT_DECORATION: DEFAULT_4XL_HEAVY_TEXT_DECORATION$2,
  DEFAULT_5XL_BOLD_FONT_FAMILY: DEFAULT_5XL_BOLD_FONT_FAMILY$2,
  DEFAULT_5XL_BOLD_FONT_SIZE: DEFAULT_5XL_BOLD_FONT_SIZE$2,
  DEFAULT_5XL_BOLD_FONT_STRETCH: DEFAULT_5XL_BOLD_FONT_STRETCH$2,
  DEFAULT_5XL_BOLD_FONT_STYLE: DEFAULT_5XL_BOLD_FONT_STYLE$2,
  DEFAULT_5XL_BOLD_FONT_STYLE_OLD: DEFAULT_5XL_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_5XL_BOLD_FONT_WEIGHT: DEFAULT_5XL_BOLD_FONT_WEIGHT$2,
  DEFAULT_5XL_BOLD_LETTER_SPACING: DEFAULT_5XL_BOLD_LETTER_SPACING$2,
  DEFAULT_5XL_BOLD_LINE_HEIGHT: DEFAULT_5XL_BOLD_LINE_HEIGHT$2,
  DEFAULT_5XL_BOLD_PARAGRAPH_INDENT: DEFAULT_5XL_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_5XL_BOLD_PARAGRAPH_SPACING: DEFAULT_5XL_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_5XL_BOLD_TEXT_CASE: DEFAULT_5XL_BOLD_TEXT_CASE$2,
  DEFAULT_5XL_BOLD_TEXT_DECORATION: DEFAULT_5XL_BOLD_TEXT_DECORATION$2,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_5XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_5XL_CONDENSED_HEAVY_FONT_SIZE$2,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_5XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE$2,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_5XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  DEFAULT_5XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_5XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  DEFAULT_5XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_5XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_5XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_5XL_CONDENSED_HEAVY_TEXT_CASE$2,
  DEFAULT_5XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_5XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  DEFAULT_5XL_HEAVY_FONT_FAMILY: DEFAULT_5XL_HEAVY_FONT_FAMILY$2,
  DEFAULT_5XL_HEAVY_FONT_SIZE: DEFAULT_5XL_HEAVY_FONT_SIZE$2,
  DEFAULT_5XL_HEAVY_FONT_STRETCH: DEFAULT_5XL_HEAVY_FONT_STRETCH$2,
  DEFAULT_5XL_HEAVY_FONT_STYLE: DEFAULT_5XL_HEAVY_FONT_STYLE$2,
  DEFAULT_5XL_HEAVY_FONT_STYLE_OLD: DEFAULT_5XL_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_5XL_HEAVY_FONT_WEIGHT: DEFAULT_5XL_HEAVY_FONT_WEIGHT$2,
  DEFAULT_5XL_HEAVY_LETTER_SPACING: DEFAULT_5XL_HEAVY_LETTER_SPACING$2,
  DEFAULT_5XL_HEAVY_LINE_HEIGHT: DEFAULT_5XL_HEAVY_LINE_HEIGHT$2,
  DEFAULT_5XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_5XL_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_5XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_5XL_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_5XL_HEAVY_TEXT_CASE: DEFAULT_5XL_HEAVY_TEXT_CASE$2,
  DEFAULT_5XL_HEAVY_TEXT_DECORATION: DEFAULT_5XL_HEAVY_TEXT_DECORATION$2,
  DEFAULT_6XL_BOLD_FONT_FAMILY: DEFAULT_6XL_BOLD_FONT_FAMILY$2,
  DEFAULT_6XL_BOLD_FONT_SIZE: DEFAULT_6XL_BOLD_FONT_SIZE$2,
  DEFAULT_6XL_BOLD_FONT_STRETCH: DEFAULT_6XL_BOLD_FONT_STRETCH$2,
  DEFAULT_6XL_BOLD_FONT_STYLE: DEFAULT_6XL_BOLD_FONT_STYLE$2,
  DEFAULT_6XL_BOLD_FONT_STYLE_OLD: DEFAULT_6XL_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_6XL_BOLD_FONT_WEIGHT: DEFAULT_6XL_BOLD_FONT_WEIGHT$2,
  DEFAULT_6XL_BOLD_LETTER_SPACING: DEFAULT_6XL_BOLD_LETTER_SPACING$2,
  DEFAULT_6XL_BOLD_LINE_HEIGHT: DEFAULT_6XL_BOLD_LINE_HEIGHT$2,
  DEFAULT_6XL_BOLD_PARAGRAPH_INDENT: DEFAULT_6XL_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_6XL_BOLD_PARAGRAPH_SPACING: DEFAULT_6XL_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_6XL_BOLD_TEXT_CASE: DEFAULT_6XL_BOLD_TEXT_CASE$2,
  DEFAULT_6XL_BOLD_TEXT_DECORATION: DEFAULT_6XL_BOLD_TEXT_DECORATION$2,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_6XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_6XL_CONDENSED_HEAVY_FONT_SIZE$2,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_6XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE$2,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_6XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  DEFAULT_6XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_6XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  DEFAULT_6XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_6XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_6XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_6XL_CONDENSED_HEAVY_TEXT_CASE$2,
  DEFAULT_6XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_6XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  DEFAULT_6XL_HEAVY_FONT_FAMILY: DEFAULT_6XL_HEAVY_FONT_FAMILY$2,
  DEFAULT_6XL_HEAVY_FONT_SIZE: DEFAULT_6XL_HEAVY_FONT_SIZE$2,
  DEFAULT_6XL_HEAVY_FONT_STRETCH: DEFAULT_6XL_HEAVY_FONT_STRETCH$2,
  DEFAULT_6XL_HEAVY_FONT_STYLE: DEFAULT_6XL_HEAVY_FONT_STYLE$2,
  DEFAULT_6XL_HEAVY_FONT_STYLE_OLD: DEFAULT_6XL_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_6XL_HEAVY_FONT_WEIGHT: DEFAULT_6XL_HEAVY_FONT_WEIGHT$2,
  DEFAULT_6XL_HEAVY_LETTER_SPACING: DEFAULT_6XL_HEAVY_LETTER_SPACING$2,
  DEFAULT_6XL_HEAVY_LINE_HEIGHT: DEFAULT_6XL_HEAVY_LINE_HEIGHT$2,
  DEFAULT_6XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_6XL_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_6XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_6XL_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_6XL_HEAVY_TEXT_CASE: DEFAULT_6XL_HEAVY_TEXT_CASE$2,
  DEFAULT_6XL_HEAVY_TEXT_DECORATION: DEFAULT_6XL_HEAVY_TEXT_DECORATION$2,
  DEFAULT_7XL_BOLD_FONT_FAMILY: DEFAULT_7XL_BOLD_FONT_FAMILY$2,
  DEFAULT_7XL_BOLD_FONT_SIZE: DEFAULT_7XL_BOLD_FONT_SIZE$2,
  DEFAULT_7XL_BOLD_FONT_STRETCH: DEFAULT_7XL_BOLD_FONT_STRETCH$2,
  DEFAULT_7XL_BOLD_FONT_STYLE: DEFAULT_7XL_BOLD_FONT_STYLE$2,
  DEFAULT_7XL_BOLD_FONT_STYLE_OLD: DEFAULT_7XL_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_7XL_BOLD_FONT_WEIGHT: DEFAULT_7XL_BOLD_FONT_WEIGHT$2,
  DEFAULT_7XL_BOLD_LETTER_SPACING: DEFAULT_7XL_BOLD_LETTER_SPACING$2,
  DEFAULT_7XL_BOLD_LINE_HEIGHT: DEFAULT_7XL_BOLD_LINE_HEIGHT$2,
  DEFAULT_7XL_BOLD_PARAGRAPH_INDENT: DEFAULT_7XL_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_7XL_BOLD_PARAGRAPH_SPACING: DEFAULT_7XL_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_7XL_BOLD_TEXT_CASE: DEFAULT_7XL_BOLD_TEXT_CASE$2,
  DEFAULT_7XL_BOLD_TEXT_DECORATION: DEFAULT_7XL_BOLD_TEXT_DECORATION$2,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_7XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_7XL_CONDENSED_HEAVY_FONT_SIZE$2,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_7XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE$2,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_7XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  DEFAULT_7XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_7XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  DEFAULT_7XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_7XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_7XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_7XL_CONDENSED_HEAVY_TEXT_CASE$2,
  DEFAULT_7XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_7XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  DEFAULT_7XL_HEAVY_FONT_FAMILY: DEFAULT_7XL_HEAVY_FONT_FAMILY$2,
  DEFAULT_7XL_HEAVY_FONT_SIZE: DEFAULT_7XL_HEAVY_FONT_SIZE$2,
  DEFAULT_7XL_HEAVY_FONT_STRETCH: DEFAULT_7XL_HEAVY_FONT_STRETCH$2,
  DEFAULT_7XL_HEAVY_FONT_STYLE: DEFAULT_7XL_HEAVY_FONT_STYLE$2,
  DEFAULT_7XL_HEAVY_FONT_STYLE_OLD: DEFAULT_7XL_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_7XL_HEAVY_FONT_WEIGHT: DEFAULT_7XL_HEAVY_FONT_WEIGHT$2,
  DEFAULT_7XL_HEAVY_LETTER_SPACING: DEFAULT_7XL_HEAVY_LETTER_SPACING$2,
  DEFAULT_7XL_HEAVY_LINE_HEIGHT: DEFAULT_7XL_HEAVY_LINE_HEIGHT$2,
  DEFAULT_7XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_7XL_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_7XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_7XL_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_7XL_HEAVY_TEXT_CASE: DEFAULT_7XL_HEAVY_TEXT_CASE$2,
  DEFAULT_7XL_HEAVY_TEXT_DECORATION: DEFAULT_7XL_HEAVY_TEXT_DECORATION$2,
  DEFAULT_L_BOLD_FONT_FAMILY: DEFAULT_L_BOLD_FONT_FAMILY$2,
  DEFAULT_L_BOLD_FONT_SIZE: DEFAULT_L_BOLD_FONT_SIZE$2,
  DEFAULT_L_BOLD_FONT_STRETCH: DEFAULT_L_BOLD_FONT_STRETCH$2,
  DEFAULT_L_BOLD_FONT_STYLE: DEFAULT_L_BOLD_FONT_STYLE$2,
  DEFAULT_L_BOLD_FONT_STYLE_OLD: DEFAULT_L_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_L_BOLD_FONT_WEIGHT: DEFAULT_L_BOLD_FONT_WEIGHT$2,
  DEFAULT_L_BOLD_LETTER_SPACING: DEFAULT_L_BOLD_LETTER_SPACING$2,
  DEFAULT_L_BOLD_LINE_HEIGHT: DEFAULT_L_BOLD_LINE_HEIGHT$2,
  DEFAULT_L_BOLD_PARAGRAPH_INDENT: DEFAULT_L_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_L_BOLD_PARAGRAPH_SPACING: DEFAULT_L_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_L_BOLD_TEXT_CASE: DEFAULT_L_BOLD_TEXT_CASE$2,
  DEFAULT_L_BOLD_TEXT_DECORATION: DEFAULT_L_BOLD_TEXT_DECORATION$2,
  DEFAULT_L_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_L_CONDENSED_BOLD_FONT_FAMILY$2,
  DEFAULT_L_CONDENSED_BOLD_FONT_SIZE: DEFAULT_L_CONDENSED_BOLD_FONT_SIZE$2,
  DEFAULT_L_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_L_CONDENSED_BOLD_FONT_STRETCH$2,
  DEFAULT_L_CONDENSED_BOLD_FONT_STYLE: DEFAULT_L_CONDENSED_BOLD_FONT_STYLE$2,
  DEFAULT_L_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_L_CONDENSED_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_L_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_L_CONDENSED_BOLD_FONT_WEIGHT$2,
  DEFAULT_L_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_L_CONDENSED_BOLD_LETTER_SPACING$2,
  DEFAULT_L_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_L_CONDENSED_BOLD_LINE_HEIGHT$2,
  DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_L_CONDENSED_BOLD_TEXT_CASE: DEFAULT_L_CONDENSED_BOLD_TEXT_CASE$2,
  DEFAULT_L_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_L_CONDENSED_BOLD_TEXT_DECORATION$2,
  DEFAULT_L_CONDENSED_FONT_FAMILY: DEFAULT_L_CONDENSED_FONT_FAMILY$2,
  DEFAULT_L_CONDENSED_FONT_SIZE: DEFAULT_L_CONDENSED_FONT_SIZE$2,
  DEFAULT_L_CONDENSED_FONT_STRETCH: DEFAULT_L_CONDENSED_FONT_STRETCH$2,
  DEFAULT_L_CONDENSED_FONT_STYLE: DEFAULT_L_CONDENSED_FONT_STYLE$2,
  DEFAULT_L_CONDENSED_FONT_STYLE_OLD: DEFAULT_L_CONDENSED_FONT_STYLE_OLD$2,
  DEFAULT_L_CONDENSED_FONT_WEIGHT: DEFAULT_L_CONDENSED_FONT_WEIGHT$2,
  DEFAULT_L_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_L_CONDENSED_HEAVY_FONT_FAMILY$2,
  DEFAULT_L_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_L_CONDENSED_HEAVY_FONT_SIZE$2,
  DEFAULT_L_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_L_CONDENSED_HEAVY_FONT_STRETCH$2,
  DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE$2,
  DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_L_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_L_CONDENSED_HEAVY_FONT_WEIGHT$2,
  DEFAULT_L_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_L_CONDENSED_HEAVY_LETTER_SPACING$2,
  DEFAULT_L_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_L_CONDENSED_HEAVY_LINE_HEIGHT$2,
  DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_L_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_L_CONDENSED_HEAVY_TEXT_CASE$2,
  DEFAULT_L_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_L_CONDENSED_HEAVY_TEXT_DECORATION$2,
  DEFAULT_L_CONDENSED_LETTER_SPACING: DEFAULT_L_CONDENSED_LETTER_SPACING$2,
  DEFAULT_L_CONDENSED_LINE_HEIGHT: DEFAULT_L_CONDENSED_LINE_HEIGHT$2,
  DEFAULT_L_CONDENSED_PARAGRAPH_INDENT: DEFAULT_L_CONDENSED_PARAGRAPH_INDENT$2,
  DEFAULT_L_CONDENSED_PARAGRAPH_SPACING: DEFAULT_L_CONDENSED_PARAGRAPH_SPACING$2,
  DEFAULT_L_CONDENSED_TEXT_CASE: DEFAULT_L_CONDENSED_TEXT_CASE$2,
  DEFAULT_L_CONDENSED_TEXT_DECORATION: DEFAULT_L_CONDENSED_TEXT_DECORATION$2,
  DEFAULT_L_FONT_FAMILY: DEFAULT_L_FONT_FAMILY$2,
  DEFAULT_L_FONT_SIZE: DEFAULT_L_FONT_SIZE$2,
  DEFAULT_L_FONT_STRETCH: DEFAULT_L_FONT_STRETCH$2,
  DEFAULT_L_FONT_STYLE: DEFAULT_L_FONT_STYLE$2,
  DEFAULT_L_FONT_STYLE_OLD: DEFAULT_L_FONT_STYLE_OLD$2,
  DEFAULT_L_FONT_WEIGHT: DEFAULT_L_FONT_WEIGHT$2,
  DEFAULT_L_HEAVY_FONT_FAMILY: DEFAULT_L_HEAVY_FONT_FAMILY$2,
  DEFAULT_L_HEAVY_FONT_SIZE: DEFAULT_L_HEAVY_FONT_SIZE$2,
  DEFAULT_L_HEAVY_FONT_STRETCH: DEFAULT_L_HEAVY_FONT_STRETCH$2,
  DEFAULT_L_HEAVY_FONT_STYLE: DEFAULT_L_HEAVY_FONT_STYLE$2,
  DEFAULT_L_HEAVY_FONT_STYLE_OLD: DEFAULT_L_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_L_HEAVY_FONT_WEIGHT: DEFAULT_L_HEAVY_FONT_WEIGHT$2,
  DEFAULT_L_HEAVY_LETTER_SPACING: DEFAULT_L_HEAVY_LETTER_SPACING$2,
  DEFAULT_L_HEAVY_LINE_HEIGHT: DEFAULT_L_HEAVY_LINE_HEIGHT$2,
  DEFAULT_L_HEAVY_PARAGRAPH_INDENT: DEFAULT_L_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_L_HEAVY_PARAGRAPH_SPACING: DEFAULT_L_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_L_HEAVY_TEXT_CASE: DEFAULT_L_HEAVY_TEXT_CASE$2,
  DEFAULT_L_HEAVY_TEXT_DECORATION: DEFAULT_L_HEAVY_TEXT_DECORATION$2,
  DEFAULT_L_ITALIC_FONT_FAMILY: DEFAULT_L_ITALIC_FONT_FAMILY$2,
  DEFAULT_L_ITALIC_FONT_SIZE: DEFAULT_L_ITALIC_FONT_SIZE$2,
  DEFAULT_L_ITALIC_FONT_STRETCH: DEFAULT_L_ITALIC_FONT_STRETCH$2,
  DEFAULT_L_ITALIC_FONT_STYLE: DEFAULT_L_ITALIC_FONT_STYLE$2,
  DEFAULT_L_ITALIC_FONT_STYLE_OLD: DEFAULT_L_ITALIC_FONT_STYLE_OLD$2,
  DEFAULT_L_ITALIC_FONT_WEIGHT: DEFAULT_L_ITALIC_FONT_WEIGHT$2,
  DEFAULT_L_ITALIC_LETTER_SPACING: DEFAULT_L_ITALIC_LETTER_SPACING$2,
  DEFAULT_L_ITALIC_LINE_HEIGHT: DEFAULT_L_ITALIC_LINE_HEIGHT$2,
  DEFAULT_L_ITALIC_PARAGRAPH_INDENT: DEFAULT_L_ITALIC_PARAGRAPH_INDENT$2,
  DEFAULT_L_ITALIC_PARAGRAPH_SPACING: DEFAULT_L_ITALIC_PARAGRAPH_SPACING$2,
  DEFAULT_L_ITALIC_TEXT_CASE: DEFAULT_L_ITALIC_TEXT_CASE$2,
  DEFAULT_L_ITALIC_TEXT_DECORATION: DEFAULT_L_ITALIC_TEXT_DECORATION$2,
  DEFAULT_L_LETTER_SPACING: DEFAULT_L_LETTER_SPACING$2,
  DEFAULT_L_LINE_HEIGHT: DEFAULT_L_LINE_HEIGHT$2,
  DEFAULT_L_PARAGRAPH_INDENT: DEFAULT_L_PARAGRAPH_INDENT$2,
  DEFAULT_L_PARAGRAPH_SPACING: DEFAULT_L_PARAGRAPH_SPACING$2,
  DEFAULT_L_TEXT_CASE: DEFAULT_L_TEXT_CASE$2,
  DEFAULT_L_TEXT_DECORATION: DEFAULT_L_TEXT_DECORATION$2,
  DEFAULT_M_AC_FONT_FAMILY: DEFAULT_M_AC_FONT_FAMILY$2,
  DEFAULT_M_AC_FONT_SIZE: DEFAULT_M_AC_FONT_SIZE$2,
  DEFAULT_M_AC_FONT_STRETCH: DEFAULT_M_AC_FONT_STRETCH$2,
  DEFAULT_M_AC_FONT_STYLE: DEFAULT_M_AC_FONT_STYLE$2,
  DEFAULT_M_AC_FONT_STYLE_OLD: DEFAULT_M_AC_FONT_STYLE_OLD$2,
  DEFAULT_M_AC_FONT_WEIGHT: DEFAULT_M_AC_FONT_WEIGHT$2,
  DEFAULT_M_AC_LETTER_SPACING: DEFAULT_M_AC_LETTER_SPACING$2,
  DEFAULT_M_AC_LINE_HEIGHT: DEFAULT_M_AC_LINE_HEIGHT$2,
  DEFAULT_M_AC_PARAGRAPH_INDENT: DEFAULT_M_AC_PARAGRAPH_INDENT$2,
  DEFAULT_M_AC_PARAGRAPH_SPACING: DEFAULT_M_AC_PARAGRAPH_SPACING$2,
  DEFAULT_M_AC_TEXT_CASE: DEFAULT_M_AC_TEXT_CASE$2,
  DEFAULT_M_AC_TEXT_DECORATION: DEFAULT_M_AC_TEXT_DECORATION$2,
  DEFAULT_M_BOLD_AC_FONT_FAMILY: DEFAULT_M_BOLD_AC_FONT_FAMILY$2,
  DEFAULT_M_BOLD_AC_FONT_SIZE: DEFAULT_M_BOLD_AC_FONT_SIZE$2,
  DEFAULT_M_BOLD_AC_FONT_STRETCH: DEFAULT_M_BOLD_AC_FONT_STRETCH$2,
  DEFAULT_M_BOLD_AC_FONT_STYLE: DEFAULT_M_BOLD_AC_FONT_STYLE$2,
  DEFAULT_M_BOLD_AC_FONT_STYLE_OLD: DEFAULT_M_BOLD_AC_FONT_STYLE_OLD$2,
  DEFAULT_M_BOLD_AC_FONT_WEIGHT: DEFAULT_M_BOLD_AC_FONT_WEIGHT$2,
  DEFAULT_M_BOLD_AC_LETTER_SPACING: DEFAULT_M_BOLD_AC_LETTER_SPACING$2,
  DEFAULT_M_BOLD_AC_LINE_HEIGHT: DEFAULT_M_BOLD_AC_LINE_HEIGHT$2,
  DEFAULT_M_BOLD_AC_PARAGRAPH_INDENT: DEFAULT_M_BOLD_AC_PARAGRAPH_INDENT$2,
  DEFAULT_M_BOLD_AC_PARAGRAPH_SPACING: DEFAULT_M_BOLD_AC_PARAGRAPH_SPACING$2,
  DEFAULT_M_BOLD_AC_TEXT_CASE: DEFAULT_M_BOLD_AC_TEXT_CASE$2,
  DEFAULT_M_BOLD_AC_TEXT_DECORATION: DEFAULT_M_BOLD_AC_TEXT_DECORATION$2,
  DEFAULT_M_BOLD_FONT_FAMILY: DEFAULT_M_BOLD_FONT_FAMILY$2,
  DEFAULT_M_BOLD_FONT_SIZE: DEFAULT_M_BOLD_FONT_SIZE$2,
  DEFAULT_M_BOLD_FONT_STRETCH: DEFAULT_M_BOLD_FONT_STRETCH$2,
  DEFAULT_M_BOLD_FONT_STYLE: DEFAULT_M_BOLD_FONT_STYLE$2,
  DEFAULT_M_BOLD_FONT_STYLE_OLD: DEFAULT_M_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_M_BOLD_FONT_WEIGHT: DEFAULT_M_BOLD_FONT_WEIGHT$2,
  DEFAULT_M_BOLD_LETTER_SPACING: DEFAULT_M_BOLD_LETTER_SPACING$2,
  DEFAULT_M_BOLD_LINE_HEIGHT: DEFAULT_M_BOLD_LINE_HEIGHT$2,
  DEFAULT_M_BOLD_PARAGRAPH_INDENT: DEFAULT_M_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_M_BOLD_PARAGRAPH_SPACING: DEFAULT_M_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_M_BOLD_TEXT_CASE: DEFAULT_M_BOLD_TEXT_CASE$2,
  DEFAULT_M_BOLD_TEXT_DECORATION: DEFAULT_M_BOLD_TEXT_DECORATION$2,
  DEFAULT_M_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_M_CONDENSED_BOLD_FONT_FAMILY$2,
  DEFAULT_M_CONDENSED_BOLD_FONT_SIZE: DEFAULT_M_CONDENSED_BOLD_FONT_SIZE$2,
  DEFAULT_M_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_M_CONDENSED_BOLD_FONT_STRETCH$2,
  DEFAULT_M_CONDENSED_BOLD_FONT_STYLE: DEFAULT_M_CONDENSED_BOLD_FONT_STYLE$2,
  DEFAULT_M_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_M_CONDENSED_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_M_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_M_CONDENSED_BOLD_FONT_WEIGHT$2,
  DEFAULT_M_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_M_CONDENSED_BOLD_LETTER_SPACING$2,
  DEFAULT_M_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_M_CONDENSED_BOLD_LINE_HEIGHT$2,
  DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_M_CONDENSED_BOLD_TEXT_CASE: DEFAULT_M_CONDENSED_BOLD_TEXT_CASE$2,
  DEFAULT_M_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_M_CONDENSED_BOLD_TEXT_DECORATION$2,
  DEFAULT_M_CONDENSED_FONT_FAMILY: DEFAULT_M_CONDENSED_FONT_FAMILY$2,
  DEFAULT_M_CONDENSED_FONT_SIZE: DEFAULT_M_CONDENSED_FONT_SIZE$2,
  DEFAULT_M_CONDENSED_FONT_STRETCH: DEFAULT_M_CONDENSED_FONT_STRETCH$2,
  DEFAULT_M_CONDENSED_FONT_STYLE: DEFAULT_M_CONDENSED_FONT_STYLE$2,
  DEFAULT_M_CONDENSED_FONT_STYLE_OLD: DEFAULT_M_CONDENSED_FONT_STYLE_OLD$2,
  DEFAULT_M_CONDENSED_FONT_WEIGHT: DEFAULT_M_CONDENSED_FONT_WEIGHT$2,
  DEFAULT_M_CONDENSED_LETTER_SPACING: DEFAULT_M_CONDENSED_LETTER_SPACING$2,
  DEFAULT_M_CONDENSED_LINE_HEIGHT: DEFAULT_M_CONDENSED_LINE_HEIGHT$2,
  DEFAULT_M_CONDENSED_PARAGRAPH_INDENT: DEFAULT_M_CONDENSED_PARAGRAPH_INDENT$2,
  DEFAULT_M_CONDENSED_PARAGRAPH_SPACING: DEFAULT_M_CONDENSED_PARAGRAPH_SPACING$2,
  DEFAULT_M_CONDENSED_TEXT_CASE: DEFAULT_M_CONDENSED_TEXT_CASE$2,
  DEFAULT_M_CONDENSED_TEXT_DECORATION: DEFAULT_M_CONDENSED_TEXT_DECORATION$2,
  DEFAULT_M_FONT_FAMILY: DEFAULT_M_FONT_FAMILY$2,
  DEFAULT_M_FONT_SIZE: DEFAULT_M_FONT_SIZE$2,
  DEFAULT_M_FONT_STRETCH: DEFAULT_M_FONT_STRETCH$2,
  DEFAULT_M_FONT_STYLE: DEFAULT_M_FONT_STYLE$2,
  DEFAULT_M_FONT_STYLE_OLD: DEFAULT_M_FONT_STYLE_OLD$2,
  DEFAULT_M_FONT_WEIGHT: DEFAULT_M_FONT_WEIGHT$2,
  DEFAULT_M_ITALIC_FONT_FAMILY: DEFAULT_M_ITALIC_FONT_FAMILY$2,
  DEFAULT_M_ITALIC_FONT_SIZE: DEFAULT_M_ITALIC_FONT_SIZE$2,
  DEFAULT_M_ITALIC_FONT_STRETCH: DEFAULT_M_ITALIC_FONT_STRETCH$2,
  DEFAULT_M_ITALIC_FONT_STYLE: DEFAULT_M_ITALIC_FONT_STYLE$2,
  DEFAULT_M_ITALIC_FONT_STYLE_OLD: DEFAULT_M_ITALIC_FONT_STYLE_OLD$2,
  DEFAULT_M_ITALIC_FONT_WEIGHT: DEFAULT_M_ITALIC_FONT_WEIGHT$2,
  DEFAULT_M_ITALIC_LETTER_SPACING: DEFAULT_M_ITALIC_LETTER_SPACING$2,
  DEFAULT_M_ITALIC_LINE_HEIGHT: DEFAULT_M_ITALIC_LINE_HEIGHT$2,
  DEFAULT_M_ITALIC_PARAGRAPH_INDENT: DEFAULT_M_ITALIC_PARAGRAPH_INDENT$2,
  DEFAULT_M_ITALIC_PARAGRAPH_SPACING: DEFAULT_M_ITALIC_PARAGRAPH_SPACING$2,
  DEFAULT_M_ITALIC_TEXT_CASE: DEFAULT_M_ITALIC_TEXT_CASE$2,
  DEFAULT_M_ITALIC_TEXT_DECORATION: DEFAULT_M_ITALIC_TEXT_DECORATION$2,
  DEFAULT_M_LETTER_SPACING: DEFAULT_M_LETTER_SPACING$2,
  DEFAULT_M_LINE_HEIGHT: DEFAULT_M_LINE_HEIGHT$2,
  DEFAULT_M_MEDIUM_FONT_FAMILY: DEFAULT_M_MEDIUM_FONT_FAMILY$2,
  DEFAULT_M_MEDIUM_FONT_SIZE: DEFAULT_M_MEDIUM_FONT_SIZE$2,
  DEFAULT_M_MEDIUM_FONT_STRETCH: DEFAULT_M_MEDIUM_FONT_STRETCH$2,
  DEFAULT_M_MEDIUM_FONT_STYLE: DEFAULT_M_MEDIUM_FONT_STYLE$2,
  DEFAULT_M_MEDIUM_FONT_STYLE_OLD: DEFAULT_M_MEDIUM_FONT_STYLE_OLD$2,
  DEFAULT_M_MEDIUM_FONT_WEIGHT: DEFAULT_M_MEDIUM_FONT_WEIGHT$2,
  DEFAULT_M_MEDIUM_LETTER_SPACING: DEFAULT_M_MEDIUM_LETTER_SPACING$2,
  DEFAULT_M_MEDIUM_LINE_HEIGHT: DEFAULT_M_MEDIUM_LINE_HEIGHT$2,
  DEFAULT_M_MEDIUM_PARAGRAPH_INDENT: DEFAULT_M_MEDIUM_PARAGRAPH_INDENT$2,
  DEFAULT_M_MEDIUM_PARAGRAPH_SPACING: DEFAULT_M_MEDIUM_PARAGRAPH_SPACING$2,
  DEFAULT_M_MEDIUM_TEXT_CASE: DEFAULT_M_MEDIUM_TEXT_CASE$2,
  DEFAULT_M_MEDIUM_TEXT_DECORATION: DEFAULT_M_MEDIUM_TEXT_DECORATION$2,
  DEFAULT_M_PARAGRAPH_INDENT: DEFAULT_M_PARAGRAPH_INDENT$2,
  DEFAULT_M_PARAGRAPH_SPACING: DEFAULT_M_PARAGRAPH_SPACING$2,
  DEFAULT_M_TEXT_CASE: DEFAULT_M_TEXT_CASE$2,
  DEFAULT_M_TEXT_DECORATION: DEFAULT_M_TEXT_DECORATION$2,
  DEFAULT_S_AC_FONT_FAMILY: DEFAULT_S_AC_FONT_FAMILY$2,
  DEFAULT_S_AC_FONT_SIZE: DEFAULT_S_AC_FONT_SIZE$2,
  DEFAULT_S_AC_FONT_STRETCH: DEFAULT_S_AC_FONT_STRETCH$2,
  DEFAULT_S_AC_FONT_STYLE: DEFAULT_S_AC_FONT_STYLE$2,
  DEFAULT_S_AC_FONT_STYLE_OLD: DEFAULT_S_AC_FONT_STYLE_OLD$2,
  DEFAULT_S_AC_FONT_WEIGHT: DEFAULT_S_AC_FONT_WEIGHT$2,
  DEFAULT_S_AC_LETTER_SPACING: DEFAULT_S_AC_LETTER_SPACING$2,
  DEFAULT_S_AC_LINE_HEIGHT: DEFAULT_S_AC_LINE_HEIGHT$2,
  DEFAULT_S_AC_PARAGRAPH_INDENT: DEFAULT_S_AC_PARAGRAPH_INDENT$2,
  DEFAULT_S_AC_PARAGRAPH_SPACING: DEFAULT_S_AC_PARAGRAPH_SPACING$2,
  DEFAULT_S_AC_TEXT_CASE: DEFAULT_S_AC_TEXT_CASE$2,
  DEFAULT_S_AC_TEXT_DECORATION: DEFAULT_S_AC_TEXT_DECORATION$2,
  DEFAULT_S_BOLD_AC_FONT_FAMILY: DEFAULT_S_BOLD_AC_FONT_FAMILY$2,
  DEFAULT_S_BOLD_AC_FONT_SIZE: DEFAULT_S_BOLD_AC_FONT_SIZE$2,
  DEFAULT_S_BOLD_AC_FONT_STRETCH: DEFAULT_S_BOLD_AC_FONT_STRETCH$2,
  DEFAULT_S_BOLD_AC_FONT_STYLE: DEFAULT_S_BOLD_AC_FONT_STYLE$2,
  DEFAULT_S_BOLD_AC_FONT_STYLE_OLD: DEFAULT_S_BOLD_AC_FONT_STYLE_OLD$2,
  DEFAULT_S_BOLD_AC_FONT_WEIGHT: DEFAULT_S_BOLD_AC_FONT_WEIGHT$2,
  DEFAULT_S_BOLD_AC_LETTER_SPACING: DEFAULT_S_BOLD_AC_LETTER_SPACING$2,
  DEFAULT_S_BOLD_AC_LINE_HEIGHT: DEFAULT_S_BOLD_AC_LINE_HEIGHT$2,
  DEFAULT_S_BOLD_AC_PARAGRAPH_INDENT: DEFAULT_S_BOLD_AC_PARAGRAPH_INDENT$2,
  DEFAULT_S_BOLD_AC_PARAGRAPH_SPACING: DEFAULT_S_BOLD_AC_PARAGRAPH_SPACING$2,
  DEFAULT_S_BOLD_AC_TEXT_CASE: DEFAULT_S_BOLD_AC_TEXT_CASE$2,
  DEFAULT_S_BOLD_AC_TEXT_DECORATION: DEFAULT_S_BOLD_AC_TEXT_DECORATION$2,
  DEFAULT_S_BOLD_FONT_FAMILY: DEFAULT_S_BOLD_FONT_FAMILY$2,
  DEFAULT_S_BOLD_FONT_SIZE: DEFAULT_S_BOLD_FONT_SIZE$2,
  DEFAULT_S_BOLD_FONT_STRETCH: DEFAULT_S_BOLD_FONT_STRETCH$2,
  DEFAULT_S_BOLD_FONT_STYLE: DEFAULT_S_BOLD_FONT_STYLE$2,
  DEFAULT_S_BOLD_FONT_STYLE_OLD: DEFAULT_S_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_S_BOLD_FONT_WEIGHT: DEFAULT_S_BOLD_FONT_WEIGHT$2,
  DEFAULT_S_BOLD_LETTER_SPACING: DEFAULT_S_BOLD_LETTER_SPACING$2,
  DEFAULT_S_BOLD_LINE_HEIGHT: DEFAULT_S_BOLD_LINE_HEIGHT$2,
  DEFAULT_S_BOLD_PARAGRAPH_INDENT: DEFAULT_S_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_S_BOLD_PARAGRAPH_SPACING: DEFAULT_S_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_S_BOLD_TEXT_CASE: DEFAULT_S_BOLD_TEXT_CASE$2,
  DEFAULT_S_BOLD_TEXT_DECORATION: DEFAULT_S_BOLD_TEXT_DECORATION$2,
  DEFAULT_S_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_S_CONDENSED_BOLD_FONT_FAMILY$2,
  DEFAULT_S_CONDENSED_BOLD_FONT_SIZE: DEFAULT_S_CONDENSED_BOLD_FONT_SIZE$2,
  DEFAULT_S_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_S_CONDENSED_BOLD_FONT_STRETCH$2,
  DEFAULT_S_CONDENSED_BOLD_FONT_STYLE: DEFAULT_S_CONDENSED_BOLD_FONT_STYLE$2,
  DEFAULT_S_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_S_CONDENSED_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_S_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_S_CONDENSED_BOLD_FONT_WEIGHT$2,
  DEFAULT_S_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_S_CONDENSED_BOLD_LETTER_SPACING$2,
  DEFAULT_S_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_S_CONDENSED_BOLD_LINE_HEIGHT$2,
  DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_S_CONDENSED_BOLD_TEXT_CASE: DEFAULT_S_CONDENSED_BOLD_TEXT_CASE$2,
  DEFAULT_S_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_S_CONDENSED_BOLD_TEXT_DECORATION$2,
  DEFAULT_S_CONDENSED_FONT_FAMILY: DEFAULT_S_CONDENSED_FONT_FAMILY$2,
  DEFAULT_S_CONDENSED_FONT_SIZE: DEFAULT_S_CONDENSED_FONT_SIZE$2,
  DEFAULT_S_CONDENSED_FONT_STRETCH: DEFAULT_S_CONDENSED_FONT_STRETCH$2,
  DEFAULT_S_CONDENSED_FONT_STYLE: DEFAULT_S_CONDENSED_FONT_STYLE$2,
  DEFAULT_S_CONDENSED_FONT_STYLE_OLD: DEFAULT_S_CONDENSED_FONT_STYLE_OLD$2,
  DEFAULT_S_CONDENSED_FONT_WEIGHT: DEFAULT_S_CONDENSED_FONT_WEIGHT$2,
  DEFAULT_S_CONDENSED_LETTER_SPACING: DEFAULT_S_CONDENSED_LETTER_SPACING$2,
  DEFAULT_S_CONDENSED_LINE_HEIGHT: DEFAULT_S_CONDENSED_LINE_HEIGHT$2,
  DEFAULT_S_CONDENSED_PARAGRAPH_INDENT: DEFAULT_S_CONDENSED_PARAGRAPH_INDENT$2,
  DEFAULT_S_CONDENSED_PARAGRAPH_SPACING: DEFAULT_S_CONDENSED_PARAGRAPH_SPACING$2,
  DEFAULT_S_CONDENSED_TEXT_CASE: DEFAULT_S_CONDENSED_TEXT_CASE$2,
  DEFAULT_S_CONDENSED_TEXT_DECORATION: DEFAULT_S_CONDENSED_TEXT_DECORATION$2,
  DEFAULT_S_FONT_FAMILY: DEFAULT_S_FONT_FAMILY$2,
  DEFAULT_S_FONT_SIZE: DEFAULT_S_FONT_SIZE$2,
  DEFAULT_S_FONT_STRETCH: DEFAULT_S_FONT_STRETCH$2,
  DEFAULT_S_FONT_STYLE: DEFAULT_S_FONT_STYLE$2,
  DEFAULT_S_FONT_STYLE_OLD: DEFAULT_S_FONT_STYLE_OLD$2,
  DEFAULT_S_FONT_WEIGHT: DEFAULT_S_FONT_WEIGHT$2,
  DEFAULT_S_ITALIC_FONT_FAMILY: DEFAULT_S_ITALIC_FONT_FAMILY$2,
  DEFAULT_S_ITALIC_FONT_SIZE: DEFAULT_S_ITALIC_FONT_SIZE$2,
  DEFAULT_S_ITALIC_FONT_STRETCH: DEFAULT_S_ITALIC_FONT_STRETCH$2,
  DEFAULT_S_ITALIC_FONT_STYLE: DEFAULT_S_ITALIC_FONT_STYLE$2,
  DEFAULT_S_ITALIC_FONT_STYLE_OLD: DEFAULT_S_ITALIC_FONT_STYLE_OLD$2,
  DEFAULT_S_ITALIC_FONT_WEIGHT: DEFAULT_S_ITALIC_FONT_WEIGHT$2,
  DEFAULT_S_ITALIC_LETTER_SPACING: DEFAULT_S_ITALIC_LETTER_SPACING$2,
  DEFAULT_S_ITALIC_LINE_HEIGHT: DEFAULT_S_ITALIC_LINE_HEIGHT$2,
  DEFAULT_S_ITALIC_PARAGRAPH_INDENT: DEFAULT_S_ITALIC_PARAGRAPH_INDENT$2,
  DEFAULT_S_ITALIC_PARAGRAPH_SPACING: DEFAULT_S_ITALIC_PARAGRAPH_SPACING$2,
  DEFAULT_S_ITALIC_TEXT_CASE: DEFAULT_S_ITALIC_TEXT_CASE$2,
  DEFAULT_S_ITALIC_TEXT_DECORATION: DEFAULT_S_ITALIC_TEXT_DECORATION$2,
  DEFAULT_S_LETTER_SPACING: DEFAULT_S_LETTER_SPACING$2,
  DEFAULT_S_LINE_HEIGHT: DEFAULT_S_LINE_HEIGHT$2,
  DEFAULT_S_MEDIUM_FONT_FAMILY: DEFAULT_S_MEDIUM_FONT_FAMILY$2,
  DEFAULT_S_MEDIUM_FONT_SIZE: DEFAULT_S_MEDIUM_FONT_SIZE$2,
  DEFAULT_S_MEDIUM_FONT_STRETCH: DEFAULT_S_MEDIUM_FONT_STRETCH$2,
  DEFAULT_S_MEDIUM_FONT_STYLE: DEFAULT_S_MEDIUM_FONT_STYLE$2,
  DEFAULT_S_MEDIUM_FONT_STYLE_OLD: DEFAULT_S_MEDIUM_FONT_STYLE_OLD$2,
  DEFAULT_S_MEDIUM_FONT_WEIGHT: DEFAULT_S_MEDIUM_FONT_WEIGHT$2,
  DEFAULT_S_MEDIUM_LETTER_SPACING: DEFAULT_S_MEDIUM_LETTER_SPACING$2,
  DEFAULT_S_MEDIUM_LINE_HEIGHT: DEFAULT_S_MEDIUM_LINE_HEIGHT$2,
  DEFAULT_S_MEDIUM_PARAGRAPH_INDENT: DEFAULT_S_MEDIUM_PARAGRAPH_INDENT$2,
  DEFAULT_S_MEDIUM_PARAGRAPH_SPACING: DEFAULT_S_MEDIUM_PARAGRAPH_SPACING$2,
  DEFAULT_S_MEDIUM_TEXT_CASE: DEFAULT_S_MEDIUM_TEXT_CASE$2,
  DEFAULT_S_MEDIUM_TEXT_DECORATION: DEFAULT_S_MEDIUM_TEXT_DECORATION$2,
  DEFAULT_S_PARAGRAPH_INDENT: DEFAULT_S_PARAGRAPH_INDENT$2,
  DEFAULT_S_PARAGRAPH_SPACING: DEFAULT_S_PARAGRAPH_SPACING$2,
  DEFAULT_S_TEXT_CASE: DEFAULT_S_TEXT_CASE$2,
  DEFAULT_S_TEXT_DECORATION: DEFAULT_S_TEXT_DECORATION$2,
  DEFAULT_XL_BOLD_FONT_FAMILY: DEFAULT_XL_BOLD_FONT_FAMILY$2,
  DEFAULT_XL_BOLD_FONT_SIZE: DEFAULT_XL_BOLD_FONT_SIZE$2,
  DEFAULT_XL_BOLD_FONT_STRETCH: DEFAULT_XL_BOLD_FONT_STRETCH$2,
  DEFAULT_XL_BOLD_FONT_STYLE: DEFAULT_XL_BOLD_FONT_STYLE$2,
  DEFAULT_XL_BOLD_FONT_STYLE_OLD: DEFAULT_XL_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_XL_BOLD_FONT_WEIGHT: DEFAULT_XL_BOLD_FONT_WEIGHT$2,
  DEFAULT_XL_BOLD_LETTER_SPACING: DEFAULT_XL_BOLD_LETTER_SPACING$2,
  DEFAULT_XL_BOLD_LINE_HEIGHT: DEFAULT_XL_BOLD_LINE_HEIGHT$2,
  DEFAULT_XL_BOLD_PARAGRAPH_INDENT: DEFAULT_XL_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_XL_BOLD_PARAGRAPH_SPACING: DEFAULT_XL_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_XL_BOLD_TEXT_CASE: DEFAULT_XL_BOLD_TEXT_CASE$2,
  DEFAULT_XL_BOLD_TEXT_DECORATION: DEFAULT_XL_BOLD_TEXT_DECORATION$2,
  DEFAULT_XL_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_XL_CONDENSED_BOLD_FONT_FAMILY$2,
  DEFAULT_XL_CONDENSED_BOLD_FONT_SIZE: DEFAULT_XL_CONDENSED_BOLD_FONT_SIZE$2,
  DEFAULT_XL_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_XL_CONDENSED_BOLD_FONT_STRETCH$2,
  DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE: DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE$2,
  DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_XL_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_XL_CONDENSED_BOLD_FONT_WEIGHT$2,
  DEFAULT_XL_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_XL_CONDENSED_BOLD_LETTER_SPACING$2,
  DEFAULT_XL_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_XL_CONDENSED_BOLD_LINE_HEIGHT$2,
  DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_XL_CONDENSED_BOLD_TEXT_CASE: DEFAULT_XL_CONDENSED_BOLD_TEXT_CASE$2,
  DEFAULT_XL_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_XL_CONDENSED_BOLD_TEXT_DECORATION$2,
  DEFAULT_XL_CONDENSED_FONT_FAMILY: DEFAULT_XL_CONDENSED_FONT_FAMILY$2,
  DEFAULT_XL_CONDENSED_FONT_SIZE: DEFAULT_XL_CONDENSED_FONT_SIZE$2,
  DEFAULT_XL_CONDENSED_FONT_STRETCH: DEFAULT_XL_CONDENSED_FONT_STRETCH$2,
  DEFAULT_XL_CONDENSED_FONT_STYLE: DEFAULT_XL_CONDENSED_FONT_STYLE$2,
  DEFAULT_XL_CONDENSED_FONT_STYLE_OLD: DEFAULT_XL_CONDENSED_FONT_STYLE_OLD$2,
  DEFAULT_XL_CONDENSED_FONT_WEIGHT: DEFAULT_XL_CONDENSED_FONT_WEIGHT$2,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_XL_CONDENSED_HEAVY_FONT_SIZE$2,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE$2,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  DEFAULT_XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  DEFAULT_XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_XL_CONDENSED_HEAVY_TEXT_CASE$2,
  DEFAULT_XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  DEFAULT_XL_CONDENSED_LETTER_SPACING: DEFAULT_XL_CONDENSED_LETTER_SPACING$2,
  DEFAULT_XL_CONDENSED_LINE_HEIGHT: DEFAULT_XL_CONDENSED_LINE_HEIGHT$2,
  DEFAULT_XL_CONDENSED_PARAGRAPH_INDENT: DEFAULT_XL_CONDENSED_PARAGRAPH_INDENT$2,
  DEFAULT_XL_CONDENSED_PARAGRAPH_SPACING: DEFAULT_XL_CONDENSED_PARAGRAPH_SPACING$2,
  DEFAULT_XL_CONDENSED_TEXT_CASE: DEFAULT_XL_CONDENSED_TEXT_CASE$2,
  DEFAULT_XL_CONDENSED_TEXT_DECORATION: DEFAULT_XL_CONDENSED_TEXT_DECORATION$2,
  DEFAULT_XL_FONT_FAMILY: DEFAULT_XL_FONT_FAMILY$2,
  DEFAULT_XL_FONT_SIZE: DEFAULT_XL_FONT_SIZE$2,
  DEFAULT_XL_FONT_STRETCH: DEFAULT_XL_FONT_STRETCH$2,
  DEFAULT_XL_FONT_STYLE: DEFAULT_XL_FONT_STYLE$2,
  DEFAULT_XL_FONT_STYLE_OLD: DEFAULT_XL_FONT_STYLE_OLD$2,
  DEFAULT_XL_FONT_WEIGHT: DEFAULT_XL_FONT_WEIGHT$2,
  DEFAULT_XL_HEAVY_FONT_FAMILY: DEFAULT_XL_HEAVY_FONT_FAMILY$2,
  DEFAULT_XL_HEAVY_FONT_SIZE: DEFAULT_XL_HEAVY_FONT_SIZE$2,
  DEFAULT_XL_HEAVY_FONT_STRETCH: DEFAULT_XL_HEAVY_FONT_STRETCH$2,
  DEFAULT_XL_HEAVY_FONT_STYLE: DEFAULT_XL_HEAVY_FONT_STYLE$2,
  DEFAULT_XL_HEAVY_FONT_STYLE_OLD: DEFAULT_XL_HEAVY_FONT_STYLE_OLD$2,
  DEFAULT_XL_HEAVY_FONT_WEIGHT: DEFAULT_XL_HEAVY_FONT_WEIGHT$2,
  DEFAULT_XL_HEAVY_LETTER_SPACING: DEFAULT_XL_HEAVY_LETTER_SPACING$2,
  DEFAULT_XL_HEAVY_LINE_HEIGHT: DEFAULT_XL_HEAVY_LINE_HEIGHT$2,
  DEFAULT_XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_XL_HEAVY_PARAGRAPH_INDENT$2,
  DEFAULT_XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_XL_HEAVY_PARAGRAPH_SPACING$2,
  DEFAULT_XL_HEAVY_TEXT_CASE: DEFAULT_XL_HEAVY_TEXT_CASE$2,
  DEFAULT_XL_HEAVY_TEXT_DECORATION: DEFAULT_XL_HEAVY_TEXT_DECORATION$2,
  DEFAULT_XL_ITALIC_FONT_FAMILY: DEFAULT_XL_ITALIC_FONT_FAMILY$2,
  DEFAULT_XL_ITALIC_FONT_SIZE: DEFAULT_XL_ITALIC_FONT_SIZE$2,
  DEFAULT_XL_ITALIC_FONT_STRETCH: DEFAULT_XL_ITALIC_FONT_STRETCH$2,
  DEFAULT_XL_ITALIC_FONT_STYLE: DEFAULT_XL_ITALIC_FONT_STYLE$2,
  DEFAULT_XL_ITALIC_FONT_STYLE_OLD: DEFAULT_XL_ITALIC_FONT_STYLE_OLD$2,
  DEFAULT_XL_ITALIC_FONT_WEIGHT: DEFAULT_XL_ITALIC_FONT_WEIGHT$2,
  DEFAULT_XL_ITALIC_LETTER_SPACING: DEFAULT_XL_ITALIC_LETTER_SPACING$2,
  DEFAULT_XL_ITALIC_LINE_HEIGHT: DEFAULT_XL_ITALIC_LINE_HEIGHT$2,
  DEFAULT_XL_ITALIC_PARAGRAPH_INDENT: DEFAULT_XL_ITALIC_PARAGRAPH_INDENT$2,
  DEFAULT_XL_ITALIC_PARAGRAPH_SPACING: DEFAULT_XL_ITALIC_PARAGRAPH_SPACING$2,
  DEFAULT_XL_ITALIC_TEXT_CASE: DEFAULT_XL_ITALIC_TEXT_CASE$2,
  DEFAULT_XL_ITALIC_TEXT_DECORATION: DEFAULT_XL_ITALIC_TEXT_DECORATION$2,
  DEFAULT_XL_LETTER_SPACING: DEFAULT_XL_LETTER_SPACING$2,
  DEFAULT_XL_LINE_HEIGHT: DEFAULT_XL_LINE_HEIGHT$2,
  DEFAULT_XL_PARAGRAPH_INDENT: DEFAULT_XL_PARAGRAPH_INDENT$2,
  DEFAULT_XL_PARAGRAPH_SPACING: DEFAULT_XL_PARAGRAPH_SPACING$2,
  DEFAULT_XL_TEXT_CASE: DEFAULT_XL_TEXT_CASE$2,
  DEFAULT_XL_TEXT_DECORATION: DEFAULT_XL_TEXT_DECORATION$2,
  DEFAULT_XS_AC_FONT_FAMILY: DEFAULT_XS_AC_FONT_FAMILY$2,
  DEFAULT_XS_AC_FONT_SIZE: DEFAULT_XS_AC_FONT_SIZE$2,
  DEFAULT_XS_AC_FONT_STRETCH: DEFAULT_XS_AC_FONT_STRETCH$2,
  DEFAULT_XS_AC_FONT_STYLE: DEFAULT_XS_AC_FONT_STYLE$2,
  DEFAULT_XS_AC_FONT_STYLE_OLD: DEFAULT_XS_AC_FONT_STYLE_OLD$2,
  DEFAULT_XS_AC_FONT_WEIGHT: DEFAULT_XS_AC_FONT_WEIGHT$2,
  DEFAULT_XS_AC_LETTER_SPACING: DEFAULT_XS_AC_LETTER_SPACING$2,
  DEFAULT_XS_AC_LINE_HEIGHT: DEFAULT_XS_AC_LINE_HEIGHT$2,
  DEFAULT_XS_AC_PARAGRAPH_INDENT: DEFAULT_XS_AC_PARAGRAPH_INDENT$2,
  DEFAULT_XS_AC_PARAGRAPH_SPACING: DEFAULT_XS_AC_PARAGRAPH_SPACING$2,
  DEFAULT_XS_AC_TEXT_CASE: DEFAULT_XS_AC_TEXT_CASE$2,
  DEFAULT_XS_AC_TEXT_DECORATION: DEFAULT_XS_AC_TEXT_DECORATION$2,
  DEFAULT_XS_BOLD_AC_FONT_FAMILY: DEFAULT_XS_BOLD_AC_FONT_FAMILY$2,
  DEFAULT_XS_BOLD_AC_FONT_SIZE: DEFAULT_XS_BOLD_AC_FONT_SIZE$2,
  DEFAULT_XS_BOLD_AC_FONT_STRETCH: DEFAULT_XS_BOLD_AC_FONT_STRETCH$2,
  DEFAULT_XS_BOLD_AC_FONT_STYLE: DEFAULT_XS_BOLD_AC_FONT_STYLE$2,
  DEFAULT_XS_BOLD_AC_FONT_STYLE_OLD: DEFAULT_XS_BOLD_AC_FONT_STYLE_OLD$2,
  DEFAULT_XS_BOLD_AC_FONT_WEIGHT: DEFAULT_XS_BOLD_AC_FONT_WEIGHT$2,
  DEFAULT_XS_BOLD_AC_LETTER_SPACING: DEFAULT_XS_BOLD_AC_LETTER_SPACING$2,
  DEFAULT_XS_BOLD_AC_LINE_HEIGHT: DEFAULT_XS_BOLD_AC_LINE_HEIGHT$2,
  DEFAULT_XS_BOLD_AC_PARAGRAPH_INDENT: DEFAULT_XS_BOLD_AC_PARAGRAPH_INDENT$2,
  DEFAULT_XS_BOLD_AC_PARAGRAPH_SPACING: DEFAULT_XS_BOLD_AC_PARAGRAPH_SPACING$2,
  DEFAULT_XS_BOLD_AC_TEXT_CASE: DEFAULT_XS_BOLD_AC_TEXT_CASE$2,
  DEFAULT_XS_BOLD_AC_TEXT_DECORATION: DEFAULT_XS_BOLD_AC_TEXT_DECORATION$2,
  DEFAULT_XS_BOLD_FONT_FAMILY: DEFAULT_XS_BOLD_FONT_FAMILY$2,
  DEFAULT_XS_BOLD_FONT_SIZE: DEFAULT_XS_BOLD_FONT_SIZE$2,
  DEFAULT_XS_BOLD_FONT_STRETCH: DEFAULT_XS_BOLD_FONT_STRETCH$2,
  DEFAULT_XS_BOLD_FONT_STYLE: DEFAULT_XS_BOLD_FONT_STYLE$2,
  DEFAULT_XS_BOLD_FONT_STYLE_OLD: DEFAULT_XS_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_XS_BOLD_FONT_WEIGHT: DEFAULT_XS_BOLD_FONT_WEIGHT$2,
  DEFAULT_XS_BOLD_LETTER_SPACING: DEFAULT_XS_BOLD_LETTER_SPACING$2,
  DEFAULT_XS_BOLD_LINE_HEIGHT: DEFAULT_XS_BOLD_LINE_HEIGHT$2,
  DEFAULT_XS_BOLD_PARAGRAPH_INDENT: DEFAULT_XS_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_XS_BOLD_PARAGRAPH_SPACING: DEFAULT_XS_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_XS_BOLD_TEXT_CASE: DEFAULT_XS_BOLD_TEXT_CASE$2,
  DEFAULT_XS_BOLD_TEXT_DECORATION: DEFAULT_XS_BOLD_TEXT_DECORATION$2,
  DEFAULT_XS_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_XS_CONDENSED_BOLD_FONT_FAMILY$2,
  DEFAULT_XS_CONDENSED_BOLD_FONT_SIZE: DEFAULT_XS_CONDENSED_BOLD_FONT_SIZE$2,
  DEFAULT_XS_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_XS_CONDENSED_BOLD_FONT_STRETCH$2,
  DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE: DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE$2,
  DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE_OLD$2,
  DEFAULT_XS_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_XS_CONDENSED_BOLD_FONT_WEIGHT$2,
  DEFAULT_XS_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_XS_CONDENSED_BOLD_LETTER_SPACING$2,
  DEFAULT_XS_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_XS_CONDENSED_BOLD_LINE_HEIGHT$2,
  DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT$2,
  DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING$2,
  DEFAULT_XS_CONDENSED_BOLD_TEXT_CASE: DEFAULT_XS_CONDENSED_BOLD_TEXT_CASE$2,
  DEFAULT_XS_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_XS_CONDENSED_BOLD_TEXT_DECORATION$2,
  DEFAULT_XS_FONT_FAMILY: DEFAULT_XS_FONT_FAMILY$2,
  DEFAULT_XS_FONT_SIZE: DEFAULT_XS_FONT_SIZE$2,
  DEFAULT_XS_FONT_STRETCH: DEFAULT_XS_FONT_STRETCH$2,
  DEFAULT_XS_FONT_STYLE: DEFAULT_XS_FONT_STYLE$2,
  DEFAULT_XS_FONT_STYLE_OLD: DEFAULT_XS_FONT_STYLE_OLD$2,
  DEFAULT_XS_FONT_WEIGHT: DEFAULT_XS_FONT_WEIGHT$2,
  DEFAULT_XS_ITALIC_FONT_FAMILY: DEFAULT_XS_ITALIC_FONT_FAMILY$2,
  DEFAULT_XS_ITALIC_FONT_SIZE: DEFAULT_XS_ITALIC_FONT_SIZE$2,
  DEFAULT_XS_ITALIC_FONT_STRETCH: DEFAULT_XS_ITALIC_FONT_STRETCH$2,
  DEFAULT_XS_ITALIC_FONT_STYLE: DEFAULT_XS_ITALIC_FONT_STYLE$2,
  DEFAULT_XS_ITALIC_FONT_STYLE_OLD: DEFAULT_XS_ITALIC_FONT_STYLE_OLD$2,
  DEFAULT_XS_ITALIC_FONT_WEIGHT: DEFAULT_XS_ITALIC_FONT_WEIGHT$2,
  DEFAULT_XS_ITALIC_LETTER_SPACING: DEFAULT_XS_ITALIC_LETTER_SPACING$2,
  DEFAULT_XS_ITALIC_LINE_HEIGHT: DEFAULT_XS_ITALIC_LINE_HEIGHT$2,
  DEFAULT_XS_ITALIC_PARAGRAPH_INDENT: DEFAULT_XS_ITALIC_PARAGRAPH_INDENT$2,
  DEFAULT_XS_ITALIC_PARAGRAPH_SPACING: DEFAULT_XS_ITALIC_PARAGRAPH_SPACING$2,
  DEFAULT_XS_ITALIC_TEXT_CASE: DEFAULT_XS_ITALIC_TEXT_CASE$2,
  DEFAULT_XS_ITALIC_TEXT_DECORATION: DEFAULT_XS_ITALIC_TEXT_DECORATION$2,
  DEFAULT_XS_LETTER_SPACING: DEFAULT_XS_LETTER_SPACING$2,
  DEFAULT_XS_LINE_HEIGHT: DEFAULT_XS_LINE_HEIGHT$2,
  DEFAULT_XS_PARAGRAPH_INDENT: DEFAULT_XS_PARAGRAPH_INDENT$2,
  DEFAULT_XS_PARAGRAPH_SPACING: DEFAULT_XS_PARAGRAPH_SPACING$2,
  DEFAULT_XS_TEXT_CASE: DEFAULT_XS_TEXT_CASE$2,
  DEFAULT_XS_TEXT_DECORATION: DEFAULT_XS_TEXT_DECORATION$2,
  YLE_NEXT_2XL_BOLD_FONT_FAMILY: YLE_NEXT_2XL_BOLD_FONT_FAMILY$2,
  YLE_NEXT_2XL_BOLD_FONT_SIZE: YLE_NEXT_2XL_BOLD_FONT_SIZE$2,
  YLE_NEXT_2XL_BOLD_FONT_STRETCH: YLE_NEXT_2XL_BOLD_FONT_STRETCH$2,
  YLE_NEXT_2XL_BOLD_FONT_STYLE: YLE_NEXT_2XL_BOLD_FONT_STYLE$2,
  YLE_NEXT_2XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_2XL_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_2XL_BOLD_FONT_WEIGHT: YLE_NEXT_2XL_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_2XL_BOLD_LETTER_SPACING: YLE_NEXT_2XL_BOLD_LETTER_SPACING$2,
  YLE_NEXT_2XL_BOLD_LINE_HEIGHT: YLE_NEXT_2XL_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_2XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_2XL_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_2XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_2XL_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_2XL_BOLD_TEXT_CASE: YLE_NEXT_2XL_BOLD_TEXT_CASE$2,
  YLE_NEXT_2XL_BOLD_TEXT_DECORATION: YLE_NEXT_2XL_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_FAMILY$2,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_SIZE$2,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STRETCH$2,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE$2,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_2XL_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_2XL_CONDENSED_BOLD_LETTER_SPACING$2,
  YLE_NEXT_2XL_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_2XL_CONDENSED_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_CASE$2,
  YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_SIZE$2,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE$2,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_2XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_2XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_2XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_2XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_CASE$2,
  YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_2XL_FONT_FAMILY: YLE_NEXT_2XL_FONT_FAMILY$2,
  YLE_NEXT_2XL_FONT_SIZE: YLE_NEXT_2XL_FONT_SIZE$2,
  YLE_NEXT_2XL_FONT_STRETCH: YLE_NEXT_2XL_FONT_STRETCH$2,
  YLE_NEXT_2XL_FONT_STYLE: YLE_NEXT_2XL_FONT_STYLE$2,
  YLE_NEXT_2XL_FONT_STYLE_OLD: YLE_NEXT_2XL_FONT_STYLE_OLD$2,
  YLE_NEXT_2XL_FONT_WEIGHT: YLE_NEXT_2XL_FONT_WEIGHT$2,
  YLE_NEXT_2XL_HEAVY_FONT_FAMILY: YLE_NEXT_2XL_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_2XL_HEAVY_FONT_SIZE: YLE_NEXT_2XL_HEAVY_FONT_SIZE$2,
  YLE_NEXT_2XL_HEAVY_FONT_STRETCH: YLE_NEXT_2XL_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_2XL_HEAVY_FONT_STYLE: YLE_NEXT_2XL_HEAVY_FONT_STYLE$2,
  YLE_NEXT_2XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_2XL_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_2XL_HEAVY_FONT_WEIGHT: YLE_NEXT_2XL_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_2XL_HEAVY_LETTER_SPACING: YLE_NEXT_2XL_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_2XL_HEAVY_LINE_HEIGHT: YLE_NEXT_2XL_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_2XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_2XL_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_2XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_2XL_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_2XL_HEAVY_TEXT_CASE: YLE_NEXT_2XL_HEAVY_TEXT_CASE$2,
  YLE_NEXT_2XL_HEAVY_TEXT_DECORATION: YLE_NEXT_2XL_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_2XL_LETTER_SPACING: YLE_NEXT_2XL_LETTER_SPACING$2,
  YLE_NEXT_2XL_LINE_HEIGHT: YLE_NEXT_2XL_LINE_HEIGHT$2,
  YLE_NEXT_2XL_PARAGRAPH_INDENT: YLE_NEXT_2XL_PARAGRAPH_INDENT$2,
  YLE_NEXT_2XL_PARAGRAPH_SPACING: YLE_NEXT_2XL_PARAGRAPH_SPACING$2,
  YLE_NEXT_2XL_TEXT_CASE: YLE_NEXT_2XL_TEXT_CASE$2,
  YLE_NEXT_2XL_TEXT_DECORATION: YLE_NEXT_2XL_TEXT_DECORATION$2,
  YLE_NEXT_3XL_BOLD_FONT_FAMILY: YLE_NEXT_3XL_BOLD_FONT_FAMILY$2,
  YLE_NEXT_3XL_BOLD_FONT_SIZE: YLE_NEXT_3XL_BOLD_FONT_SIZE$2,
  YLE_NEXT_3XL_BOLD_FONT_STRETCH: YLE_NEXT_3XL_BOLD_FONT_STRETCH$2,
  YLE_NEXT_3XL_BOLD_FONT_STYLE: YLE_NEXT_3XL_BOLD_FONT_STYLE$2,
  YLE_NEXT_3XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_3XL_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_3XL_BOLD_FONT_WEIGHT: YLE_NEXT_3XL_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_3XL_BOLD_LETTER_SPACING: YLE_NEXT_3XL_BOLD_LETTER_SPACING$2,
  YLE_NEXT_3XL_BOLD_LINE_HEIGHT: YLE_NEXT_3XL_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_3XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_3XL_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_3XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_3XL_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_3XL_BOLD_TEXT_CASE: YLE_NEXT_3XL_BOLD_TEXT_CASE$2,
  YLE_NEXT_3XL_BOLD_TEXT_DECORATION: YLE_NEXT_3XL_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_SIZE$2,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE$2,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_3XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_3XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_3XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_3XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_CASE$2,
  YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_3XL_HEAVY_FONT_FAMILY: YLE_NEXT_3XL_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_3XL_HEAVY_FONT_SIZE: YLE_NEXT_3XL_HEAVY_FONT_SIZE$2,
  YLE_NEXT_3XL_HEAVY_FONT_STRETCH: YLE_NEXT_3XL_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_3XL_HEAVY_FONT_STYLE: YLE_NEXT_3XL_HEAVY_FONT_STYLE$2,
  YLE_NEXT_3XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_3XL_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_3XL_HEAVY_FONT_WEIGHT: YLE_NEXT_3XL_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_3XL_HEAVY_LETTER_SPACING: YLE_NEXT_3XL_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_3XL_HEAVY_LINE_HEIGHT: YLE_NEXT_3XL_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_3XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_3XL_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_3XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_3XL_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_3XL_HEAVY_TEXT_CASE: YLE_NEXT_3XL_HEAVY_TEXT_CASE$2,
  YLE_NEXT_3XL_HEAVY_TEXT_DECORATION: YLE_NEXT_3XL_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_4XL_BOLD_FONT_FAMILY: YLE_NEXT_4XL_BOLD_FONT_FAMILY$2,
  YLE_NEXT_4XL_BOLD_FONT_SIZE: YLE_NEXT_4XL_BOLD_FONT_SIZE$2,
  YLE_NEXT_4XL_BOLD_FONT_STRETCH: YLE_NEXT_4XL_BOLD_FONT_STRETCH$2,
  YLE_NEXT_4XL_BOLD_FONT_STYLE: YLE_NEXT_4XL_BOLD_FONT_STYLE$2,
  YLE_NEXT_4XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_4XL_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_4XL_BOLD_FONT_WEIGHT: YLE_NEXT_4XL_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_4XL_BOLD_LETTER_SPACING: YLE_NEXT_4XL_BOLD_LETTER_SPACING$2,
  YLE_NEXT_4XL_BOLD_LINE_HEIGHT: YLE_NEXT_4XL_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_4XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_4XL_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_4XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_4XL_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_4XL_BOLD_TEXT_CASE: YLE_NEXT_4XL_BOLD_TEXT_CASE$2,
  YLE_NEXT_4XL_BOLD_TEXT_DECORATION: YLE_NEXT_4XL_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_SIZE$2,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE$2,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_4XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_4XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_4XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_4XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_CASE$2,
  YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_4XL_HEAVY_FONT_FAMILY: YLE_NEXT_4XL_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_4XL_HEAVY_FONT_SIZE: YLE_NEXT_4XL_HEAVY_FONT_SIZE$2,
  YLE_NEXT_4XL_HEAVY_FONT_STRETCH: YLE_NEXT_4XL_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_4XL_HEAVY_FONT_STYLE: YLE_NEXT_4XL_HEAVY_FONT_STYLE$2,
  YLE_NEXT_4XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_4XL_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_4XL_HEAVY_FONT_WEIGHT: YLE_NEXT_4XL_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_4XL_HEAVY_LETTER_SPACING: YLE_NEXT_4XL_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_4XL_HEAVY_LINE_HEIGHT: YLE_NEXT_4XL_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_4XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_4XL_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_4XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_4XL_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_4XL_HEAVY_TEXT_CASE: YLE_NEXT_4XL_HEAVY_TEXT_CASE$2,
  YLE_NEXT_4XL_HEAVY_TEXT_DECORATION: YLE_NEXT_4XL_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_5XL_BOLD_FONT_FAMILY: YLE_NEXT_5XL_BOLD_FONT_FAMILY$2,
  YLE_NEXT_5XL_BOLD_FONT_SIZE: YLE_NEXT_5XL_BOLD_FONT_SIZE$2,
  YLE_NEXT_5XL_BOLD_FONT_STRETCH: YLE_NEXT_5XL_BOLD_FONT_STRETCH$2,
  YLE_NEXT_5XL_BOLD_FONT_STYLE: YLE_NEXT_5XL_BOLD_FONT_STYLE$2,
  YLE_NEXT_5XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_5XL_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_5XL_BOLD_FONT_WEIGHT: YLE_NEXT_5XL_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_5XL_BOLD_LETTER_SPACING: YLE_NEXT_5XL_BOLD_LETTER_SPACING$2,
  YLE_NEXT_5XL_BOLD_LINE_HEIGHT: YLE_NEXT_5XL_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_5XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_5XL_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_5XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_5XL_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_5XL_BOLD_TEXT_CASE: YLE_NEXT_5XL_BOLD_TEXT_CASE$2,
  YLE_NEXT_5XL_BOLD_TEXT_DECORATION: YLE_NEXT_5XL_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_SIZE$2,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE$2,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_5XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_5XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_5XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_5XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_CASE$2,
  YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_5XL_HEAVY_FONT_FAMILY: YLE_NEXT_5XL_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_5XL_HEAVY_FONT_SIZE: YLE_NEXT_5XL_HEAVY_FONT_SIZE$2,
  YLE_NEXT_5XL_HEAVY_FONT_STRETCH: YLE_NEXT_5XL_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_5XL_HEAVY_FONT_STYLE: YLE_NEXT_5XL_HEAVY_FONT_STYLE$2,
  YLE_NEXT_5XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_5XL_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_5XL_HEAVY_FONT_WEIGHT: YLE_NEXT_5XL_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_5XL_HEAVY_LETTER_SPACING: YLE_NEXT_5XL_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_5XL_HEAVY_LINE_HEIGHT: YLE_NEXT_5XL_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_5XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_5XL_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_5XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_5XL_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_5XL_HEAVY_TEXT_CASE: YLE_NEXT_5XL_HEAVY_TEXT_CASE$2,
  YLE_NEXT_5XL_HEAVY_TEXT_DECORATION: YLE_NEXT_5XL_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_6XL_BOLD_FONT_FAMILY: YLE_NEXT_6XL_BOLD_FONT_FAMILY$2,
  YLE_NEXT_6XL_BOLD_FONT_SIZE: YLE_NEXT_6XL_BOLD_FONT_SIZE$2,
  YLE_NEXT_6XL_BOLD_FONT_STRETCH: YLE_NEXT_6XL_BOLD_FONT_STRETCH$2,
  YLE_NEXT_6XL_BOLD_FONT_STYLE: YLE_NEXT_6XL_BOLD_FONT_STYLE$2,
  YLE_NEXT_6XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_6XL_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_6XL_BOLD_FONT_WEIGHT: YLE_NEXT_6XL_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_6XL_BOLD_LETTER_SPACING: YLE_NEXT_6XL_BOLD_LETTER_SPACING$2,
  YLE_NEXT_6XL_BOLD_LINE_HEIGHT: YLE_NEXT_6XL_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_6XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_6XL_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_6XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_6XL_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_6XL_BOLD_TEXT_CASE: YLE_NEXT_6XL_BOLD_TEXT_CASE$2,
  YLE_NEXT_6XL_BOLD_TEXT_DECORATION: YLE_NEXT_6XL_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_SIZE$2,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE$2,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_6XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_6XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_6XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_6XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_CASE$2,
  YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_6XL_HEAVY_FONT_FAMILY: YLE_NEXT_6XL_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_6XL_HEAVY_FONT_SIZE: YLE_NEXT_6XL_HEAVY_FONT_SIZE$2,
  YLE_NEXT_6XL_HEAVY_FONT_STRETCH: YLE_NEXT_6XL_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_6XL_HEAVY_FONT_STYLE: YLE_NEXT_6XL_HEAVY_FONT_STYLE$2,
  YLE_NEXT_6XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_6XL_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_6XL_HEAVY_FONT_WEIGHT: YLE_NEXT_6XL_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_6XL_HEAVY_LETTER_SPACING: YLE_NEXT_6XL_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_6XL_HEAVY_LINE_HEIGHT: YLE_NEXT_6XL_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_6XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_6XL_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_6XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_6XL_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_6XL_HEAVY_TEXT_CASE: YLE_NEXT_6XL_HEAVY_TEXT_CASE$2,
  YLE_NEXT_6XL_HEAVY_TEXT_DECORATION: YLE_NEXT_6XL_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_7XL_BOLD_FONT_FAMILY: YLE_NEXT_7XL_BOLD_FONT_FAMILY$2,
  YLE_NEXT_7XL_BOLD_FONT_SIZE: YLE_NEXT_7XL_BOLD_FONT_SIZE$2,
  YLE_NEXT_7XL_BOLD_FONT_STRETCH: YLE_NEXT_7XL_BOLD_FONT_STRETCH$2,
  YLE_NEXT_7XL_BOLD_FONT_STYLE: YLE_NEXT_7XL_BOLD_FONT_STYLE$2,
  YLE_NEXT_7XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_7XL_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_7XL_BOLD_FONT_WEIGHT: YLE_NEXT_7XL_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_7XL_BOLD_LETTER_SPACING: YLE_NEXT_7XL_BOLD_LETTER_SPACING$2,
  YLE_NEXT_7XL_BOLD_LINE_HEIGHT: YLE_NEXT_7XL_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_7XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_7XL_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_7XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_7XL_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_7XL_BOLD_TEXT_CASE: YLE_NEXT_7XL_BOLD_TEXT_CASE$2,
  YLE_NEXT_7XL_BOLD_TEXT_DECORATION: YLE_NEXT_7XL_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_SIZE$2,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE$2,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_7XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_7XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_7XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_7XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_CASE$2,
  YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_7XL_HEAVY_FONT_FAMILY: YLE_NEXT_7XL_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_7XL_HEAVY_FONT_SIZE: YLE_NEXT_7XL_HEAVY_FONT_SIZE$2,
  YLE_NEXT_7XL_HEAVY_FONT_STRETCH: YLE_NEXT_7XL_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_7XL_HEAVY_FONT_STYLE: YLE_NEXT_7XL_HEAVY_FONT_STYLE$2,
  YLE_NEXT_7XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_7XL_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_7XL_HEAVY_FONT_WEIGHT: YLE_NEXT_7XL_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_7XL_HEAVY_LETTER_SPACING: YLE_NEXT_7XL_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_7XL_HEAVY_LINE_HEIGHT: YLE_NEXT_7XL_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_7XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_7XL_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_7XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_7XL_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_7XL_HEAVY_TEXT_CASE: YLE_NEXT_7XL_HEAVY_TEXT_CASE$2,
  YLE_NEXT_7XL_HEAVY_TEXT_DECORATION: YLE_NEXT_7XL_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_L_BOLD_FONT_FAMILY: YLE_NEXT_L_BOLD_FONT_FAMILY$2,
  YLE_NEXT_L_BOLD_FONT_SIZE: YLE_NEXT_L_BOLD_FONT_SIZE$2,
  YLE_NEXT_L_BOLD_FONT_STRETCH: YLE_NEXT_L_BOLD_FONT_STRETCH$2,
  YLE_NEXT_L_BOLD_FONT_STYLE: YLE_NEXT_L_BOLD_FONT_STYLE$2,
  YLE_NEXT_L_BOLD_FONT_STYLE_OLD: YLE_NEXT_L_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_L_BOLD_FONT_WEIGHT: YLE_NEXT_L_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_L_BOLD_LETTER_SPACING: YLE_NEXT_L_BOLD_LETTER_SPACING$2,
  YLE_NEXT_L_BOLD_LINE_HEIGHT: YLE_NEXT_L_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_L_BOLD_PARAGRAPH_INDENT: YLE_NEXT_L_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_L_BOLD_PARAGRAPH_SPACING: YLE_NEXT_L_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_L_BOLD_TEXT_CASE: YLE_NEXT_L_BOLD_TEXT_CASE$2,
  YLE_NEXT_L_BOLD_TEXT_DECORATION: YLE_NEXT_L_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_L_CONDENSED_BOLD_FONT_FAMILY$2,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_L_CONDENSED_BOLD_FONT_SIZE$2,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_L_CONDENSED_BOLD_FONT_STRETCH$2,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE$2,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_L_CONDENSED_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_L_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_L_CONDENSED_BOLD_LETTER_SPACING$2,
  YLE_NEXT_L_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_L_CONDENSED_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_L_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_L_CONDENSED_BOLD_TEXT_CASE$2,
  YLE_NEXT_L_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_L_CONDENSED_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_L_CONDENSED_FONT_FAMILY: YLE_NEXT_L_CONDENSED_FONT_FAMILY$2,
  YLE_NEXT_L_CONDENSED_FONT_SIZE: YLE_NEXT_L_CONDENSED_FONT_SIZE$2,
  YLE_NEXT_L_CONDENSED_FONT_STRETCH: YLE_NEXT_L_CONDENSED_FONT_STRETCH$2,
  YLE_NEXT_L_CONDENSED_FONT_STYLE: YLE_NEXT_L_CONDENSED_FONT_STYLE$2,
  YLE_NEXT_L_CONDENSED_FONT_STYLE_OLD: YLE_NEXT_L_CONDENSED_FONT_STYLE_OLD$2,
  YLE_NEXT_L_CONDENSED_FONT_WEIGHT: YLE_NEXT_L_CONDENSED_FONT_WEIGHT$2,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_L_CONDENSED_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_L_CONDENSED_HEAVY_FONT_SIZE$2,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_L_CONDENSED_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE$2,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_L_CONDENSED_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_L_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_L_CONDENSED_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_L_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_L_CONDENSED_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_L_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_L_CONDENSED_HEAVY_TEXT_CASE$2,
  YLE_NEXT_L_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_L_CONDENSED_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_L_CONDENSED_LETTER_SPACING: YLE_NEXT_L_CONDENSED_LETTER_SPACING$2,
  YLE_NEXT_L_CONDENSED_LINE_HEIGHT: YLE_NEXT_L_CONDENSED_LINE_HEIGHT$2,
  YLE_NEXT_L_CONDENSED_PARAGRAPH_INDENT: YLE_NEXT_L_CONDENSED_PARAGRAPH_INDENT$2,
  YLE_NEXT_L_CONDENSED_PARAGRAPH_SPACING: YLE_NEXT_L_CONDENSED_PARAGRAPH_SPACING$2,
  YLE_NEXT_L_CONDENSED_TEXT_CASE: YLE_NEXT_L_CONDENSED_TEXT_CASE$2,
  YLE_NEXT_L_CONDENSED_TEXT_DECORATION: YLE_NEXT_L_CONDENSED_TEXT_DECORATION$2,
  YLE_NEXT_L_FONT_FAMILY: YLE_NEXT_L_FONT_FAMILY$2,
  YLE_NEXT_L_FONT_SIZE: YLE_NEXT_L_FONT_SIZE$2,
  YLE_NEXT_L_FONT_STRETCH: YLE_NEXT_L_FONT_STRETCH$2,
  YLE_NEXT_L_FONT_STYLE: YLE_NEXT_L_FONT_STYLE$2,
  YLE_NEXT_L_FONT_STYLE_OLD: YLE_NEXT_L_FONT_STYLE_OLD$2,
  YLE_NEXT_L_FONT_WEIGHT: YLE_NEXT_L_FONT_WEIGHT$2,
  YLE_NEXT_L_HEAVY_FONT_FAMILY: YLE_NEXT_L_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_L_HEAVY_FONT_SIZE: YLE_NEXT_L_HEAVY_FONT_SIZE$2,
  YLE_NEXT_L_HEAVY_FONT_STRETCH: YLE_NEXT_L_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_L_HEAVY_FONT_STYLE: YLE_NEXT_L_HEAVY_FONT_STYLE$2,
  YLE_NEXT_L_HEAVY_FONT_STYLE_OLD: YLE_NEXT_L_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_L_HEAVY_FONT_WEIGHT: YLE_NEXT_L_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_L_HEAVY_LETTER_SPACING: YLE_NEXT_L_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_L_HEAVY_LINE_HEIGHT: YLE_NEXT_L_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_L_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_L_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_L_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_L_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_L_HEAVY_TEXT_CASE: YLE_NEXT_L_HEAVY_TEXT_CASE$2,
  YLE_NEXT_L_HEAVY_TEXT_DECORATION: YLE_NEXT_L_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_L_ITALIC_FONT_FAMILY: YLE_NEXT_L_ITALIC_FONT_FAMILY$2,
  YLE_NEXT_L_ITALIC_FONT_SIZE: YLE_NEXT_L_ITALIC_FONT_SIZE$2,
  YLE_NEXT_L_ITALIC_FONT_STRETCH: YLE_NEXT_L_ITALIC_FONT_STRETCH$2,
  YLE_NEXT_L_ITALIC_FONT_STYLE: YLE_NEXT_L_ITALIC_FONT_STYLE$2,
  YLE_NEXT_L_ITALIC_FONT_STYLE_OLD: YLE_NEXT_L_ITALIC_FONT_STYLE_OLD$2,
  YLE_NEXT_L_ITALIC_FONT_WEIGHT: YLE_NEXT_L_ITALIC_FONT_WEIGHT$2,
  YLE_NEXT_L_ITALIC_LETTER_SPACING: YLE_NEXT_L_ITALIC_LETTER_SPACING$2,
  YLE_NEXT_L_ITALIC_LINE_HEIGHT: YLE_NEXT_L_ITALIC_LINE_HEIGHT$2,
  YLE_NEXT_L_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_L_ITALIC_PARAGRAPH_INDENT$2,
  YLE_NEXT_L_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_L_ITALIC_PARAGRAPH_SPACING$2,
  YLE_NEXT_L_ITALIC_TEXT_CASE: YLE_NEXT_L_ITALIC_TEXT_CASE$2,
  YLE_NEXT_L_ITALIC_TEXT_DECORATION: YLE_NEXT_L_ITALIC_TEXT_DECORATION$2,
  YLE_NEXT_L_LETTER_SPACING: YLE_NEXT_L_LETTER_SPACING$2,
  YLE_NEXT_L_LINE_HEIGHT: YLE_NEXT_L_LINE_HEIGHT$2,
  YLE_NEXT_L_PARAGRAPH_INDENT: YLE_NEXT_L_PARAGRAPH_INDENT$2,
  YLE_NEXT_L_PARAGRAPH_SPACING: YLE_NEXT_L_PARAGRAPH_SPACING$2,
  YLE_NEXT_L_TEXT_CASE: YLE_NEXT_L_TEXT_CASE$2,
  YLE_NEXT_L_TEXT_DECORATION: YLE_NEXT_L_TEXT_DECORATION$2,
  YLE_NEXT_M_AC_FONT_FAMILY: YLE_NEXT_M_AC_FONT_FAMILY$2,
  YLE_NEXT_M_AC_FONT_SIZE: YLE_NEXT_M_AC_FONT_SIZE$2,
  YLE_NEXT_M_AC_FONT_STRETCH: YLE_NEXT_M_AC_FONT_STRETCH$2,
  YLE_NEXT_M_AC_FONT_STYLE: YLE_NEXT_M_AC_FONT_STYLE$2,
  YLE_NEXT_M_AC_FONT_STYLE_OLD: YLE_NEXT_M_AC_FONT_STYLE_OLD$2,
  YLE_NEXT_M_AC_FONT_WEIGHT: YLE_NEXT_M_AC_FONT_WEIGHT$2,
  YLE_NEXT_M_AC_LETTER_SPACING: YLE_NEXT_M_AC_LETTER_SPACING$2,
  YLE_NEXT_M_AC_LINE_HEIGHT: YLE_NEXT_M_AC_LINE_HEIGHT$2,
  YLE_NEXT_M_AC_PARAGRAPH_INDENT: YLE_NEXT_M_AC_PARAGRAPH_INDENT$2,
  YLE_NEXT_M_AC_PARAGRAPH_SPACING: YLE_NEXT_M_AC_PARAGRAPH_SPACING$2,
  YLE_NEXT_M_AC_TEXT_CASE: YLE_NEXT_M_AC_TEXT_CASE$2,
  YLE_NEXT_M_AC_TEXT_DECORATION: YLE_NEXT_M_AC_TEXT_DECORATION$2,
  YLE_NEXT_M_BOLD_AC_FONT_FAMILY: YLE_NEXT_M_BOLD_AC_FONT_FAMILY$2,
  YLE_NEXT_M_BOLD_AC_FONT_SIZE: YLE_NEXT_M_BOLD_AC_FONT_SIZE$2,
  YLE_NEXT_M_BOLD_AC_FONT_STRETCH: YLE_NEXT_M_BOLD_AC_FONT_STRETCH$2,
  YLE_NEXT_M_BOLD_AC_FONT_STYLE: YLE_NEXT_M_BOLD_AC_FONT_STYLE$2,
  YLE_NEXT_M_BOLD_AC_FONT_STYLE_OLD: YLE_NEXT_M_BOLD_AC_FONT_STYLE_OLD$2,
  YLE_NEXT_M_BOLD_AC_FONT_WEIGHT: YLE_NEXT_M_BOLD_AC_FONT_WEIGHT$2,
  YLE_NEXT_M_BOLD_AC_LETTER_SPACING: YLE_NEXT_M_BOLD_AC_LETTER_SPACING$2,
  YLE_NEXT_M_BOLD_AC_LINE_HEIGHT: YLE_NEXT_M_BOLD_AC_LINE_HEIGHT$2,
  YLE_NEXT_M_BOLD_AC_PARAGRAPH_INDENT: YLE_NEXT_M_BOLD_AC_PARAGRAPH_INDENT$2,
  YLE_NEXT_M_BOLD_AC_PARAGRAPH_SPACING: YLE_NEXT_M_BOLD_AC_PARAGRAPH_SPACING$2,
  YLE_NEXT_M_BOLD_AC_TEXT_CASE: YLE_NEXT_M_BOLD_AC_TEXT_CASE$2,
  YLE_NEXT_M_BOLD_AC_TEXT_DECORATION: YLE_NEXT_M_BOLD_AC_TEXT_DECORATION$2,
  YLE_NEXT_M_BOLD_FONT_FAMILY: YLE_NEXT_M_BOLD_FONT_FAMILY$2,
  YLE_NEXT_M_BOLD_FONT_SIZE: YLE_NEXT_M_BOLD_FONT_SIZE$2,
  YLE_NEXT_M_BOLD_FONT_STRETCH: YLE_NEXT_M_BOLD_FONT_STRETCH$2,
  YLE_NEXT_M_BOLD_FONT_STYLE: YLE_NEXT_M_BOLD_FONT_STYLE$2,
  YLE_NEXT_M_BOLD_FONT_STYLE_OLD: YLE_NEXT_M_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_M_BOLD_FONT_WEIGHT: YLE_NEXT_M_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_M_BOLD_LETTER_SPACING: YLE_NEXT_M_BOLD_LETTER_SPACING$2,
  YLE_NEXT_M_BOLD_LINE_HEIGHT: YLE_NEXT_M_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_M_BOLD_PARAGRAPH_INDENT: YLE_NEXT_M_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_M_BOLD_PARAGRAPH_SPACING: YLE_NEXT_M_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_M_BOLD_TEXT_CASE: YLE_NEXT_M_BOLD_TEXT_CASE$2,
  YLE_NEXT_M_BOLD_TEXT_DECORATION: YLE_NEXT_M_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_M_CONDENSED_BOLD_FONT_FAMILY$2,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_M_CONDENSED_BOLD_FONT_SIZE$2,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_M_CONDENSED_BOLD_FONT_STRETCH$2,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE$2,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_M_CONDENSED_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_M_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_M_CONDENSED_BOLD_LETTER_SPACING$2,
  YLE_NEXT_M_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_M_CONDENSED_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_M_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_M_CONDENSED_BOLD_TEXT_CASE$2,
  YLE_NEXT_M_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_M_CONDENSED_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_M_CONDENSED_FONT_FAMILY: YLE_NEXT_M_CONDENSED_FONT_FAMILY$2,
  YLE_NEXT_M_CONDENSED_FONT_SIZE: YLE_NEXT_M_CONDENSED_FONT_SIZE$2,
  YLE_NEXT_M_CONDENSED_FONT_STRETCH: YLE_NEXT_M_CONDENSED_FONT_STRETCH$2,
  YLE_NEXT_M_CONDENSED_FONT_STYLE: YLE_NEXT_M_CONDENSED_FONT_STYLE$2,
  YLE_NEXT_M_CONDENSED_FONT_STYLE_OLD: YLE_NEXT_M_CONDENSED_FONT_STYLE_OLD$2,
  YLE_NEXT_M_CONDENSED_FONT_WEIGHT: YLE_NEXT_M_CONDENSED_FONT_WEIGHT$2,
  YLE_NEXT_M_CONDENSED_LETTER_SPACING: YLE_NEXT_M_CONDENSED_LETTER_SPACING$2,
  YLE_NEXT_M_CONDENSED_LINE_HEIGHT: YLE_NEXT_M_CONDENSED_LINE_HEIGHT$2,
  YLE_NEXT_M_CONDENSED_PARAGRAPH_INDENT: YLE_NEXT_M_CONDENSED_PARAGRAPH_INDENT$2,
  YLE_NEXT_M_CONDENSED_PARAGRAPH_SPACING: YLE_NEXT_M_CONDENSED_PARAGRAPH_SPACING$2,
  YLE_NEXT_M_CONDENSED_TEXT_CASE: YLE_NEXT_M_CONDENSED_TEXT_CASE$2,
  YLE_NEXT_M_CONDENSED_TEXT_DECORATION: YLE_NEXT_M_CONDENSED_TEXT_DECORATION$2,
  YLE_NEXT_M_FONT_FAMILY: YLE_NEXT_M_FONT_FAMILY$2,
  YLE_NEXT_M_FONT_SIZE: YLE_NEXT_M_FONT_SIZE$2,
  YLE_NEXT_M_FONT_STRETCH: YLE_NEXT_M_FONT_STRETCH$2,
  YLE_NEXT_M_FONT_STYLE: YLE_NEXT_M_FONT_STYLE$2,
  YLE_NEXT_M_FONT_STYLE_OLD: YLE_NEXT_M_FONT_STYLE_OLD$2,
  YLE_NEXT_M_FONT_WEIGHT: YLE_NEXT_M_FONT_WEIGHT$2,
  YLE_NEXT_M_ITALIC_FONT_FAMILY: YLE_NEXT_M_ITALIC_FONT_FAMILY$2,
  YLE_NEXT_M_ITALIC_FONT_SIZE: YLE_NEXT_M_ITALIC_FONT_SIZE$2,
  YLE_NEXT_M_ITALIC_FONT_STRETCH: YLE_NEXT_M_ITALIC_FONT_STRETCH$2,
  YLE_NEXT_M_ITALIC_FONT_STYLE: YLE_NEXT_M_ITALIC_FONT_STYLE$2,
  YLE_NEXT_M_ITALIC_FONT_STYLE_OLD: YLE_NEXT_M_ITALIC_FONT_STYLE_OLD$2,
  YLE_NEXT_M_ITALIC_FONT_WEIGHT: YLE_NEXT_M_ITALIC_FONT_WEIGHT$2,
  YLE_NEXT_M_ITALIC_LETTER_SPACING: YLE_NEXT_M_ITALIC_LETTER_SPACING$2,
  YLE_NEXT_M_ITALIC_LINE_HEIGHT: YLE_NEXT_M_ITALIC_LINE_HEIGHT$2,
  YLE_NEXT_M_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_M_ITALIC_PARAGRAPH_INDENT$2,
  YLE_NEXT_M_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_M_ITALIC_PARAGRAPH_SPACING$2,
  YLE_NEXT_M_ITALIC_TEXT_CASE: YLE_NEXT_M_ITALIC_TEXT_CASE$2,
  YLE_NEXT_M_ITALIC_TEXT_DECORATION: YLE_NEXT_M_ITALIC_TEXT_DECORATION$2,
  YLE_NEXT_M_LETTER_SPACING: YLE_NEXT_M_LETTER_SPACING$2,
  YLE_NEXT_M_LINE_HEIGHT: YLE_NEXT_M_LINE_HEIGHT$2,
  YLE_NEXT_M_MEDIUM_FONT_FAMILY: YLE_NEXT_M_MEDIUM_FONT_FAMILY$2,
  YLE_NEXT_M_MEDIUM_FONT_SIZE: YLE_NEXT_M_MEDIUM_FONT_SIZE$2,
  YLE_NEXT_M_MEDIUM_FONT_STRETCH: YLE_NEXT_M_MEDIUM_FONT_STRETCH$2,
  YLE_NEXT_M_MEDIUM_FONT_STYLE: YLE_NEXT_M_MEDIUM_FONT_STYLE$2,
  YLE_NEXT_M_MEDIUM_FONT_STYLE_OLD: YLE_NEXT_M_MEDIUM_FONT_STYLE_OLD$2,
  YLE_NEXT_M_MEDIUM_FONT_WEIGHT: YLE_NEXT_M_MEDIUM_FONT_WEIGHT$2,
  YLE_NEXT_M_MEDIUM_LETTER_SPACING: YLE_NEXT_M_MEDIUM_LETTER_SPACING$2,
  YLE_NEXT_M_MEDIUM_LINE_HEIGHT: YLE_NEXT_M_MEDIUM_LINE_HEIGHT$2,
  YLE_NEXT_M_MEDIUM_PARAGRAPH_INDENT: YLE_NEXT_M_MEDIUM_PARAGRAPH_INDENT$2,
  YLE_NEXT_M_MEDIUM_PARAGRAPH_SPACING: YLE_NEXT_M_MEDIUM_PARAGRAPH_SPACING$2,
  YLE_NEXT_M_MEDIUM_TEXT_CASE: YLE_NEXT_M_MEDIUM_TEXT_CASE$2,
  YLE_NEXT_M_MEDIUM_TEXT_DECORATION: YLE_NEXT_M_MEDIUM_TEXT_DECORATION$2,
  YLE_NEXT_M_PARAGRAPH_INDENT: YLE_NEXT_M_PARAGRAPH_INDENT$2,
  YLE_NEXT_M_PARAGRAPH_SPACING: YLE_NEXT_M_PARAGRAPH_SPACING$2,
  YLE_NEXT_M_TEXT_CASE: YLE_NEXT_M_TEXT_CASE$2,
  YLE_NEXT_M_TEXT_DECORATION: YLE_NEXT_M_TEXT_DECORATION$2,
  YLE_NEXT_S_AC_FONT_FAMILY: YLE_NEXT_S_AC_FONT_FAMILY$2,
  YLE_NEXT_S_AC_FONT_SIZE: YLE_NEXT_S_AC_FONT_SIZE$2,
  YLE_NEXT_S_AC_FONT_STRETCH: YLE_NEXT_S_AC_FONT_STRETCH$2,
  YLE_NEXT_S_AC_FONT_STYLE: YLE_NEXT_S_AC_FONT_STYLE$2,
  YLE_NEXT_S_AC_FONT_STYLE_OLD: YLE_NEXT_S_AC_FONT_STYLE_OLD$2,
  YLE_NEXT_S_AC_FONT_WEIGHT: YLE_NEXT_S_AC_FONT_WEIGHT$2,
  YLE_NEXT_S_AC_LETTER_SPACING: YLE_NEXT_S_AC_LETTER_SPACING$2,
  YLE_NEXT_S_AC_LINE_HEIGHT: YLE_NEXT_S_AC_LINE_HEIGHT$2,
  YLE_NEXT_S_AC_PARAGRAPH_INDENT: YLE_NEXT_S_AC_PARAGRAPH_INDENT$2,
  YLE_NEXT_S_AC_PARAGRAPH_SPACING: YLE_NEXT_S_AC_PARAGRAPH_SPACING$2,
  YLE_NEXT_S_AC_TEXT_CASE: YLE_NEXT_S_AC_TEXT_CASE$2,
  YLE_NEXT_S_AC_TEXT_DECORATION: YLE_NEXT_S_AC_TEXT_DECORATION$2,
  YLE_NEXT_S_BOLD_AC_FONT_FAMILY: YLE_NEXT_S_BOLD_AC_FONT_FAMILY$2,
  YLE_NEXT_S_BOLD_AC_FONT_SIZE: YLE_NEXT_S_BOLD_AC_FONT_SIZE$2,
  YLE_NEXT_S_BOLD_AC_FONT_STRETCH: YLE_NEXT_S_BOLD_AC_FONT_STRETCH$2,
  YLE_NEXT_S_BOLD_AC_FONT_STYLE: YLE_NEXT_S_BOLD_AC_FONT_STYLE$2,
  YLE_NEXT_S_BOLD_AC_FONT_STYLE_OLD: YLE_NEXT_S_BOLD_AC_FONT_STYLE_OLD$2,
  YLE_NEXT_S_BOLD_AC_FONT_WEIGHT: YLE_NEXT_S_BOLD_AC_FONT_WEIGHT$2,
  YLE_NEXT_S_BOLD_AC_LETTER_SPACING: YLE_NEXT_S_BOLD_AC_LETTER_SPACING$2,
  YLE_NEXT_S_BOLD_AC_LINE_HEIGHT: YLE_NEXT_S_BOLD_AC_LINE_HEIGHT$2,
  YLE_NEXT_S_BOLD_AC_PARAGRAPH_INDENT: YLE_NEXT_S_BOLD_AC_PARAGRAPH_INDENT$2,
  YLE_NEXT_S_BOLD_AC_PARAGRAPH_SPACING: YLE_NEXT_S_BOLD_AC_PARAGRAPH_SPACING$2,
  YLE_NEXT_S_BOLD_AC_TEXT_CASE: YLE_NEXT_S_BOLD_AC_TEXT_CASE$2,
  YLE_NEXT_S_BOLD_AC_TEXT_DECORATION: YLE_NEXT_S_BOLD_AC_TEXT_DECORATION$2,
  YLE_NEXT_S_BOLD_FONT_FAMILY: YLE_NEXT_S_BOLD_FONT_FAMILY$2,
  YLE_NEXT_S_BOLD_FONT_SIZE: YLE_NEXT_S_BOLD_FONT_SIZE$2,
  YLE_NEXT_S_BOLD_FONT_STRETCH: YLE_NEXT_S_BOLD_FONT_STRETCH$2,
  YLE_NEXT_S_BOLD_FONT_STYLE: YLE_NEXT_S_BOLD_FONT_STYLE$2,
  YLE_NEXT_S_BOLD_FONT_STYLE_OLD: YLE_NEXT_S_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_S_BOLD_FONT_WEIGHT: YLE_NEXT_S_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_S_BOLD_LETTER_SPACING: YLE_NEXT_S_BOLD_LETTER_SPACING$2,
  YLE_NEXT_S_BOLD_LINE_HEIGHT: YLE_NEXT_S_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_S_BOLD_PARAGRAPH_INDENT: YLE_NEXT_S_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_S_BOLD_PARAGRAPH_SPACING: YLE_NEXT_S_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_S_BOLD_TEXT_CASE: YLE_NEXT_S_BOLD_TEXT_CASE$2,
  YLE_NEXT_S_BOLD_TEXT_DECORATION: YLE_NEXT_S_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_S_CONDENSED_BOLD_FONT_FAMILY$2,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_S_CONDENSED_BOLD_FONT_SIZE$2,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_S_CONDENSED_BOLD_FONT_STRETCH$2,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE$2,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_S_CONDENSED_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_S_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_S_CONDENSED_BOLD_LETTER_SPACING$2,
  YLE_NEXT_S_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_S_CONDENSED_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_S_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_S_CONDENSED_BOLD_TEXT_CASE$2,
  YLE_NEXT_S_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_S_CONDENSED_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_S_CONDENSED_FONT_FAMILY: YLE_NEXT_S_CONDENSED_FONT_FAMILY$2,
  YLE_NEXT_S_CONDENSED_FONT_SIZE: YLE_NEXT_S_CONDENSED_FONT_SIZE$2,
  YLE_NEXT_S_CONDENSED_FONT_STRETCH: YLE_NEXT_S_CONDENSED_FONT_STRETCH$2,
  YLE_NEXT_S_CONDENSED_FONT_STYLE: YLE_NEXT_S_CONDENSED_FONT_STYLE$2,
  YLE_NEXT_S_CONDENSED_FONT_STYLE_OLD: YLE_NEXT_S_CONDENSED_FONT_STYLE_OLD$2,
  YLE_NEXT_S_CONDENSED_FONT_WEIGHT: YLE_NEXT_S_CONDENSED_FONT_WEIGHT$2,
  YLE_NEXT_S_CONDENSED_LETTER_SPACING: YLE_NEXT_S_CONDENSED_LETTER_SPACING$2,
  YLE_NEXT_S_CONDENSED_LINE_HEIGHT: YLE_NEXT_S_CONDENSED_LINE_HEIGHT$2,
  YLE_NEXT_S_CONDENSED_PARAGRAPH_INDENT: YLE_NEXT_S_CONDENSED_PARAGRAPH_INDENT$2,
  YLE_NEXT_S_CONDENSED_PARAGRAPH_SPACING: YLE_NEXT_S_CONDENSED_PARAGRAPH_SPACING$2,
  YLE_NEXT_S_CONDENSED_TEXT_CASE: YLE_NEXT_S_CONDENSED_TEXT_CASE$2,
  YLE_NEXT_S_CONDENSED_TEXT_DECORATION: YLE_NEXT_S_CONDENSED_TEXT_DECORATION$2,
  YLE_NEXT_S_FONT_FAMILY: YLE_NEXT_S_FONT_FAMILY$2,
  YLE_NEXT_S_FONT_SIZE: YLE_NEXT_S_FONT_SIZE$2,
  YLE_NEXT_S_FONT_STRETCH: YLE_NEXT_S_FONT_STRETCH$2,
  YLE_NEXT_S_FONT_STYLE: YLE_NEXT_S_FONT_STYLE$2,
  YLE_NEXT_S_FONT_STYLE_OLD: YLE_NEXT_S_FONT_STYLE_OLD$2,
  YLE_NEXT_S_FONT_WEIGHT: YLE_NEXT_S_FONT_WEIGHT$2,
  YLE_NEXT_S_ITALIC_FONT_FAMILY: YLE_NEXT_S_ITALIC_FONT_FAMILY$2,
  YLE_NEXT_S_ITALIC_FONT_SIZE: YLE_NEXT_S_ITALIC_FONT_SIZE$2,
  YLE_NEXT_S_ITALIC_FONT_STRETCH: YLE_NEXT_S_ITALIC_FONT_STRETCH$2,
  YLE_NEXT_S_ITALIC_FONT_STYLE: YLE_NEXT_S_ITALIC_FONT_STYLE$2,
  YLE_NEXT_S_ITALIC_FONT_STYLE_OLD: YLE_NEXT_S_ITALIC_FONT_STYLE_OLD$2,
  YLE_NEXT_S_ITALIC_FONT_WEIGHT: YLE_NEXT_S_ITALIC_FONT_WEIGHT$2,
  YLE_NEXT_S_ITALIC_LETTER_SPACING: YLE_NEXT_S_ITALIC_LETTER_SPACING$2,
  YLE_NEXT_S_ITALIC_LINE_HEIGHT: YLE_NEXT_S_ITALIC_LINE_HEIGHT$2,
  YLE_NEXT_S_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_S_ITALIC_PARAGRAPH_INDENT$2,
  YLE_NEXT_S_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_S_ITALIC_PARAGRAPH_SPACING$2,
  YLE_NEXT_S_ITALIC_TEXT_CASE: YLE_NEXT_S_ITALIC_TEXT_CASE$2,
  YLE_NEXT_S_ITALIC_TEXT_DECORATION: YLE_NEXT_S_ITALIC_TEXT_DECORATION$2,
  YLE_NEXT_S_LETTER_SPACING: YLE_NEXT_S_LETTER_SPACING$2,
  YLE_NEXT_S_LINE_HEIGHT: YLE_NEXT_S_LINE_HEIGHT$2,
  YLE_NEXT_S_MEDIUM_FONT_FAMILY: YLE_NEXT_S_MEDIUM_FONT_FAMILY$2,
  YLE_NEXT_S_MEDIUM_FONT_SIZE: YLE_NEXT_S_MEDIUM_FONT_SIZE$2,
  YLE_NEXT_S_MEDIUM_FONT_STRETCH: YLE_NEXT_S_MEDIUM_FONT_STRETCH$2,
  YLE_NEXT_S_MEDIUM_FONT_STYLE: YLE_NEXT_S_MEDIUM_FONT_STYLE$2,
  YLE_NEXT_S_MEDIUM_FONT_STYLE_OLD: YLE_NEXT_S_MEDIUM_FONT_STYLE_OLD$2,
  YLE_NEXT_S_MEDIUM_FONT_WEIGHT: YLE_NEXT_S_MEDIUM_FONT_WEIGHT$2,
  YLE_NEXT_S_MEDIUM_LETTER_SPACING: YLE_NEXT_S_MEDIUM_LETTER_SPACING$2,
  YLE_NEXT_S_MEDIUM_LINE_HEIGHT: YLE_NEXT_S_MEDIUM_LINE_HEIGHT$2,
  YLE_NEXT_S_MEDIUM_PARAGRAPH_INDENT: YLE_NEXT_S_MEDIUM_PARAGRAPH_INDENT$2,
  YLE_NEXT_S_MEDIUM_PARAGRAPH_SPACING: YLE_NEXT_S_MEDIUM_PARAGRAPH_SPACING$2,
  YLE_NEXT_S_MEDIUM_TEXT_CASE: YLE_NEXT_S_MEDIUM_TEXT_CASE$2,
  YLE_NEXT_S_MEDIUM_TEXT_DECORATION: YLE_NEXT_S_MEDIUM_TEXT_DECORATION$2,
  YLE_NEXT_S_PARAGRAPH_INDENT: YLE_NEXT_S_PARAGRAPH_INDENT$2,
  YLE_NEXT_S_PARAGRAPH_SPACING: YLE_NEXT_S_PARAGRAPH_SPACING$2,
  YLE_NEXT_S_TEXT_CASE: YLE_NEXT_S_TEXT_CASE$2,
  YLE_NEXT_S_TEXT_DECORATION: YLE_NEXT_S_TEXT_DECORATION$2,
  YLE_NEXT_XL_BOLD_FONT_FAMILY: YLE_NEXT_XL_BOLD_FONT_FAMILY$2,
  YLE_NEXT_XL_BOLD_FONT_SIZE: YLE_NEXT_XL_BOLD_FONT_SIZE$2,
  YLE_NEXT_XL_BOLD_FONT_STRETCH: YLE_NEXT_XL_BOLD_FONT_STRETCH$2,
  YLE_NEXT_XL_BOLD_FONT_STYLE: YLE_NEXT_XL_BOLD_FONT_STYLE$2,
  YLE_NEXT_XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_XL_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_XL_BOLD_FONT_WEIGHT: YLE_NEXT_XL_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_XL_BOLD_LETTER_SPACING: YLE_NEXT_XL_BOLD_LETTER_SPACING$2,
  YLE_NEXT_XL_BOLD_LINE_HEIGHT: YLE_NEXT_XL_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XL_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XL_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_XL_BOLD_TEXT_CASE: YLE_NEXT_XL_BOLD_TEXT_CASE$2,
  YLE_NEXT_XL_BOLD_TEXT_DECORATION: YLE_NEXT_XL_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_XL_CONDENSED_BOLD_FONT_FAMILY$2,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_XL_CONDENSED_BOLD_FONT_SIZE$2,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_XL_CONDENSED_BOLD_FONT_STRETCH$2,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE$2,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_XL_CONDENSED_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_XL_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_XL_CONDENSED_BOLD_LETTER_SPACING$2,
  YLE_NEXT_XL_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_XL_CONDENSED_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_XL_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_XL_CONDENSED_BOLD_TEXT_CASE$2,
  YLE_NEXT_XL_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_XL_CONDENSED_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_XL_CONDENSED_FONT_FAMILY: YLE_NEXT_XL_CONDENSED_FONT_FAMILY$2,
  YLE_NEXT_XL_CONDENSED_FONT_SIZE: YLE_NEXT_XL_CONDENSED_FONT_SIZE$2,
  YLE_NEXT_XL_CONDENSED_FONT_STRETCH: YLE_NEXT_XL_CONDENSED_FONT_STRETCH$2,
  YLE_NEXT_XL_CONDENSED_FONT_STYLE: YLE_NEXT_XL_CONDENSED_FONT_STYLE$2,
  YLE_NEXT_XL_CONDENSED_FONT_STYLE_OLD: YLE_NEXT_XL_CONDENSED_FONT_STYLE_OLD$2,
  YLE_NEXT_XL_CONDENSED_FONT_WEIGHT: YLE_NEXT_XL_CONDENSED_FONT_WEIGHT$2,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_SIZE$2,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE$2,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_XL_CONDENSED_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_XL_CONDENSED_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_CASE$2,
  YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_XL_CONDENSED_LETTER_SPACING: YLE_NEXT_XL_CONDENSED_LETTER_SPACING$2,
  YLE_NEXT_XL_CONDENSED_LINE_HEIGHT: YLE_NEXT_XL_CONDENSED_LINE_HEIGHT$2,
  YLE_NEXT_XL_CONDENSED_PARAGRAPH_INDENT: YLE_NEXT_XL_CONDENSED_PARAGRAPH_INDENT$2,
  YLE_NEXT_XL_CONDENSED_PARAGRAPH_SPACING: YLE_NEXT_XL_CONDENSED_PARAGRAPH_SPACING$2,
  YLE_NEXT_XL_CONDENSED_TEXT_CASE: YLE_NEXT_XL_CONDENSED_TEXT_CASE$2,
  YLE_NEXT_XL_CONDENSED_TEXT_DECORATION: YLE_NEXT_XL_CONDENSED_TEXT_DECORATION$2,
  YLE_NEXT_XL_FONT_FAMILY: YLE_NEXT_XL_FONT_FAMILY$2,
  YLE_NEXT_XL_FONT_SIZE: YLE_NEXT_XL_FONT_SIZE$2,
  YLE_NEXT_XL_FONT_STRETCH: YLE_NEXT_XL_FONT_STRETCH$2,
  YLE_NEXT_XL_FONT_STYLE: YLE_NEXT_XL_FONT_STYLE$2,
  YLE_NEXT_XL_FONT_STYLE_OLD: YLE_NEXT_XL_FONT_STYLE_OLD$2,
  YLE_NEXT_XL_FONT_WEIGHT: YLE_NEXT_XL_FONT_WEIGHT$2,
  YLE_NEXT_XL_HEAVY_FONT_FAMILY: YLE_NEXT_XL_HEAVY_FONT_FAMILY$2,
  YLE_NEXT_XL_HEAVY_FONT_SIZE: YLE_NEXT_XL_HEAVY_FONT_SIZE$2,
  YLE_NEXT_XL_HEAVY_FONT_STRETCH: YLE_NEXT_XL_HEAVY_FONT_STRETCH$2,
  YLE_NEXT_XL_HEAVY_FONT_STYLE: YLE_NEXT_XL_HEAVY_FONT_STYLE$2,
  YLE_NEXT_XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_XL_HEAVY_FONT_STYLE_OLD$2,
  YLE_NEXT_XL_HEAVY_FONT_WEIGHT: YLE_NEXT_XL_HEAVY_FONT_WEIGHT$2,
  YLE_NEXT_XL_HEAVY_LETTER_SPACING: YLE_NEXT_XL_HEAVY_LETTER_SPACING$2,
  YLE_NEXT_XL_HEAVY_LINE_HEIGHT: YLE_NEXT_XL_HEAVY_LINE_HEIGHT$2,
  YLE_NEXT_XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_XL_HEAVY_PARAGRAPH_INDENT$2,
  YLE_NEXT_XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_XL_HEAVY_PARAGRAPH_SPACING$2,
  YLE_NEXT_XL_HEAVY_TEXT_CASE: YLE_NEXT_XL_HEAVY_TEXT_CASE$2,
  YLE_NEXT_XL_HEAVY_TEXT_DECORATION: YLE_NEXT_XL_HEAVY_TEXT_DECORATION$2,
  YLE_NEXT_XL_ITALIC_FONT_FAMILY: YLE_NEXT_XL_ITALIC_FONT_FAMILY$2,
  YLE_NEXT_XL_ITALIC_FONT_SIZE: YLE_NEXT_XL_ITALIC_FONT_SIZE$2,
  YLE_NEXT_XL_ITALIC_FONT_STRETCH: YLE_NEXT_XL_ITALIC_FONT_STRETCH$2,
  YLE_NEXT_XL_ITALIC_FONT_STYLE: YLE_NEXT_XL_ITALIC_FONT_STYLE$2,
  YLE_NEXT_XL_ITALIC_FONT_STYLE_OLD: YLE_NEXT_XL_ITALIC_FONT_STYLE_OLD$2,
  YLE_NEXT_XL_ITALIC_FONT_WEIGHT: YLE_NEXT_XL_ITALIC_FONT_WEIGHT$2,
  YLE_NEXT_XL_ITALIC_LETTER_SPACING: YLE_NEXT_XL_ITALIC_LETTER_SPACING$2,
  YLE_NEXT_XL_ITALIC_LINE_HEIGHT: YLE_NEXT_XL_ITALIC_LINE_HEIGHT$2,
  YLE_NEXT_XL_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_XL_ITALIC_PARAGRAPH_INDENT$2,
  YLE_NEXT_XL_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_XL_ITALIC_PARAGRAPH_SPACING$2,
  YLE_NEXT_XL_ITALIC_TEXT_CASE: YLE_NEXT_XL_ITALIC_TEXT_CASE$2,
  YLE_NEXT_XL_ITALIC_TEXT_DECORATION: YLE_NEXT_XL_ITALIC_TEXT_DECORATION$2,
  YLE_NEXT_XL_LETTER_SPACING: YLE_NEXT_XL_LETTER_SPACING$2,
  YLE_NEXT_XL_LINE_HEIGHT: YLE_NEXT_XL_LINE_HEIGHT$2,
  YLE_NEXT_XL_PARAGRAPH_INDENT: YLE_NEXT_XL_PARAGRAPH_INDENT$2,
  YLE_NEXT_XL_PARAGRAPH_SPACING: YLE_NEXT_XL_PARAGRAPH_SPACING$2,
  YLE_NEXT_XL_TEXT_CASE: YLE_NEXT_XL_TEXT_CASE$2,
  YLE_NEXT_XL_TEXT_DECORATION: YLE_NEXT_XL_TEXT_DECORATION$2,
  YLE_NEXT_XS_AC_FONT_FAMILY: YLE_NEXT_XS_AC_FONT_FAMILY$2,
  YLE_NEXT_XS_AC_FONT_SIZE: YLE_NEXT_XS_AC_FONT_SIZE$2,
  YLE_NEXT_XS_AC_FONT_STRETCH: YLE_NEXT_XS_AC_FONT_STRETCH$2,
  YLE_NEXT_XS_AC_FONT_STYLE: YLE_NEXT_XS_AC_FONT_STYLE$2,
  YLE_NEXT_XS_AC_FONT_STYLE_OLD: YLE_NEXT_XS_AC_FONT_STYLE_OLD$2,
  YLE_NEXT_XS_AC_FONT_WEIGHT: YLE_NEXT_XS_AC_FONT_WEIGHT$2,
  YLE_NEXT_XS_AC_LETTER_SPACING: YLE_NEXT_XS_AC_LETTER_SPACING$2,
  YLE_NEXT_XS_AC_LINE_HEIGHT: YLE_NEXT_XS_AC_LINE_HEIGHT$2,
  YLE_NEXT_XS_AC_PARAGRAPH_INDENT: YLE_NEXT_XS_AC_PARAGRAPH_INDENT$2,
  YLE_NEXT_XS_AC_PARAGRAPH_SPACING: YLE_NEXT_XS_AC_PARAGRAPH_SPACING$2,
  YLE_NEXT_XS_AC_TEXT_CASE: YLE_NEXT_XS_AC_TEXT_CASE$2,
  YLE_NEXT_XS_AC_TEXT_DECORATION: YLE_NEXT_XS_AC_TEXT_DECORATION$2,
  YLE_NEXT_XS_BOLD_AC_FONT_FAMILY: YLE_NEXT_XS_BOLD_AC_FONT_FAMILY$2,
  YLE_NEXT_XS_BOLD_AC_FONT_SIZE: YLE_NEXT_XS_BOLD_AC_FONT_SIZE$2,
  YLE_NEXT_XS_BOLD_AC_FONT_STRETCH: YLE_NEXT_XS_BOLD_AC_FONT_STRETCH$2,
  YLE_NEXT_XS_BOLD_AC_FONT_STYLE: YLE_NEXT_XS_BOLD_AC_FONT_STYLE$2,
  YLE_NEXT_XS_BOLD_AC_FONT_STYLE_OLD: YLE_NEXT_XS_BOLD_AC_FONT_STYLE_OLD$2,
  YLE_NEXT_XS_BOLD_AC_FONT_WEIGHT: YLE_NEXT_XS_BOLD_AC_FONT_WEIGHT$2,
  YLE_NEXT_XS_BOLD_AC_LETTER_SPACING: YLE_NEXT_XS_BOLD_AC_LETTER_SPACING$2,
  YLE_NEXT_XS_BOLD_AC_LINE_HEIGHT: YLE_NEXT_XS_BOLD_AC_LINE_HEIGHT$2,
  YLE_NEXT_XS_BOLD_AC_PARAGRAPH_INDENT: YLE_NEXT_XS_BOLD_AC_PARAGRAPH_INDENT$2,
  YLE_NEXT_XS_BOLD_AC_PARAGRAPH_SPACING: YLE_NEXT_XS_BOLD_AC_PARAGRAPH_SPACING$2,
  YLE_NEXT_XS_BOLD_AC_TEXT_CASE: YLE_NEXT_XS_BOLD_AC_TEXT_CASE$2,
  YLE_NEXT_XS_BOLD_AC_TEXT_DECORATION: YLE_NEXT_XS_BOLD_AC_TEXT_DECORATION$2,
  YLE_NEXT_XS_BOLD_FONT_FAMILY: YLE_NEXT_XS_BOLD_FONT_FAMILY$2,
  YLE_NEXT_XS_BOLD_FONT_SIZE: YLE_NEXT_XS_BOLD_FONT_SIZE$2,
  YLE_NEXT_XS_BOLD_FONT_STRETCH: YLE_NEXT_XS_BOLD_FONT_STRETCH$2,
  YLE_NEXT_XS_BOLD_FONT_STYLE: YLE_NEXT_XS_BOLD_FONT_STYLE$2,
  YLE_NEXT_XS_BOLD_FONT_STYLE_OLD: YLE_NEXT_XS_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_XS_BOLD_FONT_WEIGHT: YLE_NEXT_XS_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_XS_BOLD_LETTER_SPACING: YLE_NEXT_XS_BOLD_LETTER_SPACING$2,
  YLE_NEXT_XS_BOLD_LINE_HEIGHT: YLE_NEXT_XS_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_XS_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XS_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_XS_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XS_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_XS_BOLD_TEXT_CASE: YLE_NEXT_XS_BOLD_TEXT_CASE$2,
  YLE_NEXT_XS_BOLD_TEXT_DECORATION: YLE_NEXT_XS_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_XS_CONDENSED_BOLD_FONT_FAMILY$2,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_XS_CONDENSED_BOLD_FONT_SIZE$2,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_XS_CONDENSED_BOLD_FONT_STRETCH$2,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE$2,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE_OLD$2,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_XS_CONDENSED_BOLD_FONT_WEIGHT$2,
  YLE_NEXT_XS_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_XS_CONDENSED_BOLD_LETTER_SPACING$2,
  YLE_NEXT_XS_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_XS_CONDENSED_BOLD_LINE_HEIGHT$2,
  YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT$2,
  YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING$2,
  YLE_NEXT_XS_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_XS_CONDENSED_BOLD_TEXT_CASE$2,
  YLE_NEXT_XS_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_XS_CONDENSED_BOLD_TEXT_DECORATION$2,
  YLE_NEXT_XS_FONT_FAMILY: YLE_NEXT_XS_FONT_FAMILY$2,
  YLE_NEXT_XS_FONT_SIZE: YLE_NEXT_XS_FONT_SIZE$2,
  YLE_NEXT_XS_FONT_STRETCH: YLE_NEXT_XS_FONT_STRETCH$2,
  YLE_NEXT_XS_FONT_STYLE: YLE_NEXT_XS_FONT_STYLE$2,
  YLE_NEXT_XS_FONT_STYLE_OLD: YLE_NEXT_XS_FONT_STYLE_OLD$2,
  YLE_NEXT_XS_FONT_WEIGHT: YLE_NEXT_XS_FONT_WEIGHT$2,
  YLE_NEXT_XS_ITALIC_FONT_FAMILY: YLE_NEXT_XS_ITALIC_FONT_FAMILY$2,
  YLE_NEXT_XS_ITALIC_FONT_SIZE: YLE_NEXT_XS_ITALIC_FONT_SIZE$2,
  YLE_NEXT_XS_ITALIC_FONT_STRETCH: YLE_NEXT_XS_ITALIC_FONT_STRETCH$2,
  YLE_NEXT_XS_ITALIC_FONT_STYLE: YLE_NEXT_XS_ITALIC_FONT_STYLE$2,
  YLE_NEXT_XS_ITALIC_FONT_STYLE_OLD: YLE_NEXT_XS_ITALIC_FONT_STYLE_OLD$2,
  YLE_NEXT_XS_ITALIC_FONT_WEIGHT: YLE_NEXT_XS_ITALIC_FONT_WEIGHT$2,
  YLE_NEXT_XS_ITALIC_LETTER_SPACING: YLE_NEXT_XS_ITALIC_LETTER_SPACING$2,
  YLE_NEXT_XS_ITALIC_LINE_HEIGHT: YLE_NEXT_XS_ITALIC_LINE_HEIGHT$2,
  YLE_NEXT_XS_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_XS_ITALIC_PARAGRAPH_INDENT$2,
  YLE_NEXT_XS_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_XS_ITALIC_PARAGRAPH_SPACING$2,
  YLE_NEXT_XS_ITALIC_TEXT_CASE: YLE_NEXT_XS_ITALIC_TEXT_CASE$2,
  YLE_NEXT_XS_ITALIC_TEXT_DECORATION: YLE_NEXT_XS_ITALIC_TEXT_DECORATION$2,
  YLE_NEXT_XS_LETTER_SPACING: YLE_NEXT_XS_LETTER_SPACING$2,
  YLE_NEXT_XS_LINE_HEIGHT: YLE_NEXT_XS_LINE_HEIGHT$2,
  YLE_NEXT_XS_PARAGRAPH_INDENT: YLE_NEXT_XS_PARAGRAPH_INDENT$2,
  YLE_NEXT_XS_PARAGRAPH_SPACING: YLE_NEXT_XS_PARAGRAPH_SPACING$2,
  YLE_NEXT_XS_TEXT_CASE: YLE_NEXT_XS_TEXT_CASE$2,
  YLE_NEXT_XS_TEXT_DECORATION: YLE_NEXT_XS_TEXT_DECORATION$2
});

/**
 * Yle Design System
 * v2.x.x
 */

const DEFAULT_7XL_BOLD_FONT_SIZE$1 = '56px';
const DEFAULT_7XL_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_7XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_7XL_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_7XL_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_7XL_BOLD_FONT_STRETCH$1 = 'normal';
const DEFAULT_7XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_7XL_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_7XL_BOLD_LINE_HEIGHT$1 = '1.25';
const DEFAULT_7XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_7XL_BOLD_PARAGRAPH_SPACING$1 = '56px';
const DEFAULT_7XL_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_7XL_HEAVY_FONT_SIZE$1 = '56px';
const DEFAULT_7XL_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_7XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_7XL_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_7XL_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_7XL_HEAVY_FONT_STRETCH$1 = 'normal';
const DEFAULT_7XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_7XL_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_7XL_HEAVY_LINE_HEIGHT$1 = '1.25';
const DEFAULT_7XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_7XL_HEAVY_PARAGRAPH_SPACING$1 = '56px';
const DEFAULT_7XL_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_SIZE$1 = '56px';
const DEFAULT_7XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_7XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_7XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.25';
const DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_7XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_6XL_BOLD_FONT_SIZE$1 = '48px';
const DEFAULT_6XL_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_6XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_6XL_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_6XL_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_6XL_BOLD_FONT_STRETCH$1 = 'normal';
const DEFAULT_6XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_6XL_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_6XL_BOLD_LINE_HEIGHT$1 = '1.25';
const DEFAULT_6XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_6XL_BOLD_PARAGRAPH_SPACING$1 = '48px';
const DEFAULT_6XL_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_6XL_HEAVY_FONT_SIZE$1 = '48px';
const DEFAULT_6XL_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_6XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_6XL_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_6XL_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_6XL_HEAVY_FONT_STRETCH$1 = 'normal';
const DEFAULT_6XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_6XL_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_6XL_HEAVY_LINE_HEIGHT$1 = '1.25';
const DEFAULT_6XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_6XL_HEAVY_PARAGRAPH_SPACING$1 = '48px';
const DEFAULT_6XL_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_SIZE$1 = '48px';
const DEFAULT_6XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_6XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_6XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.25';
const DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_6XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_5XL_BOLD_FONT_SIZE$1 = '40px';
const DEFAULT_5XL_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_5XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_5XL_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_5XL_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_5XL_BOLD_FONT_STRETCH$1 = 'normal';
const DEFAULT_5XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_5XL_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_5XL_BOLD_LINE_HEIGHT$1 = '1.25';
const DEFAULT_5XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_5XL_BOLD_PARAGRAPH_SPACING$1 = '40px';
const DEFAULT_5XL_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_5XL_HEAVY_FONT_SIZE$1 = '40px';
const DEFAULT_5XL_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_5XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_5XL_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_5XL_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_5XL_HEAVY_FONT_STRETCH$1 = 'normal';
const DEFAULT_5XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_5XL_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_5XL_HEAVY_LINE_HEIGHT$1 = '1.25';
const DEFAULT_5XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_5XL_HEAVY_PARAGRAPH_SPACING$1 = '40px';
const DEFAULT_5XL_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_SIZE$1 = '40px';
const DEFAULT_5XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_5XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_5XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.25';
const DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_5XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_4XL_BOLD_FONT_SIZE$1 = '32px';
const DEFAULT_4XL_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_4XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_4XL_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_4XL_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_4XL_BOLD_FONT_STRETCH$1 = 'normal';
const DEFAULT_4XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_4XL_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_4XL_BOLD_LINE_HEIGHT$1 = '1.35';
const DEFAULT_4XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_4XL_BOLD_PARAGRAPH_SPACING$1 = '32px';
const DEFAULT_4XL_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_4XL_HEAVY_FONT_SIZE$1 = '32px';
const DEFAULT_4XL_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_4XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_4XL_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_4XL_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_4XL_HEAVY_FONT_STRETCH$1 = 'normal';
const DEFAULT_4XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_4XL_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_4XL_HEAVY_LINE_HEIGHT$1 = '1.35';
const DEFAULT_4XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_4XL_HEAVY_PARAGRAPH_SPACING$1 = '32px';
const DEFAULT_4XL_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_SIZE$1 = '32px';
const DEFAULT_4XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_4XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_4XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.35';
const DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_4XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_3XL_BOLD_FONT_SIZE$1 = '28px';
const DEFAULT_3XL_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_3XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_3XL_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_3XL_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_3XL_BOLD_FONT_STRETCH$1 = 'normal';
const DEFAULT_3XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_3XL_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_3XL_BOLD_LINE_HEIGHT$1 = '1.35';
const DEFAULT_3XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_3XL_BOLD_PARAGRAPH_SPACING$1 = '28px';
const DEFAULT_3XL_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_3XL_HEAVY_FONT_SIZE$1 = '28px';
const DEFAULT_3XL_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_3XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_3XL_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_3XL_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_3XL_HEAVY_FONT_STRETCH$1 = 'normal';
const DEFAULT_3XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_3XL_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_3XL_HEAVY_LINE_HEIGHT$1 = '1.35';
const DEFAULT_3XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_3XL_HEAVY_PARAGRAPH_SPACING$1 = '28px';
const DEFAULT_3XL_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_SIZE$1 = '28px';
const DEFAULT_3XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_3XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_3XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.35';
const DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_3XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_2XL_FONT_SIZE$1 = '24px';
const DEFAULT_2XL_TEXT_DECORATION$1 = 'none';
const DEFAULT_2XL_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_2XL_FONT_WEIGHT$1 = 400;
const DEFAULT_2XL_FONT_STYLE$1 = 'normal';
const DEFAULT_2XL_FONT_STRETCH$1 = 'normal';
const DEFAULT_2XL_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_2XL_LETTER_SPACING$1 = 0;
const DEFAULT_2XL_LINE_HEIGHT$1 = '1.35';
const DEFAULT_2XL_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_2XL_PARAGRAPH_SPACING$1 = '24px';
const DEFAULT_2XL_TEXT_CASE$1 = 'none';
const DEFAULT_2XL_BOLD_FONT_SIZE$1 = '24px';
const DEFAULT_2XL_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_2XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_2XL_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_2XL_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_2XL_BOLD_FONT_STRETCH$1 = 'normal';
const DEFAULT_2XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_2XL_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_2XL_BOLD_LINE_HEIGHT$1 = '1.35';
const DEFAULT_2XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_2XL_BOLD_PARAGRAPH_SPACING$1 = '24px';
const DEFAULT_2XL_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_2XL_HEAVY_FONT_SIZE$1 = '24px';
const DEFAULT_2XL_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_2XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_2XL_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_2XL_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_2XL_HEAVY_FONT_STRETCH$1 = 'normal';
const DEFAULT_2XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_2XL_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_2XL_HEAVY_LINE_HEIGHT$1 = '1.35';
const DEFAULT_2XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_2XL_HEAVY_PARAGRAPH_SPACING$1 = '24px';
const DEFAULT_2XL_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_SIZE$1 = '24px';
const DEFAULT_2XL_CONDENSED_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_STRETCH$1 = 'condensed';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_2XL_CONDENSED_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_2XL_CONDENSED_BOLD_LINE_HEIGHT$1 = '1.35';
const DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_2XL_CONDENSED_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_SIZE$1 = '24px';
const DEFAULT_2XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_2XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_2XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.35';
const DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_2XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_XL_FONT_SIZE$1 = '20px';
const DEFAULT_XL_TEXT_DECORATION$1 = 'none';
const DEFAULT_XL_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XL_FONT_WEIGHT$1 = 400;
const DEFAULT_XL_FONT_STYLE$1 = 'normal';
const DEFAULT_XL_FONT_STRETCH$1 = 'normal';
const DEFAULT_XL_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_XL_LETTER_SPACING$1 = 0;
const DEFAULT_XL_LINE_HEIGHT$1 = '1.45';
const DEFAULT_XL_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XL_PARAGRAPH_SPACING$1 = '20px';
const DEFAULT_XL_TEXT_CASE$1 = 'none';
const DEFAULT_XL_ITALIC_FONT_SIZE$1 = '20px';
const DEFAULT_XL_ITALIC_TEXT_DECORATION$1 = 'none';
const DEFAULT_XL_ITALIC_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XL_ITALIC_FONT_WEIGHT$1 = 400;
const DEFAULT_XL_ITALIC_FONT_STYLE$1 = 'italic';
const DEFAULT_XL_ITALIC_FONT_STRETCH$1 = 'normal';
const DEFAULT_XL_ITALIC_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_XL_ITALIC_LETTER_SPACING$1 = 0;
const DEFAULT_XL_ITALIC_LINE_HEIGHT$1 = '1.45';
const DEFAULT_XL_ITALIC_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XL_ITALIC_PARAGRAPH_SPACING$1 = '20px';
const DEFAULT_XL_ITALIC_TEXT_CASE$1 = 'none';
const DEFAULT_XL_BOLD_FONT_SIZE$1 = '20px';
const DEFAULT_XL_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XL_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_XL_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_XL_BOLD_FONT_STRETCH$1 = 'normal';
const DEFAULT_XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_XL_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_XL_BOLD_LINE_HEIGHT$1 = '1.45';
const DEFAULT_XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XL_BOLD_PARAGRAPH_SPACING$1 = '20px';
const DEFAULT_XL_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_XL_HEAVY_FONT_SIZE$1 = '20px';
const DEFAULT_XL_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XL_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_XL_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_XL_HEAVY_FONT_STRETCH$1 = 'normal';
const DEFAULT_XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_XL_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_XL_HEAVY_LINE_HEIGHT$1 = '1.45';
const DEFAULT_XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XL_HEAVY_PARAGRAPH_SPACING$1 = '20px';
const DEFAULT_XL_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_XL_CONDENSED_FONT_SIZE$1 = '20px';
const DEFAULT_XL_CONDENSED_TEXT_DECORATION$1 = 'none';
const DEFAULT_XL_CONDENSED_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XL_CONDENSED_FONT_WEIGHT$1 = 400;
const DEFAULT_XL_CONDENSED_FONT_STYLE$1 = 'normal';
const DEFAULT_XL_CONDENSED_FONT_STRETCH$1 = 'condensed';
const DEFAULT_XL_CONDENSED_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_XL_CONDENSED_LETTER_SPACING$1 = 0;
const DEFAULT_XL_CONDENSED_LINE_HEIGHT$1 = '1.45';
const DEFAULT_XL_CONDENSED_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XL_CONDENSED_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_XL_CONDENSED_TEXT_CASE$1 = 'none';
const DEFAULT_XL_CONDENSED_BOLD_FONT_SIZE$1 = '20px';
const DEFAULT_XL_CONDENSED_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_XL_CONDENSED_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XL_CONDENSED_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_XL_CONDENSED_BOLD_FONT_STRETCH$1 = 'condensed';
const DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_XL_CONDENSED_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_XL_CONDENSED_BOLD_LINE_HEIGHT$1 = '1.45';
const DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_XL_CONDENSED_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_SIZE$1 = '20px';
const DEFAULT_XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.45';
const DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_L_FONT_SIZE$1 = '18px';
const DEFAULT_L_TEXT_DECORATION$1 = 'none';
const DEFAULT_L_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_L_FONT_WEIGHT$1 = 400;
const DEFAULT_L_FONT_STYLE$1 = 'normal';
const DEFAULT_L_FONT_STRETCH$1 = 'normal';
const DEFAULT_L_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_L_LETTER_SPACING$1 = 0;
const DEFAULT_L_LINE_HEIGHT$1 = '1.45';
const DEFAULT_L_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_L_PARAGRAPH_SPACING$1 = '18px';
const DEFAULT_L_TEXT_CASE$1 = 'none';
const DEFAULT_L_ITALIC_FONT_SIZE$1 = '18px';
const DEFAULT_L_ITALIC_TEXT_DECORATION$1 = 'none';
const DEFAULT_L_ITALIC_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_L_ITALIC_FONT_WEIGHT$1 = 400;
const DEFAULT_L_ITALIC_FONT_STYLE$1 = 'italic';
const DEFAULT_L_ITALIC_FONT_STRETCH$1 = 'normal';
const DEFAULT_L_ITALIC_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_L_ITALIC_LETTER_SPACING$1 = 0;
const DEFAULT_L_ITALIC_LINE_HEIGHT$1 = '1.45';
const DEFAULT_L_ITALIC_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_L_ITALIC_PARAGRAPH_SPACING$1 = '18px';
const DEFAULT_L_ITALIC_TEXT_CASE$1 = 'none';
const DEFAULT_L_BOLD_FONT_SIZE$1 = '18px';
const DEFAULT_L_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_L_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_L_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_L_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_L_BOLD_FONT_STRETCH$1 = 'normal';
const DEFAULT_L_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_L_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_L_BOLD_LINE_HEIGHT$1 = '1.45';
const DEFAULT_L_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_L_BOLD_PARAGRAPH_SPACING$1 = '18px';
const DEFAULT_L_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_L_HEAVY_FONT_SIZE$1 = '18px';
const DEFAULT_L_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_L_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_L_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_L_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_L_HEAVY_FONT_STRETCH$1 = 'normal';
const DEFAULT_L_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_L_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_L_HEAVY_LINE_HEIGHT$1 = '1.45';
const DEFAULT_L_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_L_HEAVY_PARAGRAPH_SPACING$1 = '18px';
const DEFAULT_L_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_L_CONDENSED_FONT_SIZE$1 = '18px';
const DEFAULT_L_CONDENSED_TEXT_DECORATION$1 = 'none';
const DEFAULT_L_CONDENSED_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_L_CONDENSED_FONT_WEIGHT$1 = 400;
const DEFAULT_L_CONDENSED_FONT_STYLE$1 = 'normal';
const DEFAULT_L_CONDENSED_FONT_STRETCH$1 = 'condensed';
const DEFAULT_L_CONDENSED_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_L_CONDENSED_LETTER_SPACING$1 = 0;
const DEFAULT_L_CONDENSED_LINE_HEIGHT$1 = '1.45';
const DEFAULT_L_CONDENSED_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_L_CONDENSED_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_L_CONDENSED_TEXT_CASE$1 = 'none';
const DEFAULT_L_CONDENSED_BOLD_FONT_SIZE$1 = '18px';
const DEFAULT_L_CONDENSED_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_L_CONDENSED_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_L_CONDENSED_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_L_CONDENSED_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_L_CONDENSED_BOLD_FONT_STRETCH$1 = 'condensed';
const DEFAULT_L_CONDENSED_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_L_CONDENSED_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_L_CONDENSED_BOLD_LINE_HEIGHT$1 = '1.45';
const DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_L_CONDENSED_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_L_CONDENSED_HEAVY_FONT_SIZE$1 = '18px';
const DEFAULT_L_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const DEFAULT_L_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_L_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const DEFAULT_L_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const DEFAULT_L_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const DEFAULT_L_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.45';
const DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_L_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const DEFAULT_M_FONT_SIZE$1 = '16px';
const DEFAULT_M_TEXT_DECORATION$1 = 'none';
const DEFAULT_M_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_M_FONT_WEIGHT$1 = 400;
const DEFAULT_M_FONT_STYLE$1 = 'normal';
const DEFAULT_M_FONT_STRETCH$1 = 'normal';
const DEFAULT_M_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_M_LETTER_SPACING$1 = 0;
const DEFAULT_M_LINE_HEIGHT$1 = '1.50';
const DEFAULT_M_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_M_PARAGRAPH_SPACING$1 = '16px';
const DEFAULT_M_TEXT_CASE$1 = 'none';
const DEFAULT_M_AC_FONT_SIZE$1 = '16px';
const DEFAULT_M_AC_TEXT_DECORATION$1 = 'none';
const DEFAULT_M_AC_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_M_AC_FONT_WEIGHT$1 = 400;
const DEFAULT_M_AC_FONT_STYLE$1 = 'normal';
const DEFAULT_M_AC_FONT_STRETCH$1 = 'normal';
const DEFAULT_M_AC_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_M_AC_LETTER_SPACING$1 = '0.01em';
const DEFAULT_M_AC_LINE_HEIGHT$1 = '1.50';
const DEFAULT_M_AC_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_M_AC_PARAGRAPH_SPACING$1 = '16px';
const DEFAULT_M_AC_TEXT_CASE$1 = 'uppercase';
const DEFAULT_M_ITALIC_FONT_SIZE$1 = '16px';
const DEFAULT_M_ITALIC_TEXT_DECORATION$1 = 'none';
const DEFAULT_M_ITALIC_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_M_ITALIC_FONT_WEIGHT$1 = 400;
const DEFAULT_M_ITALIC_FONT_STYLE$1 = 'italic';
const DEFAULT_M_ITALIC_FONT_STRETCH$1 = 'normal';
const DEFAULT_M_ITALIC_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_M_ITALIC_LETTER_SPACING$1 = 0;
const DEFAULT_M_ITALIC_LINE_HEIGHT$1 = '1.50';
const DEFAULT_M_ITALIC_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_M_ITALIC_PARAGRAPH_SPACING$1 = '16px';
const DEFAULT_M_ITALIC_TEXT_CASE$1 = 'none';
const DEFAULT_M_MEDIUM_FONT_SIZE$1 = '16px';
const DEFAULT_M_MEDIUM_TEXT_DECORATION$1 = 'none';
const DEFAULT_M_MEDIUM_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_M_MEDIUM_FONT_WEIGHT$1 = 500;
const DEFAULT_M_MEDIUM_FONT_STYLE$1 = 'normal';
const DEFAULT_M_MEDIUM_FONT_STRETCH$1 = 'normal';
const DEFAULT_M_MEDIUM_FONT_STYLE_OLD$1 = 'Medium';
const DEFAULT_M_MEDIUM_LETTER_SPACING$1 = 0;
const DEFAULT_M_MEDIUM_LINE_HEIGHT$1 = '1.50';
const DEFAULT_M_MEDIUM_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_M_MEDIUM_PARAGRAPH_SPACING$1 = '16px';
const DEFAULT_M_MEDIUM_TEXT_CASE$1 = 'none';
const DEFAULT_M_BOLD_FONT_SIZE$1 = '16px';
const DEFAULT_M_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_M_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_M_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_M_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_M_BOLD_FONT_STRETCH$1 = 'normal';
const DEFAULT_M_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_M_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_M_BOLD_LINE_HEIGHT$1 = '1.50';
const DEFAULT_M_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_M_BOLD_PARAGRAPH_SPACING$1 = '16px';
const DEFAULT_M_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_M_BOLD_AC_FONT_SIZE$1 = '16px';
const DEFAULT_M_BOLD_AC_TEXT_DECORATION$1 = 'none';
const DEFAULT_M_BOLD_AC_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_M_BOLD_AC_FONT_WEIGHT$1 = 700;
const DEFAULT_M_BOLD_AC_FONT_STYLE$1 = 'normal';
const DEFAULT_M_BOLD_AC_FONT_STRETCH$1 = 'normal';
const DEFAULT_M_BOLD_AC_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_M_BOLD_AC_LETTER_SPACING$1 = '0.01em';
const DEFAULT_M_BOLD_AC_LINE_HEIGHT$1 = '1.50';
const DEFAULT_M_BOLD_AC_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_M_BOLD_AC_PARAGRAPH_SPACING$1 = '16px';
const DEFAULT_M_BOLD_AC_TEXT_CASE$1 = 'uppercase';
const DEFAULT_M_CONDENSED_FONT_SIZE$1 = '16px';
const DEFAULT_M_CONDENSED_TEXT_DECORATION$1 = 'none';
const DEFAULT_M_CONDENSED_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_M_CONDENSED_FONT_WEIGHT$1 = 400;
const DEFAULT_M_CONDENSED_FONT_STYLE$1 = 'normal';
const DEFAULT_M_CONDENSED_FONT_STRETCH$1 = 'condensed';
const DEFAULT_M_CONDENSED_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_M_CONDENSED_LETTER_SPACING$1 = 0;
const DEFAULT_M_CONDENSED_LINE_HEIGHT$1 = '1.50';
const DEFAULT_M_CONDENSED_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_M_CONDENSED_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_M_CONDENSED_TEXT_CASE$1 = 'none';
const DEFAULT_M_CONDENSED_BOLD_FONT_SIZE$1 = '16px';
const DEFAULT_M_CONDENSED_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_M_CONDENSED_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_M_CONDENSED_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_M_CONDENSED_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_M_CONDENSED_BOLD_FONT_STRETCH$1 = 'condensed';
const DEFAULT_M_CONDENSED_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_M_CONDENSED_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_M_CONDENSED_BOLD_LINE_HEIGHT$1 = '1.50';
const DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_M_CONDENSED_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_S_FONT_SIZE$1 = '14px';
const DEFAULT_S_TEXT_DECORATION$1 = 'none';
const DEFAULT_S_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_S_FONT_WEIGHT$1 = 400;
const DEFAULT_S_FONT_STYLE$1 = 'normal';
const DEFAULT_S_FONT_STRETCH$1 = 'normal';
const DEFAULT_S_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_S_LETTER_SPACING$1 = 0;
const DEFAULT_S_LINE_HEIGHT$1 = '1.50';
const DEFAULT_S_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_S_PARAGRAPH_SPACING$1 = '14px';
const DEFAULT_S_TEXT_CASE$1 = 'none';
const DEFAULT_S_ITALIC_FONT_SIZE$1 = '14px';
const DEFAULT_S_ITALIC_TEXT_DECORATION$1 = 'none';
const DEFAULT_S_ITALIC_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_S_ITALIC_FONT_WEIGHT$1 = 400;
const DEFAULT_S_ITALIC_FONT_STYLE$1 = 'italic';
const DEFAULT_S_ITALIC_FONT_STRETCH$1 = 'normal';
const DEFAULT_S_ITALIC_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_S_ITALIC_LETTER_SPACING$1 = 0;
const DEFAULT_S_ITALIC_LINE_HEIGHT$1 = '1.50';
const DEFAULT_S_ITALIC_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_S_ITALIC_PARAGRAPH_SPACING$1 = '14px';
const DEFAULT_S_ITALIC_TEXT_CASE$1 = 'none';
const DEFAULT_S_AC_FONT_SIZE$1 = '14px';
const DEFAULT_S_AC_TEXT_DECORATION$1 = 'none';
const DEFAULT_S_AC_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_S_AC_FONT_WEIGHT$1 = 400;
const DEFAULT_S_AC_FONT_STYLE$1 = 'normal';
const DEFAULT_S_AC_FONT_STRETCH$1 = 'normal';
const DEFAULT_S_AC_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_S_AC_LETTER_SPACING$1 = '0.01em';
const DEFAULT_S_AC_LINE_HEIGHT$1 = '1.50';
const DEFAULT_S_AC_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_S_AC_PARAGRAPH_SPACING$1 = '14px';
const DEFAULT_S_AC_TEXT_CASE$1 = 'uppercase';
const DEFAULT_S_MEDIUM_FONT_SIZE$1 = '14px';
const DEFAULT_S_MEDIUM_TEXT_DECORATION$1 = 'none';
const DEFAULT_S_MEDIUM_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_S_MEDIUM_FONT_WEIGHT$1 = 500;
const DEFAULT_S_MEDIUM_FONT_STYLE$1 = 'normal';
const DEFAULT_S_MEDIUM_FONT_STRETCH$1 = 'normal';
const DEFAULT_S_MEDIUM_FONT_STYLE_OLD$1 = 'Medium';
const DEFAULT_S_MEDIUM_LETTER_SPACING$1 = 0;
const DEFAULT_S_MEDIUM_LINE_HEIGHT$1 = '1.50';
const DEFAULT_S_MEDIUM_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_S_MEDIUM_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_S_MEDIUM_TEXT_CASE$1 = 'none';
const DEFAULT_S_BOLD_FONT_SIZE$1 = '14px';
const DEFAULT_S_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_S_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_S_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_S_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_S_BOLD_FONT_STRETCH$1 = 'normal';
const DEFAULT_S_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_S_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_S_BOLD_LINE_HEIGHT$1 = '1.50';
const DEFAULT_S_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_S_BOLD_PARAGRAPH_SPACING$1 = '14px';
const DEFAULT_S_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_S_BOLD_AC_FONT_SIZE$1 = '14px';
const DEFAULT_S_BOLD_AC_TEXT_DECORATION$1 = 'none';
const DEFAULT_S_BOLD_AC_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_S_BOLD_AC_FONT_WEIGHT$1 = 700;
const DEFAULT_S_BOLD_AC_FONT_STYLE$1 = 'normal';
const DEFAULT_S_BOLD_AC_FONT_STRETCH$1 = 'normal';
const DEFAULT_S_BOLD_AC_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_S_BOLD_AC_LETTER_SPACING$1 = '0.01em';
const DEFAULT_S_BOLD_AC_LINE_HEIGHT$1 = '1.50';
const DEFAULT_S_BOLD_AC_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_S_BOLD_AC_PARAGRAPH_SPACING$1 = '14px';
const DEFAULT_S_BOLD_AC_TEXT_CASE$1 = 'uppercase';
const DEFAULT_S_CONDENSED_FONT_SIZE$1 = '14px';
const DEFAULT_S_CONDENSED_TEXT_DECORATION$1 = 'none';
const DEFAULT_S_CONDENSED_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_S_CONDENSED_FONT_WEIGHT$1 = 400;
const DEFAULT_S_CONDENSED_FONT_STYLE$1 = 'normal';
const DEFAULT_S_CONDENSED_FONT_STRETCH$1 = 'condensed';
const DEFAULT_S_CONDENSED_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_S_CONDENSED_LETTER_SPACING$1 = 0;
const DEFAULT_S_CONDENSED_LINE_HEIGHT$1 = '1.50';
const DEFAULT_S_CONDENSED_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_S_CONDENSED_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_S_CONDENSED_TEXT_CASE$1 = 'none';
const DEFAULT_S_CONDENSED_BOLD_FONT_SIZE$1 = '14px';
const DEFAULT_S_CONDENSED_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_S_CONDENSED_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_S_CONDENSED_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_S_CONDENSED_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_S_CONDENSED_BOLD_FONT_STRETCH$1 = 'condensed';
const DEFAULT_S_CONDENSED_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_S_CONDENSED_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_S_CONDENSED_BOLD_LINE_HEIGHT$1 = '1.50';
const DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_S_CONDENSED_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_XS_FONT_SIZE$1 = '12px';
const DEFAULT_XS_TEXT_DECORATION$1 = 'none';
const DEFAULT_XS_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XS_FONT_WEIGHT$1 = 400;
const DEFAULT_XS_FONT_STYLE$1 = 'normal';
const DEFAULT_XS_FONT_STRETCH$1 = 'normal';
const DEFAULT_XS_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_XS_LETTER_SPACING$1 = 0;
const DEFAULT_XS_LINE_HEIGHT$1 = '1.50';
const DEFAULT_XS_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XS_PARAGRAPH_SPACING$1 = '12px';
const DEFAULT_XS_TEXT_CASE$1 = 'none';
const DEFAULT_XS_ITALIC_FONT_SIZE$1 = '12px';
const DEFAULT_XS_ITALIC_TEXT_DECORATION$1 = 'none';
const DEFAULT_XS_ITALIC_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XS_ITALIC_FONT_WEIGHT$1 = 400;
const DEFAULT_XS_ITALIC_FONT_STYLE$1 = 'italic';
const DEFAULT_XS_ITALIC_FONT_STRETCH$1 = 'normal';
const DEFAULT_XS_ITALIC_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_XS_ITALIC_LETTER_SPACING$1 = 0;
const DEFAULT_XS_ITALIC_LINE_HEIGHT$1 = '1.50';
const DEFAULT_XS_ITALIC_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XS_ITALIC_PARAGRAPH_SPACING$1 = '12px';
const DEFAULT_XS_ITALIC_TEXT_CASE$1 = 'none';
const DEFAULT_XS_AC_FONT_SIZE$1 = '12px';
const DEFAULT_XS_AC_TEXT_DECORATION$1 = 'none';
const DEFAULT_XS_AC_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XS_AC_FONT_WEIGHT$1 = 400;
const DEFAULT_XS_AC_FONT_STYLE$1 = 'normal';
const DEFAULT_XS_AC_FONT_STRETCH$1 = 'normal';
const DEFAULT_XS_AC_FONT_STYLE_OLD$1 = 'Regular';
const DEFAULT_XS_AC_LETTER_SPACING$1 = '0.01em';
const DEFAULT_XS_AC_LINE_HEIGHT$1 = '1.50';
const DEFAULT_XS_AC_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XS_AC_PARAGRAPH_SPACING$1 = '12px';
const DEFAULT_XS_AC_TEXT_CASE$1 = 'uppercase';
const DEFAULT_XS_BOLD_FONT_SIZE$1 = '12px';
const DEFAULT_XS_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_XS_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XS_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_XS_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_XS_BOLD_FONT_STRETCH$1 = 'normal';
const DEFAULT_XS_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_XS_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_XS_BOLD_LINE_HEIGHT$1 = '1.50';
const DEFAULT_XS_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XS_BOLD_PARAGRAPH_SPACING$1 = '12px';
const DEFAULT_XS_BOLD_TEXT_CASE$1 = 'none';
const DEFAULT_XS_BOLD_AC_FONT_SIZE$1 = '12px';
const DEFAULT_XS_BOLD_AC_TEXT_DECORATION$1 = 'none';
const DEFAULT_XS_BOLD_AC_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XS_BOLD_AC_FONT_WEIGHT$1 = 700;
const DEFAULT_XS_BOLD_AC_FONT_STYLE$1 = 'normal';
const DEFAULT_XS_BOLD_AC_FONT_STRETCH$1 = 'normal';
const DEFAULT_XS_BOLD_AC_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_XS_BOLD_AC_LETTER_SPACING$1 = '0.01em';
const DEFAULT_XS_BOLD_AC_LINE_HEIGHT$1 = '1.50';
const DEFAULT_XS_BOLD_AC_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XS_BOLD_AC_PARAGRAPH_SPACING$1 = '12px';
const DEFAULT_XS_BOLD_AC_TEXT_CASE$1 = 'uppercase';
const DEFAULT_XS_CONDENSED_BOLD_FONT_SIZE$1 = '12px';
const DEFAULT_XS_CONDENSED_BOLD_TEXT_DECORATION$1 = 'none';
const DEFAULT_XS_CONDENSED_BOLD_FONT_FAMILY$1 = 'Yle Next';
const DEFAULT_XS_CONDENSED_BOLD_FONT_WEIGHT$1 = 700;
const DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE$1 = 'normal';
const DEFAULT_XS_CONDENSED_BOLD_FONT_STRETCH$1 = 'condensed';
const DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const DEFAULT_XS_CONDENSED_BOLD_LETTER_SPACING$1 = 0;
const DEFAULT_XS_CONDENSED_BOLD_LINE_HEIGHT$1 = '1.50';
const DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT$1 = 0;
const DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING$1 = 0;
const DEFAULT_XS_CONDENSED_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_7XL_BOLD_FONT_SIZE$1 = '56px';
const YLE_NEXT_7XL_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_7XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_7XL_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_7XL_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_7XL_BOLD_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_7XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_7XL_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_7XL_BOLD_LINE_HEIGHT$1 = '1.25';
const YLE_NEXT_7XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_7XL_BOLD_PARAGRAPH_SPACING$1 = '56px';
const YLE_NEXT_7XL_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_7XL_HEAVY_FONT_SIZE$1 = '56px';
const YLE_NEXT_7XL_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_7XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_7XL_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_7XL_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_7XL_HEAVY_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_7XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_7XL_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_7XL_HEAVY_LINE_HEIGHT$1 = '1.25';
const YLE_NEXT_7XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_7XL_HEAVY_PARAGRAPH_SPACING$1 = '56px';
const YLE_NEXT_7XL_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_SIZE$1 = '56px';
const YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_7XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_7XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.25';
const YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_6XL_BOLD_FONT_SIZE$1 = '48px';
const YLE_NEXT_6XL_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_6XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_6XL_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_6XL_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_6XL_BOLD_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_6XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_6XL_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_6XL_BOLD_LINE_HEIGHT$1 = '1.25';
const YLE_NEXT_6XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_6XL_BOLD_PARAGRAPH_SPACING$1 = '48px';
const YLE_NEXT_6XL_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_6XL_HEAVY_FONT_SIZE$1 = '48px';
const YLE_NEXT_6XL_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_6XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_6XL_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_6XL_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_6XL_HEAVY_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_6XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_6XL_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_6XL_HEAVY_LINE_HEIGHT$1 = '1.25';
const YLE_NEXT_6XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_6XL_HEAVY_PARAGRAPH_SPACING$1 = '48px';
const YLE_NEXT_6XL_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_SIZE$1 = '48px';
const YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_6XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_6XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.25';
const YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_5XL_BOLD_FONT_SIZE$1 = '40px';
const YLE_NEXT_5XL_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_5XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_5XL_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_5XL_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_5XL_BOLD_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_5XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_5XL_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_5XL_BOLD_LINE_HEIGHT$1 = '1.25';
const YLE_NEXT_5XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_5XL_BOLD_PARAGRAPH_SPACING$1 = '40px';
const YLE_NEXT_5XL_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_5XL_HEAVY_FONT_SIZE$1 = '40px';
const YLE_NEXT_5XL_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_5XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_5XL_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_5XL_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_5XL_HEAVY_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_5XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_5XL_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_5XL_HEAVY_LINE_HEIGHT$1 = '1.25';
const YLE_NEXT_5XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_5XL_HEAVY_PARAGRAPH_SPACING$1 = '40px';
const YLE_NEXT_5XL_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_SIZE$1 = '40px';
const YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_5XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_5XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.25';
const YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_4XL_BOLD_FONT_SIZE$1 = '32px';
const YLE_NEXT_4XL_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_4XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_4XL_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_4XL_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_4XL_BOLD_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_4XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_4XL_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_4XL_BOLD_LINE_HEIGHT$1 = '1.35';
const YLE_NEXT_4XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_4XL_BOLD_PARAGRAPH_SPACING$1 = '32px';
const YLE_NEXT_4XL_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_4XL_HEAVY_FONT_SIZE$1 = '32px';
const YLE_NEXT_4XL_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_4XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_4XL_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_4XL_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_4XL_HEAVY_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_4XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_4XL_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_4XL_HEAVY_LINE_HEIGHT$1 = '1.35';
const YLE_NEXT_4XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_4XL_HEAVY_PARAGRAPH_SPACING$1 = '32px';
const YLE_NEXT_4XL_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_SIZE$1 = '32px';
const YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_4XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_4XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.35';
const YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_3XL_BOLD_FONT_SIZE$1 = '28px';
const YLE_NEXT_3XL_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_3XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_3XL_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_3XL_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_3XL_BOLD_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_3XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_3XL_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_3XL_BOLD_LINE_HEIGHT$1 = '1.35';
const YLE_NEXT_3XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_3XL_BOLD_PARAGRAPH_SPACING$1 = '28px';
const YLE_NEXT_3XL_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_3XL_HEAVY_FONT_SIZE$1 = '28px';
const YLE_NEXT_3XL_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_3XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_3XL_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_3XL_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_3XL_HEAVY_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_3XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_3XL_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_3XL_HEAVY_LINE_HEIGHT$1 = '1.35';
const YLE_NEXT_3XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_3XL_HEAVY_PARAGRAPH_SPACING$1 = '28px';
const YLE_NEXT_3XL_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_SIZE$1 = '28px';
const YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_3XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_3XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.35';
const YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_2XL_FONT_SIZE$1 = '24px';
const YLE_NEXT_2XL_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_2XL_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_2XL_FONT_WEIGHT$1 = 400;
const YLE_NEXT_2XL_FONT_STYLE$1 = 'normal';
const YLE_NEXT_2XL_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_2XL_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_2XL_LETTER_SPACING$1 = 0;
const YLE_NEXT_2XL_LINE_HEIGHT$1 = '1.35';
const YLE_NEXT_2XL_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_2XL_PARAGRAPH_SPACING$1 = '24px';
const YLE_NEXT_2XL_TEXT_CASE$1 = 'none';
const YLE_NEXT_2XL_BOLD_FONT_SIZE$1 = '24px';
const YLE_NEXT_2XL_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_2XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_2XL_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_2XL_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_2XL_BOLD_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_2XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_2XL_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_2XL_BOLD_LINE_HEIGHT$1 = '1.35';
const YLE_NEXT_2XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_2XL_BOLD_PARAGRAPH_SPACING$1 = '24px';
const YLE_NEXT_2XL_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_2XL_HEAVY_FONT_SIZE$1 = '24px';
const YLE_NEXT_2XL_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_2XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_2XL_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_2XL_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_2XL_HEAVY_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_2XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_2XL_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_2XL_HEAVY_LINE_HEIGHT$1 = '1.35';
const YLE_NEXT_2XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_2XL_HEAVY_PARAGRAPH_SPACING$1 = '24px';
const YLE_NEXT_2XL_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_SIZE$1 = '24px';
const YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_2XL_CONDENSED_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_2XL_CONDENSED_BOLD_LINE_HEIGHT$1 = '1.35';
const YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_SIZE$1 = '24px';
const YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_2XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_2XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.35';
const YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_XL_FONT_SIZE$1 = '20px';
const YLE_NEXT_XL_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XL_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XL_FONT_WEIGHT$1 = 400;
const YLE_NEXT_XL_FONT_STYLE$1 = 'normal';
const YLE_NEXT_XL_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_XL_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_XL_LETTER_SPACING$1 = 0;
const YLE_NEXT_XL_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_XL_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XL_PARAGRAPH_SPACING$1 = '20px';
const YLE_NEXT_XL_TEXT_CASE$1 = 'none';
const YLE_NEXT_XL_ITALIC_FONT_SIZE$1 = '20px';
const YLE_NEXT_XL_ITALIC_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XL_ITALIC_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XL_ITALIC_FONT_WEIGHT$1 = 400;
const YLE_NEXT_XL_ITALIC_FONT_STYLE$1 = 'italic';
const YLE_NEXT_XL_ITALIC_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_XL_ITALIC_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_XL_ITALIC_LETTER_SPACING$1 = 0;
const YLE_NEXT_XL_ITALIC_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_XL_ITALIC_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XL_ITALIC_PARAGRAPH_SPACING$1 = '20px';
const YLE_NEXT_XL_ITALIC_TEXT_CASE$1 = 'none';
const YLE_NEXT_XL_BOLD_FONT_SIZE$1 = '20px';
const YLE_NEXT_XL_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XL_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XL_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_XL_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_XL_BOLD_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_XL_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_XL_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_XL_BOLD_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_XL_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XL_BOLD_PARAGRAPH_SPACING$1 = '20px';
const YLE_NEXT_XL_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_XL_HEAVY_FONT_SIZE$1 = '20px';
const YLE_NEXT_XL_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XL_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XL_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_XL_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_XL_HEAVY_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_XL_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_XL_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_XL_HEAVY_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_XL_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XL_HEAVY_PARAGRAPH_SPACING$1 = '20px';
const YLE_NEXT_XL_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_XL_CONDENSED_FONT_SIZE$1 = '20px';
const YLE_NEXT_XL_CONDENSED_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XL_CONDENSED_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XL_CONDENSED_FONT_WEIGHT$1 = 400;
const YLE_NEXT_XL_CONDENSED_FONT_STYLE$1 = 'normal';
const YLE_NEXT_XL_CONDENSED_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_XL_CONDENSED_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_XL_CONDENSED_LETTER_SPACING$1 = 0;
const YLE_NEXT_XL_CONDENSED_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_XL_CONDENSED_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XL_CONDENSED_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_XL_CONDENSED_TEXT_CASE$1 = 'none';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_SIZE$1 = '20px';
const YLE_NEXT_XL_CONDENSED_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_XL_CONDENSED_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_XL_CONDENSED_BOLD_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_XL_CONDENSED_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_SIZE$1 = '20px';
const YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_XL_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_XL_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_L_FONT_SIZE$1 = '18px';
const YLE_NEXT_L_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_L_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_L_FONT_WEIGHT$1 = 400;
const YLE_NEXT_L_FONT_STYLE$1 = 'normal';
const YLE_NEXT_L_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_L_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_L_LETTER_SPACING$1 = 0;
const YLE_NEXT_L_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_L_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_L_PARAGRAPH_SPACING$1 = '18px';
const YLE_NEXT_L_TEXT_CASE$1 = 'none';
const YLE_NEXT_L_ITALIC_FONT_SIZE$1 = '18px';
const YLE_NEXT_L_ITALIC_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_L_ITALIC_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_L_ITALIC_FONT_WEIGHT$1 = 400;
const YLE_NEXT_L_ITALIC_FONT_STYLE$1 = 'italic';
const YLE_NEXT_L_ITALIC_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_L_ITALIC_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_L_ITALIC_LETTER_SPACING$1 = 0;
const YLE_NEXT_L_ITALIC_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_L_ITALIC_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_L_ITALIC_PARAGRAPH_SPACING$1 = '18px';
const YLE_NEXT_L_ITALIC_TEXT_CASE$1 = 'none';
const YLE_NEXT_L_BOLD_FONT_SIZE$1 = '18px';
const YLE_NEXT_L_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_L_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_L_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_L_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_L_BOLD_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_L_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_L_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_L_BOLD_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_L_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_L_BOLD_PARAGRAPH_SPACING$1 = '18px';
const YLE_NEXT_L_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_L_HEAVY_FONT_SIZE$1 = '18px';
const YLE_NEXT_L_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_L_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_L_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_L_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_L_HEAVY_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_L_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_L_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_L_HEAVY_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_L_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_L_HEAVY_PARAGRAPH_SPACING$1 = '18px';
const YLE_NEXT_L_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_L_CONDENSED_FONT_SIZE$1 = '18px';
const YLE_NEXT_L_CONDENSED_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_L_CONDENSED_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_L_CONDENSED_FONT_WEIGHT$1 = 400;
const YLE_NEXT_L_CONDENSED_FONT_STYLE$1 = 'normal';
const YLE_NEXT_L_CONDENSED_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_L_CONDENSED_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_L_CONDENSED_LETTER_SPACING$1 = 0;
const YLE_NEXT_L_CONDENSED_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_L_CONDENSED_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_L_CONDENSED_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_L_CONDENSED_TEXT_CASE$1 = 'none';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_SIZE$1 = '18px';
const YLE_NEXT_L_CONDENSED_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_L_CONDENSED_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_L_CONDENSED_BOLD_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_L_CONDENSED_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_SIZE$1 = '18px';
const YLE_NEXT_L_CONDENSED_HEAVY_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_WEIGHT$1 = 900;
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE$1 = 'normal';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE_OLD$1 = 'Black';
const YLE_NEXT_L_CONDENSED_HEAVY_LETTER_SPACING$1 = 0;
const YLE_NEXT_L_CONDENSED_HEAVY_LINE_HEIGHT$1 = '1.45';
const YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_L_CONDENSED_HEAVY_TEXT_CASE$1 = 'none';
const YLE_NEXT_M_FONT_SIZE$1 = '16px';
const YLE_NEXT_M_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_M_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_M_FONT_WEIGHT$1 = 400;
const YLE_NEXT_M_FONT_STYLE$1 = 'normal';
const YLE_NEXT_M_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_M_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_M_LETTER_SPACING$1 = 0;
const YLE_NEXT_M_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_M_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_M_PARAGRAPH_SPACING$1 = '16px';
const YLE_NEXT_M_TEXT_CASE$1 = 'none';
const YLE_NEXT_M_AC_FONT_SIZE$1 = '16px';
const YLE_NEXT_M_AC_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_M_AC_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_M_AC_FONT_WEIGHT$1 = 400;
const YLE_NEXT_M_AC_FONT_STYLE$1 = 'normal';
const YLE_NEXT_M_AC_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_M_AC_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_M_AC_LETTER_SPACING$1 = '0.01em';
const YLE_NEXT_M_AC_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_M_AC_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_M_AC_PARAGRAPH_SPACING$1 = '16px';
const YLE_NEXT_M_AC_TEXT_CASE$1 = 'uppercase';
const YLE_NEXT_M_ITALIC_FONT_SIZE$1 = '16px';
const YLE_NEXT_M_ITALIC_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_M_ITALIC_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_M_ITALIC_FONT_WEIGHT$1 = 400;
const YLE_NEXT_M_ITALIC_FONT_STYLE$1 = 'italic';
const YLE_NEXT_M_ITALIC_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_M_ITALIC_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_M_ITALIC_LETTER_SPACING$1 = 0;
const YLE_NEXT_M_ITALIC_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_M_ITALIC_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_M_ITALIC_PARAGRAPH_SPACING$1 = '16px';
const YLE_NEXT_M_ITALIC_TEXT_CASE$1 = 'none';
const YLE_NEXT_M_MEDIUM_FONT_SIZE$1 = '16px';
const YLE_NEXT_M_MEDIUM_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_M_MEDIUM_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_M_MEDIUM_FONT_WEIGHT$1 = 500;
const YLE_NEXT_M_MEDIUM_FONT_STYLE$1 = 'normal';
const YLE_NEXT_M_MEDIUM_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_M_MEDIUM_FONT_STYLE_OLD$1 = 'Medium';
const YLE_NEXT_M_MEDIUM_LETTER_SPACING$1 = 0;
const YLE_NEXT_M_MEDIUM_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_M_MEDIUM_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_M_MEDIUM_PARAGRAPH_SPACING$1 = '16px';
const YLE_NEXT_M_MEDIUM_TEXT_CASE$1 = 'none';
const YLE_NEXT_M_BOLD_FONT_SIZE$1 = '16px';
const YLE_NEXT_M_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_M_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_M_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_M_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_M_BOLD_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_M_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_M_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_M_BOLD_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_M_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_M_BOLD_PARAGRAPH_SPACING$1 = '16px';
const YLE_NEXT_M_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_M_BOLD_AC_FONT_SIZE$1 = '16px';
const YLE_NEXT_M_BOLD_AC_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_M_BOLD_AC_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_M_BOLD_AC_FONT_WEIGHT$1 = 700;
const YLE_NEXT_M_BOLD_AC_FONT_STYLE$1 = 'normal';
const YLE_NEXT_M_BOLD_AC_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_M_BOLD_AC_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_M_BOLD_AC_LETTER_SPACING$1 = '0.01em';
const YLE_NEXT_M_BOLD_AC_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_M_BOLD_AC_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_M_BOLD_AC_PARAGRAPH_SPACING$1 = '16px';
const YLE_NEXT_M_BOLD_AC_TEXT_CASE$1 = 'uppercase';
const YLE_NEXT_M_CONDENSED_FONT_SIZE$1 = '16px';
const YLE_NEXT_M_CONDENSED_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_M_CONDENSED_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_M_CONDENSED_FONT_WEIGHT$1 = 400;
const YLE_NEXT_M_CONDENSED_FONT_STYLE$1 = 'normal';
const YLE_NEXT_M_CONDENSED_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_M_CONDENSED_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_M_CONDENSED_LETTER_SPACING$1 = 0;
const YLE_NEXT_M_CONDENSED_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_M_CONDENSED_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_M_CONDENSED_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_M_CONDENSED_TEXT_CASE$1 = 'none';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_SIZE$1 = '16px';
const YLE_NEXT_M_CONDENSED_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_M_CONDENSED_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_M_CONDENSED_BOLD_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_M_CONDENSED_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_S_FONT_SIZE$1 = '14px';
const YLE_NEXT_S_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_S_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_S_FONT_WEIGHT$1 = 400;
const YLE_NEXT_S_FONT_STYLE$1 = 'normal';
const YLE_NEXT_S_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_S_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_S_LETTER_SPACING$1 = 0;
const YLE_NEXT_S_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_S_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_S_PARAGRAPH_SPACING$1 = '14px';
const YLE_NEXT_S_TEXT_CASE$1 = 'none';
const YLE_NEXT_S_ITALIC_FONT_SIZE$1 = '14px';
const YLE_NEXT_S_ITALIC_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_S_ITALIC_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_S_ITALIC_FONT_WEIGHT$1 = 400;
const YLE_NEXT_S_ITALIC_FONT_STYLE$1 = 'italic';
const YLE_NEXT_S_ITALIC_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_S_ITALIC_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_S_ITALIC_LETTER_SPACING$1 = 0;
const YLE_NEXT_S_ITALIC_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_S_ITALIC_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_S_ITALIC_PARAGRAPH_SPACING$1 = '14px';
const YLE_NEXT_S_ITALIC_TEXT_CASE$1 = 'none';
const YLE_NEXT_S_AC_FONT_SIZE$1 = '14px';
const YLE_NEXT_S_AC_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_S_AC_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_S_AC_FONT_WEIGHT$1 = 400;
const YLE_NEXT_S_AC_FONT_STYLE$1 = 'normal';
const YLE_NEXT_S_AC_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_S_AC_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_S_AC_LETTER_SPACING$1 = '0.01em';
const YLE_NEXT_S_AC_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_S_AC_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_S_AC_PARAGRAPH_SPACING$1 = '14px';
const YLE_NEXT_S_AC_TEXT_CASE$1 = 'uppercase';
const YLE_NEXT_S_MEDIUM_FONT_SIZE$1 = '14px';
const YLE_NEXT_S_MEDIUM_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_S_MEDIUM_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_S_MEDIUM_FONT_WEIGHT$1 = 500;
const YLE_NEXT_S_MEDIUM_FONT_STYLE$1 = 'normal';
const YLE_NEXT_S_MEDIUM_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_S_MEDIUM_FONT_STYLE_OLD$1 = 'Medium';
const YLE_NEXT_S_MEDIUM_LETTER_SPACING$1 = 0;
const YLE_NEXT_S_MEDIUM_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_S_MEDIUM_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_S_MEDIUM_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_S_MEDIUM_TEXT_CASE$1 = 'none';
const YLE_NEXT_S_BOLD_FONT_SIZE$1 = '14px';
const YLE_NEXT_S_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_S_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_S_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_S_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_S_BOLD_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_S_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_S_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_S_BOLD_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_S_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_S_BOLD_PARAGRAPH_SPACING$1 = '14px';
const YLE_NEXT_S_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_S_BOLD_AC_FONT_SIZE$1 = '14px';
const YLE_NEXT_S_BOLD_AC_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_S_BOLD_AC_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_S_BOLD_AC_FONT_WEIGHT$1 = 700;
const YLE_NEXT_S_BOLD_AC_FONT_STYLE$1 = 'normal';
const YLE_NEXT_S_BOLD_AC_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_S_BOLD_AC_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_S_BOLD_AC_LETTER_SPACING$1 = '0.01em';
const YLE_NEXT_S_BOLD_AC_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_S_BOLD_AC_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_S_BOLD_AC_PARAGRAPH_SPACING$1 = '14px';
const YLE_NEXT_S_BOLD_AC_TEXT_CASE$1 = 'uppercase';
const YLE_NEXT_S_CONDENSED_FONT_SIZE$1 = '14px';
const YLE_NEXT_S_CONDENSED_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_S_CONDENSED_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_S_CONDENSED_FONT_WEIGHT$1 = 400;
const YLE_NEXT_S_CONDENSED_FONT_STYLE$1 = 'normal';
const YLE_NEXT_S_CONDENSED_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_S_CONDENSED_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_S_CONDENSED_LETTER_SPACING$1 = 0;
const YLE_NEXT_S_CONDENSED_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_S_CONDENSED_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_S_CONDENSED_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_S_CONDENSED_TEXT_CASE$1 = 'none';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_SIZE$1 = '14px';
const YLE_NEXT_S_CONDENSED_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_S_CONDENSED_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_S_CONDENSED_BOLD_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_S_CONDENSED_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_XS_FONT_SIZE$1 = '12px';
const YLE_NEXT_XS_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XS_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XS_FONT_WEIGHT$1 = 400;
const YLE_NEXT_XS_FONT_STYLE$1 = 'normal';
const YLE_NEXT_XS_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_XS_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_XS_LETTER_SPACING$1 = 0;
const YLE_NEXT_XS_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_XS_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XS_PARAGRAPH_SPACING$1 = '12px';
const YLE_NEXT_XS_TEXT_CASE$1 = 'none';
const YLE_NEXT_XS_ITALIC_FONT_SIZE$1 = '12px';
const YLE_NEXT_XS_ITALIC_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XS_ITALIC_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XS_ITALIC_FONT_WEIGHT$1 = 400;
const YLE_NEXT_XS_ITALIC_FONT_STYLE$1 = 'italic';
const YLE_NEXT_XS_ITALIC_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_XS_ITALIC_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_XS_ITALIC_LETTER_SPACING$1 = 0;
const YLE_NEXT_XS_ITALIC_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_XS_ITALIC_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XS_ITALIC_PARAGRAPH_SPACING$1 = '12px';
const YLE_NEXT_XS_ITALIC_TEXT_CASE$1 = 'none';
const YLE_NEXT_XS_AC_FONT_SIZE$1 = '12px';
const YLE_NEXT_XS_AC_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XS_AC_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XS_AC_FONT_WEIGHT$1 = 400;
const YLE_NEXT_XS_AC_FONT_STYLE$1 = 'normal';
const YLE_NEXT_XS_AC_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_XS_AC_FONT_STYLE_OLD$1 = 'Regular';
const YLE_NEXT_XS_AC_LETTER_SPACING$1 = '0.01em';
const YLE_NEXT_XS_AC_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_XS_AC_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XS_AC_PARAGRAPH_SPACING$1 = '12px';
const YLE_NEXT_XS_AC_TEXT_CASE$1 = 'uppercase';
const YLE_NEXT_XS_BOLD_FONT_SIZE$1 = '12px';
const YLE_NEXT_XS_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XS_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XS_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_XS_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_XS_BOLD_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_XS_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_XS_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_XS_BOLD_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_XS_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XS_BOLD_PARAGRAPH_SPACING$1 = '12px';
const YLE_NEXT_XS_BOLD_TEXT_CASE$1 = 'none';
const YLE_NEXT_XS_BOLD_AC_FONT_SIZE$1 = '12px';
const YLE_NEXT_XS_BOLD_AC_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XS_BOLD_AC_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XS_BOLD_AC_FONT_WEIGHT$1 = 700;
const YLE_NEXT_XS_BOLD_AC_FONT_STYLE$1 = 'normal';
const YLE_NEXT_XS_BOLD_AC_FONT_STRETCH$1 = 'normal';
const YLE_NEXT_XS_BOLD_AC_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_XS_BOLD_AC_LETTER_SPACING$1 = '0.01em';
const YLE_NEXT_XS_BOLD_AC_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_XS_BOLD_AC_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XS_BOLD_AC_PARAGRAPH_SPACING$1 = '12px';
const YLE_NEXT_XS_BOLD_AC_TEXT_CASE$1 = 'uppercase';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_SIZE$1 = '12px';
const YLE_NEXT_XS_CONDENSED_BOLD_TEXT_DECORATION$1 = 'none';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_FAMILY$1 = 'Yle Next';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_WEIGHT$1 = 700;
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE$1 = 'normal';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_STRETCH$1 = 'condensed';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE_OLD$1 = 'Bold';
const YLE_NEXT_XS_CONDENSED_BOLD_LETTER_SPACING$1 = 0;
const YLE_NEXT_XS_CONDENSED_BOLD_LINE_HEIGHT$1 = '1.50';
const YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT$1 = 0;
const YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING$1 = 0;
const YLE_NEXT_XS_CONDENSED_BOLD_TEXT_CASE$1 = 'none';

var typographyPx = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DEFAULT_2XL_BOLD_FONT_FAMILY: DEFAULT_2XL_BOLD_FONT_FAMILY$1,
  DEFAULT_2XL_BOLD_FONT_SIZE: DEFAULT_2XL_BOLD_FONT_SIZE$1,
  DEFAULT_2XL_BOLD_FONT_STRETCH: DEFAULT_2XL_BOLD_FONT_STRETCH$1,
  DEFAULT_2XL_BOLD_FONT_STYLE: DEFAULT_2XL_BOLD_FONT_STYLE$1,
  DEFAULT_2XL_BOLD_FONT_STYLE_OLD: DEFAULT_2XL_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_2XL_BOLD_FONT_WEIGHT: DEFAULT_2XL_BOLD_FONT_WEIGHT$1,
  DEFAULT_2XL_BOLD_LETTER_SPACING: DEFAULT_2XL_BOLD_LETTER_SPACING$1,
  DEFAULT_2XL_BOLD_LINE_HEIGHT: DEFAULT_2XL_BOLD_LINE_HEIGHT$1,
  DEFAULT_2XL_BOLD_PARAGRAPH_INDENT: DEFAULT_2XL_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_2XL_BOLD_PARAGRAPH_SPACING: DEFAULT_2XL_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_2XL_BOLD_TEXT_CASE: DEFAULT_2XL_BOLD_TEXT_CASE$1,
  DEFAULT_2XL_BOLD_TEXT_DECORATION: DEFAULT_2XL_BOLD_TEXT_DECORATION$1,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_2XL_CONDENSED_BOLD_FONT_FAMILY$1,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_SIZE: DEFAULT_2XL_CONDENSED_BOLD_FONT_SIZE$1,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_2XL_CONDENSED_BOLD_FONT_STRETCH$1,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE: DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE$1,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_2XL_CONDENSED_BOLD_FONT_WEIGHT$1,
  DEFAULT_2XL_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_2XL_CONDENSED_BOLD_LETTER_SPACING$1,
  DEFAULT_2XL_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_2XL_CONDENSED_BOLD_LINE_HEIGHT$1,
  DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_2XL_CONDENSED_BOLD_TEXT_CASE: DEFAULT_2XL_CONDENSED_BOLD_TEXT_CASE$1,
  DEFAULT_2XL_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_2XL_CONDENSED_BOLD_TEXT_DECORATION$1,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_2XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_2XL_CONDENSED_HEAVY_FONT_SIZE$1,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_2XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE$1,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_2XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  DEFAULT_2XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_2XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  DEFAULT_2XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_2XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_2XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_2XL_CONDENSED_HEAVY_TEXT_CASE$1,
  DEFAULT_2XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_2XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  DEFAULT_2XL_FONT_FAMILY: DEFAULT_2XL_FONT_FAMILY$1,
  DEFAULT_2XL_FONT_SIZE: DEFAULT_2XL_FONT_SIZE$1,
  DEFAULT_2XL_FONT_STRETCH: DEFAULT_2XL_FONT_STRETCH$1,
  DEFAULT_2XL_FONT_STYLE: DEFAULT_2XL_FONT_STYLE$1,
  DEFAULT_2XL_FONT_STYLE_OLD: DEFAULT_2XL_FONT_STYLE_OLD$1,
  DEFAULT_2XL_FONT_WEIGHT: DEFAULT_2XL_FONT_WEIGHT$1,
  DEFAULT_2XL_HEAVY_FONT_FAMILY: DEFAULT_2XL_HEAVY_FONT_FAMILY$1,
  DEFAULT_2XL_HEAVY_FONT_SIZE: DEFAULT_2XL_HEAVY_FONT_SIZE$1,
  DEFAULT_2XL_HEAVY_FONT_STRETCH: DEFAULT_2XL_HEAVY_FONT_STRETCH$1,
  DEFAULT_2XL_HEAVY_FONT_STYLE: DEFAULT_2XL_HEAVY_FONT_STYLE$1,
  DEFAULT_2XL_HEAVY_FONT_STYLE_OLD: DEFAULT_2XL_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_2XL_HEAVY_FONT_WEIGHT: DEFAULT_2XL_HEAVY_FONT_WEIGHT$1,
  DEFAULT_2XL_HEAVY_LETTER_SPACING: DEFAULT_2XL_HEAVY_LETTER_SPACING$1,
  DEFAULT_2XL_HEAVY_LINE_HEIGHT: DEFAULT_2XL_HEAVY_LINE_HEIGHT$1,
  DEFAULT_2XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_2XL_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_2XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_2XL_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_2XL_HEAVY_TEXT_CASE: DEFAULT_2XL_HEAVY_TEXT_CASE$1,
  DEFAULT_2XL_HEAVY_TEXT_DECORATION: DEFAULT_2XL_HEAVY_TEXT_DECORATION$1,
  DEFAULT_2XL_LETTER_SPACING: DEFAULT_2XL_LETTER_SPACING$1,
  DEFAULT_2XL_LINE_HEIGHT: DEFAULT_2XL_LINE_HEIGHT$1,
  DEFAULT_2XL_PARAGRAPH_INDENT: DEFAULT_2XL_PARAGRAPH_INDENT$1,
  DEFAULT_2XL_PARAGRAPH_SPACING: DEFAULT_2XL_PARAGRAPH_SPACING$1,
  DEFAULT_2XL_TEXT_CASE: DEFAULT_2XL_TEXT_CASE$1,
  DEFAULT_2XL_TEXT_DECORATION: DEFAULT_2XL_TEXT_DECORATION$1,
  DEFAULT_3XL_BOLD_FONT_FAMILY: DEFAULT_3XL_BOLD_FONT_FAMILY$1,
  DEFAULT_3XL_BOLD_FONT_SIZE: DEFAULT_3XL_BOLD_FONT_SIZE$1,
  DEFAULT_3XL_BOLD_FONT_STRETCH: DEFAULT_3XL_BOLD_FONT_STRETCH$1,
  DEFAULT_3XL_BOLD_FONT_STYLE: DEFAULT_3XL_BOLD_FONT_STYLE$1,
  DEFAULT_3XL_BOLD_FONT_STYLE_OLD: DEFAULT_3XL_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_3XL_BOLD_FONT_WEIGHT: DEFAULT_3XL_BOLD_FONT_WEIGHT$1,
  DEFAULT_3XL_BOLD_LETTER_SPACING: DEFAULT_3XL_BOLD_LETTER_SPACING$1,
  DEFAULT_3XL_BOLD_LINE_HEIGHT: DEFAULT_3XL_BOLD_LINE_HEIGHT$1,
  DEFAULT_3XL_BOLD_PARAGRAPH_INDENT: DEFAULT_3XL_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_3XL_BOLD_PARAGRAPH_SPACING: DEFAULT_3XL_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_3XL_BOLD_TEXT_CASE: DEFAULT_3XL_BOLD_TEXT_CASE$1,
  DEFAULT_3XL_BOLD_TEXT_DECORATION: DEFAULT_3XL_BOLD_TEXT_DECORATION$1,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_3XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_3XL_CONDENSED_HEAVY_FONT_SIZE$1,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_3XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE$1,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_3XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  DEFAULT_3XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_3XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  DEFAULT_3XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_3XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_3XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_3XL_CONDENSED_HEAVY_TEXT_CASE$1,
  DEFAULT_3XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_3XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  DEFAULT_3XL_HEAVY_FONT_FAMILY: DEFAULT_3XL_HEAVY_FONT_FAMILY$1,
  DEFAULT_3XL_HEAVY_FONT_SIZE: DEFAULT_3XL_HEAVY_FONT_SIZE$1,
  DEFAULT_3XL_HEAVY_FONT_STRETCH: DEFAULT_3XL_HEAVY_FONT_STRETCH$1,
  DEFAULT_3XL_HEAVY_FONT_STYLE: DEFAULT_3XL_HEAVY_FONT_STYLE$1,
  DEFAULT_3XL_HEAVY_FONT_STYLE_OLD: DEFAULT_3XL_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_3XL_HEAVY_FONT_WEIGHT: DEFAULT_3XL_HEAVY_FONT_WEIGHT$1,
  DEFAULT_3XL_HEAVY_LETTER_SPACING: DEFAULT_3XL_HEAVY_LETTER_SPACING$1,
  DEFAULT_3XL_HEAVY_LINE_HEIGHT: DEFAULT_3XL_HEAVY_LINE_HEIGHT$1,
  DEFAULT_3XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_3XL_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_3XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_3XL_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_3XL_HEAVY_TEXT_CASE: DEFAULT_3XL_HEAVY_TEXT_CASE$1,
  DEFAULT_3XL_HEAVY_TEXT_DECORATION: DEFAULT_3XL_HEAVY_TEXT_DECORATION$1,
  DEFAULT_4XL_BOLD_FONT_FAMILY: DEFAULT_4XL_BOLD_FONT_FAMILY$1,
  DEFAULT_4XL_BOLD_FONT_SIZE: DEFAULT_4XL_BOLD_FONT_SIZE$1,
  DEFAULT_4XL_BOLD_FONT_STRETCH: DEFAULT_4XL_BOLD_FONT_STRETCH$1,
  DEFAULT_4XL_BOLD_FONT_STYLE: DEFAULT_4XL_BOLD_FONT_STYLE$1,
  DEFAULT_4XL_BOLD_FONT_STYLE_OLD: DEFAULT_4XL_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_4XL_BOLD_FONT_WEIGHT: DEFAULT_4XL_BOLD_FONT_WEIGHT$1,
  DEFAULT_4XL_BOLD_LETTER_SPACING: DEFAULT_4XL_BOLD_LETTER_SPACING$1,
  DEFAULT_4XL_BOLD_LINE_HEIGHT: DEFAULT_4XL_BOLD_LINE_HEIGHT$1,
  DEFAULT_4XL_BOLD_PARAGRAPH_INDENT: DEFAULT_4XL_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_4XL_BOLD_PARAGRAPH_SPACING: DEFAULT_4XL_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_4XL_BOLD_TEXT_CASE: DEFAULT_4XL_BOLD_TEXT_CASE$1,
  DEFAULT_4XL_BOLD_TEXT_DECORATION: DEFAULT_4XL_BOLD_TEXT_DECORATION$1,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_4XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_4XL_CONDENSED_HEAVY_FONT_SIZE$1,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_4XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE$1,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_4XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  DEFAULT_4XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_4XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  DEFAULT_4XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_4XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_4XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_4XL_CONDENSED_HEAVY_TEXT_CASE$1,
  DEFAULT_4XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_4XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  DEFAULT_4XL_HEAVY_FONT_FAMILY: DEFAULT_4XL_HEAVY_FONT_FAMILY$1,
  DEFAULT_4XL_HEAVY_FONT_SIZE: DEFAULT_4XL_HEAVY_FONT_SIZE$1,
  DEFAULT_4XL_HEAVY_FONT_STRETCH: DEFAULT_4XL_HEAVY_FONT_STRETCH$1,
  DEFAULT_4XL_HEAVY_FONT_STYLE: DEFAULT_4XL_HEAVY_FONT_STYLE$1,
  DEFAULT_4XL_HEAVY_FONT_STYLE_OLD: DEFAULT_4XL_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_4XL_HEAVY_FONT_WEIGHT: DEFAULT_4XL_HEAVY_FONT_WEIGHT$1,
  DEFAULT_4XL_HEAVY_LETTER_SPACING: DEFAULT_4XL_HEAVY_LETTER_SPACING$1,
  DEFAULT_4XL_HEAVY_LINE_HEIGHT: DEFAULT_4XL_HEAVY_LINE_HEIGHT$1,
  DEFAULT_4XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_4XL_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_4XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_4XL_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_4XL_HEAVY_TEXT_CASE: DEFAULT_4XL_HEAVY_TEXT_CASE$1,
  DEFAULT_4XL_HEAVY_TEXT_DECORATION: DEFAULT_4XL_HEAVY_TEXT_DECORATION$1,
  DEFAULT_5XL_BOLD_FONT_FAMILY: DEFAULT_5XL_BOLD_FONT_FAMILY$1,
  DEFAULT_5XL_BOLD_FONT_SIZE: DEFAULT_5XL_BOLD_FONT_SIZE$1,
  DEFAULT_5XL_BOLD_FONT_STRETCH: DEFAULT_5XL_BOLD_FONT_STRETCH$1,
  DEFAULT_5XL_BOLD_FONT_STYLE: DEFAULT_5XL_BOLD_FONT_STYLE$1,
  DEFAULT_5XL_BOLD_FONT_STYLE_OLD: DEFAULT_5XL_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_5XL_BOLD_FONT_WEIGHT: DEFAULT_5XL_BOLD_FONT_WEIGHT$1,
  DEFAULT_5XL_BOLD_LETTER_SPACING: DEFAULT_5XL_BOLD_LETTER_SPACING$1,
  DEFAULT_5XL_BOLD_LINE_HEIGHT: DEFAULT_5XL_BOLD_LINE_HEIGHT$1,
  DEFAULT_5XL_BOLD_PARAGRAPH_INDENT: DEFAULT_5XL_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_5XL_BOLD_PARAGRAPH_SPACING: DEFAULT_5XL_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_5XL_BOLD_TEXT_CASE: DEFAULT_5XL_BOLD_TEXT_CASE$1,
  DEFAULT_5XL_BOLD_TEXT_DECORATION: DEFAULT_5XL_BOLD_TEXT_DECORATION$1,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_5XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_5XL_CONDENSED_HEAVY_FONT_SIZE$1,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_5XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE$1,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_5XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  DEFAULT_5XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_5XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  DEFAULT_5XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_5XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_5XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_5XL_CONDENSED_HEAVY_TEXT_CASE$1,
  DEFAULT_5XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_5XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  DEFAULT_5XL_HEAVY_FONT_FAMILY: DEFAULT_5XL_HEAVY_FONT_FAMILY$1,
  DEFAULT_5XL_HEAVY_FONT_SIZE: DEFAULT_5XL_HEAVY_FONT_SIZE$1,
  DEFAULT_5XL_HEAVY_FONT_STRETCH: DEFAULT_5XL_HEAVY_FONT_STRETCH$1,
  DEFAULT_5XL_HEAVY_FONT_STYLE: DEFAULT_5XL_HEAVY_FONT_STYLE$1,
  DEFAULT_5XL_HEAVY_FONT_STYLE_OLD: DEFAULT_5XL_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_5XL_HEAVY_FONT_WEIGHT: DEFAULT_5XL_HEAVY_FONT_WEIGHT$1,
  DEFAULT_5XL_HEAVY_LETTER_SPACING: DEFAULT_5XL_HEAVY_LETTER_SPACING$1,
  DEFAULT_5XL_HEAVY_LINE_HEIGHT: DEFAULT_5XL_HEAVY_LINE_HEIGHT$1,
  DEFAULT_5XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_5XL_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_5XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_5XL_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_5XL_HEAVY_TEXT_CASE: DEFAULT_5XL_HEAVY_TEXT_CASE$1,
  DEFAULT_5XL_HEAVY_TEXT_DECORATION: DEFAULT_5XL_HEAVY_TEXT_DECORATION$1,
  DEFAULT_6XL_BOLD_FONT_FAMILY: DEFAULT_6XL_BOLD_FONT_FAMILY$1,
  DEFAULT_6XL_BOLD_FONT_SIZE: DEFAULT_6XL_BOLD_FONT_SIZE$1,
  DEFAULT_6XL_BOLD_FONT_STRETCH: DEFAULT_6XL_BOLD_FONT_STRETCH$1,
  DEFAULT_6XL_BOLD_FONT_STYLE: DEFAULT_6XL_BOLD_FONT_STYLE$1,
  DEFAULT_6XL_BOLD_FONT_STYLE_OLD: DEFAULT_6XL_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_6XL_BOLD_FONT_WEIGHT: DEFAULT_6XL_BOLD_FONT_WEIGHT$1,
  DEFAULT_6XL_BOLD_LETTER_SPACING: DEFAULT_6XL_BOLD_LETTER_SPACING$1,
  DEFAULT_6XL_BOLD_LINE_HEIGHT: DEFAULT_6XL_BOLD_LINE_HEIGHT$1,
  DEFAULT_6XL_BOLD_PARAGRAPH_INDENT: DEFAULT_6XL_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_6XL_BOLD_PARAGRAPH_SPACING: DEFAULT_6XL_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_6XL_BOLD_TEXT_CASE: DEFAULT_6XL_BOLD_TEXT_CASE$1,
  DEFAULT_6XL_BOLD_TEXT_DECORATION: DEFAULT_6XL_BOLD_TEXT_DECORATION$1,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_6XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_6XL_CONDENSED_HEAVY_FONT_SIZE$1,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_6XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE$1,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_6XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  DEFAULT_6XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_6XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  DEFAULT_6XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_6XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_6XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_6XL_CONDENSED_HEAVY_TEXT_CASE$1,
  DEFAULT_6XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_6XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  DEFAULT_6XL_HEAVY_FONT_FAMILY: DEFAULT_6XL_HEAVY_FONT_FAMILY$1,
  DEFAULT_6XL_HEAVY_FONT_SIZE: DEFAULT_6XL_HEAVY_FONT_SIZE$1,
  DEFAULT_6XL_HEAVY_FONT_STRETCH: DEFAULT_6XL_HEAVY_FONT_STRETCH$1,
  DEFAULT_6XL_HEAVY_FONT_STYLE: DEFAULT_6XL_HEAVY_FONT_STYLE$1,
  DEFAULT_6XL_HEAVY_FONT_STYLE_OLD: DEFAULT_6XL_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_6XL_HEAVY_FONT_WEIGHT: DEFAULT_6XL_HEAVY_FONT_WEIGHT$1,
  DEFAULT_6XL_HEAVY_LETTER_SPACING: DEFAULT_6XL_HEAVY_LETTER_SPACING$1,
  DEFAULT_6XL_HEAVY_LINE_HEIGHT: DEFAULT_6XL_HEAVY_LINE_HEIGHT$1,
  DEFAULT_6XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_6XL_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_6XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_6XL_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_6XL_HEAVY_TEXT_CASE: DEFAULT_6XL_HEAVY_TEXT_CASE$1,
  DEFAULT_6XL_HEAVY_TEXT_DECORATION: DEFAULT_6XL_HEAVY_TEXT_DECORATION$1,
  DEFAULT_7XL_BOLD_FONT_FAMILY: DEFAULT_7XL_BOLD_FONT_FAMILY$1,
  DEFAULT_7XL_BOLD_FONT_SIZE: DEFAULT_7XL_BOLD_FONT_SIZE$1,
  DEFAULT_7XL_BOLD_FONT_STRETCH: DEFAULT_7XL_BOLD_FONT_STRETCH$1,
  DEFAULT_7XL_BOLD_FONT_STYLE: DEFAULT_7XL_BOLD_FONT_STYLE$1,
  DEFAULT_7XL_BOLD_FONT_STYLE_OLD: DEFAULT_7XL_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_7XL_BOLD_FONT_WEIGHT: DEFAULT_7XL_BOLD_FONT_WEIGHT$1,
  DEFAULT_7XL_BOLD_LETTER_SPACING: DEFAULT_7XL_BOLD_LETTER_SPACING$1,
  DEFAULT_7XL_BOLD_LINE_HEIGHT: DEFAULT_7XL_BOLD_LINE_HEIGHT$1,
  DEFAULT_7XL_BOLD_PARAGRAPH_INDENT: DEFAULT_7XL_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_7XL_BOLD_PARAGRAPH_SPACING: DEFAULT_7XL_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_7XL_BOLD_TEXT_CASE: DEFAULT_7XL_BOLD_TEXT_CASE$1,
  DEFAULT_7XL_BOLD_TEXT_DECORATION: DEFAULT_7XL_BOLD_TEXT_DECORATION$1,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_7XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_7XL_CONDENSED_HEAVY_FONT_SIZE$1,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_7XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE$1,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_7XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  DEFAULT_7XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_7XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  DEFAULT_7XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_7XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_7XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_7XL_CONDENSED_HEAVY_TEXT_CASE$1,
  DEFAULT_7XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_7XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  DEFAULT_7XL_HEAVY_FONT_FAMILY: DEFAULT_7XL_HEAVY_FONT_FAMILY$1,
  DEFAULT_7XL_HEAVY_FONT_SIZE: DEFAULT_7XL_HEAVY_FONT_SIZE$1,
  DEFAULT_7XL_HEAVY_FONT_STRETCH: DEFAULT_7XL_HEAVY_FONT_STRETCH$1,
  DEFAULT_7XL_HEAVY_FONT_STYLE: DEFAULT_7XL_HEAVY_FONT_STYLE$1,
  DEFAULT_7XL_HEAVY_FONT_STYLE_OLD: DEFAULT_7XL_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_7XL_HEAVY_FONT_WEIGHT: DEFAULT_7XL_HEAVY_FONT_WEIGHT$1,
  DEFAULT_7XL_HEAVY_LETTER_SPACING: DEFAULT_7XL_HEAVY_LETTER_SPACING$1,
  DEFAULT_7XL_HEAVY_LINE_HEIGHT: DEFAULT_7XL_HEAVY_LINE_HEIGHT$1,
  DEFAULT_7XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_7XL_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_7XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_7XL_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_7XL_HEAVY_TEXT_CASE: DEFAULT_7XL_HEAVY_TEXT_CASE$1,
  DEFAULT_7XL_HEAVY_TEXT_DECORATION: DEFAULT_7XL_HEAVY_TEXT_DECORATION$1,
  DEFAULT_L_BOLD_FONT_FAMILY: DEFAULT_L_BOLD_FONT_FAMILY$1,
  DEFAULT_L_BOLD_FONT_SIZE: DEFAULT_L_BOLD_FONT_SIZE$1,
  DEFAULT_L_BOLD_FONT_STRETCH: DEFAULT_L_BOLD_FONT_STRETCH$1,
  DEFAULT_L_BOLD_FONT_STYLE: DEFAULT_L_BOLD_FONT_STYLE$1,
  DEFAULT_L_BOLD_FONT_STYLE_OLD: DEFAULT_L_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_L_BOLD_FONT_WEIGHT: DEFAULT_L_BOLD_FONT_WEIGHT$1,
  DEFAULT_L_BOLD_LETTER_SPACING: DEFAULT_L_BOLD_LETTER_SPACING$1,
  DEFAULT_L_BOLD_LINE_HEIGHT: DEFAULT_L_BOLD_LINE_HEIGHT$1,
  DEFAULT_L_BOLD_PARAGRAPH_INDENT: DEFAULT_L_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_L_BOLD_PARAGRAPH_SPACING: DEFAULT_L_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_L_BOLD_TEXT_CASE: DEFAULT_L_BOLD_TEXT_CASE$1,
  DEFAULT_L_BOLD_TEXT_DECORATION: DEFAULT_L_BOLD_TEXT_DECORATION$1,
  DEFAULT_L_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_L_CONDENSED_BOLD_FONT_FAMILY$1,
  DEFAULT_L_CONDENSED_BOLD_FONT_SIZE: DEFAULT_L_CONDENSED_BOLD_FONT_SIZE$1,
  DEFAULT_L_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_L_CONDENSED_BOLD_FONT_STRETCH$1,
  DEFAULT_L_CONDENSED_BOLD_FONT_STYLE: DEFAULT_L_CONDENSED_BOLD_FONT_STYLE$1,
  DEFAULT_L_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_L_CONDENSED_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_L_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_L_CONDENSED_BOLD_FONT_WEIGHT$1,
  DEFAULT_L_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_L_CONDENSED_BOLD_LETTER_SPACING$1,
  DEFAULT_L_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_L_CONDENSED_BOLD_LINE_HEIGHT$1,
  DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_L_CONDENSED_BOLD_TEXT_CASE: DEFAULT_L_CONDENSED_BOLD_TEXT_CASE$1,
  DEFAULT_L_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_L_CONDENSED_BOLD_TEXT_DECORATION$1,
  DEFAULT_L_CONDENSED_FONT_FAMILY: DEFAULT_L_CONDENSED_FONT_FAMILY$1,
  DEFAULT_L_CONDENSED_FONT_SIZE: DEFAULT_L_CONDENSED_FONT_SIZE$1,
  DEFAULT_L_CONDENSED_FONT_STRETCH: DEFAULT_L_CONDENSED_FONT_STRETCH$1,
  DEFAULT_L_CONDENSED_FONT_STYLE: DEFAULT_L_CONDENSED_FONT_STYLE$1,
  DEFAULT_L_CONDENSED_FONT_STYLE_OLD: DEFAULT_L_CONDENSED_FONT_STYLE_OLD$1,
  DEFAULT_L_CONDENSED_FONT_WEIGHT: DEFAULT_L_CONDENSED_FONT_WEIGHT$1,
  DEFAULT_L_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_L_CONDENSED_HEAVY_FONT_FAMILY$1,
  DEFAULT_L_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_L_CONDENSED_HEAVY_FONT_SIZE$1,
  DEFAULT_L_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_L_CONDENSED_HEAVY_FONT_STRETCH$1,
  DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE$1,
  DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_L_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_L_CONDENSED_HEAVY_FONT_WEIGHT$1,
  DEFAULT_L_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_L_CONDENSED_HEAVY_LETTER_SPACING$1,
  DEFAULT_L_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_L_CONDENSED_HEAVY_LINE_HEIGHT$1,
  DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_L_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_L_CONDENSED_HEAVY_TEXT_CASE$1,
  DEFAULT_L_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_L_CONDENSED_HEAVY_TEXT_DECORATION$1,
  DEFAULT_L_CONDENSED_LETTER_SPACING: DEFAULT_L_CONDENSED_LETTER_SPACING$1,
  DEFAULT_L_CONDENSED_LINE_HEIGHT: DEFAULT_L_CONDENSED_LINE_HEIGHT$1,
  DEFAULT_L_CONDENSED_PARAGRAPH_INDENT: DEFAULT_L_CONDENSED_PARAGRAPH_INDENT$1,
  DEFAULT_L_CONDENSED_PARAGRAPH_SPACING: DEFAULT_L_CONDENSED_PARAGRAPH_SPACING$1,
  DEFAULT_L_CONDENSED_TEXT_CASE: DEFAULT_L_CONDENSED_TEXT_CASE$1,
  DEFAULT_L_CONDENSED_TEXT_DECORATION: DEFAULT_L_CONDENSED_TEXT_DECORATION$1,
  DEFAULT_L_FONT_FAMILY: DEFAULT_L_FONT_FAMILY$1,
  DEFAULT_L_FONT_SIZE: DEFAULT_L_FONT_SIZE$1,
  DEFAULT_L_FONT_STRETCH: DEFAULT_L_FONT_STRETCH$1,
  DEFAULT_L_FONT_STYLE: DEFAULT_L_FONT_STYLE$1,
  DEFAULT_L_FONT_STYLE_OLD: DEFAULT_L_FONT_STYLE_OLD$1,
  DEFAULT_L_FONT_WEIGHT: DEFAULT_L_FONT_WEIGHT$1,
  DEFAULT_L_HEAVY_FONT_FAMILY: DEFAULT_L_HEAVY_FONT_FAMILY$1,
  DEFAULT_L_HEAVY_FONT_SIZE: DEFAULT_L_HEAVY_FONT_SIZE$1,
  DEFAULT_L_HEAVY_FONT_STRETCH: DEFAULT_L_HEAVY_FONT_STRETCH$1,
  DEFAULT_L_HEAVY_FONT_STYLE: DEFAULT_L_HEAVY_FONT_STYLE$1,
  DEFAULT_L_HEAVY_FONT_STYLE_OLD: DEFAULT_L_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_L_HEAVY_FONT_WEIGHT: DEFAULT_L_HEAVY_FONT_WEIGHT$1,
  DEFAULT_L_HEAVY_LETTER_SPACING: DEFAULT_L_HEAVY_LETTER_SPACING$1,
  DEFAULT_L_HEAVY_LINE_HEIGHT: DEFAULT_L_HEAVY_LINE_HEIGHT$1,
  DEFAULT_L_HEAVY_PARAGRAPH_INDENT: DEFAULT_L_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_L_HEAVY_PARAGRAPH_SPACING: DEFAULT_L_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_L_HEAVY_TEXT_CASE: DEFAULT_L_HEAVY_TEXT_CASE$1,
  DEFAULT_L_HEAVY_TEXT_DECORATION: DEFAULT_L_HEAVY_TEXT_DECORATION$1,
  DEFAULT_L_ITALIC_FONT_FAMILY: DEFAULT_L_ITALIC_FONT_FAMILY$1,
  DEFAULT_L_ITALIC_FONT_SIZE: DEFAULT_L_ITALIC_FONT_SIZE$1,
  DEFAULT_L_ITALIC_FONT_STRETCH: DEFAULT_L_ITALIC_FONT_STRETCH$1,
  DEFAULT_L_ITALIC_FONT_STYLE: DEFAULT_L_ITALIC_FONT_STYLE$1,
  DEFAULT_L_ITALIC_FONT_STYLE_OLD: DEFAULT_L_ITALIC_FONT_STYLE_OLD$1,
  DEFAULT_L_ITALIC_FONT_WEIGHT: DEFAULT_L_ITALIC_FONT_WEIGHT$1,
  DEFAULT_L_ITALIC_LETTER_SPACING: DEFAULT_L_ITALIC_LETTER_SPACING$1,
  DEFAULT_L_ITALIC_LINE_HEIGHT: DEFAULT_L_ITALIC_LINE_HEIGHT$1,
  DEFAULT_L_ITALIC_PARAGRAPH_INDENT: DEFAULT_L_ITALIC_PARAGRAPH_INDENT$1,
  DEFAULT_L_ITALIC_PARAGRAPH_SPACING: DEFAULT_L_ITALIC_PARAGRAPH_SPACING$1,
  DEFAULT_L_ITALIC_TEXT_CASE: DEFAULT_L_ITALIC_TEXT_CASE$1,
  DEFAULT_L_ITALIC_TEXT_DECORATION: DEFAULT_L_ITALIC_TEXT_DECORATION$1,
  DEFAULT_L_LETTER_SPACING: DEFAULT_L_LETTER_SPACING$1,
  DEFAULT_L_LINE_HEIGHT: DEFAULT_L_LINE_HEIGHT$1,
  DEFAULT_L_PARAGRAPH_INDENT: DEFAULT_L_PARAGRAPH_INDENT$1,
  DEFAULT_L_PARAGRAPH_SPACING: DEFAULT_L_PARAGRAPH_SPACING$1,
  DEFAULT_L_TEXT_CASE: DEFAULT_L_TEXT_CASE$1,
  DEFAULT_L_TEXT_DECORATION: DEFAULT_L_TEXT_DECORATION$1,
  DEFAULT_M_AC_FONT_FAMILY: DEFAULT_M_AC_FONT_FAMILY$1,
  DEFAULT_M_AC_FONT_SIZE: DEFAULT_M_AC_FONT_SIZE$1,
  DEFAULT_M_AC_FONT_STRETCH: DEFAULT_M_AC_FONT_STRETCH$1,
  DEFAULT_M_AC_FONT_STYLE: DEFAULT_M_AC_FONT_STYLE$1,
  DEFAULT_M_AC_FONT_STYLE_OLD: DEFAULT_M_AC_FONT_STYLE_OLD$1,
  DEFAULT_M_AC_FONT_WEIGHT: DEFAULT_M_AC_FONT_WEIGHT$1,
  DEFAULT_M_AC_LETTER_SPACING: DEFAULT_M_AC_LETTER_SPACING$1,
  DEFAULT_M_AC_LINE_HEIGHT: DEFAULT_M_AC_LINE_HEIGHT$1,
  DEFAULT_M_AC_PARAGRAPH_INDENT: DEFAULT_M_AC_PARAGRAPH_INDENT$1,
  DEFAULT_M_AC_PARAGRAPH_SPACING: DEFAULT_M_AC_PARAGRAPH_SPACING$1,
  DEFAULT_M_AC_TEXT_CASE: DEFAULT_M_AC_TEXT_CASE$1,
  DEFAULT_M_AC_TEXT_DECORATION: DEFAULT_M_AC_TEXT_DECORATION$1,
  DEFAULT_M_BOLD_AC_FONT_FAMILY: DEFAULT_M_BOLD_AC_FONT_FAMILY$1,
  DEFAULT_M_BOLD_AC_FONT_SIZE: DEFAULT_M_BOLD_AC_FONT_SIZE$1,
  DEFAULT_M_BOLD_AC_FONT_STRETCH: DEFAULT_M_BOLD_AC_FONT_STRETCH$1,
  DEFAULT_M_BOLD_AC_FONT_STYLE: DEFAULT_M_BOLD_AC_FONT_STYLE$1,
  DEFAULT_M_BOLD_AC_FONT_STYLE_OLD: DEFAULT_M_BOLD_AC_FONT_STYLE_OLD$1,
  DEFAULT_M_BOLD_AC_FONT_WEIGHT: DEFAULT_M_BOLD_AC_FONT_WEIGHT$1,
  DEFAULT_M_BOLD_AC_LETTER_SPACING: DEFAULT_M_BOLD_AC_LETTER_SPACING$1,
  DEFAULT_M_BOLD_AC_LINE_HEIGHT: DEFAULT_M_BOLD_AC_LINE_HEIGHT$1,
  DEFAULT_M_BOLD_AC_PARAGRAPH_INDENT: DEFAULT_M_BOLD_AC_PARAGRAPH_INDENT$1,
  DEFAULT_M_BOLD_AC_PARAGRAPH_SPACING: DEFAULT_M_BOLD_AC_PARAGRAPH_SPACING$1,
  DEFAULT_M_BOLD_AC_TEXT_CASE: DEFAULT_M_BOLD_AC_TEXT_CASE$1,
  DEFAULT_M_BOLD_AC_TEXT_DECORATION: DEFAULT_M_BOLD_AC_TEXT_DECORATION$1,
  DEFAULT_M_BOLD_FONT_FAMILY: DEFAULT_M_BOLD_FONT_FAMILY$1,
  DEFAULT_M_BOLD_FONT_SIZE: DEFAULT_M_BOLD_FONT_SIZE$1,
  DEFAULT_M_BOLD_FONT_STRETCH: DEFAULT_M_BOLD_FONT_STRETCH$1,
  DEFAULT_M_BOLD_FONT_STYLE: DEFAULT_M_BOLD_FONT_STYLE$1,
  DEFAULT_M_BOLD_FONT_STYLE_OLD: DEFAULT_M_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_M_BOLD_FONT_WEIGHT: DEFAULT_M_BOLD_FONT_WEIGHT$1,
  DEFAULT_M_BOLD_LETTER_SPACING: DEFAULT_M_BOLD_LETTER_SPACING$1,
  DEFAULT_M_BOLD_LINE_HEIGHT: DEFAULT_M_BOLD_LINE_HEIGHT$1,
  DEFAULT_M_BOLD_PARAGRAPH_INDENT: DEFAULT_M_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_M_BOLD_PARAGRAPH_SPACING: DEFAULT_M_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_M_BOLD_TEXT_CASE: DEFAULT_M_BOLD_TEXT_CASE$1,
  DEFAULT_M_BOLD_TEXT_DECORATION: DEFAULT_M_BOLD_TEXT_DECORATION$1,
  DEFAULT_M_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_M_CONDENSED_BOLD_FONT_FAMILY$1,
  DEFAULT_M_CONDENSED_BOLD_FONT_SIZE: DEFAULT_M_CONDENSED_BOLD_FONT_SIZE$1,
  DEFAULT_M_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_M_CONDENSED_BOLD_FONT_STRETCH$1,
  DEFAULT_M_CONDENSED_BOLD_FONT_STYLE: DEFAULT_M_CONDENSED_BOLD_FONT_STYLE$1,
  DEFAULT_M_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_M_CONDENSED_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_M_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_M_CONDENSED_BOLD_FONT_WEIGHT$1,
  DEFAULT_M_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_M_CONDENSED_BOLD_LETTER_SPACING$1,
  DEFAULT_M_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_M_CONDENSED_BOLD_LINE_HEIGHT$1,
  DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_M_CONDENSED_BOLD_TEXT_CASE: DEFAULT_M_CONDENSED_BOLD_TEXT_CASE$1,
  DEFAULT_M_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_M_CONDENSED_BOLD_TEXT_DECORATION$1,
  DEFAULT_M_CONDENSED_FONT_FAMILY: DEFAULT_M_CONDENSED_FONT_FAMILY$1,
  DEFAULT_M_CONDENSED_FONT_SIZE: DEFAULT_M_CONDENSED_FONT_SIZE$1,
  DEFAULT_M_CONDENSED_FONT_STRETCH: DEFAULT_M_CONDENSED_FONT_STRETCH$1,
  DEFAULT_M_CONDENSED_FONT_STYLE: DEFAULT_M_CONDENSED_FONT_STYLE$1,
  DEFAULT_M_CONDENSED_FONT_STYLE_OLD: DEFAULT_M_CONDENSED_FONT_STYLE_OLD$1,
  DEFAULT_M_CONDENSED_FONT_WEIGHT: DEFAULT_M_CONDENSED_FONT_WEIGHT$1,
  DEFAULT_M_CONDENSED_LETTER_SPACING: DEFAULT_M_CONDENSED_LETTER_SPACING$1,
  DEFAULT_M_CONDENSED_LINE_HEIGHT: DEFAULT_M_CONDENSED_LINE_HEIGHT$1,
  DEFAULT_M_CONDENSED_PARAGRAPH_INDENT: DEFAULT_M_CONDENSED_PARAGRAPH_INDENT$1,
  DEFAULT_M_CONDENSED_PARAGRAPH_SPACING: DEFAULT_M_CONDENSED_PARAGRAPH_SPACING$1,
  DEFAULT_M_CONDENSED_TEXT_CASE: DEFAULT_M_CONDENSED_TEXT_CASE$1,
  DEFAULT_M_CONDENSED_TEXT_DECORATION: DEFAULT_M_CONDENSED_TEXT_DECORATION$1,
  DEFAULT_M_FONT_FAMILY: DEFAULT_M_FONT_FAMILY$1,
  DEFAULT_M_FONT_SIZE: DEFAULT_M_FONT_SIZE$1,
  DEFAULT_M_FONT_STRETCH: DEFAULT_M_FONT_STRETCH$1,
  DEFAULT_M_FONT_STYLE: DEFAULT_M_FONT_STYLE$1,
  DEFAULT_M_FONT_STYLE_OLD: DEFAULT_M_FONT_STYLE_OLD$1,
  DEFAULT_M_FONT_WEIGHT: DEFAULT_M_FONT_WEIGHT$1,
  DEFAULT_M_ITALIC_FONT_FAMILY: DEFAULT_M_ITALIC_FONT_FAMILY$1,
  DEFAULT_M_ITALIC_FONT_SIZE: DEFAULT_M_ITALIC_FONT_SIZE$1,
  DEFAULT_M_ITALIC_FONT_STRETCH: DEFAULT_M_ITALIC_FONT_STRETCH$1,
  DEFAULT_M_ITALIC_FONT_STYLE: DEFAULT_M_ITALIC_FONT_STYLE$1,
  DEFAULT_M_ITALIC_FONT_STYLE_OLD: DEFAULT_M_ITALIC_FONT_STYLE_OLD$1,
  DEFAULT_M_ITALIC_FONT_WEIGHT: DEFAULT_M_ITALIC_FONT_WEIGHT$1,
  DEFAULT_M_ITALIC_LETTER_SPACING: DEFAULT_M_ITALIC_LETTER_SPACING$1,
  DEFAULT_M_ITALIC_LINE_HEIGHT: DEFAULT_M_ITALIC_LINE_HEIGHT$1,
  DEFAULT_M_ITALIC_PARAGRAPH_INDENT: DEFAULT_M_ITALIC_PARAGRAPH_INDENT$1,
  DEFAULT_M_ITALIC_PARAGRAPH_SPACING: DEFAULT_M_ITALIC_PARAGRAPH_SPACING$1,
  DEFAULT_M_ITALIC_TEXT_CASE: DEFAULT_M_ITALIC_TEXT_CASE$1,
  DEFAULT_M_ITALIC_TEXT_DECORATION: DEFAULT_M_ITALIC_TEXT_DECORATION$1,
  DEFAULT_M_LETTER_SPACING: DEFAULT_M_LETTER_SPACING$1,
  DEFAULT_M_LINE_HEIGHT: DEFAULT_M_LINE_HEIGHT$1,
  DEFAULT_M_MEDIUM_FONT_FAMILY: DEFAULT_M_MEDIUM_FONT_FAMILY$1,
  DEFAULT_M_MEDIUM_FONT_SIZE: DEFAULT_M_MEDIUM_FONT_SIZE$1,
  DEFAULT_M_MEDIUM_FONT_STRETCH: DEFAULT_M_MEDIUM_FONT_STRETCH$1,
  DEFAULT_M_MEDIUM_FONT_STYLE: DEFAULT_M_MEDIUM_FONT_STYLE$1,
  DEFAULT_M_MEDIUM_FONT_STYLE_OLD: DEFAULT_M_MEDIUM_FONT_STYLE_OLD$1,
  DEFAULT_M_MEDIUM_FONT_WEIGHT: DEFAULT_M_MEDIUM_FONT_WEIGHT$1,
  DEFAULT_M_MEDIUM_LETTER_SPACING: DEFAULT_M_MEDIUM_LETTER_SPACING$1,
  DEFAULT_M_MEDIUM_LINE_HEIGHT: DEFAULT_M_MEDIUM_LINE_HEIGHT$1,
  DEFAULT_M_MEDIUM_PARAGRAPH_INDENT: DEFAULT_M_MEDIUM_PARAGRAPH_INDENT$1,
  DEFAULT_M_MEDIUM_PARAGRAPH_SPACING: DEFAULT_M_MEDIUM_PARAGRAPH_SPACING$1,
  DEFAULT_M_MEDIUM_TEXT_CASE: DEFAULT_M_MEDIUM_TEXT_CASE$1,
  DEFAULT_M_MEDIUM_TEXT_DECORATION: DEFAULT_M_MEDIUM_TEXT_DECORATION$1,
  DEFAULT_M_PARAGRAPH_INDENT: DEFAULT_M_PARAGRAPH_INDENT$1,
  DEFAULT_M_PARAGRAPH_SPACING: DEFAULT_M_PARAGRAPH_SPACING$1,
  DEFAULT_M_TEXT_CASE: DEFAULT_M_TEXT_CASE$1,
  DEFAULT_M_TEXT_DECORATION: DEFAULT_M_TEXT_DECORATION$1,
  DEFAULT_S_AC_FONT_FAMILY: DEFAULT_S_AC_FONT_FAMILY$1,
  DEFAULT_S_AC_FONT_SIZE: DEFAULT_S_AC_FONT_SIZE$1,
  DEFAULT_S_AC_FONT_STRETCH: DEFAULT_S_AC_FONT_STRETCH$1,
  DEFAULT_S_AC_FONT_STYLE: DEFAULT_S_AC_FONT_STYLE$1,
  DEFAULT_S_AC_FONT_STYLE_OLD: DEFAULT_S_AC_FONT_STYLE_OLD$1,
  DEFAULT_S_AC_FONT_WEIGHT: DEFAULT_S_AC_FONT_WEIGHT$1,
  DEFAULT_S_AC_LETTER_SPACING: DEFAULT_S_AC_LETTER_SPACING$1,
  DEFAULT_S_AC_LINE_HEIGHT: DEFAULT_S_AC_LINE_HEIGHT$1,
  DEFAULT_S_AC_PARAGRAPH_INDENT: DEFAULT_S_AC_PARAGRAPH_INDENT$1,
  DEFAULT_S_AC_PARAGRAPH_SPACING: DEFAULT_S_AC_PARAGRAPH_SPACING$1,
  DEFAULT_S_AC_TEXT_CASE: DEFAULT_S_AC_TEXT_CASE$1,
  DEFAULT_S_AC_TEXT_DECORATION: DEFAULT_S_AC_TEXT_DECORATION$1,
  DEFAULT_S_BOLD_AC_FONT_FAMILY: DEFAULT_S_BOLD_AC_FONT_FAMILY$1,
  DEFAULT_S_BOLD_AC_FONT_SIZE: DEFAULT_S_BOLD_AC_FONT_SIZE$1,
  DEFAULT_S_BOLD_AC_FONT_STRETCH: DEFAULT_S_BOLD_AC_FONT_STRETCH$1,
  DEFAULT_S_BOLD_AC_FONT_STYLE: DEFAULT_S_BOLD_AC_FONT_STYLE$1,
  DEFAULT_S_BOLD_AC_FONT_STYLE_OLD: DEFAULT_S_BOLD_AC_FONT_STYLE_OLD$1,
  DEFAULT_S_BOLD_AC_FONT_WEIGHT: DEFAULT_S_BOLD_AC_FONT_WEIGHT$1,
  DEFAULT_S_BOLD_AC_LETTER_SPACING: DEFAULT_S_BOLD_AC_LETTER_SPACING$1,
  DEFAULT_S_BOLD_AC_LINE_HEIGHT: DEFAULT_S_BOLD_AC_LINE_HEIGHT$1,
  DEFAULT_S_BOLD_AC_PARAGRAPH_INDENT: DEFAULT_S_BOLD_AC_PARAGRAPH_INDENT$1,
  DEFAULT_S_BOLD_AC_PARAGRAPH_SPACING: DEFAULT_S_BOLD_AC_PARAGRAPH_SPACING$1,
  DEFAULT_S_BOLD_AC_TEXT_CASE: DEFAULT_S_BOLD_AC_TEXT_CASE$1,
  DEFAULT_S_BOLD_AC_TEXT_DECORATION: DEFAULT_S_BOLD_AC_TEXT_DECORATION$1,
  DEFAULT_S_BOLD_FONT_FAMILY: DEFAULT_S_BOLD_FONT_FAMILY$1,
  DEFAULT_S_BOLD_FONT_SIZE: DEFAULT_S_BOLD_FONT_SIZE$1,
  DEFAULT_S_BOLD_FONT_STRETCH: DEFAULT_S_BOLD_FONT_STRETCH$1,
  DEFAULT_S_BOLD_FONT_STYLE: DEFAULT_S_BOLD_FONT_STYLE$1,
  DEFAULT_S_BOLD_FONT_STYLE_OLD: DEFAULT_S_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_S_BOLD_FONT_WEIGHT: DEFAULT_S_BOLD_FONT_WEIGHT$1,
  DEFAULT_S_BOLD_LETTER_SPACING: DEFAULT_S_BOLD_LETTER_SPACING$1,
  DEFAULT_S_BOLD_LINE_HEIGHT: DEFAULT_S_BOLD_LINE_HEIGHT$1,
  DEFAULT_S_BOLD_PARAGRAPH_INDENT: DEFAULT_S_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_S_BOLD_PARAGRAPH_SPACING: DEFAULT_S_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_S_BOLD_TEXT_CASE: DEFAULT_S_BOLD_TEXT_CASE$1,
  DEFAULT_S_BOLD_TEXT_DECORATION: DEFAULT_S_BOLD_TEXT_DECORATION$1,
  DEFAULT_S_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_S_CONDENSED_BOLD_FONT_FAMILY$1,
  DEFAULT_S_CONDENSED_BOLD_FONT_SIZE: DEFAULT_S_CONDENSED_BOLD_FONT_SIZE$1,
  DEFAULT_S_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_S_CONDENSED_BOLD_FONT_STRETCH$1,
  DEFAULT_S_CONDENSED_BOLD_FONT_STYLE: DEFAULT_S_CONDENSED_BOLD_FONT_STYLE$1,
  DEFAULT_S_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_S_CONDENSED_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_S_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_S_CONDENSED_BOLD_FONT_WEIGHT$1,
  DEFAULT_S_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_S_CONDENSED_BOLD_LETTER_SPACING$1,
  DEFAULT_S_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_S_CONDENSED_BOLD_LINE_HEIGHT$1,
  DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_S_CONDENSED_BOLD_TEXT_CASE: DEFAULT_S_CONDENSED_BOLD_TEXT_CASE$1,
  DEFAULT_S_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_S_CONDENSED_BOLD_TEXT_DECORATION$1,
  DEFAULT_S_CONDENSED_FONT_FAMILY: DEFAULT_S_CONDENSED_FONT_FAMILY$1,
  DEFAULT_S_CONDENSED_FONT_SIZE: DEFAULT_S_CONDENSED_FONT_SIZE$1,
  DEFAULT_S_CONDENSED_FONT_STRETCH: DEFAULT_S_CONDENSED_FONT_STRETCH$1,
  DEFAULT_S_CONDENSED_FONT_STYLE: DEFAULT_S_CONDENSED_FONT_STYLE$1,
  DEFAULT_S_CONDENSED_FONT_STYLE_OLD: DEFAULT_S_CONDENSED_FONT_STYLE_OLD$1,
  DEFAULT_S_CONDENSED_FONT_WEIGHT: DEFAULT_S_CONDENSED_FONT_WEIGHT$1,
  DEFAULT_S_CONDENSED_LETTER_SPACING: DEFAULT_S_CONDENSED_LETTER_SPACING$1,
  DEFAULT_S_CONDENSED_LINE_HEIGHT: DEFAULT_S_CONDENSED_LINE_HEIGHT$1,
  DEFAULT_S_CONDENSED_PARAGRAPH_INDENT: DEFAULT_S_CONDENSED_PARAGRAPH_INDENT$1,
  DEFAULT_S_CONDENSED_PARAGRAPH_SPACING: DEFAULT_S_CONDENSED_PARAGRAPH_SPACING$1,
  DEFAULT_S_CONDENSED_TEXT_CASE: DEFAULT_S_CONDENSED_TEXT_CASE$1,
  DEFAULT_S_CONDENSED_TEXT_DECORATION: DEFAULT_S_CONDENSED_TEXT_DECORATION$1,
  DEFAULT_S_FONT_FAMILY: DEFAULT_S_FONT_FAMILY$1,
  DEFAULT_S_FONT_SIZE: DEFAULT_S_FONT_SIZE$1,
  DEFAULT_S_FONT_STRETCH: DEFAULT_S_FONT_STRETCH$1,
  DEFAULT_S_FONT_STYLE: DEFAULT_S_FONT_STYLE$1,
  DEFAULT_S_FONT_STYLE_OLD: DEFAULT_S_FONT_STYLE_OLD$1,
  DEFAULT_S_FONT_WEIGHT: DEFAULT_S_FONT_WEIGHT$1,
  DEFAULT_S_ITALIC_FONT_FAMILY: DEFAULT_S_ITALIC_FONT_FAMILY$1,
  DEFAULT_S_ITALIC_FONT_SIZE: DEFAULT_S_ITALIC_FONT_SIZE$1,
  DEFAULT_S_ITALIC_FONT_STRETCH: DEFAULT_S_ITALIC_FONT_STRETCH$1,
  DEFAULT_S_ITALIC_FONT_STYLE: DEFAULT_S_ITALIC_FONT_STYLE$1,
  DEFAULT_S_ITALIC_FONT_STYLE_OLD: DEFAULT_S_ITALIC_FONT_STYLE_OLD$1,
  DEFAULT_S_ITALIC_FONT_WEIGHT: DEFAULT_S_ITALIC_FONT_WEIGHT$1,
  DEFAULT_S_ITALIC_LETTER_SPACING: DEFAULT_S_ITALIC_LETTER_SPACING$1,
  DEFAULT_S_ITALIC_LINE_HEIGHT: DEFAULT_S_ITALIC_LINE_HEIGHT$1,
  DEFAULT_S_ITALIC_PARAGRAPH_INDENT: DEFAULT_S_ITALIC_PARAGRAPH_INDENT$1,
  DEFAULT_S_ITALIC_PARAGRAPH_SPACING: DEFAULT_S_ITALIC_PARAGRAPH_SPACING$1,
  DEFAULT_S_ITALIC_TEXT_CASE: DEFAULT_S_ITALIC_TEXT_CASE$1,
  DEFAULT_S_ITALIC_TEXT_DECORATION: DEFAULT_S_ITALIC_TEXT_DECORATION$1,
  DEFAULT_S_LETTER_SPACING: DEFAULT_S_LETTER_SPACING$1,
  DEFAULT_S_LINE_HEIGHT: DEFAULT_S_LINE_HEIGHT$1,
  DEFAULT_S_MEDIUM_FONT_FAMILY: DEFAULT_S_MEDIUM_FONT_FAMILY$1,
  DEFAULT_S_MEDIUM_FONT_SIZE: DEFAULT_S_MEDIUM_FONT_SIZE$1,
  DEFAULT_S_MEDIUM_FONT_STRETCH: DEFAULT_S_MEDIUM_FONT_STRETCH$1,
  DEFAULT_S_MEDIUM_FONT_STYLE: DEFAULT_S_MEDIUM_FONT_STYLE$1,
  DEFAULT_S_MEDIUM_FONT_STYLE_OLD: DEFAULT_S_MEDIUM_FONT_STYLE_OLD$1,
  DEFAULT_S_MEDIUM_FONT_WEIGHT: DEFAULT_S_MEDIUM_FONT_WEIGHT$1,
  DEFAULT_S_MEDIUM_LETTER_SPACING: DEFAULT_S_MEDIUM_LETTER_SPACING$1,
  DEFAULT_S_MEDIUM_LINE_HEIGHT: DEFAULT_S_MEDIUM_LINE_HEIGHT$1,
  DEFAULT_S_MEDIUM_PARAGRAPH_INDENT: DEFAULT_S_MEDIUM_PARAGRAPH_INDENT$1,
  DEFAULT_S_MEDIUM_PARAGRAPH_SPACING: DEFAULT_S_MEDIUM_PARAGRAPH_SPACING$1,
  DEFAULT_S_MEDIUM_TEXT_CASE: DEFAULT_S_MEDIUM_TEXT_CASE$1,
  DEFAULT_S_MEDIUM_TEXT_DECORATION: DEFAULT_S_MEDIUM_TEXT_DECORATION$1,
  DEFAULT_S_PARAGRAPH_INDENT: DEFAULT_S_PARAGRAPH_INDENT$1,
  DEFAULT_S_PARAGRAPH_SPACING: DEFAULT_S_PARAGRAPH_SPACING$1,
  DEFAULT_S_TEXT_CASE: DEFAULT_S_TEXT_CASE$1,
  DEFAULT_S_TEXT_DECORATION: DEFAULT_S_TEXT_DECORATION$1,
  DEFAULT_XL_BOLD_FONT_FAMILY: DEFAULT_XL_BOLD_FONT_FAMILY$1,
  DEFAULT_XL_BOLD_FONT_SIZE: DEFAULT_XL_BOLD_FONT_SIZE$1,
  DEFAULT_XL_BOLD_FONT_STRETCH: DEFAULT_XL_BOLD_FONT_STRETCH$1,
  DEFAULT_XL_BOLD_FONT_STYLE: DEFAULT_XL_BOLD_FONT_STYLE$1,
  DEFAULT_XL_BOLD_FONT_STYLE_OLD: DEFAULT_XL_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_XL_BOLD_FONT_WEIGHT: DEFAULT_XL_BOLD_FONT_WEIGHT$1,
  DEFAULT_XL_BOLD_LETTER_SPACING: DEFAULT_XL_BOLD_LETTER_SPACING$1,
  DEFAULT_XL_BOLD_LINE_HEIGHT: DEFAULT_XL_BOLD_LINE_HEIGHT$1,
  DEFAULT_XL_BOLD_PARAGRAPH_INDENT: DEFAULT_XL_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_XL_BOLD_PARAGRAPH_SPACING: DEFAULT_XL_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_XL_BOLD_TEXT_CASE: DEFAULT_XL_BOLD_TEXT_CASE$1,
  DEFAULT_XL_BOLD_TEXT_DECORATION: DEFAULT_XL_BOLD_TEXT_DECORATION$1,
  DEFAULT_XL_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_XL_CONDENSED_BOLD_FONT_FAMILY$1,
  DEFAULT_XL_CONDENSED_BOLD_FONT_SIZE: DEFAULT_XL_CONDENSED_BOLD_FONT_SIZE$1,
  DEFAULT_XL_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_XL_CONDENSED_BOLD_FONT_STRETCH$1,
  DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE: DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE$1,
  DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_XL_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_XL_CONDENSED_BOLD_FONT_WEIGHT$1,
  DEFAULT_XL_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_XL_CONDENSED_BOLD_LETTER_SPACING$1,
  DEFAULT_XL_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_XL_CONDENSED_BOLD_LINE_HEIGHT$1,
  DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_XL_CONDENSED_BOLD_TEXT_CASE: DEFAULT_XL_CONDENSED_BOLD_TEXT_CASE$1,
  DEFAULT_XL_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_XL_CONDENSED_BOLD_TEXT_DECORATION$1,
  DEFAULT_XL_CONDENSED_FONT_FAMILY: DEFAULT_XL_CONDENSED_FONT_FAMILY$1,
  DEFAULT_XL_CONDENSED_FONT_SIZE: DEFAULT_XL_CONDENSED_FONT_SIZE$1,
  DEFAULT_XL_CONDENSED_FONT_STRETCH: DEFAULT_XL_CONDENSED_FONT_STRETCH$1,
  DEFAULT_XL_CONDENSED_FONT_STYLE: DEFAULT_XL_CONDENSED_FONT_STYLE$1,
  DEFAULT_XL_CONDENSED_FONT_STYLE_OLD: DEFAULT_XL_CONDENSED_FONT_STYLE_OLD$1,
  DEFAULT_XL_CONDENSED_FONT_WEIGHT: DEFAULT_XL_CONDENSED_FONT_WEIGHT$1,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_XL_CONDENSED_HEAVY_FONT_SIZE$1,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE$1,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  DEFAULT_XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  DEFAULT_XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_XL_CONDENSED_HEAVY_TEXT_CASE$1,
  DEFAULT_XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  DEFAULT_XL_CONDENSED_LETTER_SPACING: DEFAULT_XL_CONDENSED_LETTER_SPACING$1,
  DEFAULT_XL_CONDENSED_LINE_HEIGHT: DEFAULT_XL_CONDENSED_LINE_HEIGHT$1,
  DEFAULT_XL_CONDENSED_PARAGRAPH_INDENT: DEFAULT_XL_CONDENSED_PARAGRAPH_INDENT$1,
  DEFAULT_XL_CONDENSED_PARAGRAPH_SPACING: DEFAULT_XL_CONDENSED_PARAGRAPH_SPACING$1,
  DEFAULT_XL_CONDENSED_TEXT_CASE: DEFAULT_XL_CONDENSED_TEXT_CASE$1,
  DEFAULT_XL_CONDENSED_TEXT_DECORATION: DEFAULT_XL_CONDENSED_TEXT_DECORATION$1,
  DEFAULT_XL_FONT_FAMILY: DEFAULT_XL_FONT_FAMILY$1,
  DEFAULT_XL_FONT_SIZE: DEFAULT_XL_FONT_SIZE$1,
  DEFAULT_XL_FONT_STRETCH: DEFAULT_XL_FONT_STRETCH$1,
  DEFAULT_XL_FONT_STYLE: DEFAULT_XL_FONT_STYLE$1,
  DEFAULT_XL_FONT_STYLE_OLD: DEFAULT_XL_FONT_STYLE_OLD$1,
  DEFAULT_XL_FONT_WEIGHT: DEFAULT_XL_FONT_WEIGHT$1,
  DEFAULT_XL_HEAVY_FONT_FAMILY: DEFAULT_XL_HEAVY_FONT_FAMILY$1,
  DEFAULT_XL_HEAVY_FONT_SIZE: DEFAULT_XL_HEAVY_FONT_SIZE$1,
  DEFAULT_XL_HEAVY_FONT_STRETCH: DEFAULT_XL_HEAVY_FONT_STRETCH$1,
  DEFAULT_XL_HEAVY_FONT_STYLE: DEFAULT_XL_HEAVY_FONT_STYLE$1,
  DEFAULT_XL_HEAVY_FONT_STYLE_OLD: DEFAULT_XL_HEAVY_FONT_STYLE_OLD$1,
  DEFAULT_XL_HEAVY_FONT_WEIGHT: DEFAULT_XL_HEAVY_FONT_WEIGHT$1,
  DEFAULT_XL_HEAVY_LETTER_SPACING: DEFAULT_XL_HEAVY_LETTER_SPACING$1,
  DEFAULT_XL_HEAVY_LINE_HEIGHT: DEFAULT_XL_HEAVY_LINE_HEIGHT$1,
  DEFAULT_XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_XL_HEAVY_PARAGRAPH_INDENT$1,
  DEFAULT_XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_XL_HEAVY_PARAGRAPH_SPACING$1,
  DEFAULT_XL_HEAVY_TEXT_CASE: DEFAULT_XL_HEAVY_TEXT_CASE$1,
  DEFAULT_XL_HEAVY_TEXT_DECORATION: DEFAULT_XL_HEAVY_TEXT_DECORATION$1,
  DEFAULT_XL_ITALIC_FONT_FAMILY: DEFAULT_XL_ITALIC_FONT_FAMILY$1,
  DEFAULT_XL_ITALIC_FONT_SIZE: DEFAULT_XL_ITALIC_FONT_SIZE$1,
  DEFAULT_XL_ITALIC_FONT_STRETCH: DEFAULT_XL_ITALIC_FONT_STRETCH$1,
  DEFAULT_XL_ITALIC_FONT_STYLE: DEFAULT_XL_ITALIC_FONT_STYLE$1,
  DEFAULT_XL_ITALIC_FONT_STYLE_OLD: DEFAULT_XL_ITALIC_FONT_STYLE_OLD$1,
  DEFAULT_XL_ITALIC_FONT_WEIGHT: DEFAULT_XL_ITALIC_FONT_WEIGHT$1,
  DEFAULT_XL_ITALIC_LETTER_SPACING: DEFAULT_XL_ITALIC_LETTER_SPACING$1,
  DEFAULT_XL_ITALIC_LINE_HEIGHT: DEFAULT_XL_ITALIC_LINE_HEIGHT$1,
  DEFAULT_XL_ITALIC_PARAGRAPH_INDENT: DEFAULT_XL_ITALIC_PARAGRAPH_INDENT$1,
  DEFAULT_XL_ITALIC_PARAGRAPH_SPACING: DEFAULT_XL_ITALIC_PARAGRAPH_SPACING$1,
  DEFAULT_XL_ITALIC_TEXT_CASE: DEFAULT_XL_ITALIC_TEXT_CASE$1,
  DEFAULT_XL_ITALIC_TEXT_DECORATION: DEFAULT_XL_ITALIC_TEXT_DECORATION$1,
  DEFAULT_XL_LETTER_SPACING: DEFAULT_XL_LETTER_SPACING$1,
  DEFAULT_XL_LINE_HEIGHT: DEFAULT_XL_LINE_HEIGHT$1,
  DEFAULT_XL_PARAGRAPH_INDENT: DEFAULT_XL_PARAGRAPH_INDENT$1,
  DEFAULT_XL_PARAGRAPH_SPACING: DEFAULT_XL_PARAGRAPH_SPACING$1,
  DEFAULT_XL_TEXT_CASE: DEFAULT_XL_TEXT_CASE$1,
  DEFAULT_XL_TEXT_DECORATION: DEFAULT_XL_TEXT_DECORATION$1,
  DEFAULT_XS_AC_FONT_FAMILY: DEFAULT_XS_AC_FONT_FAMILY$1,
  DEFAULT_XS_AC_FONT_SIZE: DEFAULT_XS_AC_FONT_SIZE$1,
  DEFAULT_XS_AC_FONT_STRETCH: DEFAULT_XS_AC_FONT_STRETCH$1,
  DEFAULT_XS_AC_FONT_STYLE: DEFAULT_XS_AC_FONT_STYLE$1,
  DEFAULT_XS_AC_FONT_STYLE_OLD: DEFAULT_XS_AC_FONT_STYLE_OLD$1,
  DEFAULT_XS_AC_FONT_WEIGHT: DEFAULT_XS_AC_FONT_WEIGHT$1,
  DEFAULT_XS_AC_LETTER_SPACING: DEFAULT_XS_AC_LETTER_SPACING$1,
  DEFAULT_XS_AC_LINE_HEIGHT: DEFAULT_XS_AC_LINE_HEIGHT$1,
  DEFAULT_XS_AC_PARAGRAPH_INDENT: DEFAULT_XS_AC_PARAGRAPH_INDENT$1,
  DEFAULT_XS_AC_PARAGRAPH_SPACING: DEFAULT_XS_AC_PARAGRAPH_SPACING$1,
  DEFAULT_XS_AC_TEXT_CASE: DEFAULT_XS_AC_TEXT_CASE$1,
  DEFAULT_XS_AC_TEXT_DECORATION: DEFAULT_XS_AC_TEXT_DECORATION$1,
  DEFAULT_XS_BOLD_AC_FONT_FAMILY: DEFAULT_XS_BOLD_AC_FONT_FAMILY$1,
  DEFAULT_XS_BOLD_AC_FONT_SIZE: DEFAULT_XS_BOLD_AC_FONT_SIZE$1,
  DEFAULT_XS_BOLD_AC_FONT_STRETCH: DEFAULT_XS_BOLD_AC_FONT_STRETCH$1,
  DEFAULT_XS_BOLD_AC_FONT_STYLE: DEFAULT_XS_BOLD_AC_FONT_STYLE$1,
  DEFAULT_XS_BOLD_AC_FONT_STYLE_OLD: DEFAULT_XS_BOLD_AC_FONT_STYLE_OLD$1,
  DEFAULT_XS_BOLD_AC_FONT_WEIGHT: DEFAULT_XS_BOLD_AC_FONT_WEIGHT$1,
  DEFAULT_XS_BOLD_AC_LETTER_SPACING: DEFAULT_XS_BOLD_AC_LETTER_SPACING$1,
  DEFAULT_XS_BOLD_AC_LINE_HEIGHT: DEFAULT_XS_BOLD_AC_LINE_HEIGHT$1,
  DEFAULT_XS_BOLD_AC_PARAGRAPH_INDENT: DEFAULT_XS_BOLD_AC_PARAGRAPH_INDENT$1,
  DEFAULT_XS_BOLD_AC_PARAGRAPH_SPACING: DEFAULT_XS_BOLD_AC_PARAGRAPH_SPACING$1,
  DEFAULT_XS_BOLD_AC_TEXT_CASE: DEFAULT_XS_BOLD_AC_TEXT_CASE$1,
  DEFAULT_XS_BOLD_AC_TEXT_DECORATION: DEFAULT_XS_BOLD_AC_TEXT_DECORATION$1,
  DEFAULT_XS_BOLD_FONT_FAMILY: DEFAULT_XS_BOLD_FONT_FAMILY$1,
  DEFAULT_XS_BOLD_FONT_SIZE: DEFAULT_XS_BOLD_FONT_SIZE$1,
  DEFAULT_XS_BOLD_FONT_STRETCH: DEFAULT_XS_BOLD_FONT_STRETCH$1,
  DEFAULT_XS_BOLD_FONT_STYLE: DEFAULT_XS_BOLD_FONT_STYLE$1,
  DEFAULT_XS_BOLD_FONT_STYLE_OLD: DEFAULT_XS_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_XS_BOLD_FONT_WEIGHT: DEFAULT_XS_BOLD_FONT_WEIGHT$1,
  DEFAULT_XS_BOLD_LETTER_SPACING: DEFAULT_XS_BOLD_LETTER_SPACING$1,
  DEFAULT_XS_BOLD_LINE_HEIGHT: DEFAULT_XS_BOLD_LINE_HEIGHT$1,
  DEFAULT_XS_BOLD_PARAGRAPH_INDENT: DEFAULT_XS_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_XS_BOLD_PARAGRAPH_SPACING: DEFAULT_XS_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_XS_BOLD_TEXT_CASE: DEFAULT_XS_BOLD_TEXT_CASE$1,
  DEFAULT_XS_BOLD_TEXT_DECORATION: DEFAULT_XS_BOLD_TEXT_DECORATION$1,
  DEFAULT_XS_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_XS_CONDENSED_BOLD_FONT_FAMILY$1,
  DEFAULT_XS_CONDENSED_BOLD_FONT_SIZE: DEFAULT_XS_CONDENSED_BOLD_FONT_SIZE$1,
  DEFAULT_XS_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_XS_CONDENSED_BOLD_FONT_STRETCH$1,
  DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE: DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE$1,
  DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE_OLD$1,
  DEFAULT_XS_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_XS_CONDENSED_BOLD_FONT_WEIGHT$1,
  DEFAULT_XS_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_XS_CONDENSED_BOLD_LETTER_SPACING$1,
  DEFAULT_XS_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_XS_CONDENSED_BOLD_LINE_HEIGHT$1,
  DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT$1,
  DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING$1,
  DEFAULT_XS_CONDENSED_BOLD_TEXT_CASE: DEFAULT_XS_CONDENSED_BOLD_TEXT_CASE$1,
  DEFAULT_XS_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_XS_CONDENSED_BOLD_TEXT_DECORATION$1,
  DEFAULT_XS_FONT_FAMILY: DEFAULT_XS_FONT_FAMILY$1,
  DEFAULT_XS_FONT_SIZE: DEFAULT_XS_FONT_SIZE$1,
  DEFAULT_XS_FONT_STRETCH: DEFAULT_XS_FONT_STRETCH$1,
  DEFAULT_XS_FONT_STYLE: DEFAULT_XS_FONT_STYLE$1,
  DEFAULT_XS_FONT_STYLE_OLD: DEFAULT_XS_FONT_STYLE_OLD$1,
  DEFAULT_XS_FONT_WEIGHT: DEFAULT_XS_FONT_WEIGHT$1,
  DEFAULT_XS_ITALIC_FONT_FAMILY: DEFAULT_XS_ITALIC_FONT_FAMILY$1,
  DEFAULT_XS_ITALIC_FONT_SIZE: DEFAULT_XS_ITALIC_FONT_SIZE$1,
  DEFAULT_XS_ITALIC_FONT_STRETCH: DEFAULT_XS_ITALIC_FONT_STRETCH$1,
  DEFAULT_XS_ITALIC_FONT_STYLE: DEFAULT_XS_ITALIC_FONT_STYLE$1,
  DEFAULT_XS_ITALIC_FONT_STYLE_OLD: DEFAULT_XS_ITALIC_FONT_STYLE_OLD$1,
  DEFAULT_XS_ITALIC_FONT_WEIGHT: DEFAULT_XS_ITALIC_FONT_WEIGHT$1,
  DEFAULT_XS_ITALIC_LETTER_SPACING: DEFAULT_XS_ITALIC_LETTER_SPACING$1,
  DEFAULT_XS_ITALIC_LINE_HEIGHT: DEFAULT_XS_ITALIC_LINE_HEIGHT$1,
  DEFAULT_XS_ITALIC_PARAGRAPH_INDENT: DEFAULT_XS_ITALIC_PARAGRAPH_INDENT$1,
  DEFAULT_XS_ITALIC_PARAGRAPH_SPACING: DEFAULT_XS_ITALIC_PARAGRAPH_SPACING$1,
  DEFAULT_XS_ITALIC_TEXT_CASE: DEFAULT_XS_ITALIC_TEXT_CASE$1,
  DEFAULT_XS_ITALIC_TEXT_DECORATION: DEFAULT_XS_ITALIC_TEXT_DECORATION$1,
  DEFAULT_XS_LETTER_SPACING: DEFAULT_XS_LETTER_SPACING$1,
  DEFAULT_XS_LINE_HEIGHT: DEFAULT_XS_LINE_HEIGHT$1,
  DEFAULT_XS_PARAGRAPH_INDENT: DEFAULT_XS_PARAGRAPH_INDENT$1,
  DEFAULT_XS_PARAGRAPH_SPACING: DEFAULT_XS_PARAGRAPH_SPACING$1,
  DEFAULT_XS_TEXT_CASE: DEFAULT_XS_TEXT_CASE$1,
  DEFAULT_XS_TEXT_DECORATION: DEFAULT_XS_TEXT_DECORATION$1,
  YLE_NEXT_2XL_BOLD_FONT_FAMILY: YLE_NEXT_2XL_BOLD_FONT_FAMILY$1,
  YLE_NEXT_2XL_BOLD_FONT_SIZE: YLE_NEXT_2XL_BOLD_FONT_SIZE$1,
  YLE_NEXT_2XL_BOLD_FONT_STRETCH: YLE_NEXT_2XL_BOLD_FONT_STRETCH$1,
  YLE_NEXT_2XL_BOLD_FONT_STYLE: YLE_NEXT_2XL_BOLD_FONT_STYLE$1,
  YLE_NEXT_2XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_2XL_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_2XL_BOLD_FONT_WEIGHT: YLE_NEXT_2XL_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_2XL_BOLD_LETTER_SPACING: YLE_NEXT_2XL_BOLD_LETTER_SPACING$1,
  YLE_NEXT_2XL_BOLD_LINE_HEIGHT: YLE_NEXT_2XL_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_2XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_2XL_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_2XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_2XL_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_2XL_BOLD_TEXT_CASE: YLE_NEXT_2XL_BOLD_TEXT_CASE$1,
  YLE_NEXT_2XL_BOLD_TEXT_DECORATION: YLE_NEXT_2XL_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_FAMILY$1,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_SIZE$1,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STRETCH$1,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE$1,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_2XL_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_2XL_CONDENSED_BOLD_LETTER_SPACING$1,
  YLE_NEXT_2XL_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_2XL_CONDENSED_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_CASE$1,
  YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_SIZE$1,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE$1,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_2XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_2XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_2XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_2XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_CASE$1,
  YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_2XL_FONT_FAMILY: YLE_NEXT_2XL_FONT_FAMILY$1,
  YLE_NEXT_2XL_FONT_SIZE: YLE_NEXT_2XL_FONT_SIZE$1,
  YLE_NEXT_2XL_FONT_STRETCH: YLE_NEXT_2XL_FONT_STRETCH$1,
  YLE_NEXT_2XL_FONT_STYLE: YLE_NEXT_2XL_FONT_STYLE$1,
  YLE_NEXT_2XL_FONT_STYLE_OLD: YLE_NEXT_2XL_FONT_STYLE_OLD$1,
  YLE_NEXT_2XL_FONT_WEIGHT: YLE_NEXT_2XL_FONT_WEIGHT$1,
  YLE_NEXT_2XL_HEAVY_FONT_FAMILY: YLE_NEXT_2XL_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_2XL_HEAVY_FONT_SIZE: YLE_NEXT_2XL_HEAVY_FONT_SIZE$1,
  YLE_NEXT_2XL_HEAVY_FONT_STRETCH: YLE_NEXT_2XL_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_2XL_HEAVY_FONT_STYLE: YLE_NEXT_2XL_HEAVY_FONT_STYLE$1,
  YLE_NEXT_2XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_2XL_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_2XL_HEAVY_FONT_WEIGHT: YLE_NEXT_2XL_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_2XL_HEAVY_LETTER_SPACING: YLE_NEXT_2XL_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_2XL_HEAVY_LINE_HEIGHT: YLE_NEXT_2XL_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_2XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_2XL_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_2XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_2XL_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_2XL_HEAVY_TEXT_CASE: YLE_NEXT_2XL_HEAVY_TEXT_CASE$1,
  YLE_NEXT_2XL_HEAVY_TEXT_DECORATION: YLE_NEXT_2XL_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_2XL_LETTER_SPACING: YLE_NEXT_2XL_LETTER_SPACING$1,
  YLE_NEXT_2XL_LINE_HEIGHT: YLE_NEXT_2XL_LINE_HEIGHT$1,
  YLE_NEXT_2XL_PARAGRAPH_INDENT: YLE_NEXT_2XL_PARAGRAPH_INDENT$1,
  YLE_NEXT_2XL_PARAGRAPH_SPACING: YLE_NEXT_2XL_PARAGRAPH_SPACING$1,
  YLE_NEXT_2XL_TEXT_CASE: YLE_NEXT_2XL_TEXT_CASE$1,
  YLE_NEXT_2XL_TEXT_DECORATION: YLE_NEXT_2XL_TEXT_DECORATION$1,
  YLE_NEXT_3XL_BOLD_FONT_FAMILY: YLE_NEXT_3XL_BOLD_FONT_FAMILY$1,
  YLE_NEXT_3XL_BOLD_FONT_SIZE: YLE_NEXT_3XL_BOLD_FONT_SIZE$1,
  YLE_NEXT_3XL_BOLD_FONT_STRETCH: YLE_NEXT_3XL_BOLD_FONT_STRETCH$1,
  YLE_NEXT_3XL_BOLD_FONT_STYLE: YLE_NEXT_3XL_BOLD_FONT_STYLE$1,
  YLE_NEXT_3XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_3XL_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_3XL_BOLD_FONT_WEIGHT: YLE_NEXT_3XL_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_3XL_BOLD_LETTER_SPACING: YLE_NEXT_3XL_BOLD_LETTER_SPACING$1,
  YLE_NEXT_3XL_BOLD_LINE_HEIGHT: YLE_NEXT_3XL_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_3XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_3XL_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_3XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_3XL_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_3XL_BOLD_TEXT_CASE: YLE_NEXT_3XL_BOLD_TEXT_CASE$1,
  YLE_NEXT_3XL_BOLD_TEXT_DECORATION: YLE_NEXT_3XL_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_SIZE$1,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE$1,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_3XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_3XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_3XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_3XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_CASE$1,
  YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_3XL_HEAVY_FONT_FAMILY: YLE_NEXT_3XL_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_3XL_HEAVY_FONT_SIZE: YLE_NEXT_3XL_HEAVY_FONT_SIZE$1,
  YLE_NEXT_3XL_HEAVY_FONT_STRETCH: YLE_NEXT_3XL_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_3XL_HEAVY_FONT_STYLE: YLE_NEXT_3XL_HEAVY_FONT_STYLE$1,
  YLE_NEXT_3XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_3XL_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_3XL_HEAVY_FONT_WEIGHT: YLE_NEXT_3XL_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_3XL_HEAVY_LETTER_SPACING: YLE_NEXT_3XL_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_3XL_HEAVY_LINE_HEIGHT: YLE_NEXT_3XL_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_3XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_3XL_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_3XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_3XL_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_3XL_HEAVY_TEXT_CASE: YLE_NEXT_3XL_HEAVY_TEXT_CASE$1,
  YLE_NEXT_3XL_HEAVY_TEXT_DECORATION: YLE_NEXT_3XL_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_4XL_BOLD_FONT_FAMILY: YLE_NEXT_4XL_BOLD_FONT_FAMILY$1,
  YLE_NEXT_4XL_BOLD_FONT_SIZE: YLE_NEXT_4XL_BOLD_FONT_SIZE$1,
  YLE_NEXT_4XL_BOLD_FONT_STRETCH: YLE_NEXT_4XL_BOLD_FONT_STRETCH$1,
  YLE_NEXT_4XL_BOLD_FONT_STYLE: YLE_NEXT_4XL_BOLD_FONT_STYLE$1,
  YLE_NEXT_4XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_4XL_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_4XL_BOLD_FONT_WEIGHT: YLE_NEXT_4XL_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_4XL_BOLD_LETTER_SPACING: YLE_NEXT_4XL_BOLD_LETTER_SPACING$1,
  YLE_NEXT_4XL_BOLD_LINE_HEIGHT: YLE_NEXT_4XL_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_4XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_4XL_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_4XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_4XL_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_4XL_BOLD_TEXT_CASE: YLE_NEXT_4XL_BOLD_TEXT_CASE$1,
  YLE_NEXT_4XL_BOLD_TEXT_DECORATION: YLE_NEXT_4XL_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_SIZE$1,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE$1,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_4XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_4XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_4XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_4XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_CASE$1,
  YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_4XL_HEAVY_FONT_FAMILY: YLE_NEXT_4XL_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_4XL_HEAVY_FONT_SIZE: YLE_NEXT_4XL_HEAVY_FONT_SIZE$1,
  YLE_NEXT_4XL_HEAVY_FONT_STRETCH: YLE_NEXT_4XL_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_4XL_HEAVY_FONT_STYLE: YLE_NEXT_4XL_HEAVY_FONT_STYLE$1,
  YLE_NEXT_4XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_4XL_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_4XL_HEAVY_FONT_WEIGHT: YLE_NEXT_4XL_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_4XL_HEAVY_LETTER_SPACING: YLE_NEXT_4XL_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_4XL_HEAVY_LINE_HEIGHT: YLE_NEXT_4XL_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_4XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_4XL_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_4XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_4XL_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_4XL_HEAVY_TEXT_CASE: YLE_NEXT_4XL_HEAVY_TEXT_CASE$1,
  YLE_NEXT_4XL_HEAVY_TEXT_DECORATION: YLE_NEXT_4XL_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_5XL_BOLD_FONT_FAMILY: YLE_NEXT_5XL_BOLD_FONT_FAMILY$1,
  YLE_NEXT_5XL_BOLD_FONT_SIZE: YLE_NEXT_5XL_BOLD_FONT_SIZE$1,
  YLE_NEXT_5XL_BOLD_FONT_STRETCH: YLE_NEXT_5XL_BOLD_FONT_STRETCH$1,
  YLE_NEXT_5XL_BOLD_FONT_STYLE: YLE_NEXT_5XL_BOLD_FONT_STYLE$1,
  YLE_NEXT_5XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_5XL_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_5XL_BOLD_FONT_WEIGHT: YLE_NEXT_5XL_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_5XL_BOLD_LETTER_SPACING: YLE_NEXT_5XL_BOLD_LETTER_SPACING$1,
  YLE_NEXT_5XL_BOLD_LINE_HEIGHT: YLE_NEXT_5XL_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_5XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_5XL_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_5XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_5XL_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_5XL_BOLD_TEXT_CASE: YLE_NEXT_5XL_BOLD_TEXT_CASE$1,
  YLE_NEXT_5XL_BOLD_TEXT_DECORATION: YLE_NEXT_5XL_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_SIZE$1,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE$1,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_5XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_5XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_5XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_5XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_CASE$1,
  YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_5XL_HEAVY_FONT_FAMILY: YLE_NEXT_5XL_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_5XL_HEAVY_FONT_SIZE: YLE_NEXT_5XL_HEAVY_FONT_SIZE$1,
  YLE_NEXT_5XL_HEAVY_FONT_STRETCH: YLE_NEXT_5XL_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_5XL_HEAVY_FONT_STYLE: YLE_NEXT_5XL_HEAVY_FONT_STYLE$1,
  YLE_NEXT_5XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_5XL_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_5XL_HEAVY_FONT_WEIGHT: YLE_NEXT_5XL_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_5XL_HEAVY_LETTER_SPACING: YLE_NEXT_5XL_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_5XL_HEAVY_LINE_HEIGHT: YLE_NEXT_5XL_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_5XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_5XL_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_5XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_5XL_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_5XL_HEAVY_TEXT_CASE: YLE_NEXT_5XL_HEAVY_TEXT_CASE$1,
  YLE_NEXT_5XL_HEAVY_TEXT_DECORATION: YLE_NEXT_5XL_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_6XL_BOLD_FONT_FAMILY: YLE_NEXT_6XL_BOLD_FONT_FAMILY$1,
  YLE_NEXT_6XL_BOLD_FONT_SIZE: YLE_NEXT_6XL_BOLD_FONT_SIZE$1,
  YLE_NEXT_6XL_BOLD_FONT_STRETCH: YLE_NEXT_6XL_BOLD_FONT_STRETCH$1,
  YLE_NEXT_6XL_BOLD_FONT_STYLE: YLE_NEXT_6XL_BOLD_FONT_STYLE$1,
  YLE_NEXT_6XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_6XL_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_6XL_BOLD_FONT_WEIGHT: YLE_NEXT_6XL_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_6XL_BOLD_LETTER_SPACING: YLE_NEXT_6XL_BOLD_LETTER_SPACING$1,
  YLE_NEXT_6XL_BOLD_LINE_HEIGHT: YLE_NEXT_6XL_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_6XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_6XL_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_6XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_6XL_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_6XL_BOLD_TEXT_CASE: YLE_NEXT_6XL_BOLD_TEXT_CASE$1,
  YLE_NEXT_6XL_BOLD_TEXT_DECORATION: YLE_NEXT_6XL_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_SIZE$1,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE$1,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_6XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_6XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_6XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_6XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_CASE$1,
  YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_6XL_HEAVY_FONT_FAMILY: YLE_NEXT_6XL_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_6XL_HEAVY_FONT_SIZE: YLE_NEXT_6XL_HEAVY_FONT_SIZE$1,
  YLE_NEXT_6XL_HEAVY_FONT_STRETCH: YLE_NEXT_6XL_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_6XL_HEAVY_FONT_STYLE: YLE_NEXT_6XL_HEAVY_FONT_STYLE$1,
  YLE_NEXT_6XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_6XL_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_6XL_HEAVY_FONT_WEIGHT: YLE_NEXT_6XL_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_6XL_HEAVY_LETTER_SPACING: YLE_NEXT_6XL_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_6XL_HEAVY_LINE_HEIGHT: YLE_NEXT_6XL_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_6XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_6XL_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_6XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_6XL_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_6XL_HEAVY_TEXT_CASE: YLE_NEXT_6XL_HEAVY_TEXT_CASE$1,
  YLE_NEXT_6XL_HEAVY_TEXT_DECORATION: YLE_NEXT_6XL_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_7XL_BOLD_FONT_FAMILY: YLE_NEXT_7XL_BOLD_FONT_FAMILY$1,
  YLE_NEXT_7XL_BOLD_FONT_SIZE: YLE_NEXT_7XL_BOLD_FONT_SIZE$1,
  YLE_NEXT_7XL_BOLD_FONT_STRETCH: YLE_NEXT_7XL_BOLD_FONT_STRETCH$1,
  YLE_NEXT_7XL_BOLD_FONT_STYLE: YLE_NEXT_7XL_BOLD_FONT_STYLE$1,
  YLE_NEXT_7XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_7XL_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_7XL_BOLD_FONT_WEIGHT: YLE_NEXT_7XL_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_7XL_BOLD_LETTER_SPACING: YLE_NEXT_7XL_BOLD_LETTER_SPACING$1,
  YLE_NEXT_7XL_BOLD_LINE_HEIGHT: YLE_NEXT_7XL_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_7XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_7XL_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_7XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_7XL_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_7XL_BOLD_TEXT_CASE: YLE_NEXT_7XL_BOLD_TEXT_CASE$1,
  YLE_NEXT_7XL_BOLD_TEXT_DECORATION: YLE_NEXT_7XL_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_SIZE$1,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE$1,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_7XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_7XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_7XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_7XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_CASE$1,
  YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_7XL_HEAVY_FONT_FAMILY: YLE_NEXT_7XL_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_7XL_HEAVY_FONT_SIZE: YLE_NEXT_7XL_HEAVY_FONT_SIZE$1,
  YLE_NEXT_7XL_HEAVY_FONT_STRETCH: YLE_NEXT_7XL_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_7XL_HEAVY_FONT_STYLE: YLE_NEXT_7XL_HEAVY_FONT_STYLE$1,
  YLE_NEXT_7XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_7XL_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_7XL_HEAVY_FONT_WEIGHT: YLE_NEXT_7XL_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_7XL_HEAVY_LETTER_SPACING: YLE_NEXT_7XL_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_7XL_HEAVY_LINE_HEIGHT: YLE_NEXT_7XL_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_7XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_7XL_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_7XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_7XL_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_7XL_HEAVY_TEXT_CASE: YLE_NEXT_7XL_HEAVY_TEXT_CASE$1,
  YLE_NEXT_7XL_HEAVY_TEXT_DECORATION: YLE_NEXT_7XL_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_L_BOLD_FONT_FAMILY: YLE_NEXT_L_BOLD_FONT_FAMILY$1,
  YLE_NEXT_L_BOLD_FONT_SIZE: YLE_NEXT_L_BOLD_FONT_SIZE$1,
  YLE_NEXT_L_BOLD_FONT_STRETCH: YLE_NEXT_L_BOLD_FONT_STRETCH$1,
  YLE_NEXT_L_BOLD_FONT_STYLE: YLE_NEXT_L_BOLD_FONT_STYLE$1,
  YLE_NEXT_L_BOLD_FONT_STYLE_OLD: YLE_NEXT_L_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_L_BOLD_FONT_WEIGHT: YLE_NEXT_L_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_L_BOLD_LETTER_SPACING: YLE_NEXT_L_BOLD_LETTER_SPACING$1,
  YLE_NEXT_L_BOLD_LINE_HEIGHT: YLE_NEXT_L_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_L_BOLD_PARAGRAPH_INDENT: YLE_NEXT_L_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_L_BOLD_PARAGRAPH_SPACING: YLE_NEXT_L_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_L_BOLD_TEXT_CASE: YLE_NEXT_L_BOLD_TEXT_CASE$1,
  YLE_NEXT_L_BOLD_TEXT_DECORATION: YLE_NEXT_L_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_L_CONDENSED_BOLD_FONT_FAMILY$1,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_L_CONDENSED_BOLD_FONT_SIZE$1,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_L_CONDENSED_BOLD_FONT_STRETCH$1,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE$1,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_L_CONDENSED_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_L_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_L_CONDENSED_BOLD_LETTER_SPACING$1,
  YLE_NEXT_L_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_L_CONDENSED_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_L_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_L_CONDENSED_BOLD_TEXT_CASE$1,
  YLE_NEXT_L_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_L_CONDENSED_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_L_CONDENSED_FONT_FAMILY: YLE_NEXT_L_CONDENSED_FONT_FAMILY$1,
  YLE_NEXT_L_CONDENSED_FONT_SIZE: YLE_NEXT_L_CONDENSED_FONT_SIZE$1,
  YLE_NEXT_L_CONDENSED_FONT_STRETCH: YLE_NEXT_L_CONDENSED_FONT_STRETCH$1,
  YLE_NEXT_L_CONDENSED_FONT_STYLE: YLE_NEXT_L_CONDENSED_FONT_STYLE$1,
  YLE_NEXT_L_CONDENSED_FONT_STYLE_OLD: YLE_NEXT_L_CONDENSED_FONT_STYLE_OLD$1,
  YLE_NEXT_L_CONDENSED_FONT_WEIGHT: YLE_NEXT_L_CONDENSED_FONT_WEIGHT$1,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_L_CONDENSED_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_L_CONDENSED_HEAVY_FONT_SIZE$1,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_L_CONDENSED_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE$1,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_L_CONDENSED_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_L_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_L_CONDENSED_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_L_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_L_CONDENSED_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_L_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_L_CONDENSED_HEAVY_TEXT_CASE$1,
  YLE_NEXT_L_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_L_CONDENSED_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_L_CONDENSED_LETTER_SPACING: YLE_NEXT_L_CONDENSED_LETTER_SPACING$1,
  YLE_NEXT_L_CONDENSED_LINE_HEIGHT: YLE_NEXT_L_CONDENSED_LINE_HEIGHT$1,
  YLE_NEXT_L_CONDENSED_PARAGRAPH_INDENT: YLE_NEXT_L_CONDENSED_PARAGRAPH_INDENT$1,
  YLE_NEXT_L_CONDENSED_PARAGRAPH_SPACING: YLE_NEXT_L_CONDENSED_PARAGRAPH_SPACING$1,
  YLE_NEXT_L_CONDENSED_TEXT_CASE: YLE_NEXT_L_CONDENSED_TEXT_CASE$1,
  YLE_NEXT_L_CONDENSED_TEXT_DECORATION: YLE_NEXT_L_CONDENSED_TEXT_DECORATION$1,
  YLE_NEXT_L_FONT_FAMILY: YLE_NEXT_L_FONT_FAMILY$1,
  YLE_NEXT_L_FONT_SIZE: YLE_NEXT_L_FONT_SIZE$1,
  YLE_NEXT_L_FONT_STRETCH: YLE_NEXT_L_FONT_STRETCH$1,
  YLE_NEXT_L_FONT_STYLE: YLE_NEXT_L_FONT_STYLE$1,
  YLE_NEXT_L_FONT_STYLE_OLD: YLE_NEXT_L_FONT_STYLE_OLD$1,
  YLE_NEXT_L_FONT_WEIGHT: YLE_NEXT_L_FONT_WEIGHT$1,
  YLE_NEXT_L_HEAVY_FONT_FAMILY: YLE_NEXT_L_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_L_HEAVY_FONT_SIZE: YLE_NEXT_L_HEAVY_FONT_SIZE$1,
  YLE_NEXT_L_HEAVY_FONT_STRETCH: YLE_NEXT_L_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_L_HEAVY_FONT_STYLE: YLE_NEXT_L_HEAVY_FONT_STYLE$1,
  YLE_NEXT_L_HEAVY_FONT_STYLE_OLD: YLE_NEXT_L_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_L_HEAVY_FONT_WEIGHT: YLE_NEXT_L_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_L_HEAVY_LETTER_SPACING: YLE_NEXT_L_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_L_HEAVY_LINE_HEIGHT: YLE_NEXT_L_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_L_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_L_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_L_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_L_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_L_HEAVY_TEXT_CASE: YLE_NEXT_L_HEAVY_TEXT_CASE$1,
  YLE_NEXT_L_HEAVY_TEXT_DECORATION: YLE_NEXT_L_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_L_ITALIC_FONT_FAMILY: YLE_NEXT_L_ITALIC_FONT_FAMILY$1,
  YLE_NEXT_L_ITALIC_FONT_SIZE: YLE_NEXT_L_ITALIC_FONT_SIZE$1,
  YLE_NEXT_L_ITALIC_FONT_STRETCH: YLE_NEXT_L_ITALIC_FONT_STRETCH$1,
  YLE_NEXT_L_ITALIC_FONT_STYLE: YLE_NEXT_L_ITALIC_FONT_STYLE$1,
  YLE_NEXT_L_ITALIC_FONT_STYLE_OLD: YLE_NEXT_L_ITALIC_FONT_STYLE_OLD$1,
  YLE_NEXT_L_ITALIC_FONT_WEIGHT: YLE_NEXT_L_ITALIC_FONT_WEIGHT$1,
  YLE_NEXT_L_ITALIC_LETTER_SPACING: YLE_NEXT_L_ITALIC_LETTER_SPACING$1,
  YLE_NEXT_L_ITALIC_LINE_HEIGHT: YLE_NEXT_L_ITALIC_LINE_HEIGHT$1,
  YLE_NEXT_L_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_L_ITALIC_PARAGRAPH_INDENT$1,
  YLE_NEXT_L_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_L_ITALIC_PARAGRAPH_SPACING$1,
  YLE_NEXT_L_ITALIC_TEXT_CASE: YLE_NEXT_L_ITALIC_TEXT_CASE$1,
  YLE_NEXT_L_ITALIC_TEXT_DECORATION: YLE_NEXT_L_ITALIC_TEXT_DECORATION$1,
  YLE_NEXT_L_LETTER_SPACING: YLE_NEXT_L_LETTER_SPACING$1,
  YLE_NEXT_L_LINE_HEIGHT: YLE_NEXT_L_LINE_HEIGHT$1,
  YLE_NEXT_L_PARAGRAPH_INDENT: YLE_NEXT_L_PARAGRAPH_INDENT$1,
  YLE_NEXT_L_PARAGRAPH_SPACING: YLE_NEXT_L_PARAGRAPH_SPACING$1,
  YLE_NEXT_L_TEXT_CASE: YLE_NEXT_L_TEXT_CASE$1,
  YLE_NEXT_L_TEXT_DECORATION: YLE_NEXT_L_TEXT_DECORATION$1,
  YLE_NEXT_M_AC_FONT_FAMILY: YLE_NEXT_M_AC_FONT_FAMILY$1,
  YLE_NEXT_M_AC_FONT_SIZE: YLE_NEXT_M_AC_FONT_SIZE$1,
  YLE_NEXT_M_AC_FONT_STRETCH: YLE_NEXT_M_AC_FONT_STRETCH$1,
  YLE_NEXT_M_AC_FONT_STYLE: YLE_NEXT_M_AC_FONT_STYLE$1,
  YLE_NEXT_M_AC_FONT_STYLE_OLD: YLE_NEXT_M_AC_FONT_STYLE_OLD$1,
  YLE_NEXT_M_AC_FONT_WEIGHT: YLE_NEXT_M_AC_FONT_WEIGHT$1,
  YLE_NEXT_M_AC_LETTER_SPACING: YLE_NEXT_M_AC_LETTER_SPACING$1,
  YLE_NEXT_M_AC_LINE_HEIGHT: YLE_NEXT_M_AC_LINE_HEIGHT$1,
  YLE_NEXT_M_AC_PARAGRAPH_INDENT: YLE_NEXT_M_AC_PARAGRAPH_INDENT$1,
  YLE_NEXT_M_AC_PARAGRAPH_SPACING: YLE_NEXT_M_AC_PARAGRAPH_SPACING$1,
  YLE_NEXT_M_AC_TEXT_CASE: YLE_NEXT_M_AC_TEXT_CASE$1,
  YLE_NEXT_M_AC_TEXT_DECORATION: YLE_NEXT_M_AC_TEXT_DECORATION$1,
  YLE_NEXT_M_BOLD_AC_FONT_FAMILY: YLE_NEXT_M_BOLD_AC_FONT_FAMILY$1,
  YLE_NEXT_M_BOLD_AC_FONT_SIZE: YLE_NEXT_M_BOLD_AC_FONT_SIZE$1,
  YLE_NEXT_M_BOLD_AC_FONT_STRETCH: YLE_NEXT_M_BOLD_AC_FONT_STRETCH$1,
  YLE_NEXT_M_BOLD_AC_FONT_STYLE: YLE_NEXT_M_BOLD_AC_FONT_STYLE$1,
  YLE_NEXT_M_BOLD_AC_FONT_STYLE_OLD: YLE_NEXT_M_BOLD_AC_FONT_STYLE_OLD$1,
  YLE_NEXT_M_BOLD_AC_FONT_WEIGHT: YLE_NEXT_M_BOLD_AC_FONT_WEIGHT$1,
  YLE_NEXT_M_BOLD_AC_LETTER_SPACING: YLE_NEXT_M_BOLD_AC_LETTER_SPACING$1,
  YLE_NEXT_M_BOLD_AC_LINE_HEIGHT: YLE_NEXT_M_BOLD_AC_LINE_HEIGHT$1,
  YLE_NEXT_M_BOLD_AC_PARAGRAPH_INDENT: YLE_NEXT_M_BOLD_AC_PARAGRAPH_INDENT$1,
  YLE_NEXT_M_BOLD_AC_PARAGRAPH_SPACING: YLE_NEXT_M_BOLD_AC_PARAGRAPH_SPACING$1,
  YLE_NEXT_M_BOLD_AC_TEXT_CASE: YLE_NEXT_M_BOLD_AC_TEXT_CASE$1,
  YLE_NEXT_M_BOLD_AC_TEXT_DECORATION: YLE_NEXT_M_BOLD_AC_TEXT_DECORATION$1,
  YLE_NEXT_M_BOLD_FONT_FAMILY: YLE_NEXT_M_BOLD_FONT_FAMILY$1,
  YLE_NEXT_M_BOLD_FONT_SIZE: YLE_NEXT_M_BOLD_FONT_SIZE$1,
  YLE_NEXT_M_BOLD_FONT_STRETCH: YLE_NEXT_M_BOLD_FONT_STRETCH$1,
  YLE_NEXT_M_BOLD_FONT_STYLE: YLE_NEXT_M_BOLD_FONT_STYLE$1,
  YLE_NEXT_M_BOLD_FONT_STYLE_OLD: YLE_NEXT_M_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_M_BOLD_FONT_WEIGHT: YLE_NEXT_M_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_M_BOLD_LETTER_SPACING: YLE_NEXT_M_BOLD_LETTER_SPACING$1,
  YLE_NEXT_M_BOLD_LINE_HEIGHT: YLE_NEXT_M_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_M_BOLD_PARAGRAPH_INDENT: YLE_NEXT_M_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_M_BOLD_PARAGRAPH_SPACING: YLE_NEXT_M_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_M_BOLD_TEXT_CASE: YLE_NEXT_M_BOLD_TEXT_CASE$1,
  YLE_NEXT_M_BOLD_TEXT_DECORATION: YLE_NEXT_M_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_M_CONDENSED_BOLD_FONT_FAMILY$1,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_M_CONDENSED_BOLD_FONT_SIZE$1,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_M_CONDENSED_BOLD_FONT_STRETCH$1,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE$1,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_M_CONDENSED_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_M_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_M_CONDENSED_BOLD_LETTER_SPACING$1,
  YLE_NEXT_M_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_M_CONDENSED_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_M_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_M_CONDENSED_BOLD_TEXT_CASE$1,
  YLE_NEXT_M_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_M_CONDENSED_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_M_CONDENSED_FONT_FAMILY: YLE_NEXT_M_CONDENSED_FONT_FAMILY$1,
  YLE_NEXT_M_CONDENSED_FONT_SIZE: YLE_NEXT_M_CONDENSED_FONT_SIZE$1,
  YLE_NEXT_M_CONDENSED_FONT_STRETCH: YLE_NEXT_M_CONDENSED_FONT_STRETCH$1,
  YLE_NEXT_M_CONDENSED_FONT_STYLE: YLE_NEXT_M_CONDENSED_FONT_STYLE$1,
  YLE_NEXT_M_CONDENSED_FONT_STYLE_OLD: YLE_NEXT_M_CONDENSED_FONT_STYLE_OLD$1,
  YLE_NEXT_M_CONDENSED_FONT_WEIGHT: YLE_NEXT_M_CONDENSED_FONT_WEIGHT$1,
  YLE_NEXT_M_CONDENSED_LETTER_SPACING: YLE_NEXT_M_CONDENSED_LETTER_SPACING$1,
  YLE_NEXT_M_CONDENSED_LINE_HEIGHT: YLE_NEXT_M_CONDENSED_LINE_HEIGHT$1,
  YLE_NEXT_M_CONDENSED_PARAGRAPH_INDENT: YLE_NEXT_M_CONDENSED_PARAGRAPH_INDENT$1,
  YLE_NEXT_M_CONDENSED_PARAGRAPH_SPACING: YLE_NEXT_M_CONDENSED_PARAGRAPH_SPACING$1,
  YLE_NEXT_M_CONDENSED_TEXT_CASE: YLE_NEXT_M_CONDENSED_TEXT_CASE$1,
  YLE_NEXT_M_CONDENSED_TEXT_DECORATION: YLE_NEXT_M_CONDENSED_TEXT_DECORATION$1,
  YLE_NEXT_M_FONT_FAMILY: YLE_NEXT_M_FONT_FAMILY$1,
  YLE_NEXT_M_FONT_SIZE: YLE_NEXT_M_FONT_SIZE$1,
  YLE_NEXT_M_FONT_STRETCH: YLE_NEXT_M_FONT_STRETCH$1,
  YLE_NEXT_M_FONT_STYLE: YLE_NEXT_M_FONT_STYLE$1,
  YLE_NEXT_M_FONT_STYLE_OLD: YLE_NEXT_M_FONT_STYLE_OLD$1,
  YLE_NEXT_M_FONT_WEIGHT: YLE_NEXT_M_FONT_WEIGHT$1,
  YLE_NEXT_M_ITALIC_FONT_FAMILY: YLE_NEXT_M_ITALIC_FONT_FAMILY$1,
  YLE_NEXT_M_ITALIC_FONT_SIZE: YLE_NEXT_M_ITALIC_FONT_SIZE$1,
  YLE_NEXT_M_ITALIC_FONT_STRETCH: YLE_NEXT_M_ITALIC_FONT_STRETCH$1,
  YLE_NEXT_M_ITALIC_FONT_STYLE: YLE_NEXT_M_ITALIC_FONT_STYLE$1,
  YLE_NEXT_M_ITALIC_FONT_STYLE_OLD: YLE_NEXT_M_ITALIC_FONT_STYLE_OLD$1,
  YLE_NEXT_M_ITALIC_FONT_WEIGHT: YLE_NEXT_M_ITALIC_FONT_WEIGHT$1,
  YLE_NEXT_M_ITALIC_LETTER_SPACING: YLE_NEXT_M_ITALIC_LETTER_SPACING$1,
  YLE_NEXT_M_ITALIC_LINE_HEIGHT: YLE_NEXT_M_ITALIC_LINE_HEIGHT$1,
  YLE_NEXT_M_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_M_ITALIC_PARAGRAPH_INDENT$1,
  YLE_NEXT_M_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_M_ITALIC_PARAGRAPH_SPACING$1,
  YLE_NEXT_M_ITALIC_TEXT_CASE: YLE_NEXT_M_ITALIC_TEXT_CASE$1,
  YLE_NEXT_M_ITALIC_TEXT_DECORATION: YLE_NEXT_M_ITALIC_TEXT_DECORATION$1,
  YLE_NEXT_M_LETTER_SPACING: YLE_NEXT_M_LETTER_SPACING$1,
  YLE_NEXT_M_LINE_HEIGHT: YLE_NEXT_M_LINE_HEIGHT$1,
  YLE_NEXT_M_MEDIUM_FONT_FAMILY: YLE_NEXT_M_MEDIUM_FONT_FAMILY$1,
  YLE_NEXT_M_MEDIUM_FONT_SIZE: YLE_NEXT_M_MEDIUM_FONT_SIZE$1,
  YLE_NEXT_M_MEDIUM_FONT_STRETCH: YLE_NEXT_M_MEDIUM_FONT_STRETCH$1,
  YLE_NEXT_M_MEDIUM_FONT_STYLE: YLE_NEXT_M_MEDIUM_FONT_STYLE$1,
  YLE_NEXT_M_MEDIUM_FONT_STYLE_OLD: YLE_NEXT_M_MEDIUM_FONT_STYLE_OLD$1,
  YLE_NEXT_M_MEDIUM_FONT_WEIGHT: YLE_NEXT_M_MEDIUM_FONT_WEIGHT$1,
  YLE_NEXT_M_MEDIUM_LETTER_SPACING: YLE_NEXT_M_MEDIUM_LETTER_SPACING$1,
  YLE_NEXT_M_MEDIUM_LINE_HEIGHT: YLE_NEXT_M_MEDIUM_LINE_HEIGHT$1,
  YLE_NEXT_M_MEDIUM_PARAGRAPH_INDENT: YLE_NEXT_M_MEDIUM_PARAGRAPH_INDENT$1,
  YLE_NEXT_M_MEDIUM_PARAGRAPH_SPACING: YLE_NEXT_M_MEDIUM_PARAGRAPH_SPACING$1,
  YLE_NEXT_M_MEDIUM_TEXT_CASE: YLE_NEXT_M_MEDIUM_TEXT_CASE$1,
  YLE_NEXT_M_MEDIUM_TEXT_DECORATION: YLE_NEXT_M_MEDIUM_TEXT_DECORATION$1,
  YLE_NEXT_M_PARAGRAPH_INDENT: YLE_NEXT_M_PARAGRAPH_INDENT$1,
  YLE_NEXT_M_PARAGRAPH_SPACING: YLE_NEXT_M_PARAGRAPH_SPACING$1,
  YLE_NEXT_M_TEXT_CASE: YLE_NEXT_M_TEXT_CASE$1,
  YLE_NEXT_M_TEXT_DECORATION: YLE_NEXT_M_TEXT_DECORATION$1,
  YLE_NEXT_S_AC_FONT_FAMILY: YLE_NEXT_S_AC_FONT_FAMILY$1,
  YLE_NEXT_S_AC_FONT_SIZE: YLE_NEXT_S_AC_FONT_SIZE$1,
  YLE_NEXT_S_AC_FONT_STRETCH: YLE_NEXT_S_AC_FONT_STRETCH$1,
  YLE_NEXT_S_AC_FONT_STYLE: YLE_NEXT_S_AC_FONT_STYLE$1,
  YLE_NEXT_S_AC_FONT_STYLE_OLD: YLE_NEXT_S_AC_FONT_STYLE_OLD$1,
  YLE_NEXT_S_AC_FONT_WEIGHT: YLE_NEXT_S_AC_FONT_WEIGHT$1,
  YLE_NEXT_S_AC_LETTER_SPACING: YLE_NEXT_S_AC_LETTER_SPACING$1,
  YLE_NEXT_S_AC_LINE_HEIGHT: YLE_NEXT_S_AC_LINE_HEIGHT$1,
  YLE_NEXT_S_AC_PARAGRAPH_INDENT: YLE_NEXT_S_AC_PARAGRAPH_INDENT$1,
  YLE_NEXT_S_AC_PARAGRAPH_SPACING: YLE_NEXT_S_AC_PARAGRAPH_SPACING$1,
  YLE_NEXT_S_AC_TEXT_CASE: YLE_NEXT_S_AC_TEXT_CASE$1,
  YLE_NEXT_S_AC_TEXT_DECORATION: YLE_NEXT_S_AC_TEXT_DECORATION$1,
  YLE_NEXT_S_BOLD_AC_FONT_FAMILY: YLE_NEXT_S_BOLD_AC_FONT_FAMILY$1,
  YLE_NEXT_S_BOLD_AC_FONT_SIZE: YLE_NEXT_S_BOLD_AC_FONT_SIZE$1,
  YLE_NEXT_S_BOLD_AC_FONT_STRETCH: YLE_NEXT_S_BOLD_AC_FONT_STRETCH$1,
  YLE_NEXT_S_BOLD_AC_FONT_STYLE: YLE_NEXT_S_BOLD_AC_FONT_STYLE$1,
  YLE_NEXT_S_BOLD_AC_FONT_STYLE_OLD: YLE_NEXT_S_BOLD_AC_FONT_STYLE_OLD$1,
  YLE_NEXT_S_BOLD_AC_FONT_WEIGHT: YLE_NEXT_S_BOLD_AC_FONT_WEIGHT$1,
  YLE_NEXT_S_BOLD_AC_LETTER_SPACING: YLE_NEXT_S_BOLD_AC_LETTER_SPACING$1,
  YLE_NEXT_S_BOLD_AC_LINE_HEIGHT: YLE_NEXT_S_BOLD_AC_LINE_HEIGHT$1,
  YLE_NEXT_S_BOLD_AC_PARAGRAPH_INDENT: YLE_NEXT_S_BOLD_AC_PARAGRAPH_INDENT$1,
  YLE_NEXT_S_BOLD_AC_PARAGRAPH_SPACING: YLE_NEXT_S_BOLD_AC_PARAGRAPH_SPACING$1,
  YLE_NEXT_S_BOLD_AC_TEXT_CASE: YLE_NEXT_S_BOLD_AC_TEXT_CASE$1,
  YLE_NEXT_S_BOLD_AC_TEXT_DECORATION: YLE_NEXT_S_BOLD_AC_TEXT_DECORATION$1,
  YLE_NEXT_S_BOLD_FONT_FAMILY: YLE_NEXT_S_BOLD_FONT_FAMILY$1,
  YLE_NEXT_S_BOLD_FONT_SIZE: YLE_NEXT_S_BOLD_FONT_SIZE$1,
  YLE_NEXT_S_BOLD_FONT_STRETCH: YLE_NEXT_S_BOLD_FONT_STRETCH$1,
  YLE_NEXT_S_BOLD_FONT_STYLE: YLE_NEXT_S_BOLD_FONT_STYLE$1,
  YLE_NEXT_S_BOLD_FONT_STYLE_OLD: YLE_NEXT_S_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_S_BOLD_FONT_WEIGHT: YLE_NEXT_S_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_S_BOLD_LETTER_SPACING: YLE_NEXT_S_BOLD_LETTER_SPACING$1,
  YLE_NEXT_S_BOLD_LINE_HEIGHT: YLE_NEXT_S_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_S_BOLD_PARAGRAPH_INDENT: YLE_NEXT_S_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_S_BOLD_PARAGRAPH_SPACING: YLE_NEXT_S_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_S_BOLD_TEXT_CASE: YLE_NEXT_S_BOLD_TEXT_CASE$1,
  YLE_NEXT_S_BOLD_TEXT_DECORATION: YLE_NEXT_S_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_S_CONDENSED_BOLD_FONT_FAMILY$1,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_S_CONDENSED_BOLD_FONT_SIZE$1,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_S_CONDENSED_BOLD_FONT_STRETCH$1,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE$1,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_S_CONDENSED_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_S_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_S_CONDENSED_BOLD_LETTER_SPACING$1,
  YLE_NEXT_S_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_S_CONDENSED_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_S_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_S_CONDENSED_BOLD_TEXT_CASE$1,
  YLE_NEXT_S_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_S_CONDENSED_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_S_CONDENSED_FONT_FAMILY: YLE_NEXT_S_CONDENSED_FONT_FAMILY$1,
  YLE_NEXT_S_CONDENSED_FONT_SIZE: YLE_NEXT_S_CONDENSED_FONT_SIZE$1,
  YLE_NEXT_S_CONDENSED_FONT_STRETCH: YLE_NEXT_S_CONDENSED_FONT_STRETCH$1,
  YLE_NEXT_S_CONDENSED_FONT_STYLE: YLE_NEXT_S_CONDENSED_FONT_STYLE$1,
  YLE_NEXT_S_CONDENSED_FONT_STYLE_OLD: YLE_NEXT_S_CONDENSED_FONT_STYLE_OLD$1,
  YLE_NEXT_S_CONDENSED_FONT_WEIGHT: YLE_NEXT_S_CONDENSED_FONT_WEIGHT$1,
  YLE_NEXT_S_CONDENSED_LETTER_SPACING: YLE_NEXT_S_CONDENSED_LETTER_SPACING$1,
  YLE_NEXT_S_CONDENSED_LINE_HEIGHT: YLE_NEXT_S_CONDENSED_LINE_HEIGHT$1,
  YLE_NEXT_S_CONDENSED_PARAGRAPH_INDENT: YLE_NEXT_S_CONDENSED_PARAGRAPH_INDENT$1,
  YLE_NEXT_S_CONDENSED_PARAGRAPH_SPACING: YLE_NEXT_S_CONDENSED_PARAGRAPH_SPACING$1,
  YLE_NEXT_S_CONDENSED_TEXT_CASE: YLE_NEXT_S_CONDENSED_TEXT_CASE$1,
  YLE_NEXT_S_CONDENSED_TEXT_DECORATION: YLE_NEXT_S_CONDENSED_TEXT_DECORATION$1,
  YLE_NEXT_S_FONT_FAMILY: YLE_NEXT_S_FONT_FAMILY$1,
  YLE_NEXT_S_FONT_SIZE: YLE_NEXT_S_FONT_SIZE$1,
  YLE_NEXT_S_FONT_STRETCH: YLE_NEXT_S_FONT_STRETCH$1,
  YLE_NEXT_S_FONT_STYLE: YLE_NEXT_S_FONT_STYLE$1,
  YLE_NEXT_S_FONT_STYLE_OLD: YLE_NEXT_S_FONT_STYLE_OLD$1,
  YLE_NEXT_S_FONT_WEIGHT: YLE_NEXT_S_FONT_WEIGHT$1,
  YLE_NEXT_S_ITALIC_FONT_FAMILY: YLE_NEXT_S_ITALIC_FONT_FAMILY$1,
  YLE_NEXT_S_ITALIC_FONT_SIZE: YLE_NEXT_S_ITALIC_FONT_SIZE$1,
  YLE_NEXT_S_ITALIC_FONT_STRETCH: YLE_NEXT_S_ITALIC_FONT_STRETCH$1,
  YLE_NEXT_S_ITALIC_FONT_STYLE: YLE_NEXT_S_ITALIC_FONT_STYLE$1,
  YLE_NEXT_S_ITALIC_FONT_STYLE_OLD: YLE_NEXT_S_ITALIC_FONT_STYLE_OLD$1,
  YLE_NEXT_S_ITALIC_FONT_WEIGHT: YLE_NEXT_S_ITALIC_FONT_WEIGHT$1,
  YLE_NEXT_S_ITALIC_LETTER_SPACING: YLE_NEXT_S_ITALIC_LETTER_SPACING$1,
  YLE_NEXT_S_ITALIC_LINE_HEIGHT: YLE_NEXT_S_ITALIC_LINE_HEIGHT$1,
  YLE_NEXT_S_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_S_ITALIC_PARAGRAPH_INDENT$1,
  YLE_NEXT_S_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_S_ITALIC_PARAGRAPH_SPACING$1,
  YLE_NEXT_S_ITALIC_TEXT_CASE: YLE_NEXT_S_ITALIC_TEXT_CASE$1,
  YLE_NEXT_S_ITALIC_TEXT_DECORATION: YLE_NEXT_S_ITALIC_TEXT_DECORATION$1,
  YLE_NEXT_S_LETTER_SPACING: YLE_NEXT_S_LETTER_SPACING$1,
  YLE_NEXT_S_LINE_HEIGHT: YLE_NEXT_S_LINE_HEIGHT$1,
  YLE_NEXT_S_MEDIUM_FONT_FAMILY: YLE_NEXT_S_MEDIUM_FONT_FAMILY$1,
  YLE_NEXT_S_MEDIUM_FONT_SIZE: YLE_NEXT_S_MEDIUM_FONT_SIZE$1,
  YLE_NEXT_S_MEDIUM_FONT_STRETCH: YLE_NEXT_S_MEDIUM_FONT_STRETCH$1,
  YLE_NEXT_S_MEDIUM_FONT_STYLE: YLE_NEXT_S_MEDIUM_FONT_STYLE$1,
  YLE_NEXT_S_MEDIUM_FONT_STYLE_OLD: YLE_NEXT_S_MEDIUM_FONT_STYLE_OLD$1,
  YLE_NEXT_S_MEDIUM_FONT_WEIGHT: YLE_NEXT_S_MEDIUM_FONT_WEIGHT$1,
  YLE_NEXT_S_MEDIUM_LETTER_SPACING: YLE_NEXT_S_MEDIUM_LETTER_SPACING$1,
  YLE_NEXT_S_MEDIUM_LINE_HEIGHT: YLE_NEXT_S_MEDIUM_LINE_HEIGHT$1,
  YLE_NEXT_S_MEDIUM_PARAGRAPH_INDENT: YLE_NEXT_S_MEDIUM_PARAGRAPH_INDENT$1,
  YLE_NEXT_S_MEDIUM_PARAGRAPH_SPACING: YLE_NEXT_S_MEDIUM_PARAGRAPH_SPACING$1,
  YLE_NEXT_S_MEDIUM_TEXT_CASE: YLE_NEXT_S_MEDIUM_TEXT_CASE$1,
  YLE_NEXT_S_MEDIUM_TEXT_DECORATION: YLE_NEXT_S_MEDIUM_TEXT_DECORATION$1,
  YLE_NEXT_S_PARAGRAPH_INDENT: YLE_NEXT_S_PARAGRAPH_INDENT$1,
  YLE_NEXT_S_PARAGRAPH_SPACING: YLE_NEXT_S_PARAGRAPH_SPACING$1,
  YLE_NEXT_S_TEXT_CASE: YLE_NEXT_S_TEXT_CASE$1,
  YLE_NEXT_S_TEXT_DECORATION: YLE_NEXT_S_TEXT_DECORATION$1,
  YLE_NEXT_XL_BOLD_FONT_FAMILY: YLE_NEXT_XL_BOLD_FONT_FAMILY$1,
  YLE_NEXT_XL_BOLD_FONT_SIZE: YLE_NEXT_XL_BOLD_FONT_SIZE$1,
  YLE_NEXT_XL_BOLD_FONT_STRETCH: YLE_NEXT_XL_BOLD_FONT_STRETCH$1,
  YLE_NEXT_XL_BOLD_FONT_STYLE: YLE_NEXT_XL_BOLD_FONT_STYLE$1,
  YLE_NEXT_XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_XL_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_XL_BOLD_FONT_WEIGHT: YLE_NEXT_XL_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_XL_BOLD_LETTER_SPACING: YLE_NEXT_XL_BOLD_LETTER_SPACING$1,
  YLE_NEXT_XL_BOLD_LINE_HEIGHT: YLE_NEXT_XL_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XL_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XL_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_XL_BOLD_TEXT_CASE: YLE_NEXT_XL_BOLD_TEXT_CASE$1,
  YLE_NEXT_XL_BOLD_TEXT_DECORATION: YLE_NEXT_XL_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_XL_CONDENSED_BOLD_FONT_FAMILY$1,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_XL_CONDENSED_BOLD_FONT_SIZE$1,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_XL_CONDENSED_BOLD_FONT_STRETCH$1,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE$1,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_XL_CONDENSED_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_XL_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_XL_CONDENSED_BOLD_LETTER_SPACING$1,
  YLE_NEXT_XL_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_XL_CONDENSED_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_XL_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_XL_CONDENSED_BOLD_TEXT_CASE$1,
  YLE_NEXT_XL_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_XL_CONDENSED_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_XL_CONDENSED_FONT_FAMILY: YLE_NEXT_XL_CONDENSED_FONT_FAMILY$1,
  YLE_NEXT_XL_CONDENSED_FONT_SIZE: YLE_NEXT_XL_CONDENSED_FONT_SIZE$1,
  YLE_NEXT_XL_CONDENSED_FONT_STRETCH: YLE_NEXT_XL_CONDENSED_FONT_STRETCH$1,
  YLE_NEXT_XL_CONDENSED_FONT_STYLE: YLE_NEXT_XL_CONDENSED_FONT_STYLE$1,
  YLE_NEXT_XL_CONDENSED_FONT_STYLE_OLD: YLE_NEXT_XL_CONDENSED_FONT_STYLE_OLD$1,
  YLE_NEXT_XL_CONDENSED_FONT_WEIGHT: YLE_NEXT_XL_CONDENSED_FONT_WEIGHT$1,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_SIZE$1,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE$1,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_XL_CONDENSED_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_XL_CONDENSED_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_CASE$1,
  YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_XL_CONDENSED_LETTER_SPACING: YLE_NEXT_XL_CONDENSED_LETTER_SPACING$1,
  YLE_NEXT_XL_CONDENSED_LINE_HEIGHT: YLE_NEXT_XL_CONDENSED_LINE_HEIGHT$1,
  YLE_NEXT_XL_CONDENSED_PARAGRAPH_INDENT: YLE_NEXT_XL_CONDENSED_PARAGRAPH_INDENT$1,
  YLE_NEXT_XL_CONDENSED_PARAGRAPH_SPACING: YLE_NEXT_XL_CONDENSED_PARAGRAPH_SPACING$1,
  YLE_NEXT_XL_CONDENSED_TEXT_CASE: YLE_NEXT_XL_CONDENSED_TEXT_CASE$1,
  YLE_NEXT_XL_CONDENSED_TEXT_DECORATION: YLE_NEXT_XL_CONDENSED_TEXT_DECORATION$1,
  YLE_NEXT_XL_FONT_FAMILY: YLE_NEXT_XL_FONT_FAMILY$1,
  YLE_NEXT_XL_FONT_SIZE: YLE_NEXT_XL_FONT_SIZE$1,
  YLE_NEXT_XL_FONT_STRETCH: YLE_NEXT_XL_FONT_STRETCH$1,
  YLE_NEXT_XL_FONT_STYLE: YLE_NEXT_XL_FONT_STYLE$1,
  YLE_NEXT_XL_FONT_STYLE_OLD: YLE_NEXT_XL_FONT_STYLE_OLD$1,
  YLE_NEXT_XL_FONT_WEIGHT: YLE_NEXT_XL_FONT_WEIGHT$1,
  YLE_NEXT_XL_HEAVY_FONT_FAMILY: YLE_NEXT_XL_HEAVY_FONT_FAMILY$1,
  YLE_NEXT_XL_HEAVY_FONT_SIZE: YLE_NEXT_XL_HEAVY_FONT_SIZE$1,
  YLE_NEXT_XL_HEAVY_FONT_STRETCH: YLE_NEXT_XL_HEAVY_FONT_STRETCH$1,
  YLE_NEXT_XL_HEAVY_FONT_STYLE: YLE_NEXT_XL_HEAVY_FONT_STYLE$1,
  YLE_NEXT_XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_XL_HEAVY_FONT_STYLE_OLD$1,
  YLE_NEXT_XL_HEAVY_FONT_WEIGHT: YLE_NEXT_XL_HEAVY_FONT_WEIGHT$1,
  YLE_NEXT_XL_HEAVY_LETTER_SPACING: YLE_NEXT_XL_HEAVY_LETTER_SPACING$1,
  YLE_NEXT_XL_HEAVY_LINE_HEIGHT: YLE_NEXT_XL_HEAVY_LINE_HEIGHT$1,
  YLE_NEXT_XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_XL_HEAVY_PARAGRAPH_INDENT$1,
  YLE_NEXT_XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_XL_HEAVY_PARAGRAPH_SPACING$1,
  YLE_NEXT_XL_HEAVY_TEXT_CASE: YLE_NEXT_XL_HEAVY_TEXT_CASE$1,
  YLE_NEXT_XL_HEAVY_TEXT_DECORATION: YLE_NEXT_XL_HEAVY_TEXT_DECORATION$1,
  YLE_NEXT_XL_ITALIC_FONT_FAMILY: YLE_NEXT_XL_ITALIC_FONT_FAMILY$1,
  YLE_NEXT_XL_ITALIC_FONT_SIZE: YLE_NEXT_XL_ITALIC_FONT_SIZE$1,
  YLE_NEXT_XL_ITALIC_FONT_STRETCH: YLE_NEXT_XL_ITALIC_FONT_STRETCH$1,
  YLE_NEXT_XL_ITALIC_FONT_STYLE: YLE_NEXT_XL_ITALIC_FONT_STYLE$1,
  YLE_NEXT_XL_ITALIC_FONT_STYLE_OLD: YLE_NEXT_XL_ITALIC_FONT_STYLE_OLD$1,
  YLE_NEXT_XL_ITALIC_FONT_WEIGHT: YLE_NEXT_XL_ITALIC_FONT_WEIGHT$1,
  YLE_NEXT_XL_ITALIC_LETTER_SPACING: YLE_NEXT_XL_ITALIC_LETTER_SPACING$1,
  YLE_NEXT_XL_ITALIC_LINE_HEIGHT: YLE_NEXT_XL_ITALIC_LINE_HEIGHT$1,
  YLE_NEXT_XL_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_XL_ITALIC_PARAGRAPH_INDENT$1,
  YLE_NEXT_XL_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_XL_ITALIC_PARAGRAPH_SPACING$1,
  YLE_NEXT_XL_ITALIC_TEXT_CASE: YLE_NEXT_XL_ITALIC_TEXT_CASE$1,
  YLE_NEXT_XL_ITALIC_TEXT_DECORATION: YLE_NEXT_XL_ITALIC_TEXT_DECORATION$1,
  YLE_NEXT_XL_LETTER_SPACING: YLE_NEXT_XL_LETTER_SPACING$1,
  YLE_NEXT_XL_LINE_HEIGHT: YLE_NEXT_XL_LINE_HEIGHT$1,
  YLE_NEXT_XL_PARAGRAPH_INDENT: YLE_NEXT_XL_PARAGRAPH_INDENT$1,
  YLE_NEXT_XL_PARAGRAPH_SPACING: YLE_NEXT_XL_PARAGRAPH_SPACING$1,
  YLE_NEXT_XL_TEXT_CASE: YLE_NEXT_XL_TEXT_CASE$1,
  YLE_NEXT_XL_TEXT_DECORATION: YLE_NEXT_XL_TEXT_DECORATION$1,
  YLE_NEXT_XS_AC_FONT_FAMILY: YLE_NEXT_XS_AC_FONT_FAMILY$1,
  YLE_NEXT_XS_AC_FONT_SIZE: YLE_NEXT_XS_AC_FONT_SIZE$1,
  YLE_NEXT_XS_AC_FONT_STRETCH: YLE_NEXT_XS_AC_FONT_STRETCH$1,
  YLE_NEXT_XS_AC_FONT_STYLE: YLE_NEXT_XS_AC_FONT_STYLE$1,
  YLE_NEXT_XS_AC_FONT_STYLE_OLD: YLE_NEXT_XS_AC_FONT_STYLE_OLD$1,
  YLE_NEXT_XS_AC_FONT_WEIGHT: YLE_NEXT_XS_AC_FONT_WEIGHT$1,
  YLE_NEXT_XS_AC_LETTER_SPACING: YLE_NEXT_XS_AC_LETTER_SPACING$1,
  YLE_NEXT_XS_AC_LINE_HEIGHT: YLE_NEXT_XS_AC_LINE_HEIGHT$1,
  YLE_NEXT_XS_AC_PARAGRAPH_INDENT: YLE_NEXT_XS_AC_PARAGRAPH_INDENT$1,
  YLE_NEXT_XS_AC_PARAGRAPH_SPACING: YLE_NEXT_XS_AC_PARAGRAPH_SPACING$1,
  YLE_NEXT_XS_AC_TEXT_CASE: YLE_NEXT_XS_AC_TEXT_CASE$1,
  YLE_NEXT_XS_AC_TEXT_DECORATION: YLE_NEXT_XS_AC_TEXT_DECORATION$1,
  YLE_NEXT_XS_BOLD_AC_FONT_FAMILY: YLE_NEXT_XS_BOLD_AC_FONT_FAMILY$1,
  YLE_NEXT_XS_BOLD_AC_FONT_SIZE: YLE_NEXT_XS_BOLD_AC_FONT_SIZE$1,
  YLE_NEXT_XS_BOLD_AC_FONT_STRETCH: YLE_NEXT_XS_BOLD_AC_FONT_STRETCH$1,
  YLE_NEXT_XS_BOLD_AC_FONT_STYLE: YLE_NEXT_XS_BOLD_AC_FONT_STYLE$1,
  YLE_NEXT_XS_BOLD_AC_FONT_STYLE_OLD: YLE_NEXT_XS_BOLD_AC_FONT_STYLE_OLD$1,
  YLE_NEXT_XS_BOLD_AC_FONT_WEIGHT: YLE_NEXT_XS_BOLD_AC_FONT_WEIGHT$1,
  YLE_NEXT_XS_BOLD_AC_LETTER_SPACING: YLE_NEXT_XS_BOLD_AC_LETTER_SPACING$1,
  YLE_NEXT_XS_BOLD_AC_LINE_HEIGHT: YLE_NEXT_XS_BOLD_AC_LINE_HEIGHT$1,
  YLE_NEXT_XS_BOLD_AC_PARAGRAPH_INDENT: YLE_NEXT_XS_BOLD_AC_PARAGRAPH_INDENT$1,
  YLE_NEXT_XS_BOLD_AC_PARAGRAPH_SPACING: YLE_NEXT_XS_BOLD_AC_PARAGRAPH_SPACING$1,
  YLE_NEXT_XS_BOLD_AC_TEXT_CASE: YLE_NEXT_XS_BOLD_AC_TEXT_CASE$1,
  YLE_NEXT_XS_BOLD_AC_TEXT_DECORATION: YLE_NEXT_XS_BOLD_AC_TEXT_DECORATION$1,
  YLE_NEXT_XS_BOLD_FONT_FAMILY: YLE_NEXT_XS_BOLD_FONT_FAMILY$1,
  YLE_NEXT_XS_BOLD_FONT_SIZE: YLE_NEXT_XS_BOLD_FONT_SIZE$1,
  YLE_NEXT_XS_BOLD_FONT_STRETCH: YLE_NEXT_XS_BOLD_FONT_STRETCH$1,
  YLE_NEXT_XS_BOLD_FONT_STYLE: YLE_NEXT_XS_BOLD_FONT_STYLE$1,
  YLE_NEXT_XS_BOLD_FONT_STYLE_OLD: YLE_NEXT_XS_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_XS_BOLD_FONT_WEIGHT: YLE_NEXT_XS_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_XS_BOLD_LETTER_SPACING: YLE_NEXT_XS_BOLD_LETTER_SPACING$1,
  YLE_NEXT_XS_BOLD_LINE_HEIGHT: YLE_NEXT_XS_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_XS_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XS_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_XS_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XS_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_XS_BOLD_TEXT_CASE: YLE_NEXT_XS_BOLD_TEXT_CASE$1,
  YLE_NEXT_XS_BOLD_TEXT_DECORATION: YLE_NEXT_XS_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_XS_CONDENSED_BOLD_FONT_FAMILY$1,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_XS_CONDENSED_BOLD_FONT_SIZE$1,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_XS_CONDENSED_BOLD_FONT_STRETCH$1,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE$1,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE_OLD$1,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_XS_CONDENSED_BOLD_FONT_WEIGHT$1,
  YLE_NEXT_XS_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_XS_CONDENSED_BOLD_LETTER_SPACING$1,
  YLE_NEXT_XS_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_XS_CONDENSED_BOLD_LINE_HEIGHT$1,
  YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT$1,
  YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING$1,
  YLE_NEXT_XS_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_XS_CONDENSED_BOLD_TEXT_CASE$1,
  YLE_NEXT_XS_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_XS_CONDENSED_BOLD_TEXT_DECORATION$1,
  YLE_NEXT_XS_FONT_FAMILY: YLE_NEXT_XS_FONT_FAMILY$1,
  YLE_NEXT_XS_FONT_SIZE: YLE_NEXT_XS_FONT_SIZE$1,
  YLE_NEXT_XS_FONT_STRETCH: YLE_NEXT_XS_FONT_STRETCH$1,
  YLE_NEXT_XS_FONT_STYLE: YLE_NEXT_XS_FONT_STYLE$1,
  YLE_NEXT_XS_FONT_STYLE_OLD: YLE_NEXT_XS_FONT_STYLE_OLD$1,
  YLE_NEXT_XS_FONT_WEIGHT: YLE_NEXT_XS_FONT_WEIGHT$1,
  YLE_NEXT_XS_ITALIC_FONT_FAMILY: YLE_NEXT_XS_ITALIC_FONT_FAMILY$1,
  YLE_NEXT_XS_ITALIC_FONT_SIZE: YLE_NEXT_XS_ITALIC_FONT_SIZE$1,
  YLE_NEXT_XS_ITALIC_FONT_STRETCH: YLE_NEXT_XS_ITALIC_FONT_STRETCH$1,
  YLE_NEXT_XS_ITALIC_FONT_STYLE: YLE_NEXT_XS_ITALIC_FONT_STYLE$1,
  YLE_NEXT_XS_ITALIC_FONT_STYLE_OLD: YLE_NEXT_XS_ITALIC_FONT_STYLE_OLD$1,
  YLE_NEXT_XS_ITALIC_FONT_WEIGHT: YLE_NEXT_XS_ITALIC_FONT_WEIGHT$1,
  YLE_NEXT_XS_ITALIC_LETTER_SPACING: YLE_NEXT_XS_ITALIC_LETTER_SPACING$1,
  YLE_NEXT_XS_ITALIC_LINE_HEIGHT: YLE_NEXT_XS_ITALIC_LINE_HEIGHT$1,
  YLE_NEXT_XS_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_XS_ITALIC_PARAGRAPH_INDENT$1,
  YLE_NEXT_XS_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_XS_ITALIC_PARAGRAPH_SPACING$1,
  YLE_NEXT_XS_ITALIC_TEXT_CASE: YLE_NEXT_XS_ITALIC_TEXT_CASE$1,
  YLE_NEXT_XS_ITALIC_TEXT_DECORATION: YLE_NEXT_XS_ITALIC_TEXT_DECORATION$1,
  YLE_NEXT_XS_LETTER_SPACING: YLE_NEXT_XS_LETTER_SPACING$1,
  YLE_NEXT_XS_LINE_HEIGHT: YLE_NEXT_XS_LINE_HEIGHT$1,
  YLE_NEXT_XS_PARAGRAPH_INDENT: YLE_NEXT_XS_PARAGRAPH_INDENT$1,
  YLE_NEXT_XS_PARAGRAPH_SPACING: YLE_NEXT_XS_PARAGRAPH_SPACING$1,
  YLE_NEXT_XS_TEXT_CASE: YLE_NEXT_XS_TEXT_CASE$1,
  YLE_NEXT_XS_TEXT_DECORATION: YLE_NEXT_XS_TEXT_DECORATION$1
});

/**
 * Yle Design System
 * v2.x.x
 */

const DEFAULT_7XL_BOLD_FONT_SIZE = '3.5rem';
const DEFAULT_7XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_7XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_7XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_7XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_7XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_7XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_7XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_7XL_BOLD_LINE_HEIGHT = '1.25';
const DEFAULT_7XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_7XL_BOLD_PARAGRAPH_SPACING = '3.5rem';
const DEFAULT_7XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_7XL_HEAVY_FONT_SIZE = '3.5rem';
const DEFAULT_7XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_7XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_7XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_7XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_7XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_7XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_7XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_7XL_HEAVY_LINE_HEIGHT = '1.25';
const DEFAULT_7XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_7XL_HEAVY_PARAGRAPH_SPACING = '3.5rem';
const DEFAULT_7XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_SIZE = '3.5rem';
const DEFAULT_7XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_7XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const DEFAULT_7XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.25';
const DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const DEFAULT_7XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const DEFAULT_6XL_BOLD_FONT_SIZE = '3rem';
const DEFAULT_6XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_6XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_6XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_6XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_6XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_6XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_6XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_6XL_BOLD_LINE_HEIGHT = '1.25';
const DEFAULT_6XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_6XL_BOLD_PARAGRAPH_SPACING = '3rem';
const DEFAULT_6XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_6XL_HEAVY_FONT_SIZE = '3rem';
const DEFAULT_6XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_6XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_6XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_6XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_6XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_6XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_6XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_6XL_HEAVY_LINE_HEIGHT = '1.25';
const DEFAULT_6XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_6XL_HEAVY_PARAGRAPH_SPACING = '3rem';
const DEFAULT_6XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_SIZE = '3rem';
const DEFAULT_6XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_6XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const DEFAULT_6XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.25';
const DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const DEFAULT_6XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const DEFAULT_5XL_BOLD_FONT_SIZE = '2.5rem';
const DEFAULT_5XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_5XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_5XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_5XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_5XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_5XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_5XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_5XL_BOLD_LINE_HEIGHT = '1.25';
const DEFAULT_5XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_5XL_BOLD_PARAGRAPH_SPACING = '2.5rem';
const DEFAULT_5XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_5XL_HEAVY_FONT_SIZE = '2.5rem';
const DEFAULT_5XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_5XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_5XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_5XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_5XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_5XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_5XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_5XL_HEAVY_LINE_HEIGHT = '1.25';
const DEFAULT_5XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_5XL_HEAVY_PARAGRAPH_SPACING = '2.5rem';
const DEFAULT_5XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_SIZE = '2.5rem';
const DEFAULT_5XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_5XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const DEFAULT_5XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.25';
const DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const DEFAULT_5XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const DEFAULT_4XL_BOLD_FONT_SIZE = '2rem';
const DEFAULT_4XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_4XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_4XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_4XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_4XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_4XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_4XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_4XL_BOLD_LINE_HEIGHT = '1.35';
const DEFAULT_4XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_4XL_BOLD_PARAGRAPH_SPACING = '2rem';
const DEFAULT_4XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_4XL_HEAVY_FONT_SIZE = '2rem';
const DEFAULT_4XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_4XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_4XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_4XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_4XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_4XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_4XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_4XL_HEAVY_LINE_HEIGHT = '1.35';
const DEFAULT_4XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_4XL_HEAVY_PARAGRAPH_SPACING = '2rem';
const DEFAULT_4XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_SIZE = '2rem';
const DEFAULT_4XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_4XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const DEFAULT_4XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.35';
const DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const DEFAULT_4XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const DEFAULT_3XL_BOLD_FONT_SIZE = '1.75rem';
const DEFAULT_3XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_3XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_3XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_3XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_3XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_3XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_3XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_3XL_BOLD_LINE_HEIGHT = '1.35';
const DEFAULT_3XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_3XL_BOLD_PARAGRAPH_SPACING = '1.75rem';
const DEFAULT_3XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_3XL_HEAVY_FONT_SIZE = '1.75rem';
const DEFAULT_3XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_3XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_3XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_3XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_3XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_3XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_3XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_3XL_HEAVY_LINE_HEIGHT = '1.35';
const DEFAULT_3XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_3XL_HEAVY_PARAGRAPH_SPACING = '1.75rem';
const DEFAULT_3XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_SIZE = '1.75rem';
const DEFAULT_3XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_3XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const DEFAULT_3XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.35';
const DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const DEFAULT_3XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const DEFAULT_2XL_FONT_SIZE = '1.5rem';
const DEFAULT_2XL_TEXT_DECORATION = 'none';
const DEFAULT_2XL_FONT_FAMILY = 'Yle Next';
const DEFAULT_2XL_FONT_WEIGHT = 400;
const DEFAULT_2XL_FONT_STYLE = 'normal';
const DEFAULT_2XL_FONT_STRETCH = 'normal';
const DEFAULT_2XL_FONT_STYLE_OLD = 'Regular';
const DEFAULT_2XL_LETTER_SPACING = 0;
const DEFAULT_2XL_LINE_HEIGHT = '1.35';
const DEFAULT_2XL_PARAGRAPH_INDENT = 0;
const DEFAULT_2XL_PARAGRAPH_SPACING = '1.5rem';
const DEFAULT_2XL_TEXT_CASE = 'none';
const DEFAULT_2XL_BOLD_FONT_SIZE = '1.5rem';
const DEFAULT_2XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_2XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_2XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_2XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_2XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_2XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_2XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_2XL_BOLD_LINE_HEIGHT = '1.35';
const DEFAULT_2XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_2XL_BOLD_PARAGRAPH_SPACING = '1.5rem';
const DEFAULT_2XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_2XL_HEAVY_FONT_SIZE = '1.5rem';
const DEFAULT_2XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_2XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_2XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_2XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_2XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_2XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_2XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_2XL_HEAVY_LINE_HEIGHT = '1.35';
const DEFAULT_2XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_2XL_HEAVY_PARAGRAPH_SPACING = '1.5rem';
const DEFAULT_2XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_SIZE = '1.5rem';
const DEFAULT_2XL_CONDENSED_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_WEIGHT = 700;
const DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE = 'normal';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_STRETCH = 'condensed';
const DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_2XL_CONDENSED_BOLD_LETTER_SPACING = 0;
const DEFAULT_2XL_CONDENSED_BOLD_LINE_HEIGHT = '1.35';
const DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING = 0;
const DEFAULT_2XL_CONDENSED_BOLD_TEXT_CASE = 'none';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_SIZE = '1.5rem';
const DEFAULT_2XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_2XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const DEFAULT_2XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.35';
const DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const DEFAULT_2XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const DEFAULT_XL_FONT_SIZE = '1.25rem';
const DEFAULT_XL_TEXT_DECORATION = 'none';
const DEFAULT_XL_FONT_FAMILY = 'Yle Next';
const DEFAULT_XL_FONT_WEIGHT = 400;
const DEFAULT_XL_FONT_STYLE = 'normal';
const DEFAULT_XL_FONT_STRETCH = 'normal';
const DEFAULT_XL_FONT_STYLE_OLD = 'Regular';
const DEFAULT_XL_LETTER_SPACING = 0;
const DEFAULT_XL_LINE_HEIGHT = '1.45';
const DEFAULT_XL_PARAGRAPH_INDENT = 0;
const DEFAULT_XL_PARAGRAPH_SPACING = '1.25rem';
const DEFAULT_XL_TEXT_CASE = 'none';
const DEFAULT_XL_ITALIC_FONT_SIZE = '1.25rem';
const DEFAULT_XL_ITALIC_TEXT_DECORATION = 'none';
const DEFAULT_XL_ITALIC_FONT_FAMILY = 'Yle Next';
const DEFAULT_XL_ITALIC_FONT_WEIGHT = 400;
const DEFAULT_XL_ITALIC_FONT_STYLE = 'italic';
const DEFAULT_XL_ITALIC_FONT_STRETCH = 'normal';
const DEFAULT_XL_ITALIC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_XL_ITALIC_LETTER_SPACING = 0;
const DEFAULT_XL_ITALIC_LINE_HEIGHT = '1.45';
const DEFAULT_XL_ITALIC_PARAGRAPH_INDENT = 0;
const DEFAULT_XL_ITALIC_PARAGRAPH_SPACING = '1.25rem';
const DEFAULT_XL_ITALIC_TEXT_CASE = 'none';
const DEFAULT_XL_BOLD_FONT_SIZE = '1.25rem';
const DEFAULT_XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_XL_BOLD_LINE_HEIGHT = '1.45';
const DEFAULT_XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_XL_BOLD_PARAGRAPH_SPACING = '1.25rem';
const DEFAULT_XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_XL_HEAVY_FONT_SIZE = '1.25rem';
const DEFAULT_XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_XL_HEAVY_LINE_HEIGHT = '1.45';
const DEFAULT_XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_XL_HEAVY_PARAGRAPH_SPACING = '1.25rem';
const DEFAULT_XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_XL_CONDENSED_FONT_SIZE = '1.25rem';
const DEFAULT_XL_CONDENSED_TEXT_DECORATION = 'none';
const DEFAULT_XL_CONDENSED_FONT_FAMILY = 'Yle Next';
const DEFAULT_XL_CONDENSED_FONT_WEIGHT = 400;
const DEFAULT_XL_CONDENSED_FONT_STYLE = 'normal';
const DEFAULT_XL_CONDENSED_FONT_STRETCH = 'condensed';
const DEFAULT_XL_CONDENSED_FONT_STYLE_OLD = 'Regular';
const DEFAULT_XL_CONDENSED_LETTER_SPACING = 0;
const DEFAULT_XL_CONDENSED_LINE_HEIGHT = '1.45';
const DEFAULT_XL_CONDENSED_PARAGRAPH_INDENT = 0;
const DEFAULT_XL_CONDENSED_PARAGRAPH_SPACING = 0;
const DEFAULT_XL_CONDENSED_TEXT_CASE = 'none';
const DEFAULT_XL_CONDENSED_BOLD_FONT_SIZE = '1.25rem';
const DEFAULT_XL_CONDENSED_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_XL_CONDENSED_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_XL_CONDENSED_BOLD_FONT_WEIGHT = 700;
const DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE = 'normal';
const DEFAULT_XL_CONDENSED_BOLD_FONT_STRETCH = 'condensed';
const DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_XL_CONDENSED_BOLD_LETTER_SPACING = 0;
const DEFAULT_XL_CONDENSED_BOLD_LINE_HEIGHT = '1.45';
const DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING = 0;
const DEFAULT_XL_CONDENSED_BOLD_TEXT_CASE = 'none';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_SIZE = '1.25rem';
const DEFAULT_XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const DEFAULT_XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.45';
const DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const DEFAULT_XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const DEFAULT_L_FONT_SIZE = '1.125rem';
const DEFAULT_L_TEXT_DECORATION = 'none';
const DEFAULT_L_FONT_FAMILY = 'Yle Next';
const DEFAULT_L_FONT_WEIGHT = 400;
const DEFAULT_L_FONT_STYLE = 'normal';
const DEFAULT_L_FONT_STRETCH = 'normal';
const DEFAULT_L_FONT_STYLE_OLD = 'Regular';
const DEFAULT_L_LETTER_SPACING = 0;
const DEFAULT_L_LINE_HEIGHT = '1.45';
const DEFAULT_L_PARAGRAPH_INDENT = 0;
const DEFAULT_L_PARAGRAPH_SPACING = '1.125rem';
const DEFAULT_L_TEXT_CASE = 'none';
const DEFAULT_L_ITALIC_FONT_SIZE = '1.125rem';
const DEFAULT_L_ITALIC_TEXT_DECORATION = 'none';
const DEFAULT_L_ITALIC_FONT_FAMILY = 'Yle Next';
const DEFAULT_L_ITALIC_FONT_WEIGHT = 400;
const DEFAULT_L_ITALIC_FONT_STYLE = 'italic';
const DEFAULT_L_ITALIC_FONT_STRETCH = 'normal';
const DEFAULT_L_ITALIC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_L_ITALIC_LETTER_SPACING = 0;
const DEFAULT_L_ITALIC_LINE_HEIGHT = '1.45';
const DEFAULT_L_ITALIC_PARAGRAPH_INDENT = 0;
const DEFAULT_L_ITALIC_PARAGRAPH_SPACING = '1.125rem';
const DEFAULT_L_ITALIC_TEXT_CASE = 'none';
const DEFAULT_L_BOLD_FONT_SIZE = '1.125rem';
const DEFAULT_L_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_L_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_L_BOLD_FONT_WEIGHT = 700;
const DEFAULT_L_BOLD_FONT_STYLE = 'normal';
const DEFAULT_L_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_L_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_L_BOLD_LETTER_SPACING = 0;
const DEFAULT_L_BOLD_LINE_HEIGHT = '1.45';
const DEFAULT_L_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_L_BOLD_PARAGRAPH_SPACING = '1.125rem';
const DEFAULT_L_BOLD_TEXT_CASE = 'none';
const DEFAULT_L_HEAVY_FONT_SIZE = '1.125rem';
const DEFAULT_L_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_L_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_L_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_L_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_L_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_L_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_L_HEAVY_LETTER_SPACING = 0;
const DEFAULT_L_HEAVY_LINE_HEIGHT = '1.45';
const DEFAULT_L_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_L_HEAVY_PARAGRAPH_SPACING = '1.125rem';
const DEFAULT_L_HEAVY_TEXT_CASE = 'none';
const DEFAULT_L_CONDENSED_FONT_SIZE = '1.125rem';
const DEFAULT_L_CONDENSED_TEXT_DECORATION = 'none';
const DEFAULT_L_CONDENSED_FONT_FAMILY = 'Yle Next';
const DEFAULT_L_CONDENSED_FONT_WEIGHT = 400;
const DEFAULT_L_CONDENSED_FONT_STYLE = 'normal';
const DEFAULT_L_CONDENSED_FONT_STRETCH = 'condensed';
const DEFAULT_L_CONDENSED_FONT_STYLE_OLD = 'Regular';
const DEFAULT_L_CONDENSED_LETTER_SPACING = 0;
const DEFAULT_L_CONDENSED_LINE_HEIGHT = '1.45';
const DEFAULT_L_CONDENSED_PARAGRAPH_INDENT = 0;
const DEFAULT_L_CONDENSED_PARAGRAPH_SPACING = 0;
const DEFAULT_L_CONDENSED_TEXT_CASE = 'none';
const DEFAULT_L_CONDENSED_BOLD_FONT_SIZE = '1.125rem';
const DEFAULT_L_CONDENSED_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_L_CONDENSED_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_L_CONDENSED_BOLD_FONT_WEIGHT = 700;
const DEFAULT_L_CONDENSED_BOLD_FONT_STYLE = 'normal';
const DEFAULT_L_CONDENSED_BOLD_FONT_STRETCH = 'condensed';
const DEFAULT_L_CONDENSED_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_L_CONDENSED_BOLD_LETTER_SPACING = 0;
const DEFAULT_L_CONDENSED_BOLD_LINE_HEIGHT = '1.45';
const DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_SPACING = 0;
const DEFAULT_L_CONDENSED_BOLD_TEXT_CASE = 'none';
const DEFAULT_L_CONDENSED_HEAVY_FONT_SIZE = '1.125rem';
const DEFAULT_L_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_L_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_L_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_L_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_L_CONDENSED_HEAVY_LETTER_SPACING = 0;
const DEFAULT_L_CONDENSED_HEAVY_LINE_HEIGHT = '1.45';
const DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const DEFAULT_L_CONDENSED_HEAVY_TEXT_CASE = 'none';
const DEFAULT_M_FONT_SIZE = '1rem';
const DEFAULT_M_TEXT_DECORATION = 'none';
const DEFAULT_M_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_FONT_WEIGHT = 400;
const DEFAULT_M_FONT_STYLE = 'normal';
const DEFAULT_M_FONT_STRETCH = 'normal';
const DEFAULT_M_FONT_STYLE_OLD = 'Regular';
const DEFAULT_M_LETTER_SPACING = 0;
const DEFAULT_M_LINE_HEIGHT = '1.50';
const DEFAULT_M_PARAGRAPH_INDENT = 0;
const DEFAULT_M_PARAGRAPH_SPACING = '1rem';
const DEFAULT_M_TEXT_CASE = 'none';
const DEFAULT_M_AC_FONT_SIZE = '1rem';
const DEFAULT_M_AC_TEXT_DECORATION = 'none';
const DEFAULT_M_AC_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_AC_FONT_WEIGHT = 400;
const DEFAULT_M_AC_FONT_STYLE = 'normal';
const DEFAULT_M_AC_FONT_STRETCH = 'normal';
const DEFAULT_M_AC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_M_AC_LETTER_SPACING = '0.01em';
const DEFAULT_M_AC_LINE_HEIGHT = '1.50';
const DEFAULT_M_AC_PARAGRAPH_INDENT = 0;
const DEFAULT_M_AC_PARAGRAPH_SPACING = '1rem';
const DEFAULT_M_AC_TEXT_CASE = 'uppercase';
const DEFAULT_M_ITALIC_FONT_SIZE = '1rem';
const DEFAULT_M_ITALIC_TEXT_DECORATION = 'none';
const DEFAULT_M_ITALIC_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_ITALIC_FONT_WEIGHT = 400;
const DEFAULT_M_ITALIC_FONT_STYLE = 'italic';
const DEFAULT_M_ITALIC_FONT_STRETCH = 'normal';
const DEFAULT_M_ITALIC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_M_ITALIC_LETTER_SPACING = 0;
const DEFAULT_M_ITALIC_LINE_HEIGHT = '1.50';
const DEFAULT_M_ITALIC_PARAGRAPH_INDENT = 0;
const DEFAULT_M_ITALIC_PARAGRAPH_SPACING = '1rem';
const DEFAULT_M_ITALIC_TEXT_CASE = 'none';
const DEFAULT_M_MEDIUM_FONT_SIZE = '1rem';
const DEFAULT_M_MEDIUM_TEXT_DECORATION = 'none';
const DEFAULT_M_MEDIUM_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_MEDIUM_FONT_WEIGHT = 500;
const DEFAULT_M_MEDIUM_FONT_STYLE = 'normal';
const DEFAULT_M_MEDIUM_FONT_STRETCH = 'normal';
const DEFAULT_M_MEDIUM_FONT_STYLE_OLD = 'Medium';
const DEFAULT_M_MEDIUM_LETTER_SPACING = 0;
const DEFAULT_M_MEDIUM_LINE_HEIGHT = '1.50';
const DEFAULT_M_MEDIUM_PARAGRAPH_INDENT = 0;
const DEFAULT_M_MEDIUM_PARAGRAPH_SPACING = '1rem';
const DEFAULT_M_MEDIUM_TEXT_CASE = 'none';
const DEFAULT_M_BOLD_FONT_SIZE = '1rem';
const DEFAULT_M_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_M_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_BOLD_FONT_WEIGHT = 700;
const DEFAULT_M_BOLD_FONT_STYLE = 'normal';
const DEFAULT_M_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_M_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_M_BOLD_LETTER_SPACING = 0;
const DEFAULT_M_BOLD_LINE_HEIGHT = '1.50';
const DEFAULT_M_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_M_BOLD_PARAGRAPH_SPACING = '1rem';
const DEFAULT_M_BOLD_TEXT_CASE = 'none';
const DEFAULT_M_BOLD_AC_FONT_SIZE = '1rem';
const DEFAULT_M_BOLD_AC_TEXT_DECORATION = 'none';
const DEFAULT_M_BOLD_AC_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_BOLD_AC_FONT_WEIGHT = 700;
const DEFAULT_M_BOLD_AC_FONT_STYLE = 'normal';
const DEFAULT_M_BOLD_AC_FONT_STRETCH = 'normal';
const DEFAULT_M_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const DEFAULT_M_BOLD_AC_LETTER_SPACING = '0.01em';
const DEFAULT_M_BOLD_AC_LINE_HEIGHT = '1.50';
const DEFAULT_M_BOLD_AC_PARAGRAPH_INDENT = 0;
const DEFAULT_M_BOLD_AC_PARAGRAPH_SPACING = '1rem';
const DEFAULT_M_BOLD_AC_TEXT_CASE = 'uppercase';
const DEFAULT_M_CONDENSED_FONT_SIZE = '1rem';
const DEFAULT_M_CONDENSED_TEXT_DECORATION = 'none';
const DEFAULT_M_CONDENSED_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_CONDENSED_FONT_WEIGHT = 400;
const DEFAULT_M_CONDENSED_FONT_STYLE = 'normal';
const DEFAULT_M_CONDENSED_FONT_STRETCH = 'condensed';
const DEFAULT_M_CONDENSED_FONT_STYLE_OLD = 'Regular';
const DEFAULT_M_CONDENSED_LETTER_SPACING = 0;
const DEFAULT_M_CONDENSED_LINE_HEIGHT = '1.50';
const DEFAULT_M_CONDENSED_PARAGRAPH_INDENT = 0;
const DEFAULT_M_CONDENSED_PARAGRAPH_SPACING = 0;
const DEFAULT_M_CONDENSED_TEXT_CASE = 'none';
const DEFAULT_M_CONDENSED_BOLD_FONT_SIZE = '1rem';
const DEFAULT_M_CONDENSED_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_M_CONDENSED_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_CONDENSED_BOLD_FONT_WEIGHT = 700;
const DEFAULT_M_CONDENSED_BOLD_FONT_STYLE = 'normal';
const DEFAULT_M_CONDENSED_BOLD_FONT_STRETCH = 'condensed';
const DEFAULT_M_CONDENSED_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_M_CONDENSED_BOLD_LETTER_SPACING = 0;
const DEFAULT_M_CONDENSED_BOLD_LINE_HEIGHT = '1.50';
const DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_SPACING = 0;
const DEFAULT_M_CONDENSED_BOLD_TEXT_CASE = 'none';
const DEFAULT_S_FONT_SIZE = '0.875rem';
const DEFAULT_S_TEXT_DECORATION = 'none';
const DEFAULT_S_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_FONT_WEIGHT = 400;
const DEFAULT_S_FONT_STYLE = 'normal';
const DEFAULT_S_FONT_STRETCH = 'normal';
const DEFAULT_S_FONT_STYLE_OLD = 'Regular';
const DEFAULT_S_LETTER_SPACING = 0;
const DEFAULT_S_LINE_HEIGHT = '1.50';
const DEFAULT_S_PARAGRAPH_INDENT = 0;
const DEFAULT_S_PARAGRAPH_SPACING = '0.875rem';
const DEFAULT_S_TEXT_CASE = 'none';
const DEFAULT_S_ITALIC_FONT_SIZE = '0.875rem';
const DEFAULT_S_ITALIC_TEXT_DECORATION = 'none';
const DEFAULT_S_ITALIC_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_ITALIC_FONT_WEIGHT = 400;
const DEFAULT_S_ITALIC_FONT_STYLE = 'italic';
const DEFAULT_S_ITALIC_FONT_STRETCH = 'normal';
const DEFAULT_S_ITALIC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_S_ITALIC_LETTER_SPACING = 0;
const DEFAULT_S_ITALIC_LINE_HEIGHT = '1.50';
const DEFAULT_S_ITALIC_PARAGRAPH_INDENT = 0;
const DEFAULT_S_ITALIC_PARAGRAPH_SPACING = '0.875rem';
const DEFAULT_S_ITALIC_TEXT_CASE = 'none';
const DEFAULT_S_AC_FONT_SIZE = '0.875rem';
const DEFAULT_S_AC_TEXT_DECORATION = 'none';
const DEFAULT_S_AC_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_AC_FONT_WEIGHT = 400;
const DEFAULT_S_AC_FONT_STYLE = 'normal';
const DEFAULT_S_AC_FONT_STRETCH = 'normal';
const DEFAULT_S_AC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_S_AC_LETTER_SPACING = '0.01em';
const DEFAULT_S_AC_LINE_HEIGHT = '1.50';
const DEFAULT_S_AC_PARAGRAPH_INDENT = 0;
const DEFAULT_S_AC_PARAGRAPH_SPACING = '0.875rem';
const DEFAULT_S_AC_TEXT_CASE = 'uppercase';
const DEFAULT_S_MEDIUM_FONT_SIZE = '0.875rem';
const DEFAULT_S_MEDIUM_TEXT_DECORATION = 'none';
const DEFAULT_S_MEDIUM_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_MEDIUM_FONT_WEIGHT = 500;
const DEFAULT_S_MEDIUM_FONT_STYLE = 'normal';
const DEFAULT_S_MEDIUM_FONT_STRETCH = 'normal';
const DEFAULT_S_MEDIUM_FONT_STYLE_OLD = 'Medium';
const DEFAULT_S_MEDIUM_LETTER_SPACING = 0;
const DEFAULT_S_MEDIUM_LINE_HEIGHT = '1.50';
const DEFAULT_S_MEDIUM_PARAGRAPH_INDENT = 0;
const DEFAULT_S_MEDIUM_PARAGRAPH_SPACING = 0;
const DEFAULT_S_MEDIUM_TEXT_CASE = 'none';
const DEFAULT_S_BOLD_FONT_SIZE = '0.875rem';
const DEFAULT_S_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_S_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_BOLD_FONT_WEIGHT = 700;
const DEFAULT_S_BOLD_FONT_STYLE = 'normal';
const DEFAULT_S_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_S_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_S_BOLD_LETTER_SPACING = 0;
const DEFAULT_S_BOLD_LINE_HEIGHT = '1.50';
const DEFAULT_S_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_S_BOLD_PARAGRAPH_SPACING = '0.875rem';
const DEFAULT_S_BOLD_TEXT_CASE = 'none';
const DEFAULT_S_BOLD_AC_FONT_SIZE = '0.875rem';
const DEFAULT_S_BOLD_AC_TEXT_DECORATION = 'none';
const DEFAULT_S_BOLD_AC_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_BOLD_AC_FONT_WEIGHT = 700;
const DEFAULT_S_BOLD_AC_FONT_STYLE = 'normal';
const DEFAULT_S_BOLD_AC_FONT_STRETCH = 'normal';
const DEFAULT_S_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const DEFAULT_S_BOLD_AC_LETTER_SPACING = '0.01em';
const DEFAULT_S_BOLD_AC_LINE_HEIGHT = '1.50';
const DEFAULT_S_BOLD_AC_PARAGRAPH_INDENT = 0;
const DEFAULT_S_BOLD_AC_PARAGRAPH_SPACING = '0.875rem';
const DEFAULT_S_BOLD_AC_TEXT_CASE = 'uppercase';
const DEFAULT_S_CONDENSED_FONT_SIZE = '0.875rem';
const DEFAULT_S_CONDENSED_TEXT_DECORATION = 'none';
const DEFAULT_S_CONDENSED_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_CONDENSED_FONT_WEIGHT = 400;
const DEFAULT_S_CONDENSED_FONT_STYLE = 'normal';
const DEFAULT_S_CONDENSED_FONT_STRETCH = 'condensed';
const DEFAULT_S_CONDENSED_FONT_STYLE_OLD = 'Regular';
const DEFAULT_S_CONDENSED_LETTER_SPACING = 0;
const DEFAULT_S_CONDENSED_LINE_HEIGHT = '1.50';
const DEFAULT_S_CONDENSED_PARAGRAPH_INDENT = 0;
const DEFAULT_S_CONDENSED_PARAGRAPH_SPACING = 0;
const DEFAULT_S_CONDENSED_TEXT_CASE = 'none';
const DEFAULT_S_CONDENSED_BOLD_FONT_SIZE = '0.875rem';
const DEFAULT_S_CONDENSED_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_S_CONDENSED_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_CONDENSED_BOLD_FONT_WEIGHT = 700;
const DEFAULT_S_CONDENSED_BOLD_FONT_STYLE = 'normal';
const DEFAULT_S_CONDENSED_BOLD_FONT_STRETCH = 'condensed';
const DEFAULT_S_CONDENSED_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_S_CONDENSED_BOLD_LETTER_SPACING = 0;
const DEFAULT_S_CONDENSED_BOLD_LINE_HEIGHT = '1.50';
const DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_SPACING = 0;
const DEFAULT_S_CONDENSED_BOLD_TEXT_CASE = 'none';
const DEFAULT_XS_FONT_SIZE = '0.75rem';
const DEFAULT_XS_TEXT_DECORATION = 'none';
const DEFAULT_XS_FONT_FAMILY = 'Yle Next';
const DEFAULT_XS_FONT_WEIGHT = 400;
const DEFAULT_XS_FONT_STYLE = 'normal';
const DEFAULT_XS_FONT_STRETCH = 'normal';
const DEFAULT_XS_FONT_STYLE_OLD = 'Regular';
const DEFAULT_XS_LETTER_SPACING = 0;
const DEFAULT_XS_LINE_HEIGHT = '1.50';
const DEFAULT_XS_PARAGRAPH_INDENT = 0;
const DEFAULT_XS_PARAGRAPH_SPACING = '0.75rem';
const DEFAULT_XS_TEXT_CASE = 'none';
const DEFAULT_XS_ITALIC_FONT_SIZE = '0.75rem';
const DEFAULT_XS_ITALIC_TEXT_DECORATION = 'none';
const DEFAULT_XS_ITALIC_FONT_FAMILY = 'Yle Next';
const DEFAULT_XS_ITALIC_FONT_WEIGHT = 400;
const DEFAULT_XS_ITALIC_FONT_STYLE = 'italic';
const DEFAULT_XS_ITALIC_FONT_STRETCH = 'normal';
const DEFAULT_XS_ITALIC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_XS_ITALIC_LETTER_SPACING = 0;
const DEFAULT_XS_ITALIC_LINE_HEIGHT = '1.50';
const DEFAULT_XS_ITALIC_PARAGRAPH_INDENT = 0;
const DEFAULT_XS_ITALIC_PARAGRAPH_SPACING = '0.75rem';
const DEFAULT_XS_ITALIC_TEXT_CASE = 'none';
const DEFAULT_XS_AC_FONT_SIZE = '0.75rem';
const DEFAULT_XS_AC_TEXT_DECORATION = 'none';
const DEFAULT_XS_AC_FONT_FAMILY = 'Yle Next';
const DEFAULT_XS_AC_FONT_WEIGHT = 400;
const DEFAULT_XS_AC_FONT_STYLE = 'normal';
const DEFAULT_XS_AC_FONT_STRETCH = 'normal';
const DEFAULT_XS_AC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_XS_AC_LETTER_SPACING = '0.01em';
const DEFAULT_XS_AC_LINE_HEIGHT = '1.50';
const DEFAULT_XS_AC_PARAGRAPH_INDENT = 0;
const DEFAULT_XS_AC_PARAGRAPH_SPACING = '0.75rem';
const DEFAULT_XS_AC_TEXT_CASE = 'uppercase';
const DEFAULT_XS_BOLD_FONT_SIZE = '0.75rem';
const DEFAULT_XS_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_XS_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_XS_BOLD_FONT_WEIGHT = 700;
const DEFAULT_XS_BOLD_FONT_STYLE = 'normal';
const DEFAULT_XS_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_XS_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_XS_BOLD_LETTER_SPACING = 0;
const DEFAULT_XS_BOLD_LINE_HEIGHT = '1.50';
const DEFAULT_XS_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_XS_BOLD_PARAGRAPH_SPACING = '0.75rem';
const DEFAULT_XS_BOLD_TEXT_CASE = 'none';
const DEFAULT_XS_BOLD_AC_FONT_SIZE = '0.75rem';
const DEFAULT_XS_BOLD_AC_TEXT_DECORATION = 'none';
const DEFAULT_XS_BOLD_AC_FONT_FAMILY = 'Yle Next';
const DEFAULT_XS_BOLD_AC_FONT_WEIGHT = 700;
const DEFAULT_XS_BOLD_AC_FONT_STYLE = 'normal';
const DEFAULT_XS_BOLD_AC_FONT_STRETCH = 'normal';
const DEFAULT_XS_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const DEFAULT_XS_BOLD_AC_LETTER_SPACING = '0.01em';
const DEFAULT_XS_BOLD_AC_LINE_HEIGHT = '1.50';
const DEFAULT_XS_BOLD_AC_PARAGRAPH_INDENT = 0;
const DEFAULT_XS_BOLD_AC_PARAGRAPH_SPACING = '0.75rem';
const DEFAULT_XS_BOLD_AC_TEXT_CASE = 'uppercase';
const DEFAULT_XS_CONDENSED_BOLD_FONT_SIZE = '0.75rem';
const DEFAULT_XS_CONDENSED_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_XS_CONDENSED_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_XS_CONDENSED_BOLD_FONT_WEIGHT = 700;
const DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE = 'normal';
const DEFAULT_XS_CONDENSED_BOLD_FONT_STRETCH = 'condensed';
const DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_XS_CONDENSED_BOLD_LETTER_SPACING = 0;
const DEFAULT_XS_CONDENSED_BOLD_LINE_HEIGHT = '1.50';
const DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING = 0;
const DEFAULT_XS_CONDENSED_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_7XL_BOLD_FONT_SIZE = '3.5rem';
const YLE_NEXT_7XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_7XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_7XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_7XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_7XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_7XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_7XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_7XL_BOLD_LINE_HEIGHT = '1.25';
const YLE_NEXT_7XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_7XL_BOLD_PARAGRAPH_SPACING = '3.5rem';
const YLE_NEXT_7XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_7XL_HEAVY_FONT_SIZE = '3.5rem';
const YLE_NEXT_7XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_7XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_7XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_7XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_7XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_7XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_7XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_7XL_HEAVY_LINE_HEIGHT = '1.25';
const YLE_NEXT_7XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_7XL_HEAVY_PARAGRAPH_SPACING = '3.5rem';
const YLE_NEXT_7XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_SIZE = '3.5rem';
const YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_7XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_7XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.25';
const YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_6XL_BOLD_FONT_SIZE = '3rem';
const YLE_NEXT_6XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_6XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_6XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_6XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_6XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_6XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_6XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_6XL_BOLD_LINE_HEIGHT = '1.25';
const YLE_NEXT_6XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_6XL_BOLD_PARAGRAPH_SPACING = '3rem';
const YLE_NEXT_6XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_6XL_HEAVY_FONT_SIZE = '3rem';
const YLE_NEXT_6XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_6XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_6XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_6XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_6XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_6XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_6XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_6XL_HEAVY_LINE_HEIGHT = '1.25';
const YLE_NEXT_6XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_6XL_HEAVY_PARAGRAPH_SPACING = '3rem';
const YLE_NEXT_6XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_SIZE = '3rem';
const YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_6XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_6XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.25';
const YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_5XL_BOLD_FONT_SIZE = '2.5rem';
const YLE_NEXT_5XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_5XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_5XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_5XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_5XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_5XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_5XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_5XL_BOLD_LINE_HEIGHT = '1.25';
const YLE_NEXT_5XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_5XL_BOLD_PARAGRAPH_SPACING = '2.5rem';
const YLE_NEXT_5XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_5XL_HEAVY_FONT_SIZE = '2.5rem';
const YLE_NEXT_5XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_5XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_5XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_5XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_5XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_5XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_5XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_5XL_HEAVY_LINE_HEIGHT = '1.25';
const YLE_NEXT_5XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_5XL_HEAVY_PARAGRAPH_SPACING = '2.5rem';
const YLE_NEXT_5XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_SIZE = '2.5rem';
const YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_5XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_5XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.25';
const YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_4XL_BOLD_FONT_SIZE = '2rem';
const YLE_NEXT_4XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_4XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_4XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_4XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_4XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_4XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_4XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_4XL_BOLD_LINE_HEIGHT = '1.35';
const YLE_NEXT_4XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_4XL_BOLD_PARAGRAPH_SPACING = '2rem';
const YLE_NEXT_4XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_4XL_HEAVY_FONT_SIZE = '2rem';
const YLE_NEXT_4XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_4XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_4XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_4XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_4XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_4XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_4XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_4XL_HEAVY_LINE_HEIGHT = '1.35';
const YLE_NEXT_4XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_4XL_HEAVY_PARAGRAPH_SPACING = '2rem';
const YLE_NEXT_4XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_SIZE = '2rem';
const YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_4XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_4XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.35';
const YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_3XL_BOLD_FONT_SIZE = '1.75rem';
const YLE_NEXT_3XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_3XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_3XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_3XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_3XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_3XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_3XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_3XL_BOLD_LINE_HEIGHT = '1.35';
const YLE_NEXT_3XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_3XL_BOLD_PARAGRAPH_SPACING = '1.75rem';
const YLE_NEXT_3XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_3XL_HEAVY_FONT_SIZE = '1.75rem';
const YLE_NEXT_3XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_3XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_3XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_3XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_3XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_3XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_3XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_3XL_HEAVY_LINE_HEIGHT = '1.35';
const YLE_NEXT_3XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_3XL_HEAVY_PARAGRAPH_SPACING = '1.75rem';
const YLE_NEXT_3XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_SIZE = '1.75rem';
const YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_3XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_3XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.35';
const YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_2XL_FONT_SIZE = '1.5rem';
const YLE_NEXT_2XL_TEXT_DECORATION = 'none';
const YLE_NEXT_2XL_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_2XL_FONT_WEIGHT = 400;
const YLE_NEXT_2XL_FONT_STYLE = 'normal';
const YLE_NEXT_2XL_FONT_STRETCH = 'normal';
const YLE_NEXT_2XL_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_2XL_LETTER_SPACING = 0;
const YLE_NEXT_2XL_LINE_HEIGHT = '1.35';
const YLE_NEXT_2XL_PARAGRAPH_INDENT = 0;
const YLE_NEXT_2XL_PARAGRAPH_SPACING = '1.5rem';
const YLE_NEXT_2XL_TEXT_CASE = 'none';
const YLE_NEXT_2XL_BOLD_FONT_SIZE = '1.5rem';
const YLE_NEXT_2XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_2XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_2XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_2XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_2XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_2XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_2XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_2XL_BOLD_LINE_HEIGHT = '1.35';
const YLE_NEXT_2XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_2XL_BOLD_PARAGRAPH_SPACING = '1.5rem';
const YLE_NEXT_2XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_2XL_HEAVY_FONT_SIZE = '1.5rem';
const YLE_NEXT_2XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_2XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_2XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_2XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_2XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_2XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_2XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_2XL_HEAVY_LINE_HEIGHT = '1.35';
const YLE_NEXT_2XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_2XL_HEAVY_PARAGRAPH_SPACING = '1.5rem';
const YLE_NEXT_2XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_SIZE = '1.5rem';
const YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STRETCH = 'condensed';
const YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_2XL_CONDENSED_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_2XL_CONDENSED_BOLD_LINE_HEIGHT = '1.35';
const YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING = 0;
const YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_SIZE = '1.5rem';
const YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_2XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_2XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.35';
const YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_XL_FONT_SIZE = '1.25rem';
const YLE_NEXT_XL_TEXT_DECORATION = 'none';
const YLE_NEXT_XL_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XL_FONT_WEIGHT = 400;
const YLE_NEXT_XL_FONT_STYLE = 'normal';
const YLE_NEXT_XL_FONT_STRETCH = 'normal';
const YLE_NEXT_XL_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_XL_LETTER_SPACING = 0;
const YLE_NEXT_XL_LINE_HEIGHT = '1.45';
const YLE_NEXT_XL_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XL_PARAGRAPH_SPACING = '1.25rem';
const YLE_NEXT_XL_TEXT_CASE = 'none';
const YLE_NEXT_XL_ITALIC_FONT_SIZE = '1.25rem';
const YLE_NEXT_XL_ITALIC_TEXT_DECORATION = 'none';
const YLE_NEXT_XL_ITALIC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XL_ITALIC_FONT_WEIGHT = 400;
const YLE_NEXT_XL_ITALIC_FONT_STYLE = 'italic';
const YLE_NEXT_XL_ITALIC_FONT_STRETCH = 'normal';
const YLE_NEXT_XL_ITALIC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_XL_ITALIC_LETTER_SPACING = 0;
const YLE_NEXT_XL_ITALIC_LINE_HEIGHT = '1.45';
const YLE_NEXT_XL_ITALIC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XL_ITALIC_PARAGRAPH_SPACING = '1.25rem';
const YLE_NEXT_XL_ITALIC_TEXT_CASE = 'none';
const YLE_NEXT_XL_BOLD_FONT_SIZE = '1.25rem';
const YLE_NEXT_XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_XL_BOLD_LINE_HEIGHT = '1.45';
const YLE_NEXT_XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XL_BOLD_PARAGRAPH_SPACING = '1.25rem';
const YLE_NEXT_XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_XL_HEAVY_FONT_SIZE = '1.25rem';
const YLE_NEXT_XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_XL_HEAVY_LINE_HEIGHT = '1.45';
const YLE_NEXT_XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XL_HEAVY_PARAGRAPH_SPACING = '1.25rem';
const YLE_NEXT_XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_XL_CONDENSED_FONT_SIZE = '1.25rem';
const YLE_NEXT_XL_CONDENSED_TEXT_DECORATION = 'none';
const YLE_NEXT_XL_CONDENSED_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XL_CONDENSED_FONT_WEIGHT = 400;
const YLE_NEXT_XL_CONDENSED_FONT_STYLE = 'normal';
const YLE_NEXT_XL_CONDENSED_FONT_STRETCH = 'condensed';
const YLE_NEXT_XL_CONDENSED_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_XL_CONDENSED_LETTER_SPACING = 0;
const YLE_NEXT_XL_CONDENSED_LINE_HEIGHT = '1.45';
const YLE_NEXT_XL_CONDENSED_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XL_CONDENSED_PARAGRAPH_SPACING = 0;
const YLE_NEXT_XL_CONDENSED_TEXT_CASE = 'none';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_SIZE = '1.25rem';
const YLE_NEXT_XL_CONDENSED_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_STRETCH = 'condensed';
const YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_XL_CONDENSED_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_XL_CONDENSED_BOLD_LINE_HEIGHT = '1.45';
const YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING = 0;
const YLE_NEXT_XL_CONDENSED_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_SIZE = '1.25rem';
const YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_XL_CONDENSED_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_XL_CONDENSED_HEAVY_LINE_HEIGHT = '1.45';
const YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_L_FONT_SIZE = '1.125rem';
const YLE_NEXT_L_TEXT_DECORATION = 'none';
const YLE_NEXT_L_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_L_FONT_WEIGHT = 400;
const YLE_NEXT_L_FONT_STYLE = 'normal';
const YLE_NEXT_L_FONT_STRETCH = 'normal';
const YLE_NEXT_L_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_L_LETTER_SPACING = 0;
const YLE_NEXT_L_LINE_HEIGHT = '1.45';
const YLE_NEXT_L_PARAGRAPH_INDENT = 0;
const YLE_NEXT_L_PARAGRAPH_SPACING = '1.125rem';
const YLE_NEXT_L_TEXT_CASE = 'none';
const YLE_NEXT_L_ITALIC_FONT_SIZE = '1.125rem';
const YLE_NEXT_L_ITALIC_TEXT_DECORATION = 'none';
const YLE_NEXT_L_ITALIC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_L_ITALIC_FONT_WEIGHT = 400;
const YLE_NEXT_L_ITALIC_FONT_STYLE = 'italic';
const YLE_NEXT_L_ITALIC_FONT_STRETCH = 'normal';
const YLE_NEXT_L_ITALIC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_L_ITALIC_LETTER_SPACING = 0;
const YLE_NEXT_L_ITALIC_LINE_HEIGHT = '1.45';
const YLE_NEXT_L_ITALIC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_L_ITALIC_PARAGRAPH_SPACING = '1.125rem';
const YLE_NEXT_L_ITALIC_TEXT_CASE = 'none';
const YLE_NEXT_L_BOLD_FONT_SIZE = '1.125rem';
const YLE_NEXT_L_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_L_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_L_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_L_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_L_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_L_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_L_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_L_BOLD_LINE_HEIGHT = '1.45';
const YLE_NEXT_L_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_L_BOLD_PARAGRAPH_SPACING = '1.125rem';
const YLE_NEXT_L_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_L_HEAVY_FONT_SIZE = '1.125rem';
const YLE_NEXT_L_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_L_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_L_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_L_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_L_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_L_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_L_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_L_HEAVY_LINE_HEIGHT = '1.45';
const YLE_NEXT_L_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_L_HEAVY_PARAGRAPH_SPACING = '1.125rem';
const YLE_NEXT_L_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_L_CONDENSED_FONT_SIZE = '1.125rem';
const YLE_NEXT_L_CONDENSED_TEXT_DECORATION = 'none';
const YLE_NEXT_L_CONDENSED_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_L_CONDENSED_FONT_WEIGHT = 400;
const YLE_NEXT_L_CONDENSED_FONT_STYLE = 'normal';
const YLE_NEXT_L_CONDENSED_FONT_STRETCH = 'condensed';
const YLE_NEXT_L_CONDENSED_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_L_CONDENSED_LETTER_SPACING = 0;
const YLE_NEXT_L_CONDENSED_LINE_HEIGHT = '1.45';
const YLE_NEXT_L_CONDENSED_PARAGRAPH_INDENT = 0;
const YLE_NEXT_L_CONDENSED_PARAGRAPH_SPACING = 0;
const YLE_NEXT_L_CONDENSED_TEXT_CASE = 'none';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_SIZE = '1.125rem';
const YLE_NEXT_L_CONDENSED_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_STRETCH = 'condensed';
const YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_L_CONDENSED_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_L_CONDENSED_BOLD_LINE_HEIGHT = '1.45';
const YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_SPACING = 0;
const YLE_NEXT_L_CONDENSED_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_SIZE = '1.125rem';
const YLE_NEXT_L_CONDENSED_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_STRETCH = 'condensed';
const YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_L_CONDENSED_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_L_CONDENSED_HEAVY_LINE_HEIGHT = '1.45';
const YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING = 0;
const YLE_NEXT_L_CONDENSED_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_M_FONT_SIZE = '1rem';
const YLE_NEXT_M_TEXT_DECORATION = 'none';
const YLE_NEXT_M_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_FONT_WEIGHT = 400;
const YLE_NEXT_M_FONT_STYLE = 'normal';
const YLE_NEXT_M_FONT_STRETCH = 'normal';
const YLE_NEXT_M_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_M_LETTER_SPACING = 0;
const YLE_NEXT_M_LINE_HEIGHT = '1.50';
const YLE_NEXT_M_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_PARAGRAPH_SPACING = '1rem';
const YLE_NEXT_M_TEXT_CASE = 'none';
const YLE_NEXT_M_AC_FONT_SIZE = '1rem';
const YLE_NEXT_M_AC_TEXT_DECORATION = 'none';
const YLE_NEXT_M_AC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_AC_FONT_WEIGHT = 400;
const YLE_NEXT_M_AC_FONT_STYLE = 'normal';
const YLE_NEXT_M_AC_FONT_STRETCH = 'normal';
const YLE_NEXT_M_AC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_M_AC_LETTER_SPACING = '0.01em';
const YLE_NEXT_M_AC_LINE_HEIGHT = '1.50';
const YLE_NEXT_M_AC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_AC_PARAGRAPH_SPACING = '1rem';
const YLE_NEXT_M_AC_TEXT_CASE = 'uppercase';
const YLE_NEXT_M_ITALIC_FONT_SIZE = '1rem';
const YLE_NEXT_M_ITALIC_TEXT_DECORATION = 'none';
const YLE_NEXT_M_ITALIC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_ITALIC_FONT_WEIGHT = 400;
const YLE_NEXT_M_ITALIC_FONT_STYLE = 'italic';
const YLE_NEXT_M_ITALIC_FONT_STRETCH = 'normal';
const YLE_NEXT_M_ITALIC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_M_ITALIC_LETTER_SPACING = 0;
const YLE_NEXT_M_ITALIC_LINE_HEIGHT = '1.50';
const YLE_NEXT_M_ITALIC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_ITALIC_PARAGRAPH_SPACING = '1rem';
const YLE_NEXT_M_ITALIC_TEXT_CASE = 'none';
const YLE_NEXT_M_MEDIUM_FONT_SIZE = '1rem';
const YLE_NEXT_M_MEDIUM_TEXT_DECORATION = 'none';
const YLE_NEXT_M_MEDIUM_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_MEDIUM_FONT_WEIGHT = 500;
const YLE_NEXT_M_MEDIUM_FONT_STYLE = 'normal';
const YLE_NEXT_M_MEDIUM_FONT_STRETCH = 'normal';
const YLE_NEXT_M_MEDIUM_FONT_STYLE_OLD = 'Medium';
const YLE_NEXT_M_MEDIUM_LETTER_SPACING = 0;
const YLE_NEXT_M_MEDIUM_LINE_HEIGHT = '1.50';
const YLE_NEXT_M_MEDIUM_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_MEDIUM_PARAGRAPH_SPACING = '1rem';
const YLE_NEXT_M_MEDIUM_TEXT_CASE = 'none';
const YLE_NEXT_M_BOLD_FONT_SIZE = '1rem';
const YLE_NEXT_M_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_M_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_M_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_M_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_M_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_M_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_M_BOLD_LINE_HEIGHT = '1.50';
const YLE_NEXT_M_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_BOLD_PARAGRAPH_SPACING = '1rem';
const YLE_NEXT_M_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_M_BOLD_AC_FONT_SIZE = '1rem';
const YLE_NEXT_M_BOLD_AC_TEXT_DECORATION = 'none';
const YLE_NEXT_M_BOLD_AC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_BOLD_AC_FONT_WEIGHT = 700;
const YLE_NEXT_M_BOLD_AC_FONT_STYLE = 'normal';
const YLE_NEXT_M_BOLD_AC_FONT_STRETCH = 'normal';
const YLE_NEXT_M_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_M_BOLD_AC_LETTER_SPACING = '0.01em';
const YLE_NEXT_M_BOLD_AC_LINE_HEIGHT = '1.50';
const YLE_NEXT_M_BOLD_AC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_BOLD_AC_PARAGRAPH_SPACING = '1rem';
const YLE_NEXT_M_BOLD_AC_TEXT_CASE = 'uppercase';
const YLE_NEXT_M_CONDENSED_FONT_SIZE = '1rem';
const YLE_NEXT_M_CONDENSED_TEXT_DECORATION = 'none';
const YLE_NEXT_M_CONDENSED_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_CONDENSED_FONT_WEIGHT = 400;
const YLE_NEXT_M_CONDENSED_FONT_STYLE = 'normal';
const YLE_NEXT_M_CONDENSED_FONT_STRETCH = 'condensed';
const YLE_NEXT_M_CONDENSED_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_M_CONDENSED_LETTER_SPACING = 0;
const YLE_NEXT_M_CONDENSED_LINE_HEIGHT = '1.50';
const YLE_NEXT_M_CONDENSED_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_CONDENSED_PARAGRAPH_SPACING = 0;
const YLE_NEXT_M_CONDENSED_TEXT_CASE = 'none';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_SIZE = '1rem';
const YLE_NEXT_M_CONDENSED_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_STRETCH = 'condensed';
const YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_M_CONDENSED_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_M_CONDENSED_BOLD_LINE_HEIGHT = '1.50';
const YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_SPACING = 0;
const YLE_NEXT_M_CONDENSED_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_S_FONT_SIZE = '0.875rem';
const YLE_NEXT_S_TEXT_DECORATION = 'none';
const YLE_NEXT_S_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_FONT_WEIGHT = 400;
const YLE_NEXT_S_FONT_STYLE = 'normal';
const YLE_NEXT_S_FONT_STRETCH = 'normal';
const YLE_NEXT_S_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_S_LETTER_SPACING = 0;
const YLE_NEXT_S_LINE_HEIGHT = '1.50';
const YLE_NEXT_S_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_PARAGRAPH_SPACING = '0.875rem';
const YLE_NEXT_S_TEXT_CASE = 'none';
const YLE_NEXT_S_ITALIC_FONT_SIZE = '0.875rem';
const YLE_NEXT_S_ITALIC_TEXT_DECORATION = 'none';
const YLE_NEXT_S_ITALIC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_ITALIC_FONT_WEIGHT = 400;
const YLE_NEXT_S_ITALIC_FONT_STYLE = 'italic';
const YLE_NEXT_S_ITALIC_FONT_STRETCH = 'normal';
const YLE_NEXT_S_ITALIC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_S_ITALIC_LETTER_SPACING = 0;
const YLE_NEXT_S_ITALIC_LINE_HEIGHT = '1.50';
const YLE_NEXT_S_ITALIC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_ITALIC_PARAGRAPH_SPACING = '0.875rem';
const YLE_NEXT_S_ITALIC_TEXT_CASE = 'none';
const YLE_NEXT_S_AC_FONT_SIZE = '0.875rem';
const YLE_NEXT_S_AC_TEXT_DECORATION = 'none';
const YLE_NEXT_S_AC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_AC_FONT_WEIGHT = 400;
const YLE_NEXT_S_AC_FONT_STYLE = 'normal';
const YLE_NEXT_S_AC_FONT_STRETCH = 'normal';
const YLE_NEXT_S_AC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_S_AC_LETTER_SPACING = '0.01em';
const YLE_NEXT_S_AC_LINE_HEIGHT = '1.50';
const YLE_NEXT_S_AC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_AC_PARAGRAPH_SPACING = '0.875rem';
const YLE_NEXT_S_AC_TEXT_CASE = 'uppercase';
const YLE_NEXT_S_MEDIUM_FONT_SIZE = '0.875rem';
const YLE_NEXT_S_MEDIUM_TEXT_DECORATION = 'none';
const YLE_NEXT_S_MEDIUM_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_MEDIUM_FONT_WEIGHT = 500;
const YLE_NEXT_S_MEDIUM_FONT_STYLE = 'normal';
const YLE_NEXT_S_MEDIUM_FONT_STRETCH = 'normal';
const YLE_NEXT_S_MEDIUM_FONT_STYLE_OLD = 'Medium';
const YLE_NEXT_S_MEDIUM_LETTER_SPACING = 0;
const YLE_NEXT_S_MEDIUM_LINE_HEIGHT = '1.50';
const YLE_NEXT_S_MEDIUM_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_MEDIUM_PARAGRAPH_SPACING = 0;
const YLE_NEXT_S_MEDIUM_TEXT_CASE = 'none';
const YLE_NEXT_S_BOLD_FONT_SIZE = '0.875rem';
const YLE_NEXT_S_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_S_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_S_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_S_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_S_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_S_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_S_BOLD_LINE_HEIGHT = '1.50';
const YLE_NEXT_S_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_BOLD_PARAGRAPH_SPACING = '0.875rem';
const YLE_NEXT_S_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_S_BOLD_AC_FONT_SIZE = '0.875rem';
const YLE_NEXT_S_BOLD_AC_TEXT_DECORATION = 'none';
const YLE_NEXT_S_BOLD_AC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_BOLD_AC_FONT_WEIGHT = 700;
const YLE_NEXT_S_BOLD_AC_FONT_STYLE = 'normal';
const YLE_NEXT_S_BOLD_AC_FONT_STRETCH = 'normal';
const YLE_NEXT_S_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_S_BOLD_AC_LETTER_SPACING = '0.01em';
const YLE_NEXT_S_BOLD_AC_LINE_HEIGHT = '1.50';
const YLE_NEXT_S_BOLD_AC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_BOLD_AC_PARAGRAPH_SPACING = '0.875rem';
const YLE_NEXT_S_BOLD_AC_TEXT_CASE = 'uppercase';
const YLE_NEXT_S_CONDENSED_FONT_SIZE = '0.875rem';
const YLE_NEXT_S_CONDENSED_TEXT_DECORATION = 'none';
const YLE_NEXT_S_CONDENSED_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_CONDENSED_FONT_WEIGHT = 400;
const YLE_NEXT_S_CONDENSED_FONT_STYLE = 'normal';
const YLE_NEXT_S_CONDENSED_FONT_STRETCH = 'condensed';
const YLE_NEXT_S_CONDENSED_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_S_CONDENSED_LETTER_SPACING = 0;
const YLE_NEXT_S_CONDENSED_LINE_HEIGHT = '1.50';
const YLE_NEXT_S_CONDENSED_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_CONDENSED_PARAGRAPH_SPACING = 0;
const YLE_NEXT_S_CONDENSED_TEXT_CASE = 'none';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_SIZE = '0.875rem';
const YLE_NEXT_S_CONDENSED_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_STRETCH = 'condensed';
const YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_S_CONDENSED_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_S_CONDENSED_BOLD_LINE_HEIGHT = '1.50';
const YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_SPACING = 0;
const YLE_NEXT_S_CONDENSED_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_XS_FONT_SIZE = '0.75rem';
const YLE_NEXT_XS_TEXT_DECORATION = 'none';
const YLE_NEXT_XS_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XS_FONT_WEIGHT = 400;
const YLE_NEXT_XS_FONT_STYLE = 'normal';
const YLE_NEXT_XS_FONT_STRETCH = 'normal';
const YLE_NEXT_XS_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_XS_LETTER_SPACING = 0;
const YLE_NEXT_XS_LINE_HEIGHT = '1.50';
const YLE_NEXT_XS_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XS_PARAGRAPH_SPACING = '0.75rem';
const YLE_NEXT_XS_TEXT_CASE = 'none';
const YLE_NEXT_XS_ITALIC_FONT_SIZE = '0.75rem';
const YLE_NEXT_XS_ITALIC_TEXT_DECORATION = 'none';
const YLE_NEXT_XS_ITALIC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XS_ITALIC_FONT_WEIGHT = 400;
const YLE_NEXT_XS_ITALIC_FONT_STYLE = 'italic';
const YLE_NEXT_XS_ITALIC_FONT_STRETCH = 'normal';
const YLE_NEXT_XS_ITALIC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_XS_ITALIC_LETTER_SPACING = 0;
const YLE_NEXT_XS_ITALIC_LINE_HEIGHT = '1.50';
const YLE_NEXT_XS_ITALIC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XS_ITALIC_PARAGRAPH_SPACING = '0.75rem';
const YLE_NEXT_XS_ITALIC_TEXT_CASE = 'none';
const YLE_NEXT_XS_AC_FONT_SIZE = '0.75rem';
const YLE_NEXT_XS_AC_TEXT_DECORATION = 'none';
const YLE_NEXT_XS_AC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XS_AC_FONT_WEIGHT = 400;
const YLE_NEXT_XS_AC_FONT_STYLE = 'normal';
const YLE_NEXT_XS_AC_FONT_STRETCH = 'normal';
const YLE_NEXT_XS_AC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_XS_AC_LETTER_SPACING = '0.01em';
const YLE_NEXT_XS_AC_LINE_HEIGHT = '1.50';
const YLE_NEXT_XS_AC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XS_AC_PARAGRAPH_SPACING = '0.75rem';
const YLE_NEXT_XS_AC_TEXT_CASE = 'uppercase';
const YLE_NEXT_XS_BOLD_FONT_SIZE = '0.75rem';
const YLE_NEXT_XS_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_XS_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XS_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_XS_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_XS_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_XS_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_XS_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_XS_BOLD_LINE_HEIGHT = '1.50';
const YLE_NEXT_XS_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XS_BOLD_PARAGRAPH_SPACING = '0.75rem';
const YLE_NEXT_XS_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_XS_BOLD_AC_FONT_SIZE = '0.75rem';
const YLE_NEXT_XS_BOLD_AC_TEXT_DECORATION = 'none';
const YLE_NEXT_XS_BOLD_AC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XS_BOLD_AC_FONT_WEIGHT = 700;
const YLE_NEXT_XS_BOLD_AC_FONT_STYLE = 'normal';
const YLE_NEXT_XS_BOLD_AC_FONT_STRETCH = 'normal';
const YLE_NEXT_XS_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_XS_BOLD_AC_LETTER_SPACING = '0.01em';
const YLE_NEXT_XS_BOLD_AC_LINE_HEIGHT = '1.50';
const YLE_NEXT_XS_BOLD_AC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XS_BOLD_AC_PARAGRAPH_SPACING = '0.75rem';
const YLE_NEXT_XS_BOLD_AC_TEXT_CASE = 'uppercase';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_SIZE = '0.75rem';
const YLE_NEXT_XS_CONDENSED_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_STRETCH = 'condensed';
const YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_XS_CONDENSED_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_XS_CONDENSED_BOLD_LINE_HEIGHT = '1.50';
const YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING = 0;
const YLE_NEXT_XS_CONDENSED_BOLD_TEXT_CASE = 'none';

var typographyRem = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DEFAULT_2XL_BOLD_FONT_FAMILY: DEFAULT_2XL_BOLD_FONT_FAMILY,
  DEFAULT_2XL_BOLD_FONT_SIZE: DEFAULT_2XL_BOLD_FONT_SIZE,
  DEFAULT_2XL_BOLD_FONT_STRETCH: DEFAULT_2XL_BOLD_FONT_STRETCH,
  DEFAULT_2XL_BOLD_FONT_STYLE: DEFAULT_2XL_BOLD_FONT_STYLE,
  DEFAULT_2XL_BOLD_FONT_STYLE_OLD: DEFAULT_2XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_2XL_BOLD_FONT_WEIGHT: DEFAULT_2XL_BOLD_FONT_WEIGHT,
  DEFAULT_2XL_BOLD_LETTER_SPACING: DEFAULT_2XL_BOLD_LETTER_SPACING,
  DEFAULT_2XL_BOLD_LINE_HEIGHT: DEFAULT_2XL_BOLD_LINE_HEIGHT,
  DEFAULT_2XL_BOLD_PARAGRAPH_INDENT: DEFAULT_2XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_2XL_BOLD_PARAGRAPH_SPACING: DEFAULT_2XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_2XL_BOLD_TEXT_CASE: DEFAULT_2XL_BOLD_TEXT_CASE,
  DEFAULT_2XL_BOLD_TEXT_DECORATION: DEFAULT_2XL_BOLD_TEXT_DECORATION,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_2XL_CONDENSED_BOLD_FONT_FAMILY,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_SIZE: DEFAULT_2XL_CONDENSED_BOLD_FONT_SIZE,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_2XL_CONDENSED_BOLD_FONT_STRETCH,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE: DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD,
  DEFAULT_2XL_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_2XL_CONDENSED_BOLD_FONT_WEIGHT,
  DEFAULT_2XL_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_2XL_CONDENSED_BOLD_LETTER_SPACING,
  DEFAULT_2XL_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_2XL_CONDENSED_BOLD_LINE_HEIGHT,
  DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT,
  DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING,
  DEFAULT_2XL_CONDENSED_BOLD_TEXT_CASE: DEFAULT_2XL_CONDENSED_BOLD_TEXT_CASE,
  DEFAULT_2XL_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_2XL_CONDENSED_BOLD_TEXT_DECORATION,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_2XL_CONDENSED_HEAVY_FONT_FAMILY,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_2XL_CONDENSED_HEAVY_FONT_SIZE,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_2XL_CONDENSED_HEAVY_FONT_STRETCH,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  DEFAULT_2XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_2XL_CONDENSED_HEAVY_FONT_WEIGHT,
  DEFAULT_2XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_2XL_CONDENSED_HEAVY_LETTER_SPACING,
  DEFAULT_2XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_2XL_CONDENSED_HEAVY_LINE_HEIGHT,
  DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_2XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_2XL_CONDENSED_HEAVY_TEXT_CASE,
  DEFAULT_2XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_2XL_CONDENSED_HEAVY_TEXT_DECORATION,
  DEFAULT_2XL_FONT_FAMILY: DEFAULT_2XL_FONT_FAMILY,
  DEFAULT_2XL_FONT_SIZE: DEFAULT_2XL_FONT_SIZE,
  DEFAULT_2XL_FONT_STRETCH: DEFAULT_2XL_FONT_STRETCH,
  DEFAULT_2XL_FONT_STYLE: DEFAULT_2XL_FONT_STYLE,
  DEFAULT_2XL_FONT_STYLE_OLD: DEFAULT_2XL_FONT_STYLE_OLD,
  DEFAULT_2XL_FONT_WEIGHT: DEFAULT_2XL_FONT_WEIGHT,
  DEFAULT_2XL_HEAVY_FONT_FAMILY: DEFAULT_2XL_HEAVY_FONT_FAMILY,
  DEFAULT_2XL_HEAVY_FONT_SIZE: DEFAULT_2XL_HEAVY_FONT_SIZE,
  DEFAULT_2XL_HEAVY_FONT_STRETCH: DEFAULT_2XL_HEAVY_FONT_STRETCH,
  DEFAULT_2XL_HEAVY_FONT_STYLE: DEFAULT_2XL_HEAVY_FONT_STYLE,
  DEFAULT_2XL_HEAVY_FONT_STYLE_OLD: DEFAULT_2XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_2XL_HEAVY_FONT_WEIGHT: DEFAULT_2XL_HEAVY_FONT_WEIGHT,
  DEFAULT_2XL_HEAVY_LETTER_SPACING: DEFAULT_2XL_HEAVY_LETTER_SPACING,
  DEFAULT_2XL_HEAVY_LINE_HEIGHT: DEFAULT_2XL_HEAVY_LINE_HEIGHT,
  DEFAULT_2XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_2XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_2XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_2XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_2XL_HEAVY_TEXT_CASE: DEFAULT_2XL_HEAVY_TEXT_CASE,
  DEFAULT_2XL_HEAVY_TEXT_DECORATION: DEFAULT_2XL_HEAVY_TEXT_DECORATION,
  DEFAULT_2XL_LETTER_SPACING: DEFAULT_2XL_LETTER_SPACING,
  DEFAULT_2XL_LINE_HEIGHT: DEFAULT_2XL_LINE_HEIGHT,
  DEFAULT_2XL_PARAGRAPH_INDENT: DEFAULT_2XL_PARAGRAPH_INDENT,
  DEFAULT_2XL_PARAGRAPH_SPACING: DEFAULT_2XL_PARAGRAPH_SPACING,
  DEFAULT_2XL_TEXT_CASE: DEFAULT_2XL_TEXT_CASE,
  DEFAULT_2XL_TEXT_DECORATION: DEFAULT_2XL_TEXT_DECORATION,
  DEFAULT_3XL_BOLD_FONT_FAMILY: DEFAULT_3XL_BOLD_FONT_FAMILY,
  DEFAULT_3XL_BOLD_FONT_SIZE: DEFAULT_3XL_BOLD_FONT_SIZE,
  DEFAULT_3XL_BOLD_FONT_STRETCH: DEFAULT_3XL_BOLD_FONT_STRETCH,
  DEFAULT_3XL_BOLD_FONT_STYLE: DEFAULT_3XL_BOLD_FONT_STYLE,
  DEFAULT_3XL_BOLD_FONT_STYLE_OLD: DEFAULT_3XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_3XL_BOLD_FONT_WEIGHT: DEFAULT_3XL_BOLD_FONT_WEIGHT,
  DEFAULT_3XL_BOLD_LETTER_SPACING: DEFAULT_3XL_BOLD_LETTER_SPACING,
  DEFAULT_3XL_BOLD_LINE_HEIGHT: DEFAULT_3XL_BOLD_LINE_HEIGHT,
  DEFAULT_3XL_BOLD_PARAGRAPH_INDENT: DEFAULT_3XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_3XL_BOLD_PARAGRAPH_SPACING: DEFAULT_3XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_3XL_BOLD_TEXT_CASE: DEFAULT_3XL_BOLD_TEXT_CASE,
  DEFAULT_3XL_BOLD_TEXT_DECORATION: DEFAULT_3XL_BOLD_TEXT_DECORATION,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_3XL_CONDENSED_HEAVY_FONT_FAMILY,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_3XL_CONDENSED_HEAVY_FONT_SIZE,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_3XL_CONDENSED_HEAVY_FONT_STRETCH,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  DEFAULT_3XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_3XL_CONDENSED_HEAVY_FONT_WEIGHT,
  DEFAULT_3XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_3XL_CONDENSED_HEAVY_LETTER_SPACING,
  DEFAULT_3XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_3XL_CONDENSED_HEAVY_LINE_HEIGHT,
  DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_3XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_3XL_CONDENSED_HEAVY_TEXT_CASE,
  DEFAULT_3XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_3XL_CONDENSED_HEAVY_TEXT_DECORATION,
  DEFAULT_3XL_HEAVY_FONT_FAMILY: DEFAULT_3XL_HEAVY_FONT_FAMILY,
  DEFAULT_3XL_HEAVY_FONT_SIZE: DEFAULT_3XL_HEAVY_FONT_SIZE,
  DEFAULT_3XL_HEAVY_FONT_STRETCH: DEFAULT_3XL_HEAVY_FONT_STRETCH,
  DEFAULT_3XL_HEAVY_FONT_STYLE: DEFAULT_3XL_HEAVY_FONT_STYLE,
  DEFAULT_3XL_HEAVY_FONT_STYLE_OLD: DEFAULT_3XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_3XL_HEAVY_FONT_WEIGHT: DEFAULT_3XL_HEAVY_FONT_WEIGHT,
  DEFAULT_3XL_HEAVY_LETTER_SPACING: DEFAULT_3XL_HEAVY_LETTER_SPACING,
  DEFAULT_3XL_HEAVY_LINE_HEIGHT: DEFAULT_3XL_HEAVY_LINE_HEIGHT,
  DEFAULT_3XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_3XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_3XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_3XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_3XL_HEAVY_TEXT_CASE: DEFAULT_3XL_HEAVY_TEXT_CASE,
  DEFAULT_3XL_HEAVY_TEXT_DECORATION: DEFAULT_3XL_HEAVY_TEXT_DECORATION,
  DEFAULT_4XL_BOLD_FONT_FAMILY: DEFAULT_4XL_BOLD_FONT_FAMILY,
  DEFAULT_4XL_BOLD_FONT_SIZE: DEFAULT_4XL_BOLD_FONT_SIZE,
  DEFAULT_4XL_BOLD_FONT_STRETCH: DEFAULT_4XL_BOLD_FONT_STRETCH,
  DEFAULT_4XL_BOLD_FONT_STYLE: DEFAULT_4XL_BOLD_FONT_STYLE,
  DEFAULT_4XL_BOLD_FONT_STYLE_OLD: DEFAULT_4XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_4XL_BOLD_FONT_WEIGHT: DEFAULT_4XL_BOLD_FONT_WEIGHT,
  DEFAULT_4XL_BOLD_LETTER_SPACING: DEFAULT_4XL_BOLD_LETTER_SPACING,
  DEFAULT_4XL_BOLD_LINE_HEIGHT: DEFAULT_4XL_BOLD_LINE_HEIGHT,
  DEFAULT_4XL_BOLD_PARAGRAPH_INDENT: DEFAULT_4XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_4XL_BOLD_PARAGRAPH_SPACING: DEFAULT_4XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_4XL_BOLD_TEXT_CASE: DEFAULT_4XL_BOLD_TEXT_CASE,
  DEFAULT_4XL_BOLD_TEXT_DECORATION: DEFAULT_4XL_BOLD_TEXT_DECORATION,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_4XL_CONDENSED_HEAVY_FONT_FAMILY,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_4XL_CONDENSED_HEAVY_FONT_SIZE,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_4XL_CONDENSED_HEAVY_FONT_STRETCH,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  DEFAULT_4XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_4XL_CONDENSED_HEAVY_FONT_WEIGHT,
  DEFAULT_4XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_4XL_CONDENSED_HEAVY_LETTER_SPACING,
  DEFAULT_4XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_4XL_CONDENSED_HEAVY_LINE_HEIGHT,
  DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_4XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_4XL_CONDENSED_HEAVY_TEXT_CASE,
  DEFAULT_4XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_4XL_CONDENSED_HEAVY_TEXT_DECORATION,
  DEFAULT_4XL_HEAVY_FONT_FAMILY: DEFAULT_4XL_HEAVY_FONT_FAMILY,
  DEFAULT_4XL_HEAVY_FONT_SIZE: DEFAULT_4XL_HEAVY_FONT_SIZE,
  DEFAULT_4XL_HEAVY_FONT_STRETCH: DEFAULT_4XL_HEAVY_FONT_STRETCH,
  DEFAULT_4XL_HEAVY_FONT_STYLE: DEFAULT_4XL_HEAVY_FONT_STYLE,
  DEFAULT_4XL_HEAVY_FONT_STYLE_OLD: DEFAULT_4XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_4XL_HEAVY_FONT_WEIGHT: DEFAULT_4XL_HEAVY_FONT_WEIGHT,
  DEFAULT_4XL_HEAVY_LETTER_SPACING: DEFAULT_4XL_HEAVY_LETTER_SPACING,
  DEFAULT_4XL_HEAVY_LINE_HEIGHT: DEFAULT_4XL_HEAVY_LINE_HEIGHT,
  DEFAULT_4XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_4XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_4XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_4XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_4XL_HEAVY_TEXT_CASE: DEFAULT_4XL_HEAVY_TEXT_CASE,
  DEFAULT_4XL_HEAVY_TEXT_DECORATION: DEFAULT_4XL_HEAVY_TEXT_DECORATION,
  DEFAULT_5XL_BOLD_FONT_FAMILY: DEFAULT_5XL_BOLD_FONT_FAMILY,
  DEFAULT_5XL_BOLD_FONT_SIZE: DEFAULT_5XL_BOLD_FONT_SIZE,
  DEFAULT_5XL_BOLD_FONT_STRETCH: DEFAULT_5XL_BOLD_FONT_STRETCH,
  DEFAULT_5XL_BOLD_FONT_STYLE: DEFAULT_5XL_BOLD_FONT_STYLE,
  DEFAULT_5XL_BOLD_FONT_STYLE_OLD: DEFAULT_5XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_5XL_BOLD_FONT_WEIGHT: DEFAULT_5XL_BOLD_FONT_WEIGHT,
  DEFAULT_5XL_BOLD_LETTER_SPACING: DEFAULT_5XL_BOLD_LETTER_SPACING,
  DEFAULT_5XL_BOLD_LINE_HEIGHT: DEFAULT_5XL_BOLD_LINE_HEIGHT,
  DEFAULT_5XL_BOLD_PARAGRAPH_INDENT: DEFAULT_5XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_5XL_BOLD_PARAGRAPH_SPACING: DEFAULT_5XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_5XL_BOLD_TEXT_CASE: DEFAULT_5XL_BOLD_TEXT_CASE,
  DEFAULT_5XL_BOLD_TEXT_DECORATION: DEFAULT_5XL_BOLD_TEXT_DECORATION,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_5XL_CONDENSED_HEAVY_FONT_FAMILY,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_5XL_CONDENSED_HEAVY_FONT_SIZE,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_5XL_CONDENSED_HEAVY_FONT_STRETCH,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  DEFAULT_5XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_5XL_CONDENSED_HEAVY_FONT_WEIGHT,
  DEFAULT_5XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_5XL_CONDENSED_HEAVY_LETTER_SPACING,
  DEFAULT_5XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_5XL_CONDENSED_HEAVY_LINE_HEIGHT,
  DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_5XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_5XL_CONDENSED_HEAVY_TEXT_CASE,
  DEFAULT_5XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_5XL_CONDENSED_HEAVY_TEXT_DECORATION,
  DEFAULT_5XL_HEAVY_FONT_FAMILY: DEFAULT_5XL_HEAVY_FONT_FAMILY,
  DEFAULT_5XL_HEAVY_FONT_SIZE: DEFAULT_5XL_HEAVY_FONT_SIZE,
  DEFAULT_5XL_HEAVY_FONT_STRETCH: DEFAULT_5XL_HEAVY_FONT_STRETCH,
  DEFAULT_5XL_HEAVY_FONT_STYLE: DEFAULT_5XL_HEAVY_FONT_STYLE,
  DEFAULT_5XL_HEAVY_FONT_STYLE_OLD: DEFAULT_5XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_5XL_HEAVY_FONT_WEIGHT: DEFAULT_5XL_HEAVY_FONT_WEIGHT,
  DEFAULT_5XL_HEAVY_LETTER_SPACING: DEFAULT_5XL_HEAVY_LETTER_SPACING,
  DEFAULT_5XL_HEAVY_LINE_HEIGHT: DEFAULT_5XL_HEAVY_LINE_HEIGHT,
  DEFAULT_5XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_5XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_5XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_5XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_5XL_HEAVY_TEXT_CASE: DEFAULT_5XL_HEAVY_TEXT_CASE,
  DEFAULT_5XL_HEAVY_TEXT_DECORATION: DEFAULT_5XL_HEAVY_TEXT_DECORATION,
  DEFAULT_6XL_BOLD_FONT_FAMILY: DEFAULT_6XL_BOLD_FONT_FAMILY,
  DEFAULT_6XL_BOLD_FONT_SIZE: DEFAULT_6XL_BOLD_FONT_SIZE,
  DEFAULT_6XL_BOLD_FONT_STRETCH: DEFAULT_6XL_BOLD_FONT_STRETCH,
  DEFAULT_6XL_BOLD_FONT_STYLE: DEFAULT_6XL_BOLD_FONT_STYLE,
  DEFAULT_6XL_BOLD_FONT_STYLE_OLD: DEFAULT_6XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_6XL_BOLD_FONT_WEIGHT: DEFAULT_6XL_BOLD_FONT_WEIGHT,
  DEFAULT_6XL_BOLD_LETTER_SPACING: DEFAULT_6XL_BOLD_LETTER_SPACING,
  DEFAULT_6XL_BOLD_LINE_HEIGHT: DEFAULT_6XL_BOLD_LINE_HEIGHT,
  DEFAULT_6XL_BOLD_PARAGRAPH_INDENT: DEFAULT_6XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_6XL_BOLD_PARAGRAPH_SPACING: DEFAULT_6XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_6XL_BOLD_TEXT_CASE: DEFAULT_6XL_BOLD_TEXT_CASE,
  DEFAULT_6XL_BOLD_TEXT_DECORATION: DEFAULT_6XL_BOLD_TEXT_DECORATION,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_6XL_CONDENSED_HEAVY_FONT_FAMILY,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_6XL_CONDENSED_HEAVY_FONT_SIZE,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_6XL_CONDENSED_HEAVY_FONT_STRETCH,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  DEFAULT_6XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_6XL_CONDENSED_HEAVY_FONT_WEIGHT,
  DEFAULT_6XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_6XL_CONDENSED_HEAVY_LETTER_SPACING,
  DEFAULT_6XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_6XL_CONDENSED_HEAVY_LINE_HEIGHT,
  DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_6XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_6XL_CONDENSED_HEAVY_TEXT_CASE,
  DEFAULT_6XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_6XL_CONDENSED_HEAVY_TEXT_DECORATION,
  DEFAULT_6XL_HEAVY_FONT_FAMILY: DEFAULT_6XL_HEAVY_FONT_FAMILY,
  DEFAULT_6XL_HEAVY_FONT_SIZE: DEFAULT_6XL_HEAVY_FONT_SIZE,
  DEFAULT_6XL_HEAVY_FONT_STRETCH: DEFAULT_6XL_HEAVY_FONT_STRETCH,
  DEFAULT_6XL_HEAVY_FONT_STYLE: DEFAULT_6XL_HEAVY_FONT_STYLE,
  DEFAULT_6XL_HEAVY_FONT_STYLE_OLD: DEFAULT_6XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_6XL_HEAVY_FONT_WEIGHT: DEFAULT_6XL_HEAVY_FONT_WEIGHT,
  DEFAULT_6XL_HEAVY_LETTER_SPACING: DEFAULT_6XL_HEAVY_LETTER_SPACING,
  DEFAULT_6XL_HEAVY_LINE_HEIGHT: DEFAULT_6XL_HEAVY_LINE_HEIGHT,
  DEFAULT_6XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_6XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_6XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_6XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_6XL_HEAVY_TEXT_CASE: DEFAULT_6XL_HEAVY_TEXT_CASE,
  DEFAULT_6XL_HEAVY_TEXT_DECORATION: DEFAULT_6XL_HEAVY_TEXT_DECORATION,
  DEFAULT_7XL_BOLD_FONT_FAMILY: DEFAULT_7XL_BOLD_FONT_FAMILY,
  DEFAULT_7XL_BOLD_FONT_SIZE: DEFAULT_7XL_BOLD_FONT_SIZE,
  DEFAULT_7XL_BOLD_FONT_STRETCH: DEFAULT_7XL_BOLD_FONT_STRETCH,
  DEFAULT_7XL_BOLD_FONT_STYLE: DEFAULT_7XL_BOLD_FONT_STYLE,
  DEFAULT_7XL_BOLD_FONT_STYLE_OLD: DEFAULT_7XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_7XL_BOLD_FONT_WEIGHT: DEFAULT_7XL_BOLD_FONT_WEIGHT,
  DEFAULT_7XL_BOLD_LETTER_SPACING: DEFAULT_7XL_BOLD_LETTER_SPACING,
  DEFAULT_7XL_BOLD_LINE_HEIGHT: DEFAULT_7XL_BOLD_LINE_HEIGHT,
  DEFAULT_7XL_BOLD_PARAGRAPH_INDENT: DEFAULT_7XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_7XL_BOLD_PARAGRAPH_SPACING: DEFAULT_7XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_7XL_BOLD_TEXT_CASE: DEFAULT_7XL_BOLD_TEXT_CASE,
  DEFAULT_7XL_BOLD_TEXT_DECORATION: DEFAULT_7XL_BOLD_TEXT_DECORATION,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_7XL_CONDENSED_HEAVY_FONT_FAMILY,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_7XL_CONDENSED_HEAVY_FONT_SIZE,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_7XL_CONDENSED_HEAVY_FONT_STRETCH,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  DEFAULT_7XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_7XL_CONDENSED_HEAVY_FONT_WEIGHT,
  DEFAULT_7XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_7XL_CONDENSED_HEAVY_LETTER_SPACING,
  DEFAULT_7XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_7XL_CONDENSED_HEAVY_LINE_HEIGHT,
  DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_7XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_7XL_CONDENSED_HEAVY_TEXT_CASE,
  DEFAULT_7XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_7XL_CONDENSED_HEAVY_TEXT_DECORATION,
  DEFAULT_7XL_HEAVY_FONT_FAMILY: DEFAULT_7XL_HEAVY_FONT_FAMILY,
  DEFAULT_7XL_HEAVY_FONT_SIZE: DEFAULT_7XL_HEAVY_FONT_SIZE,
  DEFAULT_7XL_HEAVY_FONT_STRETCH: DEFAULT_7XL_HEAVY_FONT_STRETCH,
  DEFAULT_7XL_HEAVY_FONT_STYLE: DEFAULT_7XL_HEAVY_FONT_STYLE,
  DEFAULT_7XL_HEAVY_FONT_STYLE_OLD: DEFAULT_7XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_7XL_HEAVY_FONT_WEIGHT: DEFAULT_7XL_HEAVY_FONT_WEIGHT,
  DEFAULT_7XL_HEAVY_LETTER_SPACING: DEFAULT_7XL_HEAVY_LETTER_SPACING,
  DEFAULT_7XL_HEAVY_LINE_HEIGHT: DEFAULT_7XL_HEAVY_LINE_HEIGHT,
  DEFAULT_7XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_7XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_7XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_7XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_7XL_HEAVY_TEXT_CASE: DEFAULT_7XL_HEAVY_TEXT_CASE,
  DEFAULT_7XL_HEAVY_TEXT_DECORATION: DEFAULT_7XL_HEAVY_TEXT_DECORATION,
  DEFAULT_L_BOLD_FONT_FAMILY: DEFAULT_L_BOLD_FONT_FAMILY,
  DEFAULT_L_BOLD_FONT_SIZE: DEFAULT_L_BOLD_FONT_SIZE,
  DEFAULT_L_BOLD_FONT_STRETCH: DEFAULT_L_BOLD_FONT_STRETCH,
  DEFAULT_L_BOLD_FONT_STYLE: DEFAULT_L_BOLD_FONT_STYLE,
  DEFAULT_L_BOLD_FONT_STYLE_OLD: DEFAULT_L_BOLD_FONT_STYLE_OLD,
  DEFAULT_L_BOLD_FONT_WEIGHT: DEFAULT_L_BOLD_FONT_WEIGHT,
  DEFAULT_L_BOLD_LETTER_SPACING: DEFAULT_L_BOLD_LETTER_SPACING,
  DEFAULT_L_BOLD_LINE_HEIGHT: DEFAULT_L_BOLD_LINE_HEIGHT,
  DEFAULT_L_BOLD_PARAGRAPH_INDENT: DEFAULT_L_BOLD_PARAGRAPH_INDENT,
  DEFAULT_L_BOLD_PARAGRAPH_SPACING: DEFAULT_L_BOLD_PARAGRAPH_SPACING,
  DEFAULT_L_BOLD_TEXT_CASE: DEFAULT_L_BOLD_TEXT_CASE,
  DEFAULT_L_BOLD_TEXT_DECORATION: DEFAULT_L_BOLD_TEXT_DECORATION,
  DEFAULT_L_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_L_CONDENSED_BOLD_FONT_FAMILY,
  DEFAULT_L_CONDENSED_BOLD_FONT_SIZE: DEFAULT_L_CONDENSED_BOLD_FONT_SIZE,
  DEFAULT_L_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_L_CONDENSED_BOLD_FONT_STRETCH,
  DEFAULT_L_CONDENSED_BOLD_FONT_STYLE: DEFAULT_L_CONDENSED_BOLD_FONT_STYLE,
  DEFAULT_L_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_L_CONDENSED_BOLD_FONT_STYLE_OLD,
  DEFAULT_L_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_L_CONDENSED_BOLD_FONT_WEIGHT,
  DEFAULT_L_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_L_CONDENSED_BOLD_LETTER_SPACING,
  DEFAULT_L_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_L_CONDENSED_BOLD_LINE_HEIGHT,
  DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_INDENT,
  DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_L_CONDENSED_BOLD_PARAGRAPH_SPACING,
  DEFAULT_L_CONDENSED_BOLD_TEXT_CASE: DEFAULT_L_CONDENSED_BOLD_TEXT_CASE,
  DEFAULT_L_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_L_CONDENSED_BOLD_TEXT_DECORATION,
  DEFAULT_L_CONDENSED_FONT_FAMILY: DEFAULT_L_CONDENSED_FONT_FAMILY,
  DEFAULT_L_CONDENSED_FONT_SIZE: DEFAULT_L_CONDENSED_FONT_SIZE,
  DEFAULT_L_CONDENSED_FONT_STRETCH: DEFAULT_L_CONDENSED_FONT_STRETCH,
  DEFAULT_L_CONDENSED_FONT_STYLE: DEFAULT_L_CONDENSED_FONT_STYLE,
  DEFAULT_L_CONDENSED_FONT_STYLE_OLD: DEFAULT_L_CONDENSED_FONT_STYLE_OLD,
  DEFAULT_L_CONDENSED_FONT_WEIGHT: DEFAULT_L_CONDENSED_FONT_WEIGHT,
  DEFAULT_L_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_L_CONDENSED_HEAVY_FONT_FAMILY,
  DEFAULT_L_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_L_CONDENSED_HEAVY_FONT_SIZE,
  DEFAULT_L_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_L_CONDENSED_HEAVY_FONT_STRETCH,
  DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE,
  DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_L_CONDENSED_HEAVY_FONT_STYLE_OLD,
  DEFAULT_L_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_L_CONDENSED_HEAVY_FONT_WEIGHT,
  DEFAULT_L_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_L_CONDENSED_HEAVY_LETTER_SPACING,
  DEFAULT_L_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_L_CONDENSED_HEAVY_LINE_HEIGHT,
  DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_L_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_L_CONDENSED_HEAVY_TEXT_CASE,
  DEFAULT_L_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_L_CONDENSED_HEAVY_TEXT_DECORATION,
  DEFAULT_L_CONDENSED_LETTER_SPACING: DEFAULT_L_CONDENSED_LETTER_SPACING,
  DEFAULT_L_CONDENSED_LINE_HEIGHT: DEFAULT_L_CONDENSED_LINE_HEIGHT,
  DEFAULT_L_CONDENSED_PARAGRAPH_INDENT: DEFAULT_L_CONDENSED_PARAGRAPH_INDENT,
  DEFAULT_L_CONDENSED_PARAGRAPH_SPACING: DEFAULT_L_CONDENSED_PARAGRAPH_SPACING,
  DEFAULT_L_CONDENSED_TEXT_CASE: DEFAULT_L_CONDENSED_TEXT_CASE,
  DEFAULT_L_CONDENSED_TEXT_DECORATION: DEFAULT_L_CONDENSED_TEXT_DECORATION,
  DEFAULT_L_FONT_FAMILY: DEFAULT_L_FONT_FAMILY,
  DEFAULT_L_FONT_SIZE: DEFAULT_L_FONT_SIZE,
  DEFAULT_L_FONT_STRETCH: DEFAULT_L_FONT_STRETCH,
  DEFAULT_L_FONT_STYLE: DEFAULT_L_FONT_STYLE,
  DEFAULT_L_FONT_STYLE_OLD: DEFAULT_L_FONT_STYLE_OLD,
  DEFAULT_L_FONT_WEIGHT: DEFAULT_L_FONT_WEIGHT,
  DEFAULT_L_HEAVY_FONT_FAMILY: DEFAULT_L_HEAVY_FONT_FAMILY,
  DEFAULT_L_HEAVY_FONT_SIZE: DEFAULT_L_HEAVY_FONT_SIZE,
  DEFAULT_L_HEAVY_FONT_STRETCH: DEFAULT_L_HEAVY_FONT_STRETCH,
  DEFAULT_L_HEAVY_FONT_STYLE: DEFAULT_L_HEAVY_FONT_STYLE,
  DEFAULT_L_HEAVY_FONT_STYLE_OLD: DEFAULT_L_HEAVY_FONT_STYLE_OLD,
  DEFAULT_L_HEAVY_FONT_WEIGHT: DEFAULT_L_HEAVY_FONT_WEIGHT,
  DEFAULT_L_HEAVY_LETTER_SPACING: DEFAULT_L_HEAVY_LETTER_SPACING,
  DEFAULT_L_HEAVY_LINE_HEIGHT: DEFAULT_L_HEAVY_LINE_HEIGHT,
  DEFAULT_L_HEAVY_PARAGRAPH_INDENT: DEFAULT_L_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_L_HEAVY_PARAGRAPH_SPACING: DEFAULT_L_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_L_HEAVY_TEXT_CASE: DEFAULT_L_HEAVY_TEXT_CASE,
  DEFAULT_L_HEAVY_TEXT_DECORATION: DEFAULT_L_HEAVY_TEXT_DECORATION,
  DEFAULT_L_ITALIC_FONT_FAMILY: DEFAULT_L_ITALIC_FONT_FAMILY,
  DEFAULT_L_ITALIC_FONT_SIZE: DEFAULT_L_ITALIC_FONT_SIZE,
  DEFAULT_L_ITALIC_FONT_STRETCH: DEFAULT_L_ITALIC_FONT_STRETCH,
  DEFAULT_L_ITALIC_FONT_STYLE: DEFAULT_L_ITALIC_FONT_STYLE,
  DEFAULT_L_ITALIC_FONT_STYLE_OLD: DEFAULT_L_ITALIC_FONT_STYLE_OLD,
  DEFAULT_L_ITALIC_FONT_WEIGHT: DEFAULT_L_ITALIC_FONT_WEIGHT,
  DEFAULT_L_ITALIC_LETTER_SPACING: DEFAULT_L_ITALIC_LETTER_SPACING,
  DEFAULT_L_ITALIC_LINE_HEIGHT: DEFAULT_L_ITALIC_LINE_HEIGHT,
  DEFAULT_L_ITALIC_PARAGRAPH_INDENT: DEFAULT_L_ITALIC_PARAGRAPH_INDENT,
  DEFAULT_L_ITALIC_PARAGRAPH_SPACING: DEFAULT_L_ITALIC_PARAGRAPH_SPACING,
  DEFAULT_L_ITALIC_TEXT_CASE: DEFAULT_L_ITALIC_TEXT_CASE,
  DEFAULT_L_ITALIC_TEXT_DECORATION: DEFAULT_L_ITALIC_TEXT_DECORATION,
  DEFAULT_L_LETTER_SPACING: DEFAULT_L_LETTER_SPACING,
  DEFAULT_L_LINE_HEIGHT: DEFAULT_L_LINE_HEIGHT,
  DEFAULT_L_PARAGRAPH_INDENT: DEFAULT_L_PARAGRAPH_INDENT,
  DEFAULT_L_PARAGRAPH_SPACING: DEFAULT_L_PARAGRAPH_SPACING,
  DEFAULT_L_TEXT_CASE: DEFAULT_L_TEXT_CASE,
  DEFAULT_L_TEXT_DECORATION: DEFAULT_L_TEXT_DECORATION,
  DEFAULT_M_AC_FONT_FAMILY: DEFAULT_M_AC_FONT_FAMILY,
  DEFAULT_M_AC_FONT_SIZE: DEFAULT_M_AC_FONT_SIZE,
  DEFAULT_M_AC_FONT_STRETCH: DEFAULT_M_AC_FONT_STRETCH,
  DEFAULT_M_AC_FONT_STYLE: DEFAULT_M_AC_FONT_STYLE,
  DEFAULT_M_AC_FONT_STYLE_OLD: DEFAULT_M_AC_FONT_STYLE_OLD,
  DEFAULT_M_AC_FONT_WEIGHT: DEFAULT_M_AC_FONT_WEIGHT,
  DEFAULT_M_AC_LETTER_SPACING: DEFAULT_M_AC_LETTER_SPACING,
  DEFAULT_M_AC_LINE_HEIGHT: DEFAULT_M_AC_LINE_HEIGHT,
  DEFAULT_M_AC_PARAGRAPH_INDENT: DEFAULT_M_AC_PARAGRAPH_INDENT,
  DEFAULT_M_AC_PARAGRAPH_SPACING: DEFAULT_M_AC_PARAGRAPH_SPACING,
  DEFAULT_M_AC_TEXT_CASE: DEFAULT_M_AC_TEXT_CASE,
  DEFAULT_M_AC_TEXT_DECORATION: DEFAULT_M_AC_TEXT_DECORATION,
  DEFAULT_M_BOLD_AC_FONT_FAMILY: DEFAULT_M_BOLD_AC_FONT_FAMILY,
  DEFAULT_M_BOLD_AC_FONT_SIZE: DEFAULT_M_BOLD_AC_FONT_SIZE,
  DEFAULT_M_BOLD_AC_FONT_STRETCH: DEFAULT_M_BOLD_AC_FONT_STRETCH,
  DEFAULT_M_BOLD_AC_FONT_STYLE: DEFAULT_M_BOLD_AC_FONT_STYLE,
  DEFAULT_M_BOLD_AC_FONT_STYLE_OLD: DEFAULT_M_BOLD_AC_FONT_STYLE_OLD,
  DEFAULT_M_BOLD_AC_FONT_WEIGHT: DEFAULT_M_BOLD_AC_FONT_WEIGHT,
  DEFAULT_M_BOLD_AC_LETTER_SPACING: DEFAULT_M_BOLD_AC_LETTER_SPACING,
  DEFAULT_M_BOLD_AC_LINE_HEIGHT: DEFAULT_M_BOLD_AC_LINE_HEIGHT,
  DEFAULT_M_BOLD_AC_PARAGRAPH_INDENT: DEFAULT_M_BOLD_AC_PARAGRAPH_INDENT,
  DEFAULT_M_BOLD_AC_PARAGRAPH_SPACING: DEFAULT_M_BOLD_AC_PARAGRAPH_SPACING,
  DEFAULT_M_BOLD_AC_TEXT_CASE: DEFAULT_M_BOLD_AC_TEXT_CASE,
  DEFAULT_M_BOLD_AC_TEXT_DECORATION: DEFAULT_M_BOLD_AC_TEXT_DECORATION,
  DEFAULT_M_BOLD_FONT_FAMILY: DEFAULT_M_BOLD_FONT_FAMILY,
  DEFAULT_M_BOLD_FONT_SIZE: DEFAULT_M_BOLD_FONT_SIZE,
  DEFAULT_M_BOLD_FONT_STRETCH: DEFAULT_M_BOLD_FONT_STRETCH,
  DEFAULT_M_BOLD_FONT_STYLE: DEFAULT_M_BOLD_FONT_STYLE,
  DEFAULT_M_BOLD_FONT_STYLE_OLD: DEFAULT_M_BOLD_FONT_STYLE_OLD,
  DEFAULT_M_BOLD_FONT_WEIGHT: DEFAULT_M_BOLD_FONT_WEIGHT,
  DEFAULT_M_BOLD_LETTER_SPACING: DEFAULT_M_BOLD_LETTER_SPACING,
  DEFAULT_M_BOLD_LINE_HEIGHT: DEFAULT_M_BOLD_LINE_HEIGHT,
  DEFAULT_M_BOLD_PARAGRAPH_INDENT: DEFAULT_M_BOLD_PARAGRAPH_INDENT,
  DEFAULT_M_BOLD_PARAGRAPH_SPACING: DEFAULT_M_BOLD_PARAGRAPH_SPACING,
  DEFAULT_M_BOLD_TEXT_CASE: DEFAULT_M_BOLD_TEXT_CASE,
  DEFAULT_M_BOLD_TEXT_DECORATION: DEFAULT_M_BOLD_TEXT_DECORATION,
  DEFAULT_M_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_M_CONDENSED_BOLD_FONT_FAMILY,
  DEFAULT_M_CONDENSED_BOLD_FONT_SIZE: DEFAULT_M_CONDENSED_BOLD_FONT_SIZE,
  DEFAULT_M_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_M_CONDENSED_BOLD_FONT_STRETCH,
  DEFAULT_M_CONDENSED_BOLD_FONT_STYLE: DEFAULT_M_CONDENSED_BOLD_FONT_STYLE,
  DEFAULT_M_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_M_CONDENSED_BOLD_FONT_STYLE_OLD,
  DEFAULT_M_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_M_CONDENSED_BOLD_FONT_WEIGHT,
  DEFAULT_M_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_M_CONDENSED_BOLD_LETTER_SPACING,
  DEFAULT_M_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_M_CONDENSED_BOLD_LINE_HEIGHT,
  DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_INDENT,
  DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_M_CONDENSED_BOLD_PARAGRAPH_SPACING,
  DEFAULT_M_CONDENSED_BOLD_TEXT_CASE: DEFAULT_M_CONDENSED_BOLD_TEXT_CASE,
  DEFAULT_M_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_M_CONDENSED_BOLD_TEXT_DECORATION,
  DEFAULT_M_CONDENSED_FONT_FAMILY: DEFAULT_M_CONDENSED_FONT_FAMILY,
  DEFAULT_M_CONDENSED_FONT_SIZE: DEFAULT_M_CONDENSED_FONT_SIZE,
  DEFAULT_M_CONDENSED_FONT_STRETCH: DEFAULT_M_CONDENSED_FONT_STRETCH,
  DEFAULT_M_CONDENSED_FONT_STYLE: DEFAULT_M_CONDENSED_FONT_STYLE,
  DEFAULT_M_CONDENSED_FONT_STYLE_OLD: DEFAULT_M_CONDENSED_FONT_STYLE_OLD,
  DEFAULT_M_CONDENSED_FONT_WEIGHT: DEFAULT_M_CONDENSED_FONT_WEIGHT,
  DEFAULT_M_CONDENSED_LETTER_SPACING: DEFAULT_M_CONDENSED_LETTER_SPACING,
  DEFAULT_M_CONDENSED_LINE_HEIGHT: DEFAULT_M_CONDENSED_LINE_HEIGHT,
  DEFAULT_M_CONDENSED_PARAGRAPH_INDENT: DEFAULT_M_CONDENSED_PARAGRAPH_INDENT,
  DEFAULT_M_CONDENSED_PARAGRAPH_SPACING: DEFAULT_M_CONDENSED_PARAGRAPH_SPACING,
  DEFAULT_M_CONDENSED_TEXT_CASE: DEFAULT_M_CONDENSED_TEXT_CASE,
  DEFAULT_M_CONDENSED_TEXT_DECORATION: DEFAULT_M_CONDENSED_TEXT_DECORATION,
  DEFAULT_M_FONT_FAMILY: DEFAULT_M_FONT_FAMILY,
  DEFAULT_M_FONT_SIZE: DEFAULT_M_FONT_SIZE,
  DEFAULT_M_FONT_STRETCH: DEFAULT_M_FONT_STRETCH,
  DEFAULT_M_FONT_STYLE: DEFAULT_M_FONT_STYLE,
  DEFAULT_M_FONT_STYLE_OLD: DEFAULT_M_FONT_STYLE_OLD,
  DEFAULT_M_FONT_WEIGHT: DEFAULT_M_FONT_WEIGHT,
  DEFAULT_M_ITALIC_FONT_FAMILY: DEFAULT_M_ITALIC_FONT_FAMILY,
  DEFAULT_M_ITALIC_FONT_SIZE: DEFAULT_M_ITALIC_FONT_SIZE,
  DEFAULT_M_ITALIC_FONT_STRETCH: DEFAULT_M_ITALIC_FONT_STRETCH,
  DEFAULT_M_ITALIC_FONT_STYLE: DEFAULT_M_ITALIC_FONT_STYLE,
  DEFAULT_M_ITALIC_FONT_STYLE_OLD: DEFAULT_M_ITALIC_FONT_STYLE_OLD,
  DEFAULT_M_ITALIC_FONT_WEIGHT: DEFAULT_M_ITALIC_FONT_WEIGHT,
  DEFAULT_M_ITALIC_LETTER_SPACING: DEFAULT_M_ITALIC_LETTER_SPACING,
  DEFAULT_M_ITALIC_LINE_HEIGHT: DEFAULT_M_ITALIC_LINE_HEIGHT,
  DEFAULT_M_ITALIC_PARAGRAPH_INDENT: DEFAULT_M_ITALIC_PARAGRAPH_INDENT,
  DEFAULT_M_ITALIC_PARAGRAPH_SPACING: DEFAULT_M_ITALIC_PARAGRAPH_SPACING,
  DEFAULT_M_ITALIC_TEXT_CASE: DEFAULT_M_ITALIC_TEXT_CASE,
  DEFAULT_M_ITALIC_TEXT_DECORATION: DEFAULT_M_ITALIC_TEXT_DECORATION,
  DEFAULT_M_LETTER_SPACING: DEFAULT_M_LETTER_SPACING,
  DEFAULT_M_LINE_HEIGHT: DEFAULT_M_LINE_HEIGHT,
  DEFAULT_M_MEDIUM_FONT_FAMILY: DEFAULT_M_MEDIUM_FONT_FAMILY,
  DEFAULT_M_MEDIUM_FONT_SIZE: DEFAULT_M_MEDIUM_FONT_SIZE,
  DEFAULT_M_MEDIUM_FONT_STRETCH: DEFAULT_M_MEDIUM_FONT_STRETCH,
  DEFAULT_M_MEDIUM_FONT_STYLE: DEFAULT_M_MEDIUM_FONT_STYLE,
  DEFAULT_M_MEDIUM_FONT_STYLE_OLD: DEFAULT_M_MEDIUM_FONT_STYLE_OLD,
  DEFAULT_M_MEDIUM_FONT_WEIGHT: DEFAULT_M_MEDIUM_FONT_WEIGHT,
  DEFAULT_M_MEDIUM_LETTER_SPACING: DEFAULT_M_MEDIUM_LETTER_SPACING,
  DEFAULT_M_MEDIUM_LINE_HEIGHT: DEFAULT_M_MEDIUM_LINE_HEIGHT,
  DEFAULT_M_MEDIUM_PARAGRAPH_INDENT: DEFAULT_M_MEDIUM_PARAGRAPH_INDENT,
  DEFAULT_M_MEDIUM_PARAGRAPH_SPACING: DEFAULT_M_MEDIUM_PARAGRAPH_SPACING,
  DEFAULT_M_MEDIUM_TEXT_CASE: DEFAULT_M_MEDIUM_TEXT_CASE,
  DEFAULT_M_MEDIUM_TEXT_DECORATION: DEFAULT_M_MEDIUM_TEXT_DECORATION,
  DEFAULT_M_PARAGRAPH_INDENT: DEFAULT_M_PARAGRAPH_INDENT,
  DEFAULT_M_PARAGRAPH_SPACING: DEFAULT_M_PARAGRAPH_SPACING,
  DEFAULT_M_TEXT_CASE: DEFAULT_M_TEXT_CASE,
  DEFAULT_M_TEXT_DECORATION: DEFAULT_M_TEXT_DECORATION,
  DEFAULT_S_AC_FONT_FAMILY: DEFAULT_S_AC_FONT_FAMILY,
  DEFAULT_S_AC_FONT_SIZE: DEFAULT_S_AC_FONT_SIZE,
  DEFAULT_S_AC_FONT_STRETCH: DEFAULT_S_AC_FONT_STRETCH,
  DEFAULT_S_AC_FONT_STYLE: DEFAULT_S_AC_FONT_STYLE,
  DEFAULT_S_AC_FONT_STYLE_OLD: DEFAULT_S_AC_FONT_STYLE_OLD,
  DEFAULT_S_AC_FONT_WEIGHT: DEFAULT_S_AC_FONT_WEIGHT,
  DEFAULT_S_AC_LETTER_SPACING: DEFAULT_S_AC_LETTER_SPACING,
  DEFAULT_S_AC_LINE_HEIGHT: DEFAULT_S_AC_LINE_HEIGHT,
  DEFAULT_S_AC_PARAGRAPH_INDENT: DEFAULT_S_AC_PARAGRAPH_INDENT,
  DEFAULT_S_AC_PARAGRAPH_SPACING: DEFAULT_S_AC_PARAGRAPH_SPACING,
  DEFAULT_S_AC_TEXT_CASE: DEFAULT_S_AC_TEXT_CASE,
  DEFAULT_S_AC_TEXT_DECORATION: DEFAULT_S_AC_TEXT_DECORATION,
  DEFAULT_S_BOLD_AC_FONT_FAMILY: DEFAULT_S_BOLD_AC_FONT_FAMILY,
  DEFAULT_S_BOLD_AC_FONT_SIZE: DEFAULT_S_BOLD_AC_FONT_SIZE,
  DEFAULT_S_BOLD_AC_FONT_STRETCH: DEFAULT_S_BOLD_AC_FONT_STRETCH,
  DEFAULT_S_BOLD_AC_FONT_STYLE: DEFAULT_S_BOLD_AC_FONT_STYLE,
  DEFAULT_S_BOLD_AC_FONT_STYLE_OLD: DEFAULT_S_BOLD_AC_FONT_STYLE_OLD,
  DEFAULT_S_BOLD_AC_FONT_WEIGHT: DEFAULT_S_BOLD_AC_FONT_WEIGHT,
  DEFAULT_S_BOLD_AC_LETTER_SPACING: DEFAULT_S_BOLD_AC_LETTER_SPACING,
  DEFAULT_S_BOLD_AC_LINE_HEIGHT: DEFAULT_S_BOLD_AC_LINE_HEIGHT,
  DEFAULT_S_BOLD_AC_PARAGRAPH_INDENT: DEFAULT_S_BOLD_AC_PARAGRAPH_INDENT,
  DEFAULT_S_BOLD_AC_PARAGRAPH_SPACING: DEFAULT_S_BOLD_AC_PARAGRAPH_SPACING,
  DEFAULT_S_BOLD_AC_TEXT_CASE: DEFAULT_S_BOLD_AC_TEXT_CASE,
  DEFAULT_S_BOLD_AC_TEXT_DECORATION: DEFAULT_S_BOLD_AC_TEXT_DECORATION,
  DEFAULT_S_BOLD_FONT_FAMILY: DEFAULT_S_BOLD_FONT_FAMILY,
  DEFAULT_S_BOLD_FONT_SIZE: DEFAULT_S_BOLD_FONT_SIZE,
  DEFAULT_S_BOLD_FONT_STRETCH: DEFAULT_S_BOLD_FONT_STRETCH,
  DEFAULT_S_BOLD_FONT_STYLE: DEFAULT_S_BOLD_FONT_STYLE,
  DEFAULT_S_BOLD_FONT_STYLE_OLD: DEFAULT_S_BOLD_FONT_STYLE_OLD,
  DEFAULT_S_BOLD_FONT_WEIGHT: DEFAULT_S_BOLD_FONT_WEIGHT,
  DEFAULT_S_BOLD_LETTER_SPACING: DEFAULT_S_BOLD_LETTER_SPACING,
  DEFAULT_S_BOLD_LINE_HEIGHT: DEFAULT_S_BOLD_LINE_HEIGHT,
  DEFAULT_S_BOLD_PARAGRAPH_INDENT: DEFAULT_S_BOLD_PARAGRAPH_INDENT,
  DEFAULT_S_BOLD_PARAGRAPH_SPACING: DEFAULT_S_BOLD_PARAGRAPH_SPACING,
  DEFAULT_S_BOLD_TEXT_CASE: DEFAULT_S_BOLD_TEXT_CASE,
  DEFAULT_S_BOLD_TEXT_DECORATION: DEFAULT_S_BOLD_TEXT_DECORATION,
  DEFAULT_S_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_S_CONDENSED_BOLD_FONT_FAMILY,
  DEFAULT_S_CONDENSED_BOLD_FONT_SIZE: DEFAULT_S_CONDENSED_BOLD_FONT_SIZE,
  DEFAULT_S_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_S_CONDENSED_BOLD_FONT_STRETCH,
  DEFAULT_S_CONDENSED_BOLD_FONT_STYLE: DEFAULT_S_CONDENSED_BOLD_FONT_STYLE,
  DEFAULT_S_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_S_CONDENSED_BOLD_FONT_STYLE_OLD,
  DEFAULT_S_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_S_CONDENSED_BOLD_FONT_WEIGHT,
  DEFAULT_S_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_S_CONDENSED_BOLD_LETTER_SPACING,
  DEFAULT_S_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_S_CONDENSED_BOLD_LINE_HEIGHT,
  DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_INDENT,
  DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_S_CONDENSED_BOLD_PARAGRAPH_SPACING,
  DEFAULT_S_CONDENSED_BOLD_TEXT_CASE: DEFAULT_S_CONDENSED_BOLD_TEXT_CASE,
  DEFAULT_S_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_S_CONDENSED_BOLD_TEXT_DECORATION,
  DEFAULT_S_CONDENSED_FONT_FAMILY: DEFAULT_S_CONDENSED_FONT_FAMILY,
  DEFAULT_S_CONDENSED_FONT_SIZE: DEFAULT_S_CONDENSED_FONT_SIZE,
  DEFAULT_S_CONDENSED_FONT_STRETCH: DEFAULT_S_CONDENSED_FONT_STRETCH,
  DEFAULT_S_CONDENSED_FONT_STYLE: DEFAULT_S_CONDENSED_FONT_STYLE,
  DEFAULT_S_CONDENSED_FONT_STYLE_OLD: DEFAULT_S_CONDENSED_FONT_STYLE_OLD,
  DEFAULT_S_CONDENSED_FONT_WEIGHT: DEFAULT_S_CONDENSED_FONT_WEIGHT,
  DEFAULT_S_CONDENSED_LETTER_SPACING: DEFAULT_S_CONDENSED_LETTER_SPACING,
  DEFAULT_S_CONDENSED_LINE_HEIGHT: DEFAULT_S_CONDENSED_LINE_HEIGHT,
  DEFAULT_S_CONDENSED_PARAGRAPH_INDENT: DEFAULT_S_CONDENSED_PARAGRAPH_INDENT,
  DEFAULT_S_CONDENSED_PARAGRAPH_SPACING: DEFAULT_S_CONDENSED_PARAGRAPH_SPACING,
  DEFAULT_S_CONDENSED_TEXT_CASE: DEFAULT_S_CONDENSED_TEXT_CASE,
  DEFAULT_S_CONDENSED_TEXT_DECORATION: DEFAULT_S_CONDENSED_TEXT_DECORATION,
  DEFAULT_S_FONT_FAMILY: DEFAULT_S_FONT_FAMILY,
  DEFAULT_S_FONT_SIZE: DEFAULT_S_FONT_SIZE,
  DEFAULT_S_FONT_STRETCH: DEFAULT_S_FONT_STRETCH,
  DEFAULT_S_FONT_STYLE: DEFAULT_S_FONT_STYLE,
  DEFAULT_S_FONT_STYLE_OLD: DEFAULT_S_FONT_STYLE_OLD,
  DEFAULT_S_FONT_WEIGHT: DEFAULT_S_FONT_WEIGHT,
  DEFAULT_S_ITALIC_FONT_FAMILY: DEFAULT_S_ITALIC_FONT_FAMILY,
  DEFAULT_S_ITALIC_FONT_SIZE: DEFAULT_S_ITALIC_FONT_SIZE,
  DEFAULT_S_ITALIC_FONT_STRETCH: DEFAULT_S_ITALIC_FONT_STRETCH,
  DEFAULT_S_ITALIC_FONT_STYLE: DEFAULT_S_ITALIC_FONT_STYLE,
  DEFAULT_S_ITALIC_FONT_STYLE_OLD: DEFAULT_S_ITALIC_FONT_STYLE_OLD,
  DEFAULT_S_ITALIC_FONT_WEIGHT: DEFAULT_S_ITALIC_FONT_WEIGHT,
  DEFAULT_S_ITALIC_LETTER_SPACING: DEFAULT_S_ITALIC_LETTER_SPACING,
  DEFAULT_S_ITALIC_LINE_HEIGHT: DEFAULT_S_ITALIC_LINE_HEIGHT,
  DEFAULT_S_ITALIC_PARAGRAPH_INDENT: DEFAULT_S_ITALIC_PARAGRAPH_INDENT,
  DEFAULT_S_ITALIC_PARAGRAPH_SPACING: DEFAULT_S_ITALIC_PARAGRAPH_SPACING,
  DEFAULT_S_ITALIC_TEXT_CASE: DEFAULT_S_ITALIC_TEXT_CASE,
  DEFAULT_S_ITALIC_TEXT_DECORATION: DEFAULT_S_ITALIC_TEXT_DECORATION,
  DEFAULT_S_LETTER_SPACING: DEFAULT_S_LETTER_SPACING,
  DEFAULT_S_LINE_HEIGHT: DEFAULT_S_LINE_HEIGHT,
  DEFAULT_S_MEDIUM_FONT_FAMILY: DEFAULT_S_MEDIUM_FONT_FAMILY,
  DEFAULT_S_MEDIUM_FONT_SIZE: DEFAULT_S_MEDIUM_FONT_SIZE,
  DEFAULT_S_MEDIUM_FONT_STRETCH: DEFAULT_S_MEDIUM_FONT_STRETCH,
  DEFAULT_S_MEDIUM_FONT_STYLE: DEFAULT_S_MEDIUM_FONT_STYLE,
  DEFAULT_S_MEDIUM_FONT_STYLE_OLD: DEFAULT_S_MEDIUM_FONT_STYLE_OLD,
  DEFAULT_S_MEDIUM_FONT_WEIGHT: DEFAULT_S_MEDIUM_FONT_WEIGHT,
  DEFAULT_S_MEDIUM_LETTER_SPACING: DEFAULT_S_MEDIUM_LETTER_SPACING,
  DEFAULT_S_MEDIUM_LINE_HEIGHT: DEFAULT_S_MEDIUM_LINE_HEIGHT,
  DEFAULT_S_MEDIUM_PARAGRAPH_INDENT: DEFAULT_S_MEDIUM_PARAGRAPH_INDENT,
  DEFAULT_S_MEDIUM_PARAGRAPH_SPACING: DEFAULT_S_MEDIUM_PARAGRAPH_SPACING,
  DEFAULT_S_MEDIUM_TEXT_CASE: DEFAULT_S_MEDIUM_TEXT_CASE,
  DEFAULT_S_MEDIUM_TEXT_DECORATION: DEFAULT_S_MEDIUM_TEXT_DECORATION,
  DEFAULT_S_PARAGRAPH_INDENT: DEFAULT_S_PARAGRAPH_INDENT,
  DEFAULT_S_PARAGRAPH_SPACING: DEFAULT_S_PARAGRAPH_SPACING,
  DEFAULT_S_TEXT_CASE: DEFAULT_S_TEXT_CASE,
  DEFAULT_S_TEXT_DECORATION: DEFAULT_S_TEXT_DECORATION,
  DEFAULT_XL_BOLD_FONT_FAMILY: DEFAULT_XL_BOLD_FONT_FAMILY,
  DEFAULT_XL_BOLD_FONT_SIZE: DEFAULT_XL_BOLD_FONT_SIZE,
  DEFAULT_XL_BOLD_FONT_STRETCH: DEFAULT_XL_BOLD_FONT_STRETCH,
  DEFAULT_XL_BOLD_FONT_STYLE: DEFAULT_XL_BOLD_FONT_STYLE,
  DEFAULT_XL_BOLD_FONT_STYLE_OLD: DEFAULT_XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_XL_BOLD_FONT_WEIGHT: DEFAULT_XL_BOLD_FONT_WEIGHT,
  DEFAULT_XL_BOLD_LETTER_SPACING: DEFAULT_XL_BOLD_LETTER_SPACING,
  DEFAULT_XL_BOLD_LINE_HEIGHT: DEFAULT_XL_BOLD_LINE_HEIGHT,
  DEFAULT_XL_BOLD_PARAGRAPH_INDENT: DEFAULT_XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_XL_BOLD_PARAGRAPH_SPACING: DEFAULT_XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_XL_BOLD_TEXT_CASE: DEFAULT_XL_BOLD_TEXT_CASE,
  DEFAULT_XL_BOLD_TEXT_DECORATION: DEFAULT_XL_BOLD_TEXT_DECORATION,
  DEFAULT_XL_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_XL_CONDENSED_BOLD_FONT_FAMILY,
  DEFAULT_XL_CONDENSED_BOLD_FONT_SIZE: DEFAULT_XL_CONDENSED_BOLD_FONT_SIZE,
  DEFAULT_XL_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_XL_CONDENSED_BOLD_FONT_STRETCH,
  DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE: DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE,
  DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_XL_CONDENSED_BOLD_FONT_STYLE_OLD,
  DEFAULT_XL_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_XL_CONDENSED_BOLD_FONT_WEIGHT,
  DEFAULT_XL_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_XL_CONDENSED_BOLD_LETTER_SPACING,
  DEFAULT_XL_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_XL_CONDENSED_BOLD_LINE_HEIGHT,
  DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT,
  DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING,
  DEFAULT_XL_CONDENSED_BOLD_TEXT_CASE: DEFAULT_XL_CONDENSED_BOLD_TEXT_CASE,
  DEFAULT_XL_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_XL_CONDENSED_BOLD_TEXT_DECORATION,
  DEFAULT_XL_CONDENSED_FONT_FAMILY: DEFAULT_XL_CONDENSED_FONT_FAMILY,
  DEFAULT_XL_CONDENSED_FONT_SIZE: DEFAULT_XL_CONDENSED_FONT_SIZE,
  DEFAULT_XL_CONDENSED_FONT_STRETCH: DEFAULT_XL_CONDENSED_FONT_STRETCH,
  DEFAULT_XL_CONDENSED_FONT_STYLE: DEFAULT_XL_CONDENSED_FONT_STYLE,
  DEFAULT_XL_CONDENSED_FONT_STYLE_OLD: DEFAULT_XL_CONDENSED_FONT_STYLE_OLD,
  DEFAULT_XL_CONDENSED_FONT_WEIGHT: DEFAULT_XL_CONDENSED_FONT_WEIGHT,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_FAMILY: DEFAULT_XL_CONDENSED_HEAVY_FONT_FAMILY,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_SIZE: DEFAULT_XL_CONDENSED_HEAVY_FONT_SIZE,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_STRETCH: DEFAULT_XL_CONDENSED_HEAVY_FONT_STRETCH,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE: DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD: DEFAULT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  DEFAULT_XL_CONDENSED_HEAVY_FONT_WEIGHT: DEFAULT_XL_CONDENSED_HEAVY_FONT_WEIGHT,
  DEFAULT_XL_CONDENSED_HEAVY_LETTER_SPACING: DEFAULT_XL_CONDENSED_HEAVY_LETTER_SPACING,
  DEFAULT_XL_CONDENSED_HEAVY_LINE_HEIGHT: DEFAULT_XL_CONDENSED_HEAVY_LINE_HEIGHT,
  DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: DEFAULT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_XL_CONDENSED_HEAVY_TEXT_CASE: DEFAULT_XL_CONDENSED_HEAVY_TEXT_CASE,
  DEFAULT_XL_CONDENSED_HEAVY_TEXT_DECORATION: DEFAULT_XL_CONDENSED_HEAVY_TEXT_DECORATION,
  DEFAULT_XL_CONDENSED_LETTER_SPACING: DEFAULT_XL_CONDENSED_LETTER_SPACING,
  DEFAULT_XL_CONDENSED_LINE_HEIGHT: DEFAULT_XL_CONDENSED_LINE_HEIGHT,
  DEFAULT_XL_CONDENSED_PARAGRAPH_INDENT: DEFAULT_XL_CONDENSED_PARAGRAPH_INDENT,
  DEFAULT_XL_CONDENSED_PARAGRAPH_SPACING: DEFAULT_XL_CONDENSED_PARAGRAPH_SPACING,
  DEFAULT_XL_CONDENSED_TEXT_CASE: DEFAULT_XL_CONDENSED_TEXT_CASE,
  DEFAULT_XL_CONDENSED_TEXT_DECORATION: DEFAULT_XL_CONDENSED_TEXT_DECORATION,
  DEFAULT_XL_FONT_FAMILY: DEFAULT_XL_FONT_FAMILY,
  DEFAULT_XL_FONT_SIZE: DEFAULT_XL_FONT_SIZE,
  DEFAULT_XL_FONT_STRETCH: DEFAULT_XL_FONT_STRETCH,
  DEFAULT_XL_FONT_STYLE: DEFAULT_XL_FONT_STYLE,
  DEFAULT_XL_FONT_STYLE_OLD: DEFAULT_XL_FONT_STYLE_OLD,
  DEFAULT_XL_FONT_WEIGHT: DEFAULT_XL_FONT_WEIGHT,
  DEFAULT_XL_HEAVY_FONT_FAMILY: DEFAULT_XL_HEAVY_FONT_FAMILY,
  DEFAULT_XL_HEAVY_FONT_SIZE: DEFAULT_XL_HEAVY_FONT_SIZE,
  DEFAULT_XL_HEAVY_FONT_STRETCH: DEFAULT_XL_HEAVY_FONT_STRETCH,
  DEFAULT_XL_HEAVY_FONT_STYLE: DEFAULT_XL_HEAVY_FONT_STYLE,
  DEFAULT_XL_HEAVY_FONT_STYLE_OLD: DEFAULT_XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_XL_HEAVY_FONT_WEIGHT: DEFAULT_XL_HEAVY_FONT_WEIGHT,
  DEFAULT_XL_HEAVY_LETTER_SPACING: DEFAULT_XL_HEAVY_LETTER_SPACING,
  DEFAULT_XL_HEAVY_LINE_HEIGHT: DEFAULT_XL_HEAVY_LINE_HEIGHT,
  DEFAULT_XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_XL_HEAVY_TEXT_CASE: DEFAULT_XL_HEAVY_TEXT_CASE,
  DEFAULT_XL_HEAVY_TEXT_DECORATION: DEFAULT_XL_HEAVY_TEXT_DECORATION,
  DEFAULT_XL_ITALIC_FONT_FAMILY: DEFAULT_XL_ITALIC_FONT_FAMILY,
  DEFAULT_XL_ITALIC_FONT_SIZE: DEFAULT_XL_ITALIC_FONT_SIZE,
  DEFAULT_XL_ITALIC_FONT_STRETCH: DEFAULT_XL_ITALIC_FONT_STRETCH,
  DEFAULT_XL_ITALIC_FONT_STYLE: DEFAULT_XL_ITALIC_FONT_STYLE,
  DEFAULT_XL_ITALIC_FONT_STYLE_OLD: DEFAULT_XL_ITALIC_FONT_STYLE_OLD,
  DEFAULT_XL_ITALIC_FONT_WEIGHT: DEFAULT_XL_ITALIC_FONT_WEIGHT,
  DEFAULT_XL_ITALIC_LETTER_SPACING: DEFAULT_XL_ITALIC_LETTER_SPACING,
  DEFAULT_XL_ITALIC_LINE_HEIGHT: DEFAULT_XL_ITALIC_LINE_HEIGHT,
  DEFAULT_XL_ITALIC_PARAGRAPH_INDENT: DEFAULT_XL_ITALIC_PARAGRAPH_INDENT,
  DEFAULT_XL_ITALIC_PARAGRAPH_SPACING: DEFAULT_XL_ITALIC_PARAGRAPH_SPACING,
  DEFAULT_XL_ITALIC_TEXT_CASE: DEFAULT_XL_ITALIC_TEXT_CASE,
  DEFAULT_XL_ITALIC_TEXT_DECORATION: DEFAULT_XL_ITALIC_TEXT_DECORATION,
  DEFAULT_XL_LETTER_SPACING: DEFAULT_XL_LETTER_SPACING,
  DEFAULT_XL_LINE_HEIGHT: DEFAULT_XL_LINE_HEIGHT,
  DEFAULT_XL_PARAGRAPH_INDENT: DEFAULT_XL_PARAGRAPH_INDENT,
  DEFAULT_XL_PARAGRAPH_SPACING: DEFAULT_XL_PARAGRAPH_SPACING,
  DEFAULT_XL_TEXT_CASE: DEFAULT_XL_TEXT_CASE,
  DEFAULT_XL_TEXT_DECORATION: DEFAULT_XL_TEXT_DECORATION,
  DEFAULT_XS_AC_FONT_FAMILY: DEFAULT_XS_AC_FONT_FAMILY,
  DEFAULT_XS_AC_FONT_SIZE: DEFAULT_XS_AC_FONT_SIZE,
  DEFAULT_XS_AC_FONT_STRETCH: DEFAULT_XS_AC_FONT_STRETCH,
  DEFAULT_XS_AC_FONT_STYLE: DEFAULT_XS_AC_FONT_STYLE,
  DEFAULT_XS_AC_FONT_STYLE_OLD: DEFAULT_XS_AC_FONT_STYLE_OLD,
  DEFAULT_XS_AC_FONT_WEIGHT: DEFAULT_XS_AC_FONT_WEIGHT,
  DEFAULT_XS_AC_LETTER_SPACING: DEFAULT_XS_AC_LETTER_SPACING,
  DEFAULT_XS_AC_LINE_HEIGHT: DEFAULT_XS_AC_LINE_HEIGHT,
  DEFAULT_XS_AC_PARAGRAPH_INDENT: DEFAULT_XS_AC_PARAGRAPH_INDENT,
  DEFAULT_XS_AC_PARAGRAPH_SPACING: DEFAULT_XS_AC_PARAGRAPH_SPACING,
  DEFAULT_XS_AC_TEXT_CASE: DEFAULT_XS_AC_TEXT_CASE,
  DEFAULT_XS_AC_TEXT_DECORATION: DEFAULT_XS_AC_TEXT_DECORATION,
  DEFAULT_XS_BOLD_AC_FONT_FAMILY: DEFAULT_XS_BOLD_AC_FONT_FAMILY,
  DEFAULT_XS_BOLD_AC_FONT_SIZE: DEFAULT_XS_BOLD_AC_FONT_SIZE,
  DEFAULT_XS_BOLD_AC_FONT_STRETCH: DEFAULT_XS_BOLD_AC_FONT_STRETCH,
  DEFAULT_XS_BOLD_AC_FONT_STYLE: DEFAULT_XS_BOLD_AC_FONT_STYLE,
  DEFAULT_XS_BOLD_AC_FONT_STYLE_OLD: DEFAULT_XS_BOLD_AC_FONT_STYLE_OLD,
  DEFAULT_XS_BOLD_AC_FONT_WEIGHT: DEFAULT_XS_BOLD_AC_FONT_WEIGHT,
  DEFAULT_XS_BOLD_AC_LETTER_SPACING: DEFAULT_XS_BOLD_AC_LETTER_SPACING,
  DEFAULT_XS_BOLD_AC_LINE_HEIGHT: DEFAULT_XS_BOLD_AC_LINE_HEIGHT,
  DEFAULT_XS_BOLD_AC_PARAGRAPH_INDENT: DEFAULT_XS_BOLD_AC_PARAGRAPH_INDENT,
  DEFAULT_XS_BOLD_AC_PARAGRAPH_SPACING: DEFAULT_XS_BOLD_AC_PARAGRAPH_SPACING,
  DEFAULT_XS_BOLD_AC_TEXT_CASE: DEFAULT_XS_BOLD_AC_TEXT_CASE,
  DEFAULT_XS_BOLD_AC_TEXT_DECORATION: DEFAULT_XS_BOLD_AC_TEXT_DECORATION,
  DEFAULT_XS_BOLD_FONT_FAMILY: DEFAULT_XS_BOLD_FONT_FAMILY,
  DEFAULT_XS_BOLD_FONT_SIZE: DEFAULT_XS_BOLD_FONT_SIZE,
  DEFAULT_XS_BOLD_FONT_STRETCH: DEFAULT_XS_BOLD_FONT_STRETCH,
  DEFAULT_XS_BOLD_FONT_STYLE: DEFAULT_XS_BOLD_FONT_STYLE,
  DEFAULT_XS_BOLD_FONT_STYLE_OLD: DEFAULT_XS_BOLD_FONT_STYLE_OLD,
  DEFAULT_XS_BOLD_FONT_WEIGHT: DEFAULT_XS_BOLD_FONT_WEIGHT,
  DEFAULT_XS_BOLD_LETTER_SPACING: DEFAULT_XS_BOLD_LETTER_SPACING,
  DEFAULT_XS_BOLD_LINE_HEIGHT: DEFAULT_XS_BOLD_LINE_HEIGHT,
  DEFAULT_XS_BOLD_PARAGRAPH_INDENT: DEFAULT_XS_BOLD_PARAGRAPH_INDENT,
  DEFAULT_XS_BOLD_PARAGRAPH_SPACING: DEFAULT_XS_BOLD_PARAGRAPH_SPACING,
  DEFAULT_XS_BOLD_TEXT_CASE: DEFAULT_XS_BOLD_TEXT_CASE,
  DEFAULT_XS_BOLD_TEXT_DECORATION: DEFAULT_XS_BOLD_TEXT_DECORATION,
  DEFAULT_XS_CONDENSED_BOLD_FONT_FAMILY: DEFAULT_XS_CONDENSED_BOLD_FONT_FAMILY,
  DEFAULT_XS_CONDENSED_BOLD_FONT_SIZE: DEFAULT_XS_CONDENSED_BOLD_FONT_SIZE,
  DEFAULT_XS_CONDENSED_BOLD_FONT_STRETCH: DEFAULT_XS_CONDENSED_BOLD_FONT_STRETCH,
  DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE: DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE,
  DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE_OLD: DEFAULT_XS_CONDENSED_BOLD_FONT_STYLE_OLD,
  DEFAULT_XS_CONDENSED_BOLD_FONT_WEIGHT: DEFAULT_XS_CONDENSED_BOLD_FONT_WEIGHT,
  DEFAULT_XS_CONDENSED_BOLD_LETTER_SPACING: DEFAULT_XS_CONDENSED_BOLD_LETTER_SPACING,
  DEFAULT_XS_CONDENSED_BOLD_LINE_HEIGHT: DEFAULT_XS_CONDENSED_BOLD_LINE_HEIGHT,
  DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT: DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT,
  DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING: DEFAULT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING,
  DEFAULT_XS_CONDENSED_BOLD_TEXT_CASE: DEFAULT_XS_CONDENSED_BOLD_TEXT_CASE,
  DEFAULT_XS_CONDENSED_BOLD_TEXT_DECORATION: DEFAULT_XS_CONDENSED_BOLD_TEXT_DECORATION,
  DEFAULT_XS_FONT_FAMILY: DEFAULT_XS_FONT_FAMILY,
  DEFAULT_XS_FONT_SIZE: DEFAULT_XS_FONT_SIZE,
  DEFAULT_XS_FONT_STRETCH: DEFAULT_XS_FONT_STRETCH,
  DEFAULT_XS_FONT_STYLE: DEFAULT_XS_FONT_STYLE,
  DEFAULT_XS_FONT_STYLE_OLD: DEFAULT_XS_FONT_STYLE_OLD,
  DEFAULT_XS_FONT_WEIGHT: DEFAULT_XS_FONT_WEIGHT,
  DEFAULT_XS_ITALIC_FONT_FAMILY: DEFAULT_XS_ITALIC_FONT_FAMILY,
  DEFAULT_XS_ITALIC_FONT_SIZE: DEFAULT_XS_ITALIC_FONT_SIZE,
  DEFAULT_XS_ITALIC_FONT_STRETCH: DEFAULT_XS_ITALIC_FONT_STRETCH,
  DEFAULT_XS_ITALIC_FONT_STYLE: DEFAULT_XS_ITALIC_FONT_STYLE,
  DEFAULT_XS_ITALIC_FONT_STYLE_OLD: DEFAULT_XS_ITALIC_FONT_STYLE_OLD,
  DEFAULT_XS_ITALIC_FONT_WEIGHT: DEFAULT_XS_ITALIC_FONT_WEIGHT,
  DEFAULT_XS_ITALIC_LETTER_SPACING: DEFAULT_XS_ITALIC_LETTER_SPACING,
  DEFAULT_XS_ITALIC_LINE_HEIGHT: DEFAULT_XS_ITALIC_LINE_HEIGHT,
  DEFAULT_XS_ITALIC_PARAGRAPH_INDENT: DEFAULT_XS_ITALIC_PARAGRAPH_INDENT,
  DEFAULT_XS_ITALIC_PARAGRAPH_SPACING: DEFAULT_XS_ITALIC_PARAGRAPH_SPACING,
  DEFAULT_XS_ITALIC_TEXT_CASE: DEFAULT_XS_ITALIC_TEXT_CASE,
  DEFAULT_XS_ITALIC_TEXT_DECORATION: DEFAULT_XS_ITALIC_TEXT_DECORATION,
  DEFAULT_XS_LETTER_SPACING: DEFAULT_XS_LETTER_SPACING,
  DEFAULT_XS_LINE_HEIGHT: DEFAULT_XS_LINE_HEIGHT,
  DEFAULT_XS_PARAGRAPH_INDENT: DEFAULT_XS_PARAGRAPH_INDENT,
  DEFAULT_XS_PARAGRAPH_SPACING: DEFAULT_XS_PARAGRAPH_SPACING,
  DEFAULT_XS_TEXT_CASE: DEFAULT_XS_TEXT_CASE,
  DEFAULT_XS_TEXT_DECORATION: DEFAULT_XS_TEXT_DECORATION,
  YLE_NEXT_2XL_BOLD_FONT_FAMILY: YLE_NEXT_2XL_BOLD_FONT_FAMILY,
  YLE_NEXT_2XL_BOLD_FONT_SIZE: YLE_NEXT_2XL_BOLD_FONT_SIZE,
  YLE_NEXT_2XL_BOLD_FONT_STRETCH: YLE_NEXT_2XL_BOLD_FONT_STRETCH,
  YLE_NEXT_2XL_BOLD_FONT_STYLE: YLE_NEXT_2XL_BOLD_FONT_STYLE,
  YLE_NEXT_2XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_2XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_2XL_BOLD_FONT_WEIGHT: YLE_NEXT_2XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_2XL_BOLD_LETTER_SPACING: YLE_NEXT_2XL_BOLD_LETTER_SPACING,
  YLE_NEXT_2XL_BOLD_LINE_HEIGHT: YLE_NEXT_2XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_2XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_2XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_2XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_2XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_2XL_BOLD_TEXT_CASE: YLE_NEXT_2XL_BOLD_TEXT_CASE,
  YLE_NEXT_2XL_BOLD_TEXT_DECORATION: YLE_NEXT_2XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_FAMILY,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_SIZE,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STRETCH,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_2XL_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_2XL_CONDENSED_BOLD_FONT_WEIGHT,
  YLE_NEXT_2XL_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_2XL_CONDENSED_BOLD_LETTER_SPACING,
  YLE_NEXT_2XL_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_2XL_CONDENSED_BOLD_LINE_HEIGHT,
  YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_2XL_CONDENSED_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_CASE,
  YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_2XL_CONDENSED_BOLD_TEXT_DECORATION,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_FAMILY,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_SIZE,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STRETCH,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_2XL_CONDENSED_HEAVY_FONT_WEIGHT,
  YLE_NEXT_2XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_2XL_CONDENSED_HEAVY_LETTER_SPACING,
  YLE_NEXT_2XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_2XL_CONDENSED_HEAVY_LINE_HEIGHT,
  YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_2XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_CASE,
  YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_2XL_CONDENSED_HEAVY_TEXT_DECORATION,
  YLE_NEXT_2XL_FONT_FAMILY: YLE_NEXT_2XL_FONT_FAMILY,
  YLE_NEXT_2XL_FONT_SIZE: YLE_NEXT_2XL_FONT_SIZE,
  YLE_NEXT_2XL_FONT_STRETCH: YLE_NEXT_2XL_FONT_STRETCH,
  YLE_NEXT_2XL_FONT_STYLE: YLE_NEXT_2XL_FONT_STYLE,
  YLE_NEXT_2XL_FONT_STYLE_OLD: YLE_NEXT_2XL_FONT_STYLE_OLD,
  YLE_NEXT_2XL_FONT_WEIGHT: YLE_NEXT_2XL_FONT_WEIGHT,
  YLE_NEXT_2XL_HEAVY_FONT_FAMILY: YLE_NEXT_2XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_2XL_HEAVY_FONT_SIZE: YLE_NEXT_2XL_HEAVY_FONT_SIZE,
  YLE_NEXT_2XL_HEAVY_FONT_STRETCH: YLE_NEXT_2XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_2XL_HEAVY_FONT_STYLE: YLE_NEXT_2XL_HEAVY_FONT_STYLE,
  YLE_NEXT_2XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_2XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_2XL_HEAVY_FONT_WEIGHT: YLE_NEXT_2XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_2XL_HEAVY_LETTER_SPACING: YLE_NEXT_2XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_2XL_HEAVY_LINE_HEIGHT: YLE_NEXT_2XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_2XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_2XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_2XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_2XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_2XL_HEAVY_TEXT_CASE: YLE_NEXT_2XL_HEAVY_TEXT_CASE,
  YLE_NEXT_2XL_HEAVY_TEXT_DECORATION: YLE_NEXT_2XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_2XL_LETTER_SPACING: YLE_NEXT_2XL_LETTER_SPACING,
  YLE_NEXT_2XL_LINE_HEIGHT: YLE_NEXT_2XL_LINE_HEIGHT,
  YLE_NEXT_2XL_PARAGRAPH_INDENT: YLE_NEXT_2XL_PARAGRAPH_INDENT,
  YLE_NEXT_2XL_PARAGRAPH_SPACING: YLE_NEXT_2XL_PARAGRAPH_SPACING,
  YLE_NEXT_2XL_TEXT_CASE: YLE_NEXT_2XL_TEXT_CASE,
  YLE_NEXT_2XL_TEXT_DECORATION: YLE_NEXT_2XL_TEXT_DECORATION,
  YLE_NEXT_3XL_BOLD_FONT_FAMILY: YLE_NEXT_3XL_BOLD_FONT_FAMILY,
  YLE_NEXT_3XL_BOLD_FONT_SIZE: YLE_NEXT_3XL_BOLD_FONT_SIZE,
  YLE_NEXT_3XL_BOLD_FONT_STRETCH: YLE_NEXT_3XL_BOLD_FONT_STRETCH,
  YLE_NEXT_3XL_BOLD_FONT_STYLE: YLE_NEXT_3XL_BOLD_FONT_STYLE,
  YLE_NEXT_3XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_3XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_3XL_BOLD_FONT_WEIGHT: YLE_NEXT_3XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_3XL_BOLD_LETTER_SPACING: YLE_NEXT_3XL_BOLD_LETTER_SPACING,
  YLE_NEXT_3XL_BOLD_LINE_HEIGHT: YLE_NEXT_3XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_3XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_3XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_3XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_3XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_3XL_BOLD_TEXT_CASE: YLE_NEXT_3XL_BOLD_TEXT_CASE,
  YLE_NEXT_3XL_BOLD_TEXT_DECORATION: YLE_NEXT_3XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_FAMILY,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_SIZE,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STRETCH,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_3XL_CONDENSED_HEAVY_FONT_WEIGHT,
  YLE_NEXT_3XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_3XL_CONDENSED_HEAVY_LETTER_SPACING,
  YLE_NEXT_3XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_3XL_CONDENSED_HEAVY_LINE_HEIGHT,
  YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_3XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_CASE,
  YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_3XL_CONDENSED_HEAVY_TEXT_DECORATION,
  YLE_NEXT_3XL_HEAVY_FONT_FAMILY: YLE_NEXT_3XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_3XL_HEAVY_FONT_SIZE: YLE_NEXT_3XL_HEAVY_FONT_SIZE,
  YLE_NEXT_3XL_HEAVY_FONT_STRETCH: YLE_NEXT_3XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_3XL_HEAVY_FONT_STYLE: YLE_NEXT_3XL_HEAVY_FONT_STYLE,
  YLE_NEXT_3XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_3XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_3XL_HEAVY_FONT_WEIGHT: YLE_NEXT_3XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_3XL_HEAVY_LETTER_SPACING: YLE_NEXT_3XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_3XL_HEAVY_LINE_HEIGHT: YLE_NEXT_3XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_3XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_3XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_3XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_3XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_3XL_HEAVY_TEXT_CASE: YLE_NEXT_3XL_HEAVY_TEXT_CASE,
  YLE_NEXT_3XL_HEAVY_TEXT_DECORATION: YLE_NEXT_3XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_4XL_BOLD_FONT_FAMILY: YLE_NEXT_4XL_BOLD_FONT_FAMILY,
  YLE_NEXT_4XL_BOLD_FONT_SIZE: YLE_NEXT_4XL_BOLD_FONT_SIZE,
  YLE_NEXT_4XL_BOLD_FONT_STRETCH: YLE_NEXT_4XL_BOLD_FONT_STRETCH,
  YLE_NEXT_4XL_BOLD_FONT_STYLE: YLE_NEXT_4XL_BOLD_FONT_STYLE,
  YLE_NEXT_4XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_4XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_4XL_BOLD_FONT_WEIGHT: YLE_NEXT_4XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_4XL_BOLD_LETTER_SPACING: YLE_NEXT_4XL_BOLD_LETTER_SPACING,
  YLE_NEXT_4XL_BOLD_LINE_HEIGHT: YLE_NEXT_4XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_4XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_4XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_4XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_4XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_4XL_BOLD_TEXT_CASE: YLE_NEXT_4XL_BOLD_TEXT_CASE,
  YLE_NEXT_4XL_BOLD_TEXT_DECORATION: YLE_NEXT_4XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_FAMILY,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_SIZE,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STRETCH,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_4XL_CONDENSED_HEAVY_FONT_WEIGHT,
  YLE_NEXT_4XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_4XL_CONDENSED_HEAVY_LETTER_SPACING,
  YLE_NEXT_4XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_4XL_CONDENSED_HEAVY_LINE_HEIGHT,
  YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_4XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_CASE,
  YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_4XL_CONDENSED_HEAVY_TEXT_DECORATION,
  YLE_NEXT_4XL_HEAVY_FONT_FAMILY: YLE_NEXT_4XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_4XL_HEAVY_FONT_SIZE: YLE_NEXT_4XL_HEAVY_FONT_SIZE,
  YLE_NEXT_4XL_HEAVY_FONT_STRETCH: YLE_NEXT_4XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_4XL_HEAVY_FONT_STYLE: YLE_NEXT_4XL_HEAVY_FONT_STYLE,
  YLE_NEXT_4XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_4XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_4XL_HEAVY_FONT_WEIGHT: YLE_NEXT_4XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_4XL_HEAVY_LETTER_SPACING: YLE_NEXT_4XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_4XL_HEAVY_LINE_HEIGHT: YLE_NEXT_4XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_4XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_4XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_4XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_4XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_4XL_HEAVY_TEXT_CASE: YLE_NEXT_4XL_HEAVY_TEXT_CASE,
  YLE_NEXT_4XL_HEAVY_TEXT_DECORATION: YLE_NEXT_4XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_5XL_BOLD_FONT_FAMILY: YLE_NEXT_5XL_BOLD_FONT_FAMILY,
  YLE_NEXT_5XL_BOLD_FONT_SIZE: YLE_NEXT_5XL_BOLD_FONT_SIZE,
  YLE_NEXT_5XL_BOLD_FONT_STRETCH: YLE_NEXT_5XL_BOLD_FONT_STRETCH,
  YLE_NEXT_5XL_BOLD_FONT_STYLE: YLE_NEXT_5XL_BOLD_FONT_STYLE,
  YLE_NEXT_5XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_5XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_5XL_BOLD_FONT_WEIGHT: YLE_NEXT_5XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_5XL_BOLD_LETTER_SPACING: YLE_NEXT_5XL_BOLD_LETTER_SPACING,
  YLE_NEXT_5XL_BOLD_LINE_HEIGHT: YLE_NEXT_5XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_5XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_5XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_5XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_5XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_5XL_BOLD_TEXT_CASE: YLE_NEXT_5XL_BOLD_TEXT_CASE,
  YLE_NEXT_5XL_BOLD_TEXT_DECORATION: YLE_NEXT_5XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_FAMILY,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_SIZE,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STRETCH,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_5XL_CONDENSED_HEAVY_FONT_WEIGHT,
  YLE_NEXT_5XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_5XL_CONDENSED_HEAVY_LETTER_SPACING,
  YLE_NEXT_5XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_5XL_CONDENSED_HEAVY_LINE_HEIGHT,
  YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_5XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_CASE,
  YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_5XL_CONDENSED_HEAVY_TEXT_DECORATION,
  YLE_NEXT_5XL_HEAVY_FONT_FAMILY: YLE_NEXT_5XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_5XL_HEAVY_FONT_SIZE: YLE_NEXT_5XL_HEAVY_FONT_SIZE,
  YLE_NEXT_5XL_HEAVY_FONT_STRETCH: YLE_NEXT_5XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_5XL_HEAVY_FONT_STYLE: YLE_NEXT_5XL_HEAVY_FONT_STYLE,
  YLE_NEXT_5XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_5XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_5XL_HEAVY_FONT_WEIGHT: YLE_NEXT_5XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_5XL_HEAVY_LETTER_SPACING: YLE_NEXT_5XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_5XL_HEAVY_LINE_HEIGHT: YLE_NEXT_5XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_5XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_5XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_5XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_5XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_5XL_HEAVY_TEXT_CASE: YLE_NEXT_5XL_HEAVY_TEXT_CASE,
  YLE_NEXT_5XL_HEAVY_TEXT_DECORATION: YLE_NEXT_5XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_6XL_BOLD_FONT_FAMILY: YLE_NEXT_6XL_BOLD_FONT_FAMILY,
  YLE_NEXT_6XL_BOLD_FONT_SIZE: YLE_NEXT_6XL_BOLD_FONT_SIZE,
  YLE_NEXT_6XL_BOLD_FONT_STRETCH: YLE_NEXT_6XL_BOLD_FONT_STRETCH,
  YLE_NEXT_6XL_BOLD_FONT_STYLE: YLE_NEXT_6XL_BOLD_FONT_STYLE,
  YLE_NEXT_6XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_6XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_6XL_BOLD_FONT_WEIGHT: YLE_NEXT_6XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_6XL_BOLD_LETTER_SPACING: YLE_NEXT_6XL_BOLD_LETTER_SPACING,
  YLE_NEXT_6XL_BOLD_LINE_HEIGHT: YLE_NEXT_6XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_6XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_6XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_6XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_6XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_6XL_BOLD_TEXT_CASE: YLE_NEXT_6XL_BOLD_TEXT_CASE,
  YLE_NEXT_6XL_BOLD_TEXT_DECORATION: YLE_NEXT_6XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_FAMILY,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_SIZE,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STRETCH,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_6XL_CONDENSED_HEAVY_FONT_WEIGHT,
  YLE_NEXT_6XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_6XL_CONDENSED_HEAVY_LETTER_SPACING,
  YLE_NEXT_6XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_6XL_CONDENSED_HEAVY_LINE_HEIGHT,
  YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_6XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_CASE,
  YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_6XL_CONDENSED_HEAVY_TEXT_DECORATION,
  YLE_NEXT_6XL_HEAVY_FONT_FAMILY: YLE_NEXT_6XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_6XL_HEAVY_FONT_SIZE: YLE_NEXT_6XL_HEAVY_FONT_SIZE,
  YLE_NEXT_6XL_HEAVY_FONT_STRETCH: YLE_NEXT_6XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_6XL_HEAVY_FONT_STYLE: YLE_NEXT_6XL_HEAVY_FONT_STYLE,
  YLE_NEXT_6XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_6XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_6XL_HEAVY_FONT_WEIGHT: YLE_NEXT_6XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_6XL_HEAVY_LETTER_SPACING: YLE_NEXT_6XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_6XL_HEAVY_LINE_HEIGHT: YLE_NEXT_6XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_6XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_6XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_6XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_6XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_6XL_HEAVY_TEXT_CASE: YLE_NEXT_6XL_HEAVY_TEXT_CASE,
  YLE_NEXT_6XL_HEAVY_TEXT_DECORATION: YLE_NEXT_6XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_7XL_BOLD_FONT_FAMILY: YLE_NEXT_7XL_BOLD_FONT_FAMILY,
  YLE_NEXT_7XL_BOLD_FONT_SIZE: YLE_NEXT_7XL_BOLD_FONT_SIZE,
  YLE_NEXT_7XL_BOLD_FONT_STRETCH: YLE_NEXT_7XL_BOLD_FONT_STRETCH,
  YLE_NEXT_7XL_BOLD_FONT_STYLE: YLE_NEXT_7XL_BOLD_FONT_STYLE,
  YLE_NEXT_7XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_7XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_7XL_BOLD_FONT_WEIGHT: YLE_NEXT_7XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_7XL_BOLD_LETTER_SPACING: YLE_NEXT_7XL_BOLD_LETTER_SPACING,
  YLE_NEXT_7XL_BOLD_LINE_HEIGHT: YLE_NEXT_7XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_7XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_7XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_7XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_7XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_7XL_BOLD_TEXT_CASE: YLE_NEXT_7XL_BOLD_TEXT_CASE,
  YLE_NEXT_7XL_BOLD_TEXT_DECORATION: YLE_NEXT_7XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_FAMILY,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_SIZE,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STRETCH,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_7XL_CONDENSED_HEAVY_FONT_WEIGHT,
  YLE_NEXT_7XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_7XL_CONDENSED_HEAVY_LETTER_SPACING,
  YLE_NEXT_7XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_7XL_CONDENSED_HEAVY_LINE_HEIGHT,
  YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_7XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_CASE,
  YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_7XL_CONDENSED_HEAVY_TEXT_DECORATION,
  YLE_NEXT_7XL_HEAVY_FONT_FAMILY: YLE_NEXT_7XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_7XL_HEAVY_FONT_SIZE: YLE_NEXT_7XL_HEAVY_FONT_SIZE,
  YLE_NEXT_7XL_HEAVY_FONT_STRETCH: YLE_NEXT_7XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_7XL_HEAVY_FONT_STYLE: YLE_NEXT_7XL_HEAVY_FONT_STYLE,
  YLE_NEXT_7XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_7XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_7XL_HEAVY_FONT_WEIGHT: YLE_NEXT_7XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_7XL_HEAVY_LETTER_SPACING: YLE_NEXT_7XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_7XL_HEAVY_LINE_HEIGHT: YLE_NEXT_7XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_7XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_7XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_7XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_7XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_7XL_HEAVY_TEXT_CASE: YLE_NEXT_7XL_HEAVY_TEXT_CASE,
  YLE_NEXT_7XL_HEAVY_TEXT_DECORATION: YLE_NEXT_7XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_L_BOLD_FONT_FAMILY: YLE_NEXT_L_BOLD_FONT_FAMILY,
  YLE_NEXT_L_BOLD_FONT_SIZE: YLE_NEXT_L_BOLD_FONT_SIZE,
  YLE_NEXT_L_BOLD_FONT_STRETCH: YLE_NEXT_L_BOLD_FONT_STRETCH,
  YLE_NEXT_L_BOLD_FONT_STYLE: YLE_NEXT_L_BOLD_FONT_STYLE,
  YLE_NEXT_L_BOLD_FONT_STYLE_OLD: YLE_NEXT_L_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_L_BOLD_FONT_WEIGHT: YLE_NEXT_L_BOLD_FONT_WEIGHT,
  YLE_NEXT_L_BOLD_LETTER_SPACING: YLE_NEXT_L_BOLD_LETTER_SPACING,
  YLE_NEXT_L_BOLD_LINE_HEIGHT: YLE_NEXT_L_BOLD_LINE_HEIGHT,
  YLE_NEXT_L_BOLD_PARAGRAPH_INDENT: YLE_NEXT_L_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_L_BOLD_PARAGRAPH_SPACING: YLE_NEXT_L_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_L_BOLD_TEXT_CASE: YLE_NEXT_L_BOLD_TEXT_CASE,
  YLE_NEXT_L_BOLD_TEXT_DECORATION: YLE_NEXT_L_BOLD_TEXT_DECORATION,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_L_CONDENSED_BOLD_FONT_FAMILY,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_L_CONDENSED_BOLD_FONT_SIZE,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_L_CONDENSED_BOLD_FONT_STRETCH,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_L_CONDENSED_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_L_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_L_CONDENSED_BOLD_FONT_WEIGHT,
  YLE_NEXT_L_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_L_CONDENSED_BOLD_LETTER_SPACING,
  YLE_NEXT_L_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_L_CONDENSED_BOLD_LINE_HEIGHT,
  YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_L_CONDENSED_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_L_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_L_CONDENSED_BOLD_TEXT_CASE,
  YLE_NEXT_L_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_L_CONDENSED_BOLD_TEXT_DECORATION,
  YLE_NEXT_L_CONDENSED_FONT_FAMILY: YLE_NEXT_L_CONDENSED_FONT_FAMILY,
  YLE_NEXT_L_CONDENSED_FONT_SIZE: YLE_NEXT_L_CONDENSED_FONT_SIZE,
  YLE_NEXT_L_CONDENSED_FONT_STRETCH: YLE_NEXT_L_CONDENSED_FONT_STRETCH,
  YLE_NEXT_L_CONDENSED_FONT_STYLE: YLE_NEXT_L_CONDENSED_FONT_STYLE,
  YLE_NEXT_L_CONDENSED_FONT_STYLE_OLD: YLE_NEXT_L_CONDENSED_FONT_STYLE_OLD,
  YLE_NEXT_L_CONDENSED_FONT_WEIGHT: YLE_NEXT_L_CONDENSED_FONT_WEIGHT,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_L_CONDENSED_HEAVY_FONT_FAMILY,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_L_CONDENSED_HEAVY_FONT_SIZE,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_L_CONDENSED_HEAVY_FONT_STRETCH,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_L_CONDENSED_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_L_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_L_CONDENSED_HEAVY_FONT_WEIGHT,
  YLE_NEXT_L_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_L_CONDENSED_HEAVY_LETTER_SPACING,
  YLE_NEXT_L_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_L_CONDENSED_HEAVY_LINE_HEIGHT,
  YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_L_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_L_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_L_CONDENSED_HEAVY_TEXT_CASE,
  YLE_NEXT_L_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_L_CONDENSED_HEAVY_TEXT_DECORATION,
  YLE_NEXT_L_CONDENSED_LETTER_SPACING: YLE_NEXT_L_CONDENSED_LETTER_SPACING,
  YLE_NEXT_L_CONDENSED_LINE_HEIGHT: YLE_NEXT_L_CONDENSED_LINE_HEIGHT,
  YLE_NEXT_L_CONDENSED_PARAGRAPH_INDENT: YLE_NEXT_L_CONDENSED_PARAGRAPH_INDENT,
  YLE_NEXT_L_CONDENSED_PARAGRAPH_SPACING: YLE_NEXT_L_CONDENSED_PARAGRAPH_SPACING,
  YLE_NEXT_L_CONDENSED_TEXT_CASE: YLE_NEXT_L_CONDENSED_TEXT_CASE,
  YLE_NEXT_L_CONDENSED_TEXT_DECORATION: YLE_NEXT_L_CONDENSED_TEXT_DECORATION,
  YLE_NEXT_L_FONT_FAMILY: YLE_NEXT_L_FONT_FAMILY,
  YLE_NEXT_L_FONT_SIZE: YLE_NEXT_L_FONT_SIZE,
  YLE_NEXT_L_FONT_STRETCH: YLE_NEXT_L_FONT_STRETCH,
  YLE_NEXT_L_FONT_STYLE: YLE_NEXT_L_FONT_STYLE,
  YLE_NEXT_L_FONT_STYLE_OLD: YLE_NEXT_L_FONT_STYLE_OLD,
  YLE_NEXT_L_FONT_WEIGHT: YLE_NEXT_L_FONT_WEIGHT,
  YLE_NEXT_L_HEAVY_FONT_FAMILY: YLE_NEXT_L_HEAVY_FONT_FAMILY,
  YLE_NEXT_L_HEAVY_FONT_SIZE: YLE_NEXT_L_HEAVY_FONT_SIZE,
  YLE_NEXT_L_HEAVY_FONT_STRETCH: YLE_NEXT_L_HEAVY_FONT_STRETCH,
  YLE_NEXT_L_HEAVY_FONT_STYLE: YLE_NEXT_L_HEAVY_FONT_STYLE,
  YLE_NEXT_L_HEAVY_FONT_STYLE_OLD: YLE_NEXT_L_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_L_HEAVY_FONT_WEIGHT: YLE_NEXT_L_HEAVY_FONT_WEIGHT,
  YLE_NEXT_L_HEAVY_LETTER_SPACING: YLE_NEXT_L_HEAVY_LETTER_SPACING,
  YLE_NEXT_L_HEAVY_LINE_HEIGHT: YLE_NEXT_L_HEAVY_LINE_HEIGHT,
  YLE_NEXT_L_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_L_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_L_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_L_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_L_HEAVY_TEXT_CASE: YLE_NEXT_L_HEAVY_TEXT_CASE,
  YLE_NEXT_L_HEAVY_TEXT_DECORATION: YLE_NEXT_L_HEAVY_TEXT_DECORATION,
  YLE_NEXT_L_ITALIC_FONT_FAMILY: YLE_NEXT_L_ITALIC_FONT_FAMILY,
  YLE_NEXT_L_ITALIC_FONT_SIZE: YLE_NEXT_L_ITALIC_FONT_SIZE,
  YLE_NEXT_L_ITALIC_FONT_STRETCH: YLE_NEXT_L_ITALIC_FONT_STRETCH,
  YLE_NEXT_L_ITALIC_FONT_STYLE: YLE_NEXT_L_ITALIC_FONT_STYLE,
  YLE_NEXT_L_ITALIC_FONT_STYLE_OLD: YLE_NEXT_L_ITALIC_FONT_STYLE_OLD,
  YLE_NEXT_L_ITALIC_FONT_WEIGHT: YLE_NEXT_L_ITALIC_FONT_WEIGHT,
  YLE_NEXT_L_ITALIC_LETTER_SPACING: YLE_NEXT_L_ITALIC_LETTER_SPACING,
  YLE_NEXT_L_ITALIC_LINE_HEIGHT: YLE_NEXT_L_ITALIC_LINE_HEIGHT,
  YLE_NEXT_L_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_L_ITALIC_PARAGRAPH_INDENT,
  YLE_NEXT_L_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_L_ITALIC_PARAGRAPH_SPACING,
  YLE_NEXT_L_ITALIC_TEXT_CASE: YLE_NEXT_L_ITALIC_TEXT_CASE,
  YLE_NEXT_L_ITALIC_TEXT_DECORATION: YLE_NEXT_L_ITALIC_TEXT_DECORATION,
  YLE_NEXT_L_LETTER_SPACING: YLE_NEXT_L_LETTER_SPACING,
  YLE_NEXT_L_LINE_HEIGHT: YLE_NEXT_L_LINE_HEIGHT,
  YLE_NEXT_L_PARAGRAPH_INDENT: YLE_NEXT_L_PARAGRAPH_INDENT,
  YLE_NEXT_L_PARAGRAPH_SPACING: YLE_NEXT_L_PARAGRAPH_SPACING,
  YLE_NEXT_L_TEXT_CASE: YLE_NEXT_L_TEXT_CASE,
  YLE_NEXT_L_TEXT_DECORATION: YLE_NEXT_L_TEXT_DECORATION,
  YLE_NEXT_M_AC_FONT_FAMILY: YLE_NEXT_M_AC_FONT_FAMILY,
  YLE_NEXT_M_AC_FONT_SIZE: YLE_NEXT_M_AC_FONT_SIZE,
  YLE_NEXT_M_AC_FONT_STRETCH: YLE_NEXT_M_AC_FONT_STRETCH,
  YLE_NEXT_M_AC_FONT_STYLE: YLE_NEXT_M_AC_FONT_STYLE,
  YLE_NEXT_M_AC_FONT_STYLE_OLD: YLE_NEXT_M_AC_FONT_STYLE_OLD,
  YLE_NEXT_M_AC_FONT_WEIGHT: YLE_NEXT_M_AC_FONT_WEIGHT,
  YLE_NEXT_M_AC_LETTER_SPACING: YLE_NEXT_M_AC_LETTER_SPACING,
  YLE_NEXT_M_AC_LINE_HEIGHT: YLE_NEXT_M_AC_LINE_HEIGHT,
  YLE_NEXT_M_AC_PARAGRAPH_INDENT: YLE_NEXT_M_AC_PARAGRAPH_INDENT,
  YLE_NEXT_M_AC_PARAGRAPH_SPACING: YLE_NEXT_M_AC_PARAGRAPH_SPACING,
  YLE_NEXT_M_AC_TEXT_CASE: YLE_NEXT_M_AC_TEXT_CASE,
  YLE_NEXT_M_AC_TEXT_DECORATION: YLE_NEXT_M_AC_TEXT_DECORATION,
  YLE_NEXT_M_BOLD_AC_FONT_FAMILY: YLE_NEXT_M_BOLD_AC_FONT_FAMILY,
  YLE_NEXT_M_BOLD_AC_FONT_SIZE: YLE_NEXT_M_BOLD_AC_FONT_SIZE,
  YLE_NEXT_M_BOLD_AC_FONT_STRETCH: YLE_NEXT_M_BOLD_AC_FONT_STRETCH,
  YLE_NEXT_M_BOLD_AC_FONT_STYLE: YLE_NEXT_M_BOLD_AC_FONT_STYLE,
  YLE_NEXT_M_BOLD_AC_FONT_STYLE_OLD: YLE_NEXT_M_BOLD_AC_FONT_STYLE_OLD,
  YLE_NEXT_M_BOLD_AC_FONT_WEIGHT: YLE_NEXT_M_BOLD_AC_FONT_WEIGHT,
  YLE_NEXT_M_BOLD_AC_LETTER_SPACING: YLE_NEXT_M_BOLD_AC_LETTER_SPACING,
  YLE_NEXT_M_BOLD_AC_LINE_HEIGHT: YLE_NEXT_M_BOLD_AC_LINE_HEIGHT,
  YLE_NEXT_M_BOLD_AC_PARAGRAPH_INDENT: YLE_NEXT_M_BOLD_AC_PARAGRAPH_INDENT,
  YLE_NEXT_M_BOLD_AC_PARAGRAPH_SPACING: YLE_NEXT_M_BOLD_AC_PARAGRAPH_SPACING,
  YLE_NEXT_M_BOLD_AC_TEXT_CASE: YLE_NEXT_M_BOLD_AC_TEXT_CASE,
  YLE_NEXT_M_BOLD_AC_TEXT_DECORATION: YLE_NEXT_M_BOLD_AC_TEXT_DECORATION,
  YLE_NEXT_M_BOLD_FONT_FAMILY: YLE_NEXT_M_BOLD_FONT_FAMILY,
  YLE_NEXT_M_BOLD_FONT_SIZE: YLE_NEXT_M_BOLD_FONT_SIZE,
  YLE_NEXT_M_BOLD_FONT_STRETCH: YLE_NEXT_M_BOLD_FONT_STRETCH,
  YLE_NEXT_M_BOLD_FONT_STYLE: YLE_NEXT_M_BOLD_FONT_STYLE,
  YLE_NEXT_M_BOLD_FONT_STYLE_OLD: YLE_NEXT_M_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_M_BOLD_FONT_WEIGHT: YLE_NEXT_M_BOLD_FONT_WEIGHT,
  YLE_NEXT_M_BOLD_LETTER_SPACING: YLE_NEXT_M_BOLD_LETTER_SPACING,
  YLE_NEXT_M_BOLD_LINE_HEIGHT: YLE_NEXT_M_BOLD_LINE_HEIGHT,
  YLE_NEXT_M_BOLD_PARAGRAPH_INDENT: YLE_NEXT_M_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_M_BOLD_PARAGRAPH_SPACING: YLE_NEXT_M_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_M_BOLD_TEXT_CASE: YLE_NEXT_M_BOLD_TEXT_CASE,
  YLE_NEXT_M_BOLD_TEXT_DECORATION: YLE_NEXT_M_BOLD_TEXT_DECORATION,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_M_CONDENSED_BOLD_FONT_FAMILY,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_M_CONDENSED_BOLD_FONT_SIZE,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_M_CONDENSED_BOLD_FONT_STRETCH,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_M_CONDENSED_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_M_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_M_CONDENSED_BOLD_FONT_WEIGHT,
  YLE_NEXT_M_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_M_CONDENSED_BOLD_LETTER_SPACING,
  YLE_NEXT_M_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_M_CONDENSED_BOLD_LINE_HEIGHT,
  YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_M_CONDENSED_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_M_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_M_CONDENSED_BOLD_TEXT_CASE,
  YLE_NEXT_M_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_M_CONDENSED_BOLD_TEXT_DECORATION,
  YLE_NEXT_M_CONDENSED_FONT_FAMILY: YLE_NEXT_M_CONDENSED_FONT_FAMILY,
  YLE_NEXT_M_CONDENSED_FONT_SIZE: YLE_NEXT_M_CONDENSED_FONT_SIZE,
  YLE_NEXT_M_CONDENSED_FONT_STRETCH: YLE_NEXT_M_CONDENSED_FONT_STRETCH,
  YLE_NEXT_M_CONDENSED_FONT_STYLE: YLE_NEXT_M_CONDENSED_FONT_STYLE,
  YLE_NEXT_M_CONDENSED_FONT_STYLE_OLD: YLE_NEXT_M_CONDENSED_FONT_STYLE_OLD,
  YLE_NEXT_M_CONDENSED_FONT_WEIGHT: YLE_NEXT_M_CONDENSED_FONT_WEIGHT,
  YLE_NEXT_M_CONDENSED_LETTER_SPACING: YLE_NEXT_M_CONDENSED_LETTER_SPACING,
  YLE_NEXT_M_CONDENSED_LINE_HEIGHT: YLE_NEXT_M_CONDENSED_LINE_HEIGHT,
  YLE_NEXT_M_CONDENSED_PARAGRAPH_INDENT: YLE_NEXT_M_CONDENSED_PARAGRAPH_INDENT,
  YLE_NEXT_M_CONDENSED_PARAGRAPH_SPACING: YLE_NEXT_M_CONDENSED_PARAGRAPH_SPACING,
  YLE_NEXT_M_CONDENSED_TEXT_CASE: YLE_NEXT_M_CONDENSED_TEXT_CASE,
  YLE_NEXT_M_CONDENSED_TEXT_DECORATION: YLE_NEXT_M_CONDENSED_TEXT_DECORATION,
  YLE_NEXT_M_FONT_FAMILY: YLE_NEXT_M_FONT_FAMILY,
  YLE_NEXT_M_FONT_SIZE: YLE_NEXT_M_FONT_SIZE,
  YLE_NEXT_M_FONT_STRETCH: YLE_NEXT_M_FONT_STRETCH,
  YLE_NEXT_M_FONT_STYLE: YLE_NEXT_M_FONT_STYLE,
  YLE_NEXT_M_FONT_STYLE_OLD: YLE_NEXT_M_FONT_STYLE_OLD,
  YLE_NEXT_M_FONT_WEIGHT: YLE_NEXT_M_FONT_WEIGHT,
  YLE_NEXT_M_ITALIC_FONT_FAMILY: YLE_NEXT_M_ITALIC_FONT_FAMILY,
  YLE_NEXT_M_ITALIC_FONT_SIZE: YLE_NEXT_M_ITALIC_FONT_SIZE,
  YLE_NEXT_M_ITALIC_FONT_STRETCH: YLE_NEXT_M_ITALIC_FONT_STRETCH,
  YLE_NEXT_M_ITALIC_FONT_STYLE: YLE_NEXT_M_ITALIC_FONT_STYLE,
  YLE_NEXT_M_ITALIC_FONT_STYLE_OLD: YLE_NEXT_M_ITALIC_FONT_STYLE_OLD,
  YLE_NEXT_M_ITALIC_FONT_WEIGHT: YLE_NEXT_M_ITALIC_FONT_WEIGHT,
  YLE_NEXT_M_ITALIC_LETTER_SPACING: YLE_NEXT_M_ITALIC_LETTER_SPACING,
  YLE_NEXT_M_ITALIC_LINE_HEIGHT: YLE_NEXT_M_ITALIC_LINE_HEIGHT,
  YLE_NEXT_M_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_M_ITALIC_PARAGRAPH_INDENT,
  YLE_NEXT_M_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_M_ITALIC_PARAGRAPH_SPACING,
  YLE_NEXT_M_ITALIC_TEXT_CASE: YLE_NEXT_M_ITALIC_TEXT_CASE,
  YLE_NEXT_M_ITALIC_TEXT_DECORATION: YLE_NEXT_M_ITALIC_TEXT_DECORATION,
  YLE_NEXT_M_LETTER_SPACING: YLE_NEXT_M_LETTER_SPACING,
  YLE_NEXT_M_LINE_HEIGHT: YLE_NEXT_M_LINE_HEIGHT,
  YLE_NEXT_M_MEDIUM_FONT_FAMILY: YLE_NEXT_M_MEDIUM_FONT_FAMILY,
  YLE_NEXT_M_MEDIUM_FONT_SIZE: YLE_NEXT_M_MEDIUM_FONT_SIZE,
  YLE_NEXT_M_MEDIUM_FONT_STRETCH: YLE_NEXT_M_MEDIUM_FONT_STRETCH,
  YLE_NEXT_M_MEDIUM_FONT_STYLE: YLE_NEXT_M_MEDIUM_FONT_STYLE,
  YLE_NEXT_M_MEDIUM_FONT_STYLE_OLD: YLE_NEXT_M_MEDIUM_FONT_STYLE_OLD,
  YLE_NEXT_M_MEDIUM_FONT_WEIGHT: YLE_NEXT_M_MEDIUM_FONT_WEIGHT,
  YLE_NEXT_M_MEDIUM_LETTER_SPACING: YLE_NEXT_M_MEDIUM_LETTER_SPACING,
  YLE_NEXT_M_MEDIUM_LINE_HEIGHT: YLE_NEXT_M_MEDIUM_LINE_HEIGHT,
  YLE_NEXT_M_MEDIUM_PARAGRAPH_INDENT: YLE_NEXT_M_MEDIUM_PARAGRAPH_INDENT,
  YLE_NEXT_M_MEDIUM_PARAGRAPH_SPACING: YLE_NEXT_M_MEDIUM_PARAGRAPH_SPACING,
  YLE_NEXT_M_MEDIUM_TEXT_CASE: YLE_NEXT_M_MEDIUM_TEXT_CASE,
  YLE_NEXT_M_MEDIUM_TEXT_DECORATION: YLE_NEXT_M_MEDIUM_TEXT_DECORATION,
  YLE_NEXT_M_PARAGRAPH_INDENT: YLE_NEXT_M_PARAGRAPH_INDENT,
  YLE_NEXT_M_PARAGRAPH_SPACING: YLE_NEXT_M_PARAGRAPH_SPACING,
  YLE_NEXT_M_TEXT_CASE: YLE_NEXT_M_TEXT_CASE,
  YLE_NEXT_M_TEXT_DECORATION: YLE_NEXT_M_TEXT_DECORATION,
  YLE_NEXT_S_AC_FONT_FAMILY: YLE_NEXT_S_AC_FONT_FAMILY,
  YLE_NEXT_S_AC_FONT_SIZE: YLE_NEXT_S_AC_FONT_SIZE,
  YLE_NEXT_S_AC_FONT_STRETCH: YLE_NEXT_S_AC_FONT_STRETCH,
  YLE_NEXT_S_AC_FONT_STYLE: YLE_NEXT_S_AC_FONT_STYLE,
  YLE_NEXT_S_AC_FONT_STYLE_OLD: YLE_NEXT_S_AC_FONT_STYLE_OLD,
  YLE_NEXT_S_AC_FONT_WEIGHT: YLE_NEXT_S_AC_FONT_WEIGHT,
  YLE_NEXT_S_AC_LETTER_SPACING: YLE_NEXT_S_AC_LETTER_SPACING,
  YLE_NEXT_S_AC_LINE_HEIGHT: YLE_NEXT_S_AC_LINE_HEIGHT,
  YLE_NEXT_S_AC_PARAGRAPH_INDENT: YLE_NEXT_S_AC_PARAGRAPH_INDENT,
  YLE_NEXT_S_AC_PARAGRAPH_SPACING: YLE_NEXT_S_AC_PARAGRAPH_SPACING,
  YLE_NEXT_S_AC_TEXT_CASE: YLE_NEXT_S_AC_TEXT_CASE,
  YLE_NEXT_S_AC_TEXT_DECORATION: YLE_NEXT_S_AC_TEXT_DECORATION,
  YLE_NEXT_S_BOLD_AC_FONT_FAMILY: YLE_NEXT_S_BOLD_AC_FONT_FAMILY,
  YLE_NEXT_S_BOLD_AC_FONT_SIZE: YLE_NEXT_S_BOLD_AC_FONT_SIZE,
  YLE_NEXT_S_BOLD_AC_FONT_STRETCH: YLE_NEXT_S_BOLD_AC_FONT_STRETCH,
  YLE_NEXT_S_BOLD_AC_FONT_STYLE: YLE_NEXT_S_BOLD_AC_FONT_STYLE,
  YLE_NEXT_S_BOLD_AC_FONT_STYLE_OLD: YLE_NEXT_S_BOLD_AC_FONT_STYLE_OLD,
  YLE_NEXT_S_BOLD_AC_FONT_WEIGHT: YLE_NEXT_S_BOLD_AC_FONT_WEIGHT,
  YLE_NEXT_S_BOLD_AC_LETTER_SPACING: YLE_NEXT_S_BOLD_AC_LETTER_SPACING,
  YLE_NEXT_S_BOLD_AC_LINE_HEIGHT: YLE_NEXT_S_BOLD_AC_LINE_HEIGHT,
  YLE_NEXT_S_BOLD_AC_PARAGRAPH_INDENT: YLE_NEXT_S_BOLD_AC_PARAGRAPH_INDENT,
  YLE_NEXT_S_BOLD_AC_PARAGRAPH_SPACING: YLE_NEXT_S_BOLD_AC_PARAGRAPH_SPACING,
  YLE_NEXT_S_BOLD_AC_TEXT_CASE: YLE_NEXT_S_BOLD_AC_TEXT_CASE,
  YLE_NEXT_S_BOLD_AC_TEXT_DECORATION: YLE_NEXT_S_BOLD_AC_TEXT_DECORATION,
  YLE_NEXT_S_BOLD_FONT_FAMILY: YLE_NEXT_S_BOLD_FONT_FAMILY,
  YLE_NEXT_S_BOLD_FONT_SIZE: YLE_NEXT_S_BOLD_FONT_SIZE,
  YLE_NEXT_S_BOLD_FONT_STRETCH: YLE_NEXT_S_BOLD_FONT_STRETCH,
  YLE_NEXT_S_BOLD_FONT_STYLE: YLE_NEXT_S_BOLD_FONT_STYLE,
  YLE_NEXT_S_BOLD_FONT_STYLE_OLD: YLE_NEXT_S_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_S_BOLD_FONT_WEIGHT: YLE_NEXT_S_BOLD_FONT_WEIGHT,
  YLE_NEXT_S_BOLD_LETTER_SPACING: YLE_NEXT_S_BOLD_LETTER_SPACING,
  YLE_NEXT_S_BOLD_LINE_HEIGHT: YLE_NEXT_S_BOLD_LINE_HEIGHT,
  YLE_NEXT_S_BOLD_PARAGRAPH_INDENT: YLE_NEXT_S_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_S_BOLD_PARAGRAPH_SPACING: YLE_NEXT_S_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_S_BOLD_TEXT_CASE: YLE_NEXT_S_BOLD_TEXT_CASE,
  YLE_NEXT_S_BOLD_TEXT_DECORATION: YLE_NEXT_S_BOLD_TEXT_DECORATION,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_S_CONDENSED_BOLD_FONT_FAMILY,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_S_CONDENSED_BOLD_FONT_SIZE,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_S_CONDENSED_BOLD_FONT_STRETCH,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_S_CONDENSED_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_S_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_S_CONDENSED_BOLD_FONT_WEIGHT,
  YLE_NEXT_S_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_S_CONDENSED_BOLD_LETTER_SPACING,
  YLE_NEXT_S_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_S_CONDENSED_BOLD_LINE_HEIGHT,
  YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_S_CONDENSED_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_S_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_S_CONDENSED_BOLD_TEXT_CASE,
  YLE_NEXT_S_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_S_CONDENSED_BOLD_TEXT_DECORATION,
  YLE_NEXT_S_CONDENSED_FONT_FAMILY: YLE_NEXT_S_CONDENSED_FONT_FAMILY,
  YLE_NEXT_S_CONDENSED_FONT_SIZE: YLE_NEXT_S_CONDENSED_FONT_SIZE,
  YLE_NEXT_S_CONDENSED_FONT_STRETCH: YLE_NEXT_S_CONDENSED_FONT_STRETCH,
  YLE_NEXT_S_CONDENSED_FONT_STYLE: YLE_NEXT_S_CONDENSED_FONT_STYLE,
  YLE_NEXT_S_CONDENSED_FONT_STYLE_OLD: YLE_NEXT_S_CONDENSED_FONT_STYLE_OLD,
  YLE_NEXT_S_CONDENSED_FONT_WEIGHT: YLE_NEXT_S_CONDENSED_FONT_WEIGHT,
  YLE_NEXT_S_CONDENSED_LETTER_SPACING: YLE_NEXT_S_CONDENSED_LETTER_SPACING,
  YLE_NEXT_S_CONDENSED_LINE_HEIGHT: YLE_NEXT_S_CONDENSED_LINE_HEIGHT,
  YLE_NEXT_S_CONDENSED_PARAGRAPH_INDENT: YLE_NEXT_S_CONDENSED_PARAGRAPH_INDENT,
  YLE_NEXT_S_CONDENSED_PARAGRAPH_SPACING: YLE_NEXT_S_CONDENSED_PARAGRAPH_SPACING,
  YLE_NEXT_S_CONDENSED_TEXT_CASE: YLE_NEXT_S_CONDENSED_TEXT_CASE,
  YLE_NEXT_S_CONDENSED_TEXT_DECORATION: YLE_NEXT_S_CONDENSED_TEXT_DECORATION,
  YLE_NEXT_S_FONT_FAMILY: YLE_NEXT_S_FONT_FAMILY,
  YLE_NEXT_S_FONT_SIZE: YLE_NEXT_S_FONT_SIZE,
  YLE_NEXT_S_FONT_STRETCH: YLE_NEXT_S_FONT_STRETCH,
  YLE_NEXT_S_FONT_STYLE: YLE_NEXT_S_FONT_STYLE,
  YLE_NEXT_S_FONT_STYLE_OLD: YLE_NEXT_S_FONT_STYLE_OLD,
  YLE_NEXT_S_FONT_WEIGHT: YLE_NEXT_S_FONT_WEIGHT,
  YLE_NEXT_S_ITALIC_FONT_FAMILY: YLE_NEXT_S_ITALIC_FONT_FAMILY,
  YLE_NEXT_S_ITALIC_FONT_SIZE: YLE_NEXT_S_ITALIC_FONT_SIZE,
  YLE_NEXT_S_ITALIC_FONT_STRETCH: YLE_NEXT_S_ITALIC_FONT_STRETCH,
  YLE_NEXT_S_ITALIC_FONT_STYLE: YLE_NEXT_S_ITALIC_FONT_STYLE,
  YLE_NEXT_S_ITALIC_FONT_STYLE_OLD: YLE_NEXT_S_ITALIC_FONT_STYLE_OLD,
  YLE_NEXT_S_ITALIC_FONT_WEIGHT: YLE_NEXT_S_ITALIC_FONT_WEIGHT,
  YLE_NEXT_S_ITALIC_LETTER_SPACING: YLE_NEXT_S_ITALIC_LETTER_SPACING,
  YLE_NEXT_S_ITALIC_LINE_HEIGHT: YLE_NEXT_S_ITALIC_LINE_HEIGHT,
  YLE_NEXT_S_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_S_ITALIC_PARAGRAPH_INDENT,
  YLE_NEXT_S_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_S_ITALIC_PARAGRAPH_SPACING,
  YLE_NEXT_S_ITALIC_TEXT_CASE: YLE_NEXT_S_ITALIC_TEXT_CASE,
  YLE_NEXT_S_ITALIC_TEXT_DECORATION: YLE_NEXT_S_ITALIC_TEXT_DECORATION,
  YLE_NEXT_S_LETTER_SPACING: YLE_NEXT_S_LETTER_SPACING,
  YLE_NEXT_S_LINE_HEIGHT: YLE_NEXT_S_LINE_HEIGHT,
  YLE_NEXT_S_MEDIUM_FONT_FAMILY: YLE_NEXT_S_MEDIUM_FONT_FAMILY,
  YLE_NEXT_S_MEDIUM_FONT_SIZE: YLE_NEXT_S_MEDIUM_FONT_SIZE,
  YLE_NEXT_S_MEDIUM_FONT_STRETCH: YLE_NEXT_S_MEDIUM_FONT_STRETCH,
  YLE_NEXT_S_MEDIUM_FONT_STYLE: YLE_NEXT_S_MEDIUM_FONT_STYLE,
  YLE_NEXT_S_MEDIUM_FONT_STYLE_OLD: YLE_NEXT_S_MEDIUM_FONT_STYLE_OLD,
  YLE_NEXT_S_MEDIUM_FONT_WEIGHT: YLE_NEXT_S_MEDIUM_FONT_WEIGHT,
  YLE_NEXT_S_MEDIUM_LETTER_SPACING: YLE_NEXT_S_MEDIUM_LETTER_SPACING,
  YLE_NEXT_S_MEDIUM_LINE_HEIGHT: YLE_NEXT_S_MEDIUM_LINE_HEIGHT,
  YLE_NEXT_S_MEDIUM_PARAGRAPH_INDENT: YLE_NEXT_S_MEDIUM_PARAGRAPH_INDENT,
  YLE_NEXT_S_MEDIUM_PARAGRAPH_SPACING: YLE_NEXT_S_MEDIUM_PARAGRAPH_SPACING,
  YLE_NEXT_S_MEDIUM_TEXT_CASE: YLE_NEXT_S_MEDIUM_TEXT_CASE,
  YLE_NEXT_S_MEDIUM_TEXT_DECORATION: YLE_NEXT_S_MEDIUM_TEXT_DECORATION,
  YLE_NEXT_S_PARAGRAPH_INDENT: YLE_NEXT_S_PARAGRAPH_INDENT,
  YLE_NEXT_S_PARAGRAPH_SPACING: YLE_NEXT_S_PARAGRAPH_SPACING,
  YLE_NEXT_S_TEXT_CASE: YLE_NEXT_S_TEXT_CASE,
  YLE_NEXT_S_TEXT_DECORATION: YLE_NEXT_S_TEXT_DECORATION,
  YLE_NEXT_XL_BOLD_FONT_FAMILY: YLE_NEXT_XL_BOLD_FONT_FAMILY,
  YLE_NEXT_XL_BOLD_FONT_SIZE: YLE_NEXT_XL_BOLD_FONT_SIZE,
  YLE_NEXT_XL_BOLD_FONT_STRETCH: YLE_NEXT_XL_BOLD_FONT_STRETCH,
  YLE_NEXT_XL_BOLD_FONT_STYLE: YLE_NEXT_XL_BOLD_FONT_STYLE,
  YLE_NEXT_XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_XL_BOLD_FONT_WEIGHT: YLE_NEXT_XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_XL_BOLD_LETTER_SPACING: YLE_NEXT_XL_BOLD_LETTER_SPACING,
  YLE_NEXT_XL_BOLD_LINE_HEIGHT: YLE_NEXT_XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_XL_BOLD_TEXT_CASE: YLE_NEXT_XL_BOLD_TEXT_CASE,
  YLE_NEXT_XL_BOLD_TEXT_DECORATION: YLE_NEXT_XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_XL_CONDENSED_BOLD_FONT_FAMILY,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_XL_CONDENSED_BOLD_FONT_SIZE,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_XL_CONDENSED_BOLD_FONT_STRETCH,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_XL_CONDENSED_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_XL_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_XL_CONDENSED_BOLD_FONT_WEIGHT,
  YLE_NEXT_XL_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_XL_CONDENSED_BOLD_LETTER_SPACING,
  YLE_NEXT_XL_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_XL_CONDENSED_BOLD_LINE_HEIGHT,
  YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XL_CONDENSED_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_XL_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_XL_CONDENSED_BOLD_TEXT_CASE,
  YLE_NEXT_XL_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_XL_CONDENSED_BOLD_TEXT_DECORATION,
  YLE_NEXT_XL_CONDENSED_FONT_FAMILY: YLE_NEXT_XL_CONDENSED_FONT_FAMILY,
  YLE_NEXT_XL_CONDENSED_FONT_SIZE: YLE_NEXT_XL_CONDENSED_FONT_SIZE,
  YLE_NEXT_XL_CONDENSED_FONT_STRETCH: YLE_NEXT_XL_CONDENSED_FONT_STRETCH,
  YLE_NEXT_XL_CONDENSED_FONT_STYLE: YLE_NEXT_XL_CONDENSED_FONT_STYLE,
  YLE_NEXT_XL_CONDENSED_FONT_STYLE_OLD: YLE_NEXT_XL_CONDENSED_FONT_STYLE_OLD,
  YLE_NEXT_XL_CONDENSED_FONT_WEIGHT: YLE_NEXT_XL_CONDENSED_FONT_WEIGHT,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_FAMILY: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_FAMILY,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_SIZE: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_SIZE,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STRETCH: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STRETCH,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_XL_CONDENSED_HEAVY_FONT_WEIGHT: YLE_NEXT_XL_CONDENSED_HEAVY_FONT_WEIGHT,
  YLE_NEXT_XL_CONDENSED_HEAVY_LETTER_SPACING: YLE_NEXT_XL_CONDENSED_HEAVY_LETTER_SPACING,
  YLE_NEXT_XL_CONDENSED_HEAVY_LINE_HEIGHT: YLE_NEXT_XL_CONDENSED_HEAVY_LINE_HEIGHT,
  YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_XL_CONDENSED_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_CASE: YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_CASE,
  YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_DECORATION: YLE_NEXT_XL_CONDENSED_HEAVY_TEXT_DECORATION,
  YLE_NEXT_XL_CONDENSED_LETTER_SPACING: YLE_NEXT_XL_CONDENSED_LETTER_SPACING,
  YLE_NEXT_XL_CONDENSED_LINE_HEIGHT: YLE_NEXT_XL_CONDENSED_LINE_HEIGHT,
  YLE_NEXT_XL_CONDENSED_PARAGRAPH_INDENT: YLE_NEXT_XL_CONDENSED_PARAGRAPH_INDENT,
  YLE_NEXT_XL_CONDENSED_PARAGRAPH_SPACING: YLE_NEXT_XL_CONDENSED_PARAGRAPH_SPACING,
  YLE_NEXT_XL_CONDENSED_TEXT_CASE: YLE_NEXT_XL_CONDENSED_TEXT_CASE,
  YLE_NEXT_XL_CONDENSED_TEXT_DECORATION: YLE_NEXT_XL_CONDENSED_TEXT_DECORATION,
  YLE_NEXT_XL_FONT_FAMILY: YLE_NEXT_XL_FONT_FAMILY,
  YLE_NEXT_XL_FONT_SIZE: YLE_NEXT_XL_FONT_SIZE,
  YLE_NEXT_XL_FONT_STRETCH: YLE_NEXT_XL_FONT_STRETCH,
  YLE_NEXT_XL_FONT_STYLE: YLE_NEXT_XL_FONT_STYLE,
  YLE_NEXT_XL_FONT_STYLE_OLD: YLE_NEXT_XL_FONT_STYLE_OLD,
  YLE_NEXT_XL_FONT_WEIGHT: YLE_NEXT_XL_FONT_WEIGHT,
  YLE_NEXT_XL_HEAVY_FONT_FAMILY: YLE_NEXT_XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_XL_HEAVY_FONT_SIZE: YLE_NEXT_XL_HEAVY_FONT_SIZE,
  YLE_NEXT_XL_HEAVY_FONT_STRETCH: YLE_NEXT_XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_XL_HEAVY_FONT_STYLE: YLE_NEXT_XL_HEAVY_FONT_STYLE,
  YLE_NEXT_XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_XL_HEAVY_FONT_WEIGHT: YLE_NEXT_XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_XL_HEAVY_LETTER_SPACING: YLE_NEXT_XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_XL_HEAVY_LINE_HEIGHT: YLE_NEXT_XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_XL_HEAVY_TEXT_CASE: YLE_NEXT_XL_HEAVY_TEXT_CASE,
  YLE_NEXT_XL_HEAVY_TEXT_DECORATION: YLE_NEXT_XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_XL_ITALIC_FONT_FAMILY: YLE_NEXT_XL_ITALIC_FONT_FAMILY,
  YLE_NEXT_XL_ITALIC_FONT_SIZE: YLE_NEXT_XL_ITALIC_FONT_SIZE,
  YLE_NEXT_XL_ITALIC_FONT_STRETCH: YLE_NEXT_XL_ITALIC_FONT_STRETCH,
  YLE_NEXT_XL_ITALIC_FONT_STYLE: YLE_NEXT_XL_ITALIC_FONT_STYLE,
  YLE_NEXT_XL_ITALIC_FONT_STYLE_OLD: YLE_NEXT_XL_ITALIC_FONT_STYLE_OLD,
  YLE_NEXT_XL_ITALIC_FONT_WEIGHT: YLE_NEXT_XL_ITALIC_FONT_WEIGHT,
  YLE_NEXT_XL_ITALIC_LETTER_SPACING: YLE_NEXT_XL_ITALIC_LETTER_SPACING,
  YLE_NEXT_XL_ITALIC_LINE_HEIGHT: YLE_NEXT_XL_ITALIC_LINE_HEIGHT,
  YLE_NEXT_XL_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_XL_ITALIC_PARAGRAPH_INDENT,
  YLE_NEXT_XL_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_XL_ITALIC_PARAGRAPH_SPACING,
  YLE_NEXT_XL_ITALIC_TEXT_CASE: YLE_NEXT_XL_ITALIC_TEXT_CASE,
  YLE_NEXT_XL_ITALIC_TEXT_DECORATION: YLE_NEXT_XL_ITALIC_TEXT_DECORATION,
  YLE_NEXT_XL_LETTER_SPACING: YLE_NEXT_XL_LETTER_SPACING,
  YLE_NEXT_XL_LINE_HEIGHT: YLE_NEXT_XL_LINE_HEIGHT,
  YLE_NEXT_XL_PARAGRAPH_INDENT: YLE_NEXT_XL_PARAGRAPH_INDENT,
  YLE_NEXT_XL_PARAGRAPH_SPACING: YLE_NEXT_XL_PARAGRAPH_SPACING,
  YLE_NEXT_XL_TEXT_CASE: YLE_NEXT_XL_TEXT_CASE,
  YLE_NEXT_XL_TEXT_DECORATION: YLE_NEXT_XL_TEXT_DECORATION,
  YLE_NEXT_XS_AC_FONT_FAMILY: YLE_NEXT_XS_AC_FONT_FAMILY,
  YLE_NEXT_XS_AC_FONT_SIZE: YLE_NEXT_XS_AC_FONT_SIZE,
  YLE_NEXT_XS_AC_FONT_STRETCH: YLE_NEXT_XS_AC_FONT_STRETCH,
  YLE_NEXT_XS_AC_FONT_STYLE: YLE_NEXT_XS_AC_FONT_STYLE,
  YLE_NEXT_XS_AC_FONT_STYLE_OLD: YLE_NEXT_XS_AC_FONT_STYLE_OLD,
  YLE_NEXT_XS_AC_FONT_WEIGHT: YLE_NEXT_XS_AC_FONT_WEIGHT,
  YLE_NEXT_XS_AC_LETTER_SPACING: YLE_NEXT_XS_AC_LETTER_SPACING,
  YLE_NEXT_XS_AC_LINE_HEIGHT: YLE_NEXT_XS_AC_LINE_HEIGHT,
  YLE_NEXT_XS_AC_PARAGRAPH_INDENT: YLE_NEXT_XS_AC_PARAGRAPH_INDENT,
  YLE_NEXT_XS_AC_PARAGRAPH_SPACING: YLE_NEXT_XS_AC_PARAGRAPH_SPACING,
  YLE_NEXT_XS_AC_TEXT_CASE: YLE_NEXT_XS_AC_TEXT_CASE,
  YLE_NEXT_XS_AC_TEXT_DECORATION: YLE_NEXT_XS_AC_TEXT_DECORATION,
  YLE_NEXT_XS_BOLD_AC_FONT_FAMILY: YLE_NEXT_XS_BOLD_AC_FONT_FAMILY,
  YLE_NEXT_XS_BOLD_AC_FONT_SIZE: YLE_NEXT_XS_BOLD_AC_FONT_SIZE,
  YLE_NEXT_XS_BOLD_AC_FONT_STRETCH: YLE_NEXT_XS_BOLD_AC_FONT_STRETCH,
  YLE_NEXT_XS_BOLD_AC_FONT_STYLE: YLE_NEXT_XS_BOLD_AC_FONT_STYLE,
  YLE_NEXT_XS_BOLD_AC_FONT_STYLE_OLD: YLE_NEXT_XS_BOLD_AC_FONT_STYLE_OLD,
  YLE_NEXT_XS_BOLD_AC_FONT_WEIGHT: YLE_NEXT_XS_BOLD_AC_FONT_WEIGHT,
  YLE_NEXT_XS_BOLD_AC_LETTER_SPACING: YLE_NEXT_XS_BOLD_AC_LETTER_SPACING,
  YLE_NEXT_XS_BOLD_AC_LINE_HEIGHT: YLE_NEXT_XS_BOLD_AC_LINE_HEIGHT,
  YLE_NEXT_XS_BOLD_AC_PARAGRAPH_INDENT: YLE_NEXT_XS_BOLD_AC_PARAGRAPH_INDENT,
  YLE_NEXT_XS_BOLD_AC_PARAGRAPH_SPACING: YLE_NEXT_XS_BOLD_AC_PARAGRAPH_SPACING,
  YLE_NEXT_XS_BOLD_AC_TEXT_CASE: YLE_NEXT_XS_BOLD_AC_TEXT_CASE,
  YLE_NEXT_XS_BOLD_AC_TEXT_DECORATION: YLE_NEXT_XS_BOLD_AC_TEXT_DECORATION,
  YLE_NEXT_XS_BOLD_FONT_FAMILY: YLE_NEXT_XS_BOLD_FONT_FAMILY,
  YLE_NEXT_XS_BOLD_FONT_SIZE: YLE_NEXT_XS_BOLD_FONT_SIZE,
  YLE_NEXT_XS_BOLD_FONT_STRETCH: YLE_NEXT_XS_BOLD_FONT_STRETCH,
  YLE_NEXT_XS_BOLD_FONT_STYLE: YLE_NEXT_XS_BOLD_FONT_STYLE,
  YLE_NEXT_XS_BOLD_FONT_STYLE_OLD: YLE_NEXT_XS_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_XS_BOLD_FONT_WEIGHT: YLE_NEXT_XS_BOLD_FONT_WEIGHT,
  YLE_NEXT_XS_BOLD_LETTER_SPACING: YLE_NEXT_XS_BOLD_LETTER_SPACING,
  YLE_NEXT_XS_BOLD_LINE_HEIGHT: YLE_NEXT_XS_BOLD_LINE_HEIGHT,
  YLE_NEXT_XS_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XS_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_XS_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XS_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_XS_BOLD_TEXT_CASE: YLE_NEXT_XS_BOLD_TEXT_CASE,
  YLE_NEXT_XS_BOLD_TEXT_DECORATION: YLE_NEXT_XS_BOLD_TEXT_DECORATION,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_FAMILY: YLE_NEXT_XS_CONDENSED_BOLD_FONT_FAMILY,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_SIZE: YLE_NEXT_XS_CONDENSED_BOLD_FONT_SIZE,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_STRETCH: YLE_NEXT_XS_CONDENSED_BOLD_FONT_STRETCH,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE: YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE_OLD: YLE_NEXT_XS_CONDENSED_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_XS_CONDENSED_BOLD_FONT_WEIGHT: YLE_NEXT_XS_CONDENSED_BOLD_FONT_WEIGHT,
  YLE_NEXT_XS_CONDENSED_BOLD_LETTER_SPACING: YLE_NEXT_XS_CONDENSED_BOLD_LETTER_SPACING,
  YLE_NEXT_XS_CONDENSED_BOLD_LINE_HEIGHT: YLE_NEXT_XS_CONDENSED_BOLD_LINE_HEIGHT,
  YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XS_CONDENSED_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_XS_CONDENSED_BOLD_TEXT_CASE: YLE_NEXT_XS_CONDENSED_BOLD_TEXT_CASE,
  YLE_NEXT_XS_CONDENSED_BOLD_TEXT_DECORATION: YLE_NEXT_XS_CONDENSED_BOLD_TEXT_DECORATION,
  YLE_NEXT_XS_FONT_FAMILY: YLE_NEXT_XS_FONT_FAMILY,
  YLE_NEXT_XS_FONT_SIZE: YLE_NEXT_XS_FONT_SIZE,
  YLE_NEXT_XS_FONT_STRETCH: YLE_NEXT_XS_FONT_STRETCH,
  YLE_NEXT_XS_FONT_STYLE: YLE_NEXT_XS_FONT_STYLE,
  YLE_NEXT_XS_FONT_STYLE_OLD: YLE_NEXT_XS_FONT_STYLE_OLD,
  YLE_NEXT_XS_FONT_WEIGHT: YLE_NEXT_XS_FONT_WEIGHT,
  YLE_NEXT_XS_ITALIC_FONT_FAMILY: YLE_NEXT_XS_ITALIC_FONT_FAMILY,
  YLE_NEXT_XS_ITALIC_FONT_SIZE: YLE_NEXT_XS_ITALIC_FONT_SIZE,
  YLE_NEXT_XS_ITALIC_FONT_STRETCH: YLE_NEXT_XS_ITALIC_FONT_STRETCH,
  YLE_NEXT_XS_ITALIC_FONT_STYLE: YLE_NEXT_XS_ITALIC_FONT_STYLE,
  YLE_NEXT_XS_ITALIC_FONT_STYLE_OLD: YLE_NEXT_XS_ITALIC_FONT_STYLE_OLD,
  YLE_NEXT_XS_ITALIC_FONT_WEIGHT: YLE_NEXT_XS_ITALIC_FONT_WEIGHT,
  YLE_NEXT_XS_ITALIC_LETTER_SPACING: YLE_NEXT_XS_ITALIC_LETTER_SPACING,
  YLE_NEXT_XS_ITALIC_LINE_HEIGHT: YLE_NEXT_XS_ITALIC_LINE_HEIGHT,
  YLE_NEXT_XS_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_XS_ITALIC_PARAGRAPH_INDENT,
  YLE_NEXT_XS_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_XS_ITALIC_PARAGRAPH_SPACING,
  YLE_NEXT_XS_ITALIC_TEXT_CASE: YLE_NEXT_XS_ITALIC_TEXT_CASE,
  YLE_NEXT_XS_ITALIC_TEXT_DECORATION: YLE_NEXT_XS_ITALIC_TEXT_DECORATION,
  YLE_NEXT_XS_LETTER_SPACING: YLE_NEXT_XS_LETTER_SPACING,
  YLE_NEXT_XS_LINE_HEIGHT: YLE_NEXT_XS_LINE_HEIGHT,
  YLE_NEXT_XS_PARAGRAPH_INDENT: YLE_NEXT_XS_PARAGRAPH_INDENT,
  YLE_NEXT_XS_PARAGRAPH_SPACING: YLE_NEXT_XS_PARAGRAPH_SPACING,
  YLE_NEXT_XS_TEXT_CASE: YLE_NEXT_XS_TEXT_CASE,
  YLE_NEXT_XS_TEXT_DECORATION: YLE_NEXT_XS_TEXT_DECORATION
});

/**
 * Yle Design System
 * v2.x.x
 */

const FONT_SIZE_7XL$2 = '3.5rem';
const FONT_SIZE_6XL$2 = '3rem';
const FONT_SIZE_5XL$2 = '2.5rem';
const FONT_SIZE_4XL$2 = '2rem';
const FONT_SIZE_3XL$2 = '1.75rem';
const FONT_SIZE_2XL$2 = '1.5rem';
const FONT_SIZE_XL$2 = '1.25rem';
const FONT_SIZE_LG$2 = '1.125rem';
const FONT_SIZE_MD$2 = '1rem';
const FONT_SIZE_SM$2 = '0.875rem';
const FONT_SIZE_XS$2 = '0.75rem';
const FONT_WEIGHT_HEAVY$2 = 900; // New
const FONT_WEIGHT_BOLD$2 = 700;
const FONT_WEIGHT_MEDIUM$2 = 500; // New
const FONT_WEIGHT_NORMAL$2 = 400;
const FONT_WEIGHT_LIGHT$2 = 300; // New
const LINE_HEIGHT_125$2 = '1.25';
const LINE_HEIGHT_135$2 = '1.35';
const LINE_HEIGHT_145$2 = '1.45';
const LINE_HEIGHT_150$2 = '1.50';
const FONT_FAMILY_DEFAULT$2 = 'Yle Next'; // New
const FONT_FAMILY_YLE_NEXT$2 = 'Yle Next'; // New
const TEXT_DECORATION_DEFAULT$2 = 'none';
const FONT_STYLE_DEFAULT$2 = 'normal';
const FONT_STYLE_ITALIC$2 = 'italic';
const TEXT_CASE_DEFAULT$2 = 'normal';
const TEXT_CASE_UPPERCASE$2 = 'uppercase';
const LETTER_SPACING_MD$2 = 0;
const LETTER_SPACING_LG$2 = '0.01em';
const FONT_STRETCH_DEFAULT$2 = 'normal';
const FONT_STRETCH_CONDENSED$2 = 'condensed';

var typographyTokens = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FONT_FAMILY_DEFAULT: FONT_FAMILY_DEFAULT$2,
  FONT_FAMILY_YLE_NEXT: FONT_FAMILY_YLE_NEXT$2,
  FONT_SIZE_2XL: FONT_SIZE_2XL$2,
  FONT_SIZE_3XL: FONT_SIZE_3XL$2,
  FONT_SIZE_4XL: FONT_SIZE_4XL$2,
  FONT_SIZE_5XL: FONT_SIZE_5XL$2,
  FONT_SIZE_6XL: FONT_SIZE_6XL$2,
  FONT_SIZE_7XL: FONT_SIZE_7XL$2,
  FONT_SIZE_LG: FONT_SIZE_LG$2,
  FONT_SIZE_MD: FONT_SIZE_MD$2,
  FONT_SIZE_SM: FONT_SIZE_SM$2,
  FONT_SIZE_XL: FONT_SIZE_XL$2,
  FONT_SIZE_XS: FONT_SIZE_XS$2,
  FONT_STRETCH_CONDENSED: FONT_STRETCH_CONDENSED$2,
  FONT_STRETCH_DEFAULT: FONT_STRETCH_DEFAULT$2,
  FONT_STYLE_DEFAULT: FONT_STYLE_DEFAULT$2,
  FONT_STYLE_ITALIC: FONT_STYLE_ITALIC$2,
  FONT_WEIGHT_BOLD: FONT_WEIGHT_BOLD$2,
  FONT_WEIGHT_HEAVY: FONT_WEIGHT_HEAVY$2,
  FONT_WEIGHT_LIGHT: FONT_WEIGHT_LIGHT$2,
  FONT_WEIGHT_MEDIUM: FONT_WEIGHT_MEDIUM$2,
  FONT_WEIGHT_NORMAL: FONT_WEIGHT_NORMAL$2,
  LETTER_SPACING_LG: LETTER_SPACING_LG$2,
  LETTER_SPACING_MD: LETTER_SPACING_MD$2,
  LINE_HEIGHT_125: LINE_HEIGHT_125$2,
  LINE_HEIGHT_135: LINE_HEIGHT_135$2,
  LINE_HEIGHT_145: LINE_HEIGHT_145$2,
  LINE_HEIGHT_150: LINE_HEIGHT_150$2,
  TEXT_CASE_DEFAULT: TEXT_CASE_DEFAULT$2,
  TEXT_CASE_UPPERCASE: TEXT_CASE_UPPERCASE$2,
  TEXT_DECORATION_DEFAULT: TEXT_DECORATION_DEFAULT$2
});

/**
 * Yle Design System
 * v2.x.x
 */

const FONT_SIZE_7XL$1 = '56px';
const FONT_SIZE_6XL$1 = '48px';
const FONT_SIZE_5XL$1 = '40px';
const FONT_SIZE_4XL$1 = '32px';
const FONT_SIZE_3XL$1 = '28px';
const FONT_SIZE_2XL$1 = '24px';
const FONT_SIZE_XL$1 = '20px';
const FONT_SIZE_LG$1 = '18px';
const FONT_SIZE_MD$1 = '16px';
const FONT_SIZE_SM$1 = '14px';
const FONT_SIZE_XS$1 = '12px';
const FONT_WEIGHT_HEAVY$1 = 900; // New
const FONT_WEIGHT_BOLD$1 = 700;
const FONT_WEIGHT_MEDIUM$1 = 500; // New
const FONT_WEIGHT_NORMAL$1 = 400;
const FONT_WEIGHT_LIGHT$1 = 300; // New
const LINE_HEIGHT_125$1 = '1.25';
const LINE_HEIGHT_135$1 = '1.35';
const LINE_HEIGHT_145$1 = '1.45';
const LINE_HEIGHT_150$1 = '1.50';
const FONT_FAMILY_DEFAULT$1 = 'Yle Next'; // New
const FONT_FAMILY_YLE_NEXT$1 = 'Yle Next'; // New
const TEXT_DECORATION_DEFAULT$1 = 'none';
const FONT_STYLE_DEFAULT$1 = 'normal';
const FONT_STYLE_ITALIC$1 = 'italic';
const TEXT_CASE_DEFAULT$1 = 'normal';
const TEXT_CASE_UPPERCASE$1 = 'uppercase';
const LETTER_SPACING_MD$1 = 0;
const LETTER_SPACING_LG$1 = '0.01em';
const FONT_STRETCH_DEFAULT$1 = 'normal';
const FONT_STRETCH_CONDENSED$1 = 'condensed';

var typographyTokensPx = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FONT_FAMILY_DEFAULT: FONT_FAMILY_DEFAULT$1,
  FONT_FAMILY_YLE_NEXT: FONT_FAMILY_YLE_NEXT$1,
  FONT_SIZE_2XL: FONT_SIZE_2XL$1,
  FONT_SIZE_3XL: FONT_SIZE_3XL$1,
  FONT_SIZE_4XL: FONT_SIZE_4XL$1,
  FONT_SIZE_5XL: FONT_SIZE_5XL$1,
  FONT_SIZE_6XL: FONT_SIZE_6XL$1,
  FONT_SIZE_7XL: FONT_SIZE_7XL$1,
  FONT_SIZE_LG: FONT_SIZE_LG$1,
  FONT_SIZE_MD: FONT_SIZE_MD$1,
  FONT_SIZE_SM: FONT_SIZE_SM$1,
  FONT_SIZE_XL: FONT_SIZE_XL$1,
  FONT_SIZE_XS: FONT_SIZE_XS$1,
  FONT_STRETCH_CONDENSED: FONT_STRETCH_CONDENSED$1,
  FONT_STRETCH_DEFAULT: FONT_STRETCH_DEFAULT$1,
  FONT_STYLE_DEFAULT: FONT_STYLE_DEFAULT$1,
  FONT_STYLE_ITALIC: FONT_STYLE_ITALIC$1,
  FONT_WEIGHT_BOLD: FONT_WEIGHT_BOLD$1,
  FONT_WEIGHT_HEAVY: FONT_WEIGHT_HEAVY$1,
  FONT_WEIGHT_LIGHT: FONT_WEIGHT_LIGHT$1,
  FONT_WEIGHT_MEDIUM: FONT_WEIGHT_MEDIUM$1,
  FONT_WEIGHT_NORMAL: FONT_WEIGHT_NORMAL$1,
  LETTER_SPACING_LG: LETTER_SPACING_LG$1,
  LETTER_SPACING_MD: LETTER_SPACING_MD$1,
  LINE_HEIGHT_125: LINE_HEIGHT_125$1,
  LINE_HEIGHT_135: LINE_HEIGHT_135$1,
  LINE_HEIGHT_145: LINE_HEIGHT_145$1,
  LINE_HEIGHT_150: LINE_HEIGHT_150$1,
  TEXT_CASE_DEFAULT: TEXT_CASE_DEFAULT$1,
  TEXT_CASE_UPPERCASE: TEXT_CASE_UPPERCASE$1,
  TEXT_DECORATION_DEFAULT: TEXT_DECORATION_DEFAULT$1
});

/**
 * Yle Design System
 * v2.x.x
 */

const FONT_SIZE_7XL = '3.5rem';
const FONT_SIZE_6XL = '3rem';
const FONT_SIZE_5XL = '2.5rem';
const FONT_SIZE_4XL = '2rem';
const FONT_SIZE_3XL = '1.75rem';
const FONT_SIZE_2XL = '1.5rem';
const FONT_SIZE_XL = '1.25rem';
const FONT_SIZE_LG = '1.125rem';
const FONT_SIZE_MD = '1rem';
const FONT_SIZE_SM = '0.875rem';
const FONT_SIZE_XS = '0.75rem';
const FONT_WEIGHT_HEAVY = 900; // New
const FONT_WEIGHT_BOLD = 700;
const FONT_WEIGHT_MEDIUM = 500; // New
const FONT_WEIGHT_NORMAL = 400;
const FONT_WEIGHT_LIGHT = 300; // New
const LINE_HEIGHT_125 = '1.25';
const LINE_HEIGHT_135 = '1.35';
const LINE_HEIGHT_145 = '1.45';
const LINE_HEIGHT_150 = '1.50';
const FONT_FAMILY_DEFAULT = 'Yle Next'; // New
const FONT_FAMILY_YLE_NEXT = 'Yle Next'; // New
const TEXT_DECORATION_DEFAULT = 'none';
const FONT_STYLE_DEFAULT = 'normal';
const FONT_STYLE_ITALIC = 'italic';
const TEXT_CASE_DEFAULT = 'normal';
const TEXT_CASE_UPPERCASE = 'uppercase';
const LETTER_SPACING_MD = 0;
const LETTER_SPACING_LG = '0.01em';
const FONT_STRETCH_DEFAULT = 'normal';
const FONT_STRETCH_CONDENSED = 'condensed';

var typographyTokensRem = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FONT_FAMILY_DEFAULT: FONT_FAMILY_DEFAULT,
  FONT_FAMILY_YLE_NEXT: FONT_FAMILY_YLE_NEXT,
  FONT_SIZE_2XL: FONT_SIZE_2XL,
  FONT_SIZE_3XL: FONT_SIZE_3XL,
  FONT_SIZE_4XL: FONT_SIZE_4XL,
  FONT_SIZE_5XL: FONT_SIZE_5XL,
  FONT_SIZE_6XL: FONT_SIZE_6XL,
  FONT_SIZE_7XL: FONT_SIZE_7XL,
  FONT_SIZE_LG: FONT_SIZE_LG,
  FONT_SIZE_MD: FONT_SIZE_MD,
  FONT_SIZE_SM: FONT_SIZE_SM,
  FONT_SIZE_XL: FONT_SIZE_XL,
  FONT_SIZE_XS: FONT_SIZE_XS,
  FONT_STRETCH_CONDENSED: FONT_STRETCH_CONDENSED,
  FONT_STRETCH_DEFAULT: FONT_STRETCH_DEFAULT,
  FONT_STYLE_DEFAULT: FONT_STYLE_DEFAULT,
  FONT_STYLE_ITALIC: FONT_STYLE_ITALIC,
  FONT_WEIGHT_BOLD: FONT_WEIGHT_BOLD,
  FONT_WEIGHT_HEAVY: FONT_WEIGHT_HEAVY,
  FONT_WEIGHT_LIGHT: FONT_WEIGHT_LIGHT,
  FONT_WEIGHT_MEDIUM: FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_NORMAL: FONT_WEIGHT_NORMAL,
  LETTER_SPACING_LG: LETTER_SPACING_LG,
  LETTER_SPACING_MD: LETTER_SPACING_MD,
  LINE_HEIGHT_125: LINE_HEIGHT_125,
  LINE_HEIGHT_135: LINE_HEIGHT_135,
  LINE_HEIGHT_145: LINE_HEIGHT_145,
  LINE_HEIGHT_150: LINE_HEIGHT_150,
  TEXT_CASE_DEFAULT: TEXT_CASE_DEFAULT,
  TEXT_CASE_UPPERCASE: TEXT_CASE_UPPERCASE,
  TEXT_DECORATION_DEFAULT: TEXT_DECORATION_DEFAULT
});

/**
 * Yle Design System
 * v2.x.x
 */

const TV_YLE_1 = '#3311aa';
const TV_YLE_2 = '#cb0fd0';
const TV_YLE_TEEMA = '#fe8300';
const TV_YLE_FEM = '#a3bd2f';
const TV_LASTENAREENA = '#feb500';
const RADIO_YLE_1 = '#dc006a';
const RADIO_YLE_X = '#fd2b77';
const RADIO_YLE_SUOMI = '#0000e6';
const RADIO_YLE_PUHE = '#ffff0b';
const RADIO_YLE_SAMI = '#0049bf';
const RADIO_YLE_KLASSINEN = '#0f7b87';
const RADIO_YLE_VEGA = '#169bd4';
const RADIO_YLE_X3M = '#ff4c20';
const RADIO_YLE_SUOMI_2 = '#00b9eb';

var colorsChannel = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RADIO_YLE_1: RADIO_YLE_1,
  RADIO_YLE_KLASSINEN: RADIO_YLE_KLASSINEN,
  RADIO_YLE_PUHE: RADIO_YLE_PUHE,
  RADIO_YLE_SAMI: RADIO_YLE_SAMI,
  RADIO_YLE_SUOMI: RADIO_YLE_SUOMI,
  RADIO_YLE_SUOMI_2: RADIO_YLE_SUOMI_2,
  RADIO_YLE_VEGA: RADIO_YLE_VEGA,
  RADIO_YLE_X: RADIO_YLE_X,
  RADIO_YLE_X3M: RADIO_YLE_X3M,
  TV_LASTENAREENA: TV_LASTENAREENA,
  TV_YLE_1: TV_YLE_1,
  TV_YLE_2: TV_YLE_2,
  TV_YLE_FEM: TV_YLE_FEM,
  TV_YLE_TEEMA: TV_YLE_TEEMA
});

/**
 * Yle Design System
 * v2.x.x
 */

const WEATHER_ICON_CLOUD_LIGHT$2 =
  'var(--yds-infographic-weather-icon-cloud-light, rgba(0, 0, 0, 0.15))'; // black-opacity-30
const WEATHER_ICON_CLOUD_MID$2 =
  'var(--yds-infographic-weather-icon-cloud-mid, rgba(0, 0, 0, 0.47))'; // black-opacity-50
const WEATHER_ICON_CLOUD_DARK$2 =
  'var(--yds-infographic-weather-icon-cloud-dark, rgba(0, 0, 0, 0.7))'; // black-opacity-60
const WEATHER_ICON_MOON$2 = 'var(--yds-infographic-weather-icon-moon, #95c6ff)'; // info-blue-20
const WEATHER_ICON_DROPLET$2 = 'var(--yds-infographic-weather-icon-droplet, #2684ff)'; // info-blue-50
const WEATHER_ICON_SUN$2 = 'var(--yds-infographic-weather-icon-sun, #ffc400)'; // info-yellow-50
const TEXT_DEFAULT$5 = 'var(--yds-infographic-text-default, #131415)'; // default-text
const BACKGROUND$5 = 'var(--yds-infographic-background, #ffffff)'; // background
const TOOLTIP_BACKGROUND$2 = 'var(--yds-infographic-tooltip-background, #131415)'; // negative-background
const GRIDLINE$2 = 'var(--yds-infographic-gridline, #b4b6b7)'; // gray-40
const TEXT_NEGATIVE$5 = 'var(--yds-infographic-text-negative, #f8f9fa)'; // negative-text
const TEXT_SECONDARY$2 = 'var(--yds-infographic-text-secondary, #4a4f54)'; // gray-60
const TEXT_DARK$5 = 'var(--yds-infographic-text-dark, #131415)'; // dark-text
const TEXT_LIGHT$2 = 'var(--yds-infographic-text-light, #f8f9fa)'; // light-text
const TEXT_PLUS$2 = 'var(--yds-infographic-text-plus, #00809c)'; // turquoise-70
const TEXT_MINUS$2 = 'var(--yds-infographic-text-minus, #b83c35)'; // news-orange-70
const NEWS_DEFAULT_1$2 = 'var(--yds-infographic-news-default-1, #7c59fa)'; // news-violet-40
const NEWS_DEFAULT_2$2 = 'var(--yds-infographic-news-default-2, #009cb5)'; // turquoise-60
const NEWS_DEFAULT_3$2 = 'var(--yds-infographic-news-default-3, #0b54b4)'; // info-blue-90
const NEWS_DEFAULT_4$2 = 'var(--yds-infographic-news-default-4, #f56a1b)'; // info-orange-60
const NEWS_DEFAULT_5$2 = 'var(--yds-infographic-news-default-5, #80259f)'; // info-purple-60
const NEWS_DEFAULT_6$2 = 'var(--yds-infographic-news-default-6, #2f2372)'; // news-violet-80
const NEWS_MONOCHROME_1$2 = 'var(--yds-infographic-news-monochrome-1, #1e1753)'; // news-violet-90
const NEWS_MONOCHROME_2$2 = 'var(--yds-infographic-news-monochrome-2, #413091)'; // news-violet-70
const NEWS_MONOCHROME_3$2 = 'var(--yds-infographic-news-monochrome-3, #694bd7)'; // news-violet-50
const NEWS_MONOCHROME_4$2 = 'var(--yds-infographic-news-monochrome-4, #9479fb)'; // news-violet-30
const NEWS_MONOCHROME_5$2 = 'var(--yds-infographic-news-monochrome-5, #b7a8fa)'; // news-violet-20
const NEWS_MONOCHROME_6$2 = 'var(--yds-infographic-news-monochrome-6, #d3cbfb)'; // news-violet-10
const SPORTS_DEFAULT_1$2 = 'var(--yds-infographic-sports-default-1, #5541ed)'; // sports-violet-50
const SPORTS_DEFAULT_2$2 = 'var(--yds-infographic-sports-default-2, #ea3e85)'; // sports-pink-40
const SPORTS_DEFAULT_3$2 = 'var(--yds-infographic-sports-default-3, #618515)'; // sports-lime-80
const SPORTS_DEFAULT_4$2 = 'var(--yds-infographic-sports-default-4, #8578f2)'; // sports-violet-30
const SPORTS_DEFAULT_5$2 = 'var(--yds-infographic-sports-default-5, #f273a8)'; // sports-pink-30
const SPORTS_DEFAULT_6$2 = 'var(--yds-infographic-sports-default-6, #2c4d01)'; // sports-lime-95
const SPORTS_MONOCHROME_1$2 = 'var(--yds-infographic-sports-monochrome-1, #1a1476)'; // sports-violet-80
const SPORTS_MONOCHROME_2$2 = 'var(--yds-infographic-sports-monochrome-2, #372bb1)'; // sports-violet-60
const SPORTS_MONOCHROME_3$2 = 'var(--yds-infographic-sports-monochrome-3, #5541ed)'; // sports-violet-50
const SPORTS_MONOCHROME_4$2 = 'var(--yds-infographic-sports-monochrome-4, #8578f2)'; // sports-violet-30
const SPORTS_MONOCHROME_5$2 = 'var(--yds-infographic-sports-monochrome-5, #b3abf7)'; // sports-violet-20
const SPORTS_MONOCHROME_6$2 = 'var(--yds-infographic-sports-monochrome-6, #ddd9fc)'; // sports-violet-10
const ACCENT_NEWS$2 = 'var(--yds-infographic-accent-news, #f26659)'; // news-orange-50
const POLITICAL_PARTY_FI_KOK_PRIMARY$2 =
  'var(--yds-infographic-political-party-fi-kok-primary, #0357a5)';
const POLITICAL_PARTY_FI_KOK_SECONDARY$2 =
  'var(--yds-infographic-political-party-fi-kok-secondary, #8eb4d7)';
const POLITICAL_PARTY_FI_PS_PRIMARY$2 =
  'var(--yds-infographic-political-party-fi-ps-primary, #159af0)';
const POLITICAL_PARTY_FI_PS_SECONDARY$2 =
  'var(--yds-infographic-political-party-fi-ps-secondary, #96d2f8)';
const POLITICAL_PARTY_FI_SDP_PRIMARY$2 =
  'var(--yds-infographic-political-party-fi-sdp-primary, #e01515)';
const POLITICAL_PARTY_FI_SDP_SECONDARY$2 =
  'var(--yds-infographic-political-party-fi-sdp-secondary, #ef9897)';
const POLITICAL_PARTY_FI_VIHR_PRIMARY$2 =
  'var(--yds-infographic-political-party-fi-vihr-primary, #769f20)';
const POLITICAL_PARTY_FI_VIHR_SECONDARY$2 =
  'var(--yds-infographic-political-party-fi-vihr-secondary, #bccf95)';
const POLITICAL_PARTY_FI_KESK_PRIMARY$2 =
  'var(--yds-infographic-political-party-fi-kesk-primary, #096900)';
const POLITICAL_PARTY_FI_KESK_SECONDARY$2 =
  'var(--yds-infographic-political-party-fi-kesk-secondary, #90bc8c)';
const POLITICAL_PARTY_FI_VAS_PRIMARY$2 =
  'var(--yds-infographic-political-party-fi-vas-primary, #bb1054)';
const POLITICAL_PARTY_FI_VAS_SECONDARY$2 =
  'var(--yds-infographic-political-party-fi-vas-secondary, #e094b2)';
const POLITICAL_PARTY_FI_RKP_PRIMARY$2 =
  'var(--yds-infographic-political-party-fi-rkp-primary, #c97b2d)';
const POLITICAL_PARTY_FI_RKP_SECONDARY$2 =
  'var(--yds-infographic-political-party-fi-rkp-secondary, #deb186)';
const POLITICAL_PARTY_FI_KD_PRIMARY$2 =
  'var(--yds-infographic-political-party-fi-kd-primary, #923de8)';
const POLITICAL_PARTY_FI_KD_SECONDARY$2 =
  'var(--yds-infographic-political-party-fi-kd-secondary, #cea8f5)';
const POLITICAL_PARTY_FI_LIIK_PRIMARY$2 =
  'var(--yds-infographic-political-party-fi-liik-primary, #c262b8)';
const POLITICAL_PARTY_FI_LIIK_SECONDARY$2 =
  'var(--yds-infographic-political-party-fi-liik-secondary, #e4b8df)';
const POLITICAL_PARTY_FI_OTHERS_PRIMARY$2 =
  'var(--yds-infographic-political-party-fi-others-primary, #8d8e8f)';
const POLITICAL_PARTY_FI_OTHERS_SECONDARY$2 =
  'var(--yds-infographic-political-party-fi-others-secondary, #cccccd)';
const SCALE_STRONGLY_AGREE$2 = 'var(--yds-infographic-scale-strongly-agree, #009cb5)'; // turquoise-60
const SCALE_AGREE$2 = 'var(--yds-infographic-scale-agree, #5ddbe9)'; // turquoise-30
const SCALE_NEUTRAL$2 = 'var(--yds-infographic-scale-neutral, #b4b6b7)'; // gray-40
const SCALE_DISAGREE$2 = 'var(--yds-infographic-scale-disagree, #f79c94)'; // news-orange-30
const SCALE_STRONGLY_DISAGREE$2 = 'var(--yds-infographic-scale-strongly-disagree, #f26659)'; // news-orange-50
const SURVEY_YES$2 = 'var(--yds-infographic-survey-yes, #009cb5)'; // turquoise-60
const SURVEY_NO$2 = 'var(--yds-infographic-survey-no, #f26659)'; // news-orange-50
const SURVEY_EMPTY$2 = 'var(--yds-infographic-survey-empty, #d8d9db)'; // gray-30
const SURVEY_NEUTRAL$2 = 'var(--yds-infographic-survey-neutral, #878a8b)'; // gray-50

var infographicDefault = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACCENT_NEWS: ACCENT_NEWS$2,
  BACKGROUND: BACKGROUND$5,
  GRIDLINE: GRIDLINE$2,
  NEWS_DEFAULT_1: NEWS_DEFAULT_1$2,
  NEWS_DEFAULT_2: NEWS_DEFAULT_2$2,
  NEWS_DEFAULT_3: NEWS_DEFAULT_3$2,
  NEWS_DEFAULT_4: NEWS_DEFAULT_4$2,
  NEWS_DEFAULT_5: NEWS_DEFAULT_5$2,
  NEWS_DEFAULT_6: NEWS_DEFAULT_6$2,
  NEWS_MONOCHROME_1: NEWS_MONOCHROME_1$2,
  NEWS_MONOCHROME_2: NEWS_MONOCHROME_2$2,
  NEWS_MONOCHROME_3: NEWS_MONOCHROME_3$2,
  NEWS_MONOCHROME_4: NEWS_MONOCHROME_4$2,
  NEWS_MONOCHROME_5: NEWS_MONOCHROME_5$2,
  NEWS_MONOCHROME_6: NEWS_MONOCHROME_6$2,
  POLITICAL_PARTY_FI_KD_PRIMARY: POLITICAL_PARTY_FI_KD_PRIMARY$2,
  POLITICAL_PARTY_FI_KD_SECONDARY: POLITICAL_PARTY_FI_KD_SECONDARY$2,
  POLITICAL_PARTY_FI_KESK_PRIMARY: POLITICAL_PARTY_FI_KESK_PRIMARY$2,
  POLITICAL_PARTY_FI_KESK_SECONDARY: POLITICAL_PARTY_FI_KESK_SECONDARY$2,
  POLITICAL_PARTY_FI_KOK_PRIMARY: POLITICAL_PARTY_FI_KOK_PRIMARY$2,
  POLITICAL_PARTY_FI_KOK_SECONDARY: POLITICAL_PARTY_FI_KOK_SECONDARY$2,
  POLITICAL_PARTY_FI_LIIK_PRIMARY: POLITICAL_PARTY_FI_LIIK_PRIMARY$2,
  POLITICAL_PARTY_FI_LIIK_SECONDARY: POLITICAL_PARTY_FI_LIIK_SECONDARY$2,
  POLITICAL_PARTY_FI_OTHERS_PRIMARY: POLITICAL_PARTY_FI_OTHERS_PRIMARY$2,
  POLITICAL_PARTY_FI_OTHERS_SECONDARY: POLITICAL_PARTY_FI_OTHERS_SECONDARY$2,
  POLITICAL_PARTY_FI_PS_PRIMARY: POLITICAL_PARTY_FI_PS_PRIMARY$2,
  POLITICAL_PARTY_FI_PS_SECONDARY: POLITICAL_PARTY_FI_PS_SECONDARY$2,
  POLITICAL_PARTY_FI_RKP_PRIMARY: POLITICAL_PARTY_FI_RKP_PRIMARY$2,
  POLITICAL_PARTY_FI_RKP_SECONDARY: POLITICAL_PARTY_FI_RKP_SECONDARY$2,
  POLITICAL_PARTY_FI_SDP_PRIMARY: POLITICAL_PARTY_FI_SDP_PRIMARY$2,
  POLITICAL_PARTY_FI_SDP_SECONDARY: POLITICAL_PARTY_FI_SDP_SECONDARY$2,
  POLITICAL_PARTY_FI_VAS_PRIMARY: POLITICAL_PARTY_FI_VAS_PRIMARY$2,
  POLITICAL_PARTY_FI_VAS_SECONDARY: POLITICAL_PARTY_FI_VAS_SECONDARY$2,
  POLITICAL_PARTY_FI_VIHR_PRIMARY: POLITICAL_PARTY_FI_VIHR_PRIMARY$2,
  POLITICAL_PARTY_FI_VIHR_SECONDARY: POLITICAL_PARTY_FI_VIHR_SECONDARY$2,
  SCALE_AGREE: SCALE_AGREE$2,
  SCALE_DISAGREE: SCALE_DISAGREE$2,
  SCALE_NEUTRAL: SCALE_NEUTRAL$2,
  SCALE_STRONGLY_AGREE: SCALE_STRONGLY_AGREE$2,
  SCALE_STRONGLY_DISAGREE: SCALE_STRONGLY_DISAGREE$2,
  SPORTS_DEFAULT_1: SPORTS_DEFAULT_1$2,
  SPORTS_DEFAULT_2: SPORTS_DEFAULT_2$2,
  SPORTS_DEFAULT_3: SPORTS_DEFAULT_3$2,
  SPORTS_DEFAULT_4: SPORTS_DEFAULT_4$2,
  SPORTS_DEFAULT_5: SPORTS_DEFAULT_5$2,
  SPORTS_DEFAULT_6: SPORTS_DEFAULT_6$2,
  SPORTS_MONOCHROME_1: SPORTS_MONOCHROME_1$2,
  SPORTS_MONOCHROME_2: SPORTS_MONOCHROME_2$2,
  SPORTS_MONOCHROME_3: SPORTS_MONOCHROME_3$2,
  SPORTS_MONOCHROME_4: SPORTS_MONOCHROME_4$2,
  SPORTS_MONOCHROME_5: SPORTS_MONOCHROME_5$2,
  SPORTS_MONOCHROME_6: SPORTS_MONOCHROME_6$2,
  SURVEY_EMPTY: SURVEY_EMPTY$2,
  SURVEY_NEUTRAL: SURVEY_NEUTRAL$2,
  SURVEY_NO: SURVEY_NO$2,
  SURVEY_YES: SURVEY_YES$2,
  TEXT_DARK: TEXT_DARK$5,
  TEXT_DEFAULT: TEXT_DEFAULT$5,
  TEXT_LIGHT: TEXT_LIGHT$2,
  TEXT_MINUS: TEXT_MINUS$2,
  TEXT_NEGATIVE: TEXT_NEGATIVE$5,
  TEXT_PLUS: TEXT_PLUS$2,
  TEXT_SECONDARY: TEXT_SECONDARY$2,
  TOOLTIP_BACKGROUND: TOOLTIP_BACKGROUND$2,
  WEATHER_ICON_CLOUD_DARK: WEATHER_ICON_CLOUD_DARK$2,
  WEATHER_ICON_CLOUD_LIGHT: WEATHER_ICON_CLOUD_LIGHT$2,
  WEATHER_ICON_CLOUD_MID: WEATHER_ICON_CLOUD_MID$2,
  WEATHER_ICON_DROPLET: WEATHER_ICON_DROPLET$2,
  WEATHER_ICON_MOON: WEATHER_ICON_MOON$2,
  WEATHER_ICON_SUN: WEATHER_ICON_SUN$2
});

/**
 * Yle Design System
 * v2.x.x
 */

const WEATHER_ICON_CLOUD_LIGHT$1 = 'rgba(255, 255, 255, 0.85)'; // white-opacity-70
const WEATHER_ICON_CLOUD_MID$1 = 'rgba(255, 255, 255, 0.53)'; // white-opacity-50
const WEATHER_ICON_CLOUD_DARK$1 = 'rgba(255, 255, 255, 0.21)'; // white-opacity-30
const WEATHER_ICON_MOON$1 = '#95c6ff'; // info-blue-20
const WEATHER_ICON_DROPLET$1 = '#ffffff'; // white
const WEATHER_ICON_SUN$1 = '#ffc400'; // info-yellow-50
const TEXT_DEFAULT$4 = '#f8f9fa'; // default-text
const BACKGROUND$4 = '#131415'; // background
const TOOLTIP_BACKGROUND$1 = '#ffffff'; // negative-background
const GRIDLINE$1 = '#4a4f54'; // gray-60
const TEXT_NEGATIVE$4 = '#131415'; // negative-text
const TEXT_SECONDARY$1 = '#b4b6b7'; // gray-40
const TEXT_DARK$4 = '#131415'; // dark-text
const TEXT_LIGHT$1 = '#f8f9fa'; // light-text
const TEXT_PLUS$1 = '#29ccde'; // turquoise-40
const TEXT_MINUS$1 = '#f26659'; // news-orange-50
const NEWS_DEFAULT_1$1 = '#7c59fa'; // news-violet-40
const NEWS_DEFAULT_2$1 = '#29ccde'; // turquoise-40
const NEWS_DEFAULT_3$1 = '#ffe387'; // info-yellow-20
const NEWS_DEFAULT_4$1 = '#ff8f33'; // info-orange-50
const NEWS_DEFAULT_5$1 = '#9436b5'; // info-purple-50
const NEWS_DEFAULT_6$1 = '#fff3e2'; // info-orange-5
const NEWS_MONOCHROME_1$1 = '#e6e5ff'; // news-violet-5
const NEWS_MONOCHROME_2$1 = '#d3cbfb'; // news-violet-10
const NEWS_MONOCHROME_3$1 = '#b7a8fa'; // news-violet-20
const NEWS_MONOCHROME_4$1 = '#9479fb'; // news-violet-30
const NEWS_MONOCHROME_5$1 = '#694bd7'; // news-violet-50
const NEWS_MONOCHROME_6$1 = '#413091'; // news-violet-70
const SPORTS_DEFAULT_1$1 = '#5541ed'; // sports-violet-50
const SPORTS_DEFAULT_2$1 = '#ea3e85'; // sports-pink-40
const SPORTS_DEFAULT_3$1 = '#d4ff42'; // sports-lime-30
const SPORTS_DEFAULT_4$1 = '#8578f2'; // sports-violet-30
const SPORTS_DEFAULT_5$1 = '#f7abcb'; // sports-pink-20
const SPORTS_DEFAULT_6$1 = '#ebfe8d'; // sports-lime-20
const SPORTS_MONOCHROME_1$1 = '#eeeeff'; // sports-violet-5
const SPORTS_MONOCHROME_2$1 = '#ddd9fc'; // sports-violet-10
const SPORTS_MONOCHROME_3$1 = '#b3abf7'; // sports-violet-20
const SPORTS_MONOCHROME_4$1 = '#8578f2'; // sports-violet-30
const SPORTS_MONOCHROME_5$1 = '#5541ed'; // sports-violet-50
const SPORTS_MONOCHROME_6$1 = '#372bb1'; // sports-violet-60
const ACCENT_NEWS$1 = '#f26659'; // news-orange-50
const POLITICAL_PARTY_FI_KOK_PRIMARY$1 = '#096de3';
const POLITICAL_PARTY_FI_KOK_SECONDARY$1 = '#0d4e9b';
const POLITICAL_PARTY_FI_PS_PRIMARY$1 = '#6fb4fc';
const POLITICAL_PARTY_FI_PS_SECONDARY$1 = '#146498';
const POLITICAL_PARTY_FI_SDP_PRIMARY$1 = '#ff5a5a';
const POLITICAL_PARTY_FI_SDP_SECONDARY$1 = '#a13e3f';
const POLITICAL_PARTY_FI_VIHR_PRIMARY$1 = '#8fce29';
const POLITICAL_PARTY_FI_VIHR_SECONDARY$1 = '#5e8421';
const POLITICAL_PARTY_FI_KESK_PRIMARY$1 = '#099327';
const POLITICAL_PARTY_FI_KESK_SECONDARY$1 = '#0d6020';
const POLITICAL_PARTY_FI_VAS_PRIMARY$1 = '#e22a73';
const POLITICAL_PARTY_FI_VAS_SECONDARY$1 = '#8f214d';
const POLITICAL_PARTY_FI_RKP_PRIMARY$1 = '#ffdc5d';
const POLITICAL_PARTY_FI_RKP_SECONDARY$1 = '#a1914a';
const POLITICAL_PARTY_FI_KD_PRIMARY$1 = '#923de8';
const POLITICAL_PARTY_FI_KD_SECONDARY$1 = '#5f2c94';
const POLITICAL_PARTY_FI_LIIK_PRIMARY$1 = '#cf83c8';
const POLITICAL_PARTY_FI_LIIK_SECONDARY$1 = '#7a5177';
const POLITICAL_PARTY_FI_OTHERS_PRIMARY$1 = '#aeb0b1';
const POLITICAL_PARTY_FI_OTHERS_SECONDARY$1 = '#616263';
const SCALE_STRONGLY_AGREE$1 = '#29ccde'; // turquoise-40
const SCALE_AGREE$1 = '#9cebf4'; // turquoise-20
const SCALE_NEUTRAL$1 = '#e8e9eb'; // gray-20
const SCALE_DISAGREE$1 = '#f79c94'; // news-orange-30
const SCALE_STRONGLY_DISAGREE$1 = '#f26659'; // news-orange-50
const SURVEY_YES$1 = '#29ccde'; // turquoise-40
const SURVEY_NO$1 = '#f26659'; // news-orange-50
const SURVEY_EMPTY$1 = '#e8e9eb'; // gray-20
const SURVEY_NEUTRAL$1 = '#b4b6b7'; // gray-40

var infographicDark = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACCENT_NEWS: ACCENT_NEWS$1,
  BACKGROUND: BACKGROUND$4,
  GRIDLINE: GRIDLINE$1,
  NEWS_DEFAULT_1: NEWS_DEFAULT_1$1,
  NEWS_DEFAULT_2: NEWS_DEFAULT_2$1,
  NEWS_DEFAULT_3: NEWS_DEFAULT_3$1,
  NEWS_DEFAULT_4: NEWS_DEFAULT_4$1,
  NEWS_DEFAULT_5: NEWS_DEFAULT_5$1,
  NEWS_DEFAULT_6: NEWS_DEFAULT_6$1,
  NEWS_MONOCHROME_1: NEWS_MONOCHROME_1$1,
  NEWS_MONOCHROME_2: NEWS_MONOCHROME_2$1,
  NEWS_MONOCHROME_3: NEWS_MONOCHROME_3$1,
  NEWS_MONOCHROME_4: NEWS_MONOCHROME_4$1,
  NEWS_MONOCHROME_5: NEWS_MONOCHROME_5$1,
  NEWS_MONOCHROME_6: NEWS_MONOCHROME_6$1,
  POLITICAL_PARTY_FI_KD_PRIMARY: POLITICAL_PARTY_FI_KD_PRIMARY$1,
  POLITICAL_PARTY_FI_KD_SECONDARY: POLITICAL_PARTY_FI_KD_SECONDARY$1,
  POLITICAL_PARTY_FI_KESK_PRIMARY: POLITICAL_PARTY_FI_KESK_PRIMARY$1,
  POLITICAL_PARTY_FI_KESK_SECONDARY: POLITICAL_PARTY_FI_KESK_SECONDARY$1,
  POLITICAL_PARTY_FI_KOK_PRIMARY: POLITICAL_PARTY_FI_KOK_PRIMARY$1,
  POLITICAL_PARTY_FI_KOK_SECONDARY: POLITICAL_PARTY_FI_KOK_SECONDARY$1,
  POLITICAL_PARTY_FI_LIIK_PRIMARY: POLITICAL_PARTY_FI_LIIK_PRIMARY$1,
  POLITICAL_PARTY_FI_LIIK_SECONDARY: POLITICAL_PARTY_FI_LIIK_SECONDARY$1,
  POLITICAL_PARTY_FI_OTHERS_PRIMARY: POLITICAL_PARTY_FI_OTHERS_PRIMARY$1,
  POLITICAL_PARTY_FI_OTHERS_SECONDARY: POLITICAL_PARTY_FI_OTHERS_SECONDARY$1,
  POLITICAL_PARTY_FI_PS_PRIMARY: POLITICAL_PARTY_FI_PS_PRIMARY$1,
  POLITICAL_PARTY_FI_PS_SECONDARY: POLITICAL_PARTY_FI_PS_SECONDARY$1,
  POLITICAL_PARTY_FI_RKP_PRIMARY: POLITICAL_PARTY_FI_RKP_PRIMARY$1,
  POLITICAL_PARTY_FI_RKP_SECONDARY: POLITICAL_PARTY_FI_RKP_SECONDARY$1,
  POLITICAL_PARTY_FI_SDP_PRIMARY: POLITICAL_PARTY_FI_SDP_PRIMARY$1,
  POLITICAL_PARTY_FI_SDP_SECONDARY: POLITICAL_PARTY_FI_SDP_SECONDARY$1,
  POLITICAL_PARTY_FI_VAS_PRIMARY: POLITICAL_PARTY_FI_VAS_PRIMARY$1,
  POLITICAL_PARTY_FI_VAS_SECONDARY: POLITICAL_PARTY_FI_VAS_SECONDARY$1,
  POLITICAL_PARTY_FI_VIHR_PRIMARY: POLITICAL_PARTY_FI_VIHR_PRIMARY$1,
  POLITICAL_PARTY_FI_VIHR_SECONDARY: POLITICAL_PARTY_FI_VIHR_SECONDARY$1,
  SCALE_AGREE: SCALE_AGREE$1,
  SCALE_DISAGREE: SCALE_DISAGREE$1,
  SCALE_NEUTRAL: SCALE_NEUTRAL$1,
  SCALE_STRONGLY_AGREE: SCALE_STRONGLY_AGREE$1,
  SCALE_STRONGLY_DISAGREE: SCALE_STRONGLY_DISAGREE$1,
  SPORTS_DEFAULT_1: SPORTS_DEFAULT_1$1,
  SPORTS_DEFAULT_2: SPORTS_DEFAULT_2$1,
  SPORTS_DEFAULT_3: SPORTS_DEFAULT_3$1,
  SPORTS_DEFAULT_4: SPORTS_DEFAULT_4$1,
  SPORTS_DEFAULT_5: SPORTS_DEFAULT_5$1,
  SPORTS_DEFAULT_6: SPORTS_DEFAULT_6$1,
  SPORTS_MONOCHROME_1: SPORTS_MONOCHROME_1$1,
  SPORTS_MONOCHROME_2: SPORTS_MONOCHROME_2$1,
  SPORTS_MONOCHROME_3: SPORTS_MONOCHROME_3$1,
  SPORTS_MONOCHROME_4: SPORTS_MONOCHROME_4$1,
  SPORTS_MONOCHROME_5: SPORTS_MONOCHROME_5$1,
  SPORTS_MONOCHROME_6: SPORTS_MONOCHROME_6$1,
  SURVEY_EMPTY: SURVEY_EMPTY$1,
  SURVEY_NEUTRAL: SURVEY_NEUTRAL$1,
  SURVEY_NO: SURVEY_NO$1,
  SURVEY_YES: SURVEY_YES$1,
  TEXT_DARK: TEXT_DARK$4,
  TEXT_DEFAULT: TEXT_DEFAULT$4,
  TEXT_LIGHT: TEXT_LIGHT$1,
  TEXT_MINUS: TEXT_MINUS$1,
  TEXT_NEGATIVE: TEXT_NEGATIVE$4,
  TEXT_PLUS: TEXT_PLUS$1,
  TEXT_SECONDARY: TEXT_SECONDARY$1,
  TOOLTIP_BACKGROUND: TOOLTIP_BACKGROUND$1,
  WEATHER_ICON_CLOUD_DARK: WEATHER_ICON_CLOUD_DARK$1,
  WEATHER_ICON_CLOUD_LIGHT: WEATHER_ICON_CLOUD_LIGHT$1,
  WEATHER_ICON_CLOUD_MID: WEATHER_ICON_CLOUD_MID$1,
  WEATHER_ICON_DROPLET: WEATHER_ICON_DROPLET$1,
  WEATHER_ICON_MOON: WEATHER_ICON_MOON$1,
  WEATHER_ICON_SUN: WEATHER_ICON_SUN$1
});

/**
 * Yle Design System
 * v2.x.x
 */

const WEATHER_ICON_CLOUD_LIGHT = 'rgba(0, 0, 0, 0.15)'; // black-opacity-30
const WEATHER_ICON_CLOUD_MID = 'rgba(0, 0, 0, 0.47)'; // black-opacity-50
const WEATHER_ICON_CLOUD_DARK = 'rgba(0, 0, 0, 0.7)'; // black-opacity-60
const WEATHER_ICON_MOON = '#95c6ff'; // info-blue-20
const WEATHER_ICON_DROPLET = '#2684ff'; // info-blue-50
const WEATHER_ICON_SUN = '#ffc400'; // info-yellow-50
const TEXT_DEFAULT$3 = '#131415'; // default-text
const BACKGROUND$3 = '#ffffff'; // background
const TOOLTIP_BACKGROUND = '#131415'; // negative-background
const GRIDLINE = '#b4b6b7'; // gray-40
const TEXT_NEGATIVE$3 = '#f8f9fa'; // negative-text
const TEXT_SECONDARY = '#4a4f54'; // gray-60
const TEXT_DARK$3 = '#131415'; // dark-text
const TEXT_LIGHT = '#f8f9fa'; // light-text
const TEXT_PLUS = '#00809c'; // turquoise-70
const TEXT_MINUS = '#b83c35'; // news-orange-70
const NEWS_DEFAULT_1 = '#7c59fa'; // news-violet-40
const NEWS_DEFAULT_2 = '#009cb5'; // turquoise-60
const NEWS_DEFAULT_3 = '#0b54b4'; // info-blue-90
const NEWS_DEFAULT_4 = '#f56a1b'; // info-orange-60
const NEWS_DEFAULT_5 = '#80259f'; // info-purple-60
const NEWS_DEFAULT_6 = '#2f2372'; // news-violet-80
const NEWS_MONOCHROME_1 = '#1e1753'; // news-violet-90
const NEWS_MONOCHROME_2 = '#413091'; // news-violet-70
const NEWS_MONOCHROME_3 = '#694bd7'; // news-violet-50
const NEWS_MONOCHROME_4 = '#9479fb'; // news-violet-30
const NEWS_MONOCHROME_5 = '#b7a8fa'; // news-violet-20
const NEWS_MONOCHROME_6 = '#d3cbfb'; // news-violet-10
const SPORTS_DEFAULT_1 = '#5541ed'; // sports-violet-50
const SPORTS_DEFAULT_2 = '#ea3e85'; // sports-pink-40
const SPORTS_DEFAULT_3 = '#618515'; // sports-lime-80
const SPORTS_DEFAULT_4 = '#8578f2'; // sports-violet-30
const SPORTS_DEFAULT_5 = '#f273a8'; // sports-pink-30
const SPORTS_DEFAULT_6 = '#2c4d01'; // sports-lime-95
const SPORTS_MONOCHROME_1 = '#1a1476'; // sports-violet-80
const SPORTS_MONOCHROME_2 = '#372bb1'; // sports-violet-60
const SPORTS_MONOCHROME_3 = '#5541ed'; // sports-violet-50
const SPORTS_MONOCHROME_4 = '#8578f2'; // sports-violet-30
const SPORTS_MONOCHROME_5 = '#b3abf7'; // sports-violet-20
const SPORTS_MONOCHROME_6 = '#ddd9fc'; // sports-violet-10
const ACCENT_NEWS = '#f26659'; // news-orange-50
const POLITICAL_PARTY_FI_KOK_PRIMARY = '#0357a5';
const POLITICAL_PARTY_FI_KOK_SECONDARY = '#8eb4d7';
const POLITICAL_PARTY_FI_PS_PRIMARY = '#159af0';
const POLITICAL_PARTY_FI_PS_SECONDARY = '#96d2f8';
const POLITICAL_PARTY_FI_SDP_PRIMARY = '#e01515';
const POLITICAL_PARTY_FI_SDP_SECONDARY = '#ef9897';
const POLITICAL_PARTY_FI_VIHR_PRIMARY = '#769f20';
const POLITICAL_PARTY_FI_VIHR_SECONDARY = '#bccf95';
const POLITICAL_PARTY_FI_KESK_PRIMARY = '#096900';
const POLITICAL_PARTY_FI_KESK_SECONDARY = '#90bc8c';
const POLITICAL_PARTY_FI_VAS_PRIMARY = '#bb1054';
const POLITICAL_PARTY_FI_VAS_SECONDARY = '#e094b2';
const POLITICAL_PARTY_FI_RKP_PRIMARY = '#c97b2d';
const POLITICAL_PARTY_FI_RKP_SECONDARY = '#deb186';
const POLITICAL_PARTY_FI_KD_PRIMARY = '#923de8';
const POLITICAL_PARTY_FI_KD_SECONDARY = '#cea8f5';
const POLITICAL_PARTY_FI_LIIK_PRIMARY = '#c262b8';
const POLITICAL_PARTY_FI_LIIK_SECONDARY = '#e4b8df';
const POLITICAL_PARTY_FI_OTHERS_PRIMARY = '#8d8e8f';
const POLITICAL_PARTY_FI_OTHERS_SECONDARY = '#cccccd';
const SCALE_STRONGLY_AGREE = '#009cb5'; // turquoise-60
const SCALE_AGREE = '#5ddbe9'; // turquoise-30
const SCALE_NEUTRAL = '#b4b6b7'; // gray-40
const SCALE_DISAGREE = '#f79c94'; // news-orange-30
const SCALE_STRONGLY_DISAGREE = '#f26659'; // news-orange-50
const SURVEY_YES = '#009cb5'; // turquoise-60
const SURVEY_NO = '#f26659'; // news-orange-50
const SURVEY_EMPTY = '#d8d9db'; // gray-30
const SURVEY_NEUTRAL = '#878a8b'; // gray-50

var infographicLight = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACCENT_NEWS: ACCENT_NEWS,
  BACKGROUND: BACKGROUND$3,
  GRIDLINE: GRIDLINE,
  NEWS_DEFAULT_1: NEWS_DEFAULT_1,
  NEWS_DEFAULT_2: NEWS_DEFAULT_2,
  NEWS_DEFAULT_3: NEWS_DEFAULT_3,
  NEWS_DEFAULT_4: NEWS_DEFAULT_4,
  NEWS_DEFAULT_5: NEWS_DEFAULT_5,
  NEWS_DEFAULT_6: NEWS_DEFAULT_6,
  NEWS_MONOCHROME_1: NEWS_MONOCHROME_1,
  NEWS_MONOCHROME_2: NEWS_MONOCHROME_2,
  NEWS_MONOCHROME_3: NEWS_MONOCHROME_3,
  NEWS_MONOCHROME_4: NEWS_MONOCHROME_4,
  NEWS_MONOCHROME_5: NEWS_MONOCHROME_5,
  NEWS_MONOCHROME_6: NEWS_MONOCHROME_6,
  POLITICAL_PARTY_FI_KD_PRIMARY: POLITICAL_PARTY_FI_KD_PRIMARY,
  POLITICAL_PARTY_FI_KD_SECONDARY: POLITICAL_PARTY_FI_KD_SECONDARY,
  POLITICAL_PARTY_FI_KESK_PRIMARY: POLITICAL_PARTY_FI_KESK_PRIMARY,
  POLITICAL_PARTY_FI_KESK_SECONDARY: POLITICAL_PARTY_FI_KESK_SECONDARY,
  POLITICAL_PARTY_FI_KOK_PRIMARY: POLITICAL_PARTY_FI_KOK_PRIMARY,
  POLITICAL_PARTY_FI_KOK_SECONDARY: POLITICAL_PARTY_FI_KOK_SECONDARY,
  POLITICAL_PARTY_FI_LIIK_PRIMARY: POLITICAL_PARTY_FI_LIIK_PRIMARY,
  POLITICAL_PARTY_FI_LIIK_SECONDARY: POLITICAL_PARTY_FI_LIIK_SECONDARY,
  POLITICAL_PARTY_FI_OTHERS_PRIMARY: POLITICAL_PARTY_FI_OTHERS_PRIMARY,
  POLITICAL_PARTY_FI_OTHERS_SECONDARY: POLITICAL_PARTY_FI_OTHERS_SECONDARY,
  POLITICAL_PARTY_FI_PS_PRIMARY: POLITICAL_PARTY_FI_PS_PRIMARY,
  POLITICAL_PARTY_FI_PS_SECONDARY: POLITICAL_PARTY_FI_PS_SECONDARY,
  POLITICAL_PARTY_FI_RKP_PRIMARY: POLITICAL_PARTY_FI_RKP_PRIMARY,
  POLITICAL_PARTY_FI_RKP_SECONDARY: POLITICAL_PARTY_FI_RKP_SECONDARY,
  POLITICAL_PARTY_FI_SDP_PRIMARY: POLITICAL_PARTY_FI_SDP_PRIMARY,
  POLITICAL_PARTY_FI_SDP_SECONDARY: POLITICAL_PARTY_FI_SDP_SECONDARY,
  POLITICAL_PARTY_FI_VAS_PRIMARY: POLITICAL_PARTY_FI_VAS_PRIMARY,
  POLITICAL_PARTY_FI_VAS_SECONDARY: POLITICAL_PARTY_FI_VAS_SECONDARY,
  POLITICAL_PARTY_FI_VIHR_PRIMARY: POLITICAL_PARTY_FI_VIHR_PRIMARY,
  POLITICAL_PARTY_FI_VIHR_SECONDARY: POLITICAL_PARTY_FI_VIHR_SECONDARY,
  SCALE_AGREE: SCALE_AGREE,
  SCALE_DISAGREE: SCALE_DISAGREE,
  SCALE_NEUTRAL: SCALE_NEUTRAL,
  SCALE_STRONGLY_AGREE: SCALE_STRONGLY_AGREE,
  SCALE_STRONGLY_DISAGREE: SCALE_STRONGLY_DISAGREE,
  SPORTS_DEFAULT_1: SPORTS_DEFAULT_1,
  SPORTS_DEFAULT_2: SPORTS_DEFAULT_2,
  SPORTS_DEFAULT_3: SPORTS_DEFAULT_3,
  SPORTS_DEFAULT_4: SPORTS_DEFAULT_4,
  SPORTS_DEFAULT_5: SPORTS_DEFAULT_5,
  SPORTS_DEFAULT_6: SPORTS_DEFAULT_6,
  SPORTS_MONOCHROME_1: SPORTS_MONOCHROME_1,
  SPORTS_MONOCHROME_2: SPORTS_MONOCHROME_2,
  SPORTS_MONOCHROME_3: SPORTS_MONOCHROME_3,
  SPORTS_MONOCHROME_4: SPORTS_MONOCHROME_4,
  SPORTS_MONOCHROME_5: SPORTS_MONOCHROME_5,
  SPORTS_MONOCHROME_6: SPORTS_MONOCHROME_6,
  SURVEY_EMPTY: SURVEY_EMPTY,
  SURVEY_NEUTRAL: SURVEY_NEUTRAL,
  SURVEY_NO: SURVEY_NO,
  SURVEY_YES: SURVEY_YES,
  TEXT_DARK: TEXT_DARK$3,
  TEXT_DEFAULT: TEXT_DEFAULT$3,
  TEXT_LIGHT: TEXT_LIGHT,
  TEXT_MINUS: TEXT_MINUS,
  TEXT_NEGATIVE: TEXT_NEGATIVE$3,
  TEXT_PLUS: TEXT_PLUS,
  TEXT_SECONDARY: TEXT_SECONDARY,
  TOOLTIP_BACKGROUND: TOOLTIP_BACKGROUND,
  WEATHER_ICON_CLOUD_DARK: WEATHER_ICON_CLOUD_DARK,
  WEATHER_ICON_CLOUD_LIGHT: WEATHER_ICON_CLOUD_LIGHT,
  WEATHER_ICON_CLOUD_MID: WEATHER_ICON_CLOUD_MID,
  WEATHER_ICON_DROPLET: WEATHER_ICON_DROPLET,
  WEATHER_ICON_MOON: WEATHER_ICON_MOON,
  WEATHER_ICON_SUN: WEATHER_ICON_SUN
});

/**
 * Yle Design System
 * v2.x.x
 */

var themeLightCssFragment = `--yds-color-background: #ffffff; /* white */
  --yds-color-background-variant: #f8f9fa; /* gray-5 */
  --yds-color-background-negative: #131415; /* gray-95 */
  --yds-color-background-navigation: #ffffff; /* white */
  --yds-color-background-control: rgba(0, 0, 0, 0.47); /* black-opacity-50 */
  --yds-color-background-control-disabled: rgba(0, 0, 0, 0.15); /* black-opacity-30 */
  --yds-color-background-input: #ffffff; /* white */
  --yds-color-background-highlight: #e8e9eb; /* gray-20 */
  --yds-color-background-interactive: #f1f2f4; /* gray-10 */
  --yds-color-background-dialog: #ffffff; /* white */
  --yds-color-background-dialog-overlay: rgba(0, 0, 0, 0.47); /* black-opacity-50 */
  --yds-color-background-info-primary: #9fc8ee; /* blue-20 */
  --yds-color-background-info-secondary: #f1f2f4; /* gray-10 */
  --yds-color-background-success: #62f9c2; /* green-20 */
  --yds-color-background-warning: #ffd199; /* info-orange-20 */
  --yds-color-background-error: #f99fb5; /* red-20 */
  --yds-color-background-opinion-article: #3d5483; /* info-deep-blue-60 */
  --yds-color-background-list: #f8f9fa; /* gray-5 */
  --yds-color-background-dropdown: #f8f9fa; /* gray-5 */
  --yds-color-text-default: #131415; /* gray-95 */
  --yds-color-text-negative: #f8f9fa; /* gray-5 */
  --yds-color-text-input-placeholder: #4a4f54; /* gray-60 */
  --yds-color-text-high-emphasis: rgba(0, 0, 0, 0.79); /* black-opacity-70 */
  --yds-color-text-medium-emphasis: rgba(0, 0, 0, 0.7); /* black-opacity-60 */
  --yds-color-text-disabled: rgba(0, 0, 0, 0.29); /* black-opacity-40 */
  --yds-color-text-light: #f8f9fa; /* gray-5 */
  --yds-color-text-dark: #131415; /* gray-95 */
  --yds-color-text-light-high-contrast: #ffffff; /* white */
  --yds-color-text-feedback-live: #ffffff; /* light-high-contrast-text */
  --yds-color-action-primary: #131415; /* gray-95 */
  --yds-color-action-primary-variant: rgba(0, 0, 0, 0.7); /* black-opacity-60 */
  --yds-color-action-secondary: rgba(0, 0, 0, 0.05); /* black-opacity-10 */
  --yds-color-action-secondary-variant: rgba(0, 0, 0, 0.09); /* black-opacity-20 */
  --yds-color-action-disabled: rgba(0, 0, 0, 0.15); /* black-opacity-30 */
  --yds-color-action-danger-primary: #d10b3d; /* red-60 */
  --yds-color-action-danger-primary-variant: #e90e43; /* red-50 */
  --yds-color-action-selected: #131415; /* gray-95 */
  --yds-color-action-unselected: #e8e9eb; /* gray-20 */
  --yds-color-border: #131415; /* gray-95 */
  --yds-color-border-disabled: rgba(0, 0, 0, 0.29); /* black-opacity-40 */
  --yds-color-border-primary-focus: #009cb5; /* turquoise-60 */
  --yds-color-border-secondary-focus: #131415; /* gray-95 */
  --yds-color-border-separator: rgba(0, 0, 0, 0.09); /* black-opacity-20 */
  --yds-color-border-negative: #ffffff; /* background */
  --yds-color-illustrative-icons-icon-primary: #131415; /* gray-95 */
  --yds-color-illustrative-icons-icon-secondary: #5ddbe9; /* turquoise-30 */
  --yds-color-player-progress-bar: rgba(255, 255, 255, 0.3); /* white-opacity-40 */
  --yds-color-player-progress-indicator: #29ccde; /* turquoise-40 */
  --yds-color-spinner-default: #131415; /* gray-95 */
  --yds-color-spinner-negative: #ffffff; /* white */
  --yds-color-spinner-highlight-default: #009cb5; /* turquoise-60 */
  --yds-color-spinner-highlight-negative: #29ccde; /* turquoise-40 */
  --yds-color-spinner-background-default: #d8d9db; /* gray-30 */
  --yds-color-spinner-background-negative: #323639; /* gray-70 */
  --yds-color-spinner-error: #d10b3d; /* error */
  --yds-color-spinner-success: #058657; /* success */
  --yds-color-spinner-background-error: #fcc5d3; /* red-10 */
  --yds-color-feedback-highlight: #009cb5; /* turquoise-60 */
  --yds-color-feedback-error: #d10b3d; /* red-60 */
  --yds-color-feedback-warning: #f1722a; /* orange-60 */
  --yds-color-feedback-success: #058657; /* green-70 */
  --yds-color-feedback-live: #e90e43; /* red-50 */
  --yds-color-logo-yle-background-brand: #00b4c8; /* turquoise-50 */
  --yds-color-logo-tv1: #3311aa; /* yle-tv-1 */
  --yds-color-logo-tv-2: #cb0fd0; /* yle-tv-2 */
  --yds-color-logo-yle-teema: #fe8300; /* yle-teema */
  --yds-color-logo-yle-fem: #a3bd2f; /* yle-fem */
  --yds-color-logo-lastenareena: #feb500; /* lastenareena */
  --yds-color-logo-yle-radio-1: #dc006a; /* yle-radio-1 */
  --yds-color-logo-yle-radio-suomi: #0000e6; /* yle-radio-suomi */
  --yds-color-logo-yle-x: #fd2b77; /* yle-x */
  --yds-color-logo-yle-x3m: #ff4c20; /* yle-x3m */
  --yds-color-logo-yle-vega: #169bd4; /* yle-vega */
  --yds-color-logo-yle-klassinen: #0f7b87; /* yle-klassinen */
  --yds-color-logo-yle-sami-radio: #0049bf; /* yle-sami-radio */
  --yds-color-logo-areena: #29ccde; /* turquoise-40 */
  --yds-color-logo-yle-background-default: #131415; /* default-text */
  --yds-color-logo-yle-text: #f8f9fa; /* negative-text */
  --yds-color-logo-background: #000000; /* black */
  --yds-color-logo-nega: #ffffff; /* white */
  --yds-color-logo-text: #ffffff; /* white */
  --yds-color-brand-yle: #00b4c8; /* turquoise-50 */
  --yds-color-tag-live: #e90e43; /* red-50 */
  --yds-color-tag-default: #131415; /* gray-95 */
  --yds-color-tag-opinion: #3d5483; /* info-deep-blue-60 */
  --yds-color-tag-yle-corporate: #00809c; /* turquoise-70 */
  --yds-color-tag-primary-action: #131415; /* gray-95 */
  --yds-color-tag-primary-action-variant: rgba(0, 0, 0, 0.7); /* black-opacity-60 */
  --yds-color-tag-secondary-action: rgba(0, 0, 0, 0.05); /* black-opacity-10 */
  --yds-color-tag-secondary-action-variant: rgba(0, 0, 0, 0.02); /* black-opacity-5 */
  --yds-color-tag-neutral: #e8e9eb; /* gray-20 */
  --yds-color-shadow-s: rgba(0, 0, 0, 0.15);
  --yds-color-shadow-m: rgba(0, 0, 0, 0.15);
  --yds-color-shadow-l: rgba(0, 0, 0, 0.41);
  --yds-color-tietaja-background-player-card: rgba(0, 0, 0, 0.15); /* black-opacity-30 */
  --yds-color-tietaja-text-score: #009cb5; /* highlight */
  --yds-color-tietaja-border-highlight: #009cb5; /* highlight */`;

/**
 * Yle Design System
 * v2.x.x
 */

var themeDarkCssFragment = `--yds-color-background: #131415; /* gray-95 */
  --yds-color-background-variant: #1f2123; /* gray-90 */
  --yds-color-background-negative: #ffffff; /* white */
  --yds-color-background-navigation: #000000; /* black */
  --yds-color-background-control: rgba(255, 255, 255, 0.53); /* white-opacity-50 */
  --yds-color-background-control-disabled: rgba(255, 255, 255, 0.21); /* white-opacity-30 */
  --yds-color-background-input: #131415; /* gray-95 */
  --yds-color-background-highlight: #0b3f4b; /* turquoise-95 */
  --yds-color-background-interactive: #292b2d; /* gray-80 */
  --yds-color-background-dialog: #1f2123; /* gray-90 */
  --yds-color-background-dialog-overlay: rgba(0, 0, 0, 0.7); /* black-opacity-60 */
  --yds-color-background-info-primary: #d8d9db; /* gray-30 */
  --yds-color-background-info-secondary: #292b2d; /* gray-80 */
  --yds-color-background-success: #33d59b; /* info-green-40 */
  --yds-color-background-warning: #feb054; /* info-orange-40 */
  --yds-color-background-error: #f5517a; /* red-40 */
  --yds-color-background-opinion-article: #3d5483; /* info-deep-blue-60 */
  --yds-color-background-list: #131415; /* gray-95 */
  --yds-color-background-dropdown: #292b2d; /* gray-80 */
  --yds-color-text-default: #f8f9fa; /* gray-5 */
  --yds-color-text-negative: #131415; /* gray-95 */
  --yds-color-text-input-placeholder: #878a8b; /* gray-50 */
  --yds-color-text-high-emphasis: rgba(255, 255, 255, 0.85); /* white-opacity-70 */
  --yds-color-text-medium-emphasis: rgba(255, 255, 255, 0.71); /* white-opacity-60 */
  --yds-color-text-disabled: rgba(255, 255, 255, 0.3); /* white-opacity-40 */
  --yds-color-text-light: #f8f9fa; /* gray-5 */
  --yds-color-text-dark: #131415; /* gray-95 */
  --yds-color-text-light-high-contrast: #ffffff; /* white */
  --yds-color-text-feedback-live: #ffffff; /* light-high-contrast-text */
  --yds-color-action-primary: #f8f9fa; /* gray-5 */
  --yds-color-action-primary-variant: rgba(255, 255, 255, 0.71); /* white-opacity-60 */
  --yds-color-action-secondary: rgba(255, 255, 255, 0.08); /* white-opacity-5 */
  --yds-color-action-secondary-variant: rgba(255, 255, 255, 0.17); /* white-opacity-20 */
  --yds-color-action-disabled: rgba(255, 255, 255, 0.21); /* white-opacity-30 */
  --yds-color-action-danger-primary: #f77898; /* red-30 */
  --yds-color-action-danger-primary-variant: #f5517a; /* red-40 */
  --yds-color-action-selected: #f8f9fa; /* gray-5 */
  --yds-color-action-unselected: #323639; /* gray-70 */
  --yds-color-border: #f8f9fa; /* gray-5 */
  --yds-color-border-disabled: rgba(255, 255, 255, 0.3); /* white-opacity-40 */
  --yds-color-border-primary-focus: #29ccde; /* turquoise-40 */
  --yds-color-border-secondary-focus: #f8f9fa; /* gray-5 */
  --yds-color-border-separator: rgba(255, 255, 255, 0.13); /* white-opacity-10 */
  --yds-color-border-negative: #131415; /* background */
  --yds-color-illustrative-icons-icon-primary: #f8f9fa; /* gray-5 */
  --yds-color-illustrative-icons-icon-secondary: #009cb5; /* turquoise-60 */
  --yds-color-player-progress-bar: rgba(255, 255, 255, 0.3); /* white-opacity-40 */
  --yds-color-player-progress-indicator: #29ccde; /* turquoise-40 */
  --yds-color-spinner-default: #ffffff; /* white */
  --yds-color-spinner-negative: #131415; /* gray-95 */
  --yds-color-spinner-highlight-default: #29ccde; /* turquoise-40 */
  --yds-color-spinner-highlight-negative: #009cb5; /* turquoise-60 */
  --yds-color-spinner-background-default: #323639; /* gray-70 */
  --yds-color-spinner-background-negative: #d8d9db; /* gray-30 */
  --yds-color-spinner-error: #f5517a; /* error */
  --yds-color-spinner-success: #03e592; /* success */
  --yds-color-spinner-background-error: #740722; /* red-80 */
  --yds-color-feedback-highlight: #29ccde; /* turquoise-40 */
  --yds-color-feedback-error: #f5517a; /* red-40 */
  --yds-color-feedback-warning: #ff9c31; /* orange-40 */
  --yds-color-feedback-success: #03e592; /* green-40 */
  --yds-color-feedback-live: #e90e43; /* red-50 */
  --yds-color-logo-yle-background-brand: #f8f9fa; /* gray-5 */
  --yds-color-logo-tv1: #3311aa; /* yle-tv-1 */
  --yds-color-logo-tv-2: #cb0fd0; /* yle-tv-2 */
  --yds-color-logo-yle-teema: #fe8300; /* yle-teema */
  --yds-color-logo-yle-fem: #a3bd2f; /* yle-fem */
  --yds-color-logo-lastenareena: #feb500; /* lastenareena */
  --yds-color-logo-yle-radio-1: #dc006a; /* yle-radio-1 */
  --yds-color-logo-yle-radio-suomi: #00b9eb; /* yle-radio-suomi-2 */
  --yds-color-logo-yle-x: #fd2b77; /* yle-x */
  --yds-color-logo-yle-x3m: #ff4c20; /* yle-x3m */
  --yds-color-logo-yle-vega: #169bd4; /* yle-vega */
  --yds-color-logo-yle-klassinen: #0f7b87; /* yle-klassinen */
  --yds-color-logo-yle-sami-radio: #0049bf; /* yle-sami-radio */
  --yds-color-logo-areena: #29ccde; /* turquoise-40 */
  --yds-color-logo-yle-background-default: #f8f9fa; /* default-text */
  --yds-color-logo-yle-text: #131415; /* negative-text */
  --yds-color-logo-background: #ffffff; /* white */
  --yds-color-logo-nega: #ffffff; /* white */
  --yds-color-logo-text: #000000; /* black */
  --yds-color-brand-yle: #00b4c8; /* turquoise-50 */
  --yds-color-tag-live: #e90e43; /* red-50 */
  --yds-color-tag-default: #ffffff; /* white */
  --yds-color-tag-opinion: #3d5483; /* info-deep-blue-60 */
  --yds-color-tag-yle-corporate: #00809c; /* turquoise-70 */
  --yds-color-tag-primary-action: #f8f9fa; /* gray-5 */
  --yds-color-tag-primary-action-variant: rgba(255, 255, 255, 0.71); /* white-opacity-60 */
  --yds-color-tag-secondary-action: rgba(255, 255, 255, 0.13); /* white-opacity-10 */
  --yds-color-tag-secondary-action-variant: rgba(255, 255, 255, 0.08); /* white-opacity-5 */
  --yds-color-tag-neutral: #323639; /* gray-70 */
  --yds-color-shadow-s: rgba(0, 0, 0, 0.7);
  --yds-color-shadow-m: rgba(0, 0, 0, 0.7);
  --yds-color-shadow-l: rgba(0, 0, 0, 0.87);
  --yds-color-tietaja-background-player-card: rgba(0, 0, 0, 0.29); /* black-opacity-40 */
  --yds-color-tietaja-text-score: #29ccde; /* highlight */
  --yds-color-tietaja-border-highlight: #29ccde; /* highlight */`;

/**
 * Yle Design System
 * v2.x.x
 */

var shadowLightCssFragment = `--yds-shadow-sm: 0 0 8px 0 rgba(0, 0, 0, 0.15);
  --yds-shadow-md: 0 0 16px 0 rgba(0, 0, 0, 0.15);
  --yds-shadow-lg: 0 0 24px 0 rgba(0, 0, 0, 0.41);`;

/**
 * Yle Design System
 * v2.x.x
 */

var shadowDarkCssFragment = `--yds-shadow-sm: 0 0 8px 0 rgba(0, 0, 0, 0.70);
  --yds-shadow-md: 0 0 16px 0 rgba(0, 0, 0, 0.70);
  --yds-shadow-lg: 0 0 24px 0 rgba(0, 0, 0, 0.87);`;

/**
 * Yle Design System
 * v2.x.x
 */

var infographicLightCssFragment = `--yds-infographic-weather-icon-cloud-light: rgba(0, 0, 0, 0.15); /* black-opacity-30 */
  --yds-infographic-weather-icon-cloud-mid: rgba(0, 0, 0, 0.47); /* black-opacity-50 */
  --yds-infographic-weather-icon-cloud-dark: rgba(0, 0, 0, 0.7); /* black-opacity-60 */
  --yds-infographic-weather-icon-moon: #95c6ff; /* info-blue-20 */
  --yds-infographic-weather-icon-droplet: #2684ff; /* info-blue-50 */
  --yds-infographic-weather-icon-sun: #ffc400; /* info-yellow-50 */
  --yds-infographic-text-default: #131415; /* default-text */
  --yds-infographic-background: #ffffff; /* background */
  --yds-infographic-tooltip-background: #131415; /* negative-background */
  --yds-infographic-gridline: #b4b6b7; /* gray-40 */
  --yds-infographic-text-negative: #f8f9fa; /* negative-text */
  --yds-infographic-text-secondary: #4a4f54; /* gray-60 */
  --yds-infographic-text-dark: #131415; /* dark-text */
  --yds-infographic-text-light: #f8f9fa; /* light-text */
  --yds-infographic-text-plus: #00809c; /* turquoise-70 */
  --yds-infographic-text-minus: #b83c35; /* news-orange-70 */
  --yds-infographic-news-default-1: #7c59fa; /* news-violet-40 */
  --yds-infographic-news-default-2: #009cb5; /* turquoise-60 */
  --yds-infographic-news-default-3: #0b54b4; /* info-blue-90 */
  --yds-infographic-news-default-4: #f56a1b; /* info-orange-60 */
  --yds-infographic-news-default-5: #80259f; /* info-purple-60 */
  --yds-infographic-news-default-6: #2f2372; /* news-violet-80 */
  --yds-infographic-news-monochrome-1: #1e1753; /* news-violet-90 */
  --yds-infographic-news-monochrome-2: #413091; /* news-violet-70 */
  --yds-infographic-news-monochrome-3: #694bd7; /* news-violet-50 */
  --yds-infographic-news-monochrome-4: #9479fb; /* news-violet-30 */
  --yds-infographic-news-monochrome-5: #b7a8fa; /* news-violet-20 */
  --yds-infographic-news-monochrome-6: #d3cbfb; /* news-violet-10 */
  --yds-infographic-sports-default-1: #5541ed; /* sports-violet-50 */
  --yds-infographic-sports-default-2: #ea3e85; /* sports-pink-40 */
  --yds-infographic-sports-default-3: #618515; /* sports-lime-80 */
  --yds-infographic-sports-default-4: #8578f2; /* sports-violet-30 */
  --yds-infographic-sports-default-5: #f273a8; /* sports-pink-30 */
  --yds-infographic-sports-default-6: #2c4d01; /* sports-lime-95 */
  --yds-infographic-sports-monochrome-1: #1a1476; /* sports-violet-80 */
  --yds-infographic-sports-monochrome-2: #372bb1; /* sports-violet-60 */
  --yds-infographic-sports-monochrome-3: #5541ed; /* sports-violet-50 */
  --yds-infographic-sports-monochrome-4: #8578f2; /* sports-violet-30 */
  --yds-infographic-sports-monochrome-5: #b3abf7; /* sports-violet-20 */
  --yds-infographic-sports-monochrome-6: #ddd9fc; /* sports-violet-10 */
  --yds-infographic-accent-news: #f26659; /* news-orange-50 */
  --yds-infographic-political-party-fi-kok-primary: #0357a5;
  --yds-infographic-political-party-fi-kok-secondary: #8eb4d7;
  --yds-infographic-political-party-fi-ps-primary: #159af0;
  --yds-infographic-political-party-fi-ps-secondary: #96d2f8;
  --yds-infographic-political-party-fi-sdp-primary: #e01515;
  --yds-infographic-political-party-fi-sdp-secondary: #ef9897;
  --yds-infographic-political-party-fi-vihr-primary: #769f20;
  --yds-infographic-political-party-fi-vihr-secondary: #bccf95;
  --yds-infographic-political-party-fi-kesk-primary: #096900;
  --yds-infographic-political-party-fi-kesk-secondary: #90bc8c;
  --yds-infographic-political-party-fi-vas-primary: #bb1054;
  --yds-infographic-political-party-fi-vas-secondary: #e094b2;
  --yds-infographic-political-party-fi-rkp-primary: #c97b2d;
  --yds-infographic-political-party-fi-rkp-secondary: #deb186;
  --yds-infographic-political-party-fi-kd-primary: #923de8;
  --yds-infographic-political-party-fi-kd-secondary: #cea8f5;
  --yds-infographic-political-party-fi-liik-primary: #c262b8;
  --yds-infographic-political-party-fi-liik-secondary: #e4b8df;
  --yds-infographic-political-party-fi-others-primary: #8d8e8f;
  --yds-infographic-political-party-fi-others-secondary: #cccccd;
  --yds-infographic-scale-strongly-agree: #009cb5; /* turquoise-60 */
  --yds-infographic-scale-agree: #5ddbe9; /* turquoise-30 */
  --yds-infographic-scale-neutral: #b4b6b7; /* gray-40 */
  --yds-infographic-scale-disagree: #f79c94; /* news-orange-30 */
  --yds-infographic-scale-strongly-disagree: #f26659; /* news-orange-50 */
  --yds-infographic-survey-yes: #009cb5; /* turquoise-60 */
  --yds-infographic-survey-no: #f26659; /* news-orange-50 */
  --yds-infographic-survey-empty: #d8d9db; /* gray-30 */
  --yds-infographic-survey-neutral: #878a8b; /* gray-50 */`;

/**
 * Yle Design System
 * v2.x.x
 */

var infographicDarkCssFragment = `--yds-infographic-weather-icon-cloud-light: rgba(255, 255, 255, 0.85); /* white-opacity-70 */
  --yds-infographic-weather-icon-cloud-mid: rgba(255, 255, 255, 0.53); /* white-opacity-50 */
  --yds-infographic-weather-icon-cloud-dark: rgba(255, 255, 255, 0.21); /* white-opacity-30 */
  --yds-infographic-weather-icon-moon: #95c6ff; /* info-blue-20 */
  --yds-infographic-weather-icon-droplet: #ffffff; /* white */
  --yds-infographic-weather-icon-sun: #ffc400; /* info-yellow-50 */
  --yds-infographic-text-default: #f8f9fa; /* default-text */
  --yds-infographic-background: #131415; /* background */
  --yds-infographic-tooltip-background: #ffffff; /* negative-background */
  --yds-infographic-gridline: #4a4f54; /* gray-60 */
  --yds-infographic-text-negative: #131415; /* negative-text */
  --yds-infographic-text-secondary: #b4b6b7; /* gray-40 */
  --yds-infographic-text-dark: #131415; /* dark-text */
  --yds-infographic-text-light: #f8f9fa; /* light-text */
  --yds-infographic-text-plus: #29ccde; /* turquoise-40 */
  --yds-infographic-text-minus: #f26659; /* news-orange-50 */
  --yds-infographic-news-default-1: #7c59fa; /* news-violet-40 */
  --yds-infographic-news-default-2: #29ccde; /* turquoise-40 */
  --yds-infographic-news-default-3: #ffe387; /* info-yellow-20 */
  --yds-infographic-news-default-4: #ff8f33; /* info-orange-50 */
  --yds-infographic-news-default-5: #9436b5; /* info-purple-50 */
  --yds-infographic-news-default-6: #fff3e2; /* info-orange-5 */
  --yds-infographic-news-monochrome-1: #e6e5ff; /* news-violet-5 */
  --yds-infographic-news-monochrome-2: #d3cbfb; /* news-violet-10 */
  --yds-infographic-news-monochrome-3: #b7a8fa; /* news-violet-20 */
  --yds-infographic-news-monochrome-4: #9479fb; /* news-violet-30 */
  --yds-infographic-news-monochrome-5: #694bd7; /* news-violet-50 */
  --yds-infographic-news-monochrome-6: #413091; /* news-violet-70 */
  --yds-infographic-sports-default-1: #5541ed; /* sports-violet-50 */
  --yds-infographic-sports-default-2: #ea3e85; /* sports-pink-40 */
  --yds-infographic-sports-default-3: #d4ff42; /* sports-lime-30 */
  --yds-infographic-sports-default-4: #8578f2; /* sports-violet-30 */
  --yds-infographic-sports-default-5: #f7abcb; /* sports-pink-20 */
  --yds-infographic-sports-default-6: #ebfe8d; /* sports-lime-20 */
  --yds-infographic-sports-monochrome-1: #eeeeff; /* sports-violet-5 */
  --yds-infographic-sports-monochrome-2: #ddd9fc; /* sports-violet-10 */
  --yds-infographic-sports-monochrome-3: #b3abf7; /* sports-violet-20 */
  --yds-infographic-sports-monochrome-4: #8578f2; /* sports-violet-30 */
  --yds-infographic-sports-monochrome-5: #5541ed; /* sports-violet-50 */
  --yds-infographic-sports-monochrome-6: #372bb1; /* sports-violet-60 */
  --yds-infographic-accent-news: #f26659; /* news-orange-50 */
  --yds-infographic-political-party-fi-kok-primary: #096de3;
  --yds-infographic-political-party-fi-kok-secondary: #0d4e9b;
  --yds-infographic-political-party-fi-ps-primary: #6fb4fc;
  --yds-infographic-political-party-fi-ps-secondary: #146498;
  --yds-infographic-political-party-fi-sdp-primary: #ff5a5a;
  --yds-infographic-political-party-fi-sdp-secondary: #a13e3f;
  --yds-infographic-political-party-fi-vihr-primary: #8fce29;
  --yds-infographic-political-party-fi-vihr-secondary: #5e8421;
  --yds-infographic-political-party-fi-kesk-primary: #099327;
  --yds-infographic-political-party-fi-kesk-secondary: #0d6020;
  --yds-infographic-political-party-fi-vas-primary: #e22a73;
  --yds-infographic-political-party-fi-vas-secondary: #8f214d;
  --yds-infographic-political-party-fi-rkp-primary: #ffdc5d;
  --yds-infographic-political-party-fi-rkp-secondary: #a1914a;
  --yds-infographic-political-party-fi-kd-primary: #923de8;
  --yds-infographic-political-party-fi-kd-secondary: #5f2c94;
  --yds-infographic-political-party-fi-liik-primary: #cf83c8;
  --yds-infographic-political-party-fi-liik-secondary: #7a5177;
  --yds-infographic-political-party-fi-others-primary: #aeb0b1;
  --yds-infographic-political-party-fi-others-secondary: #616263;
  --yds-infographic-scale-strongly-agree: #29ccde; /* turquoise-40 */
  --yds-infographic-scale-agree: #9cebf4; /* turquoise-20 */
  --yds-infographic-scale-neutral: #e8e9eb; /* gray-20 */
  --yds-infographic-scale-disagree: #f79c94; /* news-orange-30 */
  --yds-infographic-scale-strongly-disagree: #f26659; /* news-orange-50 */
  --yds-infographic-survey-yes: #29ccde; /* turquoise-40 */
  --yds-infographic-survey-no: #f26659; /* news-orange-50 */
  --yds-infographic-survey-empty: #e8e9eb; /* gray-20 */
  --yds-infographic-survey-neutral: #b4b6b7; /* gray-40 */`;

/**
 * Yle Design System
 * v2.x.x
 */

const BACKGROUND$2 = '#362050';
const BACKGROUND_VARIANT$2 = '#4b307a';
const BACKGROUND_INPUT$2 = '#362050'; // background
const BACKGROUND_DIALOG$2 = '#4b307a'; // background-variant
const BACKGROUND_DIALOG_OVERLAY$2 = 'rgba(0, 0, 0, 0.7)'; // dialog-overlay
const BACKGROUND_INFO_PRIMARY$2 = '#d8d9db'; // info-primary-background
const BACKGROUND_INFO_SECONDARY$2 = '#4b307a'; // background-variant
const BACKGROUND_SUCCESS$2 = '#33d59b'; // success-background
const BACKGROUND_WARNING$2 = '#feb054'; // warning-background
const BACKGROUND_ERROR$2 = '#f5517a'; // error-background
const BACKGROUND_INTERACTIVE$2 = '#362050'; // background
const BACKGROUND_NEGATIVE$2 = '#ffffff'; // negative-background
const TEXT_DEFAULT$2 = '#f8f9fa'; // default-text
const TEXT_DARK$2 = '#362050'; // background
const TEXT_DISABLED$2 = 'rgba(255, 255, 255, 0.53)'; // white-opacity-50
const TEXT_INPUT_BLACEHOLDER$2 = 'rgba(255, 255, 255, 0.53)'; // white-opacity-50
const TEXT_NEGATIVE$2 = '#362050'; // background
const TEXT_FEEDBACK_LIVE$2 = '#362050'; // dark-text
const BORDER_PRIMARY_FOCUS$2 = '#ffaf4e'; // highlight
const BORDER$2 = '#f8f9fa'; // default-text
const BORDER_DISABLED$2 = 'rgba(255, 255, 255, 0.3)'; // disabled-border
const BORDER_SEPARATOR$2 = 'rgba(255, 255, 255, 0.13)'; // separator
const BORDER_NEGATIVE$2 = '#362050'; // background
const FEEDBACK_ERROR$2 = '#f5517a'; // error
const FEEDBACK_WARNING$2 = '#ff9c31'; // warning
const FEEDBACK_SUCCESS$2 = '#03e592'; // success
const FEEDBACK_HIGHLIGHT$2 = '#ffaf4e';
const FEEDBACK_LIVE$2 = '#e90e43'; // live
const ACTION_PRIMARY$2 = '#f8f9fa'; // primary-action
const ACTION_PRIMARY_VARIANT$2 = 'rgba(255, 255, 255, 0.71)'; // primary-action-variant
const ACTION_SECONDARY$2 = 'rgba(255, 255, 255, 0.08)'; // secondary-action
const ACTION_SECONDARY_VARIANT$2 = 'rgba(255, 255, 255, 0.17)'; // secondary-action-variant
const ACTION_DISABLED$2 = 'rgba(255, 255, 255, 0.21)'; // disabled-action
const ACTION_SELECTED$2 = '#ffaf4e'; // highlight
const ACTION_UNSELECTED$2 = '#4b307a'; // background-variant
const SPINNER_DEFAULT$2 = '#ffffff'; // default
const SPINNER_NEGATIVE$2 = '#131415'; // negative
const SPINNER_BACKGROUND_DEFAULT$2 = '#323639'; // background-default
const SPINNER_BACKGROUND_NEGATIVE$2 = '#d8d9db'; // background-negative
const TIETAJA_BACKGROUND_PLAYER_CARD$2 = 'rgba(0, 0, 0, 0.29)'; // background-player-card
const TIETAJA_TEXT_SCORE$2 = '#ffaf4e'; // highlight
const TIETAJA_BORDER_HIGHLIGHT$2 = '#ffaf4e'; // highlight
const SHADOW_S$2 = 'rgba(0, 0, 0, 0.7)';
const SHADOW_L$2 = 'rgba(0, 0, 0, 0.87)';
const SHADOW_M$2 = 'rgba(0, 0, 0, 0.7)';
const TAG_LIVE$2 = '#ffaf4e'; // highlight

var futistietajaTheme = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACTION_DISABLED: ACTION_DISABLED$2,
  ACTION_PRIMARY: ACTION_PRIMARY$2,
  ACTION_PRIMARY_VARIANT: ACTION_PRIMARY_VARIANT$2,
  ACTION_SECONDARY: ACTION_SECONDARY$2,
  ACTION_SECONDARY_VARIANT: ACTION_SECONDARY_VARIANT$2,
  ACTION_SELECTED: ACTION_SELECTED$2,
  ACTION_UNSELECTED: ACTION_UNSELECTED$2,
  BACKGROUND: BACKGROUND$2,
  BACKGROUND_DIALOG: BACKGROUND_DIALOG$2,
  BACKGROUND_DIALOG_OVERLAY: BACKGROUND_DIALOG_OVERLAY$2,
  BACKGROUND_ERROR: BACKGROUND_ERROR$2,
  BACKGROUND_INFO_PRIMARY: BACKGROUND_INFO_PRIMARY$2,
  BACKGROUND_INFO_SECONDARY: BACKGROUND_INFO_SECONDARY$2,
  BACKGROUND_INPUT: BACKGROUND_INPUT$2,
  BACKGROUND_INTERACTIVE: BACKGROUND_INTERACTIVE$2,
  BACKGROUND_NEGATIVE: BACKGROUND_NEGATIVE$2,
  BACKGROUND_SUCCESS: BACKGROUND_SUCCESS$2,
  BACKGROUND_VARIANT: BACKGROUND_VARIANT$2,
  BACKGROUND_WARNING: BACKGROUND_WARNING$2,
  BORDER: BORDER$2,
  BORDER_DISABLED: BORDER_DISABLED$2,
  BORDER_NEGATIVE: BORDER_NEGATIVE$2,
  BORDER_PRIMARY_FOCUS: BORDER_PRIMARY_FOCUS$2,
  BORDER_SEPARATOR: BORDER_SEPARATOR$2,
  FEEDBACK_ERROR: FEEDBACK_ERROR$2,
  FEEDBACK_HIGHLIGHT: FEEDBACK_HIGHLIGHT$2,
  FEEDBACK_LIVE: FEEDBACK_LIVE$2,
  FEEDBACK_SUCCESS: FEEDBACK_SUCCESS$2,
  FEEDBACK_WARNING: FEEDBACK_WARNING$2,
  SHADOW_L: SHADOW_L$2,
  SHADOW_M: SHADOW_M$2,
  SHADOW_S: SHADOW_S$2,
  SPINNER_BACKGROUND_DEFAULT: SPINNER_BACKGROUND_DEFAULT$2,
  SPINNER_BACKGROUND_NEGATIVE: SPINNER_BACKGROUND_NEGATIVE$2,
  SPINNER_DEFAULT: SPINNER_DEFAULT$2,
  SPINNER_NEGATIVE: SPINNER_NEGATIVE$2,
  TAG_LIVE: TAG_LIVE$2,
  TEXT_DARK: TEXT_DARK$2,
  TEXT_DEFAULT: TEXT_DEFAULT$2,
  TEXT_DISABLED: TEXT_DISABLED$2,
  TEXT_FEEDBACK_LIVE: TEXT_FEEDBACK_LIVE$2,
  TEXT_INPUT_BLACEHOLDER: TEXT_INPUT_BLACEHOLDER$2,
  TEXT_NEGATIVE: TEXT_NEGATIVE$2,
  TIETAJA_BACKGROUND_PLAYER_CARD: TIETAJA_BACKGROUND_PLAYER_CARD$2,
  TIETAJA_BORDER_HIGHLIGHT: TIETAJA_BORDER_HIGHLIGHT$2,
  TIETAJA_TEXT_SCORE: TIETAJA_TEXT_SCORE$2
});

/**
 * Yle Design System
 * v2.x.x
 */

const BACKGROUND$1 = '#0c111c';
const BACKGROUND_VARIANT$1 = '#1f2937';
const BACKGROUND_INPUT$1 = '#0c111c'; // background
const BACKGROUND_DIALOG$1 = '#1f2937'; // background-variant
const BACKGROUND_DIALOG_OVERLAY$1 = 'rgba(0, 0, 0, 0.7)'; // dialog-overlay
const BACKGROUND_INFO_PRIMARY$1 = '#d8d9db'; // info-primary-background
const BACKGROUND_INFO_SECONDARY$1 = '#1f2937'; // background-variant
const BACKGROUND_SUCCESS$1 = '#33d59b'; // success-background
const BACKGROUND_WARNING$1 = '#feb054'; // warning-background
const BACKGROUND_ERROR$1 = '#f5517a'; // error-background
const BACKGROUND_INTERACTIVE$1 = '#0c111c'; // background
const BACKGROUND_NEGATIVE$1 = '#ffffff'; // negative-background
const TEXT_DEFAULT$1 = '#f8f9fa'; // default-text
const TEXT_DARK$1 = '#0c111c'; // background
const TEXT_DISABLED$1 = 'rgba(255, 255, 255, 0.53)'; // white-opacity-50
const TEXT_INPUT_BLACEHOLDER$1 = 'rgba(255, 255, 255, 0.53)'; // white-opacity-50
const TEXT_NEGATIVE$1 = '#0c111c'; // background
const TEXT_FEEDBACK_LIVE$1 = '#0c111c'; // dark-text
const BORDER_PRIMARY_FOCUS$1 = '#ff5cf8'; // highlight
const BORDER$1 = '#f8f9fa'; // default-text
const BORDER_DISABLED$1 = 'rgba(255, 255, 255, 0.3)'; // disabled-border
const BORDER_SEPARATOR$1 = 'rgba(255, 255, 255, 0.13)'; // separator
const BORDER_NEGATIVE$1 = '#0c111c'; // background
const FEEDBACK_ERROR$1 = '#f5517a'; // error
const FEEDBACK_WARNING$1 = '#ff9c31'; // warning
const FEEDBACK_SUCCESS$1 = '#03e592'; // success
const FEEDBACK_HIGHLIGHT$1 = '#ff5cf8';
const FEEDBACK_LIVE$1 = '#e90e43'; // live
const ACTION_PRIMARY$1 = '#f8f9fa'; // primary-action
const ACTION_PRIMARY_VARIANT$1 = 'rgba(255, 255, 255, 0.71)'; // primary-action-variant
const ACTION_SECONDARY$1 = 'rgba(255, 255, 255, 0.08)'; // secondary-action
const ACTION_SECONDARY_VARIANT$1 = 'rgba(255, 255, 255, 0.17)'; // secondary-action-variant
const ACTION_DISABLED$1 = 'rgba(255, 255, 255, 0.21)'; // disabled-action
const ACTION_SELECTED$1 = '#ff5cf8'; // highlight
const ACTION_UNSELECTED$1 = '#1f2937'; // background-variant
const SPINNER_DEFAULT$1 = '#ffffff'; // default
const SPINNER_NEGATIVE$1 = '#131415'; // negative
const SPINNER_BACKGROUND_DEFAULT$1 = '#323639'; // background-default
const SPINNER_BACKGROUND_NEGATIVE$1 = '#d8d9db'; // background-negative
const TIETAJA_BACKGROUND_PLAYER_CARD$1 = 'rgba(0, 0, 0, 0.29)'; // background-player-card
const TIETAJA_TEXT_SCORE$1 = '#ff5cf8'; // highlight
const TIETAJA_BORDER_HIGHLIGHT$1 = '#ff5cf8'; // highlight
const SHADOW_S$1 = 'rgba(0, 0, 0, 0.7)';
const SHADOW_L$1 = 'rgba(0, 0, 0, 0.87)';
const SHADOW_M$1 = 'rgba(0, 0, 0, 0.7)';
const TAG_LIVE$1 = '#ff5cf8'; // highlight

var viisutietajaTheme = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACTION_DISABLED: ACTION_DISABLED$1,
  ACTION_PRIMARY: ACTION_PRIMARY$1,
  ACTION_PRIMARY_VARIANT: ACTION_PRIMARY_VARIANT$1,
  ACTION_SECONDARY: ACTION_SECONDARY$1,
  ACTION_SECONDARY_VARIANT: ACTION_SECONDARY_VARIANT$1,
  ACTION_SELECTED: ACTION_SELECTED$1,
  ACTION_UNSELECTED: ACTION_UNSELECTED$1,
  BACKGROUND: BACKGROUND$1,
  BACKGROUND_DIALOG: BACKGROUND_DIALOG$1,
  BACKGROUND_DIALOG_OVERLAY: BACKGROUND_DIALOG_OVERLAY$1,
  BACKGROUND_ERROR: BACKGROUND_ERROR$1,
  BACKGROUND_INFO_PRIMARY: BACKGROUND_INFO_PRIMARY$1,
  BACKGROUND_INFO_SECONDARY: BACKGROUND_INFO_SECONDARY$1,
  BACKGROUND_INPUT: BACKGROUND_INPUT$1,
  BACKGROUND_INTERACTIVE: BACKGROUND_INTERACTIVE$1,
  BACKGROUND_NEGATIVE: BACKGROUND_NEGATIVE$1,
  BACKGROUND_SUCCESS: BACKGROUND_SUCCESS$1,
  BACKGROUND_VARIANT: BACKGROUND_VARIANT$1,
  BACKGROUND_WARNING: BACKGROUND_WARNING$1,
  BORDER: BORDER$1,
  BORDER_DISABLED: BORDER_DISABLED$1,
  BORDER_NEGATIVE: BORDER_NEGATIVE$1,
  BORDER_PRIMARY_FOCUS: BORDER_PRIMARY_FOCUS$1,
  BORDER_SEPARATOR: BORDER_SEPARATOR$1,
  FEEDBACK_ERROR: FEEDBACK_ERROR$1,
  FEEDBACK_HIGHLIGHT: FEEDBACK_HIGHLIGHT$1,
  FEEDBACK_LIVE: FEEDBACK_LIVE$1,
  FEEDBACK_SUCCESS: FEEDBACK_SUCCESS$1,
  FEEDBACK_WARNING: FEEDBACK_WARNING$1,
  SHADOW_L: SHADOW_L$1,
  SHADOW_M: SHADOW_M$1,
  SHADOW_S: SHADOW_S$1,
  SPINNER_BACKGROUND_DEFAULT: SPINNER_BACKGROUND_DEFAULT$1,
  SPINNER_BACKGROUND_NEGATIVE: SPINNER_BACKGROUND_NEGATIVE$1,
  SPINNER_DEFAULT: SPINNER_DEFAULT$1,
  SPINNER_NEGATIVE: SPINNER_NEGATIVE$1,
  TAG_LIVE: TAG_LIVE$1,
  TEXT_DARK: TEXT_DARK$1,
  TEXT_DEFAULT: TEXT_DEFAULT$1,
  TEXT_DISABLED: TEXT_DISABLED$1,
  TEXT_FEEDBACK_LIVE: TEXT_FEEDBACK_LIVE$1,
  TEXT_INPUT_BLACEHOLDER: TEXT_INPUT_BLACEHOLDER$1,
  TEXT_NEGATIVE: TEXT_NEGATIVE$1,
  TIETAJA_BACKGROUND_PLAYER_CARD: TIETAJA_BACKGROUND_PLAYER_CARD$1,
  TIETAJA_BORDER_HIGHLIGHT: TIETAJA_BORDER_HIGHLIGHT$1,
  TIETAJA_TEXT_SCORE: TIETAJA_TEXT_SCORE$1
});

/**
 * Yle Design System
 * v2.x.x
 */

const ACTION_DISABLED = 'rgba(255, 255, 255, 0.21)';
const ACTION_PRIMARY = '#f8f9fa';
const ACTION_PRIMARY_VARIANT = 'rgba(255, 255, 255, 0.71)';
const ACTION_SECONDARY = 'rgba(255, 255, 255, 0.08)';
const ACTION_SECONDARY_VARIANT = 'rgba(255, 255, 255, 0.17)';
const ACTION_SELECTED = '#D4FF42';
const ACTION_UNSELECTED = '#2f2a78';
const BACKGROUND = '#0D0A5C';
const BACKGROUND_DIALOG = '#2f2a78';
const BACKGROUND_DIALOG_OVERLAY = 'rgba(0, 0, 0, 0.7)';
const BACKGROUND_ERROR = '#f5517a';
const BACKGROUND_INFO_PRIMARY = '#d8d9db';
const BACKGROUND_INFO_SECONDARY = '#2f2a78';
const BACKGROUND_INPUT = '#0D0A5C';
const BACKGROUND_INTERACTIVE = '#2f2a78';
const BACKGROUND_NEGATIVE = '#ffffff';
const BACKGROUND_SUCCESS = '#33d59b';
const BACKGROUND_VARIANT = '#2f2a78';
const BACKGROUND_WARNING = '#feb054';
const BORDER = '#f8f9fa';
const BORDER_DISABLED = 'rgba(255, 255, 255, 0.3)';
const BORDER_NEGATIVE = '#0D0A5C';
const BORDER_PRIMARY_FOCUS = '#D4FF42';
const BORDER_SEPARATOR = 'rgba(255, 255, 255, 0.13)';
const FEEDBACK_ERROR = '#f5517a';
const FEEDBACK_HIGHLIGHT = '#D4FF42';
const FEEDBACK_LIVE = '#D4FF42';
const FEEDBACK_SUCCESS = '#03e592';
const FEEDBACK_WARNING = '#ff9c31';
const SHADOW_L = 'rgba(0, 0, 0, 0.87)';
const SHADOW_M = 'rgba(0, 0, 0, 0.7)';
const SHADOW_S = 'rgba(0, 0, 0, 0.7)';
const SPINNER_BACKGROUND_DEFAULT = '#292b2d';
const SPINNER_BACKGROUND_NEGATIVE = '#d8d9db';
const SPINNER_DEFAULT = '#ffffff';
const SPINNER_NEGATIVE = '#131415';
const TAG_LIVE = '#D4FF42';
const TEXT_DARK = '#0D0A5C';
const TEXT_DEFAULT = '#f8f9fa';
const TEXT_DISABLED = 'rgba(255, 255, 255, 0.3)';
const TEXT_FEEDBACK_LIVE = '#0D0A5C';
const TEXT_INPUT_BLACEHOLDER = 'rgba(255, 255, 255, 0.53)'; // white-opacity-50;
const TEXT_NEGATIVE = '#0D0A5C';
const TIETAJA_BACKGROUND_PLAYER_CARD = 'rgba(0, 0, 0, 0.29)';
const TIETAJA_BORDER_HIGHLIGHT = '#D4FF42';
const TIETAJA_TEXT_SCORE = '#D4FF42';

var yleisurheilutietajaTheme = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACTION_DISABLED: ACTION_DISABLED,
  ACTION_PRIMARY: ACTION_PRIMARY,
  ACTION_PRIMARY_VARIANT: ACTION_PRIMARY_VARIANT,
  ACTION_SECONDARY: ACTION_SECONDARY,
  ACTION_SECONDARY_VARIANT: ACTION_SECONDARY_VARIANT,
  ACTION_SELECTED: ACTION_SELECTED,
  ACTION_UNSELECTED: ACTION_UNSELECTED,
  BACKGROUND: BACKGROUND,
  BACKGROUND_DIALOG: BACKGROUND_DIALOG,
  BACKGROUND_DIALOG_OVERLAY: BACKGROUND_DIALOG_OVERLAY,
  BACKGROUND_ERROR: BACKGROUND_ERROR,
  BACKGROUND_INFO_PRIMARY: BACKGROUND_INFO_PRIMARY,
  BACKGROUND_INFO_SECONDARY: BACKGROUND_INFO_SECONDARY,
  BACKGROUND_INPUT: BACKGROUND_INPUT,
  BACKGROUND_INTERACTIVE: BACKGROUND_INTERACTIVE,
  BACKGROUND_NEGATIVE: BACKGROUND_NEGATIVE,
  BACKGROUND_SUCCESS: BACKGROUND_SUCCESS,
  BACKGROUND_VARIANT: BACKGROUND_VARIANT,
  BACKGROUND_WARNING: BACKGROUND_WARNING,
  BORDER: BORDER,
  BORDER_DISABLED: BORDER_DISABLED,
  BORDER_NEGATIVE: BORDER_NEGATIVE,
  BORDER_PRIMARY_FOCUS: BORDER_PRIMARY_FOCUS,
  BORDER_SEPARATOR: BORDER_SEPARATOR,
  FEEDBACK_ERROR: FEEDBACK_ERROR,
  FEEDBACK_HIGHLIGHT: FEEDBACK_HIGHLIGHT,
  FEEDBACK_LIVE: FEEDBACK_LIVE,
  FEEDBACK_SUCCESS: FEEDBACK_SUCCESS,
  FEEDBACK_WARNING: FEEDBACK_WARNING,
  SHADOW_L: SHADOW_L,
  SHADOW_M: SHADOW_M,
  SHADOW_S: SHADOW_S,
  SPINNER_BACKGROUND_DEFAULT: SPINNER_BACKGROUND_DEFAULT,
  SPINNER_BACKGROUND_NEGATIVE: SPINNER_BACKGROUND_NEGATIVE,
  SPINNER_DEFAULT: SPINNER_DEFAULT,
  SPINNER_NEGATIVE: SPINNER_NEGATIVE,
  TAG_LIVE: TAG_LIVE,
  TEXT_DARK: TEXT_DARK,
  TEXT_DEFAULT: TEXT_DEFAULT,
  TEXT_DISABLED: TEXT_DISABLED,
  TEXT_FEEDBACK_LIVE: TEXT_FEEDBACK_LIVE,
  TEXT_INPUT_BLACEHOLDER: TEXT_INPUT_BLACEHOLDER,
  TEXT_NEGATIVE: TEXT_NEGATIVE,
  TIETAJA_BACKGROUND_PLAYER_CARD: TIETAJA_BACKGROUND_PLAYER_CARD,
  TIETAJA_BORDER_HIGHLIGHT: TIETAJA_BORDER_HIGHLIGHT,
  TIETAJA_TEXT_SCORE: TIETAJA_TEXT_SCORE
});

const darkTheme = darkThemeImport;
const replaceTokensInTheme = (tietajaTheme) => Object.keys(darkTheme).reduce((acc, themeToken) => {
    const tietajaToken = tietajaTheme[themeToken];
    if (!tietajaToken) {
        return Object.assign(Object.assign({}, acc), { [themeToken]: darkTheme[themeToken] });
    }
    return Object.assign(Object.assign({}, acc), { [themeToken]: tietajaToken });
}, darkTheme);
const resolveTietajaTheme = (backgroundColor) => {
    switch (backgroundColor.toUpperCase()) {
        case BACKGROUND$1.toUpperCase():
            return replaceTokensInTheme(viisutietajaTheme);
        case BACKGROUND$2.toUpperCase():
            return replaceTokensInTheme(futistietajaTheme);
        case BACKGROUND.toUpperCase():
            return replaceTokensInTheme(yleisurheilutietajaTheme);
        default:
            return darkTheme;
    }
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var toTietajaTheme = (backgroundColor, highlightColor) => resolveTietajaTheme(backgroundColor);

export { border, colorsChannel as channelColors, colors as color, shadowDark as darkShadow, shadowDarkCssFragment as darkShadowCssFragment, darkThemeImport as darkTheme, themeDarkCssFragment as darkThemeCssFragment, shadowDefault as defaultShadow, themeDefault as defaultTheme, infographicDark, infographicDarkCssFragment, infographicDefault, infographicLight, infographicLightCssFragment, shadowLight as lightShadow, shadowLightCssFragment as lightShadowCssFragment, themeLight as lightTheme, themeLightCssFragment as lightThemeCssFragment, borderRadius as radius, spacing, toTietajaTheme, transition, typography, typographyPx, typographyRem, typographyTokens, typographyTokensPx, typographyTokensRem };
